var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdeation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 289.935,
    height: 270.953,
    viewBox: "0 0 289.935 270.953",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ideation-ic",
    transform: "translate(2848.321 1665.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63986",
    "data-name": "Path 63986",
    d: "M-2759.586-1623.028l1.577-.949a.569.569,0,0,1,.733.071,1.934,1.934,0,0,1,.13,1.64,80.4,80.4,0,0,0-1.623,10.671c-.226,1.8.405,3.466.753,5.158.57,2.766,1.265,5.512,2.064,8.225a20.352,20.352,0,0,0,.648,2.27c.237.861.637,1.662.934,2.5a4.079,4.079,0,0,1,.153.419,54.562,54.562,0,0,0,3.234,7.569c.494.813.839,1.7,1.258,2.551a7.069,7.069,0,0,1,.713,1.839,2.556,2.556,0,0,0,.662,1.667,10.066,10.066,0,0,1,1.931,3.645,4.264,4.264,0,0,0,1.769,2.355,1.236,1.236,0,0,1,.172.391c-.154.893.461,1.435.933,2.041a30.57,30.57,0,0,1,2.351,2.928,12.106,12.106,0,0,1,1.206,1.65,3.611,3.611,0,0,1,.238.34c1,1.667,1.919,3.385,2.905,5.063a10.113,10.113,0,0,0,.661,1.282,13.23,13.23,0,0,0,.662,1.3c.6,1.317,1.293,2.591,1.864,3.922a7.447,7.447,0,0,1,.736,1.881c.055,1.048.882,1.9.766,2.993-.9,1.333.547,2.088.785,3.141.044.194-.1-.009.036.138.094.1.194.017.179-.137a.718.718,0,0,1,.338-.119l.193.029a.723.723,0,0,1,.31.255,7.833,7.833,0,0,1,.418.98,12.522,12.522,0,0,1,.7,2.535,6.07,6.07,0,0,0,.291,1.616,1.488,1.488,0,0,1-1.115,2.152,3.549,3.549,0,0,1-.26.289c-.18.188-.364.374-.528.578a1.916,1.916,0,0,0-.234,1.335,2.8,2.8,0,0,1-1.271,2.62,2.077,2.077,0,0,0-.817,2.765c.425,1.143.543,2.3,1.625,3.155a1.114,1.114,0,0,1-.254,1.929,2.239,2.239,0,0,0-1.239,1.591c-.4,1.8-.187,3.171.828,4.122,1.408,1.317,1.365,1.533-.025,2.941-.969,1.259-1.094,4.038-.022,4.943a4.5,4.5,0,0,1,1.4,3.12c.723,4.862,4.072,7.482,8.076,8.634a5.252,5.252,0,0,1,1.6.495c.906,1.047.561,2.43.972,3.61-.506,1.362.187,2.349,1.075,3.231.815.811,1.549,1.624,1.292,2.9.056.7-.678,1.176-.533,1.9-.2.654-1.106.956-.9,1.812a2.656,2.656,0,0,1-.633,1.261,5.546,5.546,0,0,0-.888,1.067c-.248.331-.435.73-.9.824-.492-.171-.348-.51-.27-.878.123-.581.454-1.162.086-1.831a2.366,2.366,0,0,1-.231,1.955c-.6.728.045.912.369,1.272a1.664,1.664,0,0,1-.25.863c-.809,1.7-.381,3.451-.237,5.189a2.259,2.259,0,0,1-.054.442c-.14.425-.147.881-.288,1.305a2.912,2.912,0,0,0-.123.428c.126-.091.163-.32.394-.251.768.567.679,1.507.994,2.271.1.839.606,1.647.2,2.524-1.262.438-.807-.8-1.239-1.074.1.76,1.009,1.459.7,2.462-.2.629-.176,1.3-.322,1.934-.113.491.133.634.538.686a4.724,4.724,0,0,1,1.242.337,4.711,4.711,0,0,1,1.6,3.812c-.048.685.433.995.63,1.492a28.555,28.555,0,0,1,1.742,5.209.952.952,0,0,1-.3.5c-.123.125-.349.3-.13.454.114.083.27-.245.491-.221a.871.871,0,0,1,.45.75,2.072,2.072,0,0,1-.463,1.4c-.34,1.9-1.243,3.655-1.475,5.559-.49,4.021-1.4,7.964-2.049,11.953-.393,2.422-.588,4.876-1.147,7.277-.46,1.975-.878,2.275-2.957,2.316-.964.019-2.084-.479-2.863.562a1.681,1.681,0,0,1-1.126.76,1.108,1.108,0,0,1-.869-.122.309.309,0,0,1,.068-.5c-.171-.173-.242.055-.317.107a17.753,17.753,0,0,0-4.805,4.413,3.342,3.342,0,0,1-3.29,1.793c-.4-.043.1.219.042.361-.191.977-1.132.761-1.725,1.1a3.6,3.6,0,0,1-1.466.522c-1.949,0-2.417,1.82-3.493,2.883-.24.236-.3.648-.523.933-.744.935-1.269.925-1.843-.115-2.575-4.658-6.662-7.383-11.541-9.122-.842-.3-1.735-.169-2.581-.4-3.148-.2-6.3-.553-9.379.492a15.009,15.009,0,0,0-3.252,1.1c-.445.274-.876.484-.883,1.083a.894.894,0,0,1-1.017.672c-.793-.288-1.228.284-1.727.715-.682.59-1.294.566-1.786-.243a17.513,17.513,0,0,0-9.887-7.587c-.922-.305-1.16-.746-.632-1.565a2.085,2.085,0,0,0,.08-1.646c.277-1.212.008-2.609,1.189-3.512a2.265,2.265,0,0,1,.151,1.375c-.126-2.065.361-4.448-.031-6.844-.044-.2-.321.028-.128-.046.074-.028.11,0,.126.087a1.787,1.787,0,0,1-.05,1.175c-1.189-.365-.652-1.443-.908-2.193.639-2.026-.523-3.562-1.474-5.112a19.82,19.82,0,0,0-4.638-5.269c-1.544-1.211-3.454-1.75-5.2-2.582-.393-.187-.794.1-1.189.19a2.132,2.132,0,0,1-.447.087.984.984,0,0,1-.965-.522c-.143-.274-.291-.516-.668-.523-1.961-.033-3.922-.118-5.881.019-.2.085.039.311-.042.122-.029-.066.006-.128.094-.116.534.077,1.228-.512,1.569.374-.286.472-.807.473-1.25.63a2.426,2.426,0,0,1-.93.023,3.51,3.51,0,0,0-1.2-.172,2.33,2.33,0,0,1-2.751-1.606c-.124-.359-.342-.622-.786-.538a.92.92,0,0,1-.691-.986,1.176,1.176,0,0,0-.412-1.372c-2.025-1.8-3.9-3.834-6.717-4.44-2.6-1.34-5.382-.936-8.128-.858-.323.009-.389.266-.291.558-.389.7-1.057.681-1.72.675-1.266-.892-2.319.035-3.171.638-1.07.759-1.8.73-2.643-.156-.348-.364-.73-.753-1.33-.5a1.074,1.074,0,0,1-1.205-.959,1.633,1.633,0,0,0-2.471-.929,1.316,1.316,0,0,1-1.339-.505,3.662,3.662,0,0,1-2.086-2.822c-.752-4.605-1.092-9.244-1.495-13.886-.375-4.325-.3-8.626-.324-12.935a116.221,116.221,0,0,1,1.444-17.3c.156-1.071.042-2.157.105-3.233,0-.569-.262-1.168.178-1.687.573.244.642-.11.713-.564a84.181,84.181,0,0,1,3.295-14.147c.334-.985.241-2.029.579-3a10.887,10.887,0,0,0,1.361-2.305,2.317,2.317,0,0,0-.1-2.011c-.053-.443-.129-.894.352-1.175.2-.047.458.247.493.156.444-1.177,1.215-2.294.778-3.66a1.443,1.443,0,0,1,.635-1.457c.9.029.788-.786,1.007-1.278a35.81,35.81,0,0,1,1.926-4.157c.308-.508.679-1.073.149-1.685a.735.735,0,0,1,.282-.948,1.358,1.358,0,0,0,.924-.736c1.731-3.474,3.637-6.85,5.626-10.182a2.8,2.8,0,0,0,.143-.437,1.2,1.2,0,0,1,.763-.742c1.9-.659,2.2-2.3,2.439-3.98a5.715,5.715,0,0,1,2.339-3.345,3.225,3.225,0,0,0,3.889-.812,4.231,4.231,0,0,0,1.182-4.059c-.168-.894-.75.013-1.058-.256-.4-.567.023-.949.31-1.358a62.7,62.7,0,0,1,6.088-7.277c.681-.711,1.132-1.577,1.756-2.322a21.238,21.238,0,0,0,2.382-2.4,1.427,1.427,0,0,1,1.279-.726c1.028.323,1.549,1.3,2.406,1.868a8.941,8.941,0,0,0,7.174,1.735c-.15-.489-1.152-.591-.71-1.249.394-.588,1.083-.357,1.548-.1,1.809.983,3.159.344,4.561-.918,1.6-1.441,3-2.915,3.382-5.142.18-1.053.889-1.955.931-3.078a11.084,11.084,0,0,0-1.907-6.071,12.538,12.538,0,0,1-.869-1.264,1.015,1.015,0,0,1-.045-.444,21.044,21.044,0,0,1,4.969-3.943c1.2-.414,1.893-1.514,2.916-2.171,1.644-.5,2.919-1.635,4.347-2.507a4.473,4.473,0,0,1,1.46-.8c.722.019,1.014.734,1.611,1.014.078-.551-.142-1.1.095-1.609a2.128,2.128,0,0,1,1.265-1.24,24.343,24.343,0,0,0,5.285-2.934c1.837-.223,3.2-1.495,4.807-2.218.617-.277,1.65,0,1.719-1.129a.936.936,0,0,1,1.035-.222c.244.2.445.418.238.76-.674,1.408.012,2.905-.214,3.815.158-.9-.385-2.377.19-3.784.211-.328.443-.618.9-.531,1.114.574.58,1.607.68,2.221-.134-.651.424-1.627-.319-2.446A.963.963,0,0,1-2759.586-1623.028Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63987",
    "data-name": "Path 63987",
    d: "M-2809.3-1452.49l.92.009a25.994,25.994,0,0,1,5.233-.513,1.707,1.707,0,0,1,.7-.006c.423.38.751,1.031,1.492.536l0-.03a.515.515,0,0,1,.76.146c.581.966,1.63,1.159,2.557,1.565a16.456,16.456,0,0,1,8.025,7.652c.2.378.148.973.855.774.43.205.435.57.37.964a1.99,1.99,0,0,1-.48.813c-.71.529-.557,1.289-.46,1.98a23.326,23.326,0,0,1-.014,6.89,4.234,4.234,0,0,0,.241,2.115,2.04,2.04,0,0,1-.6,1.922c-.462.461-.33.759.167,1.033a.936.936,0,0,1,.2.369c1.086,1.344,2.632,1.341,4.148,1.424a6.922,6.922,0,0,1,3.572,2.2,14.992,14.992,0,0,1,3.6,4.291,1.583,1.583,0,0,0,.9.772,2.471,2.471,0,0,0,2.052-.757,14.021,14.021,0,0,1,5.41-2.734,8.618,8.618,0,0,0,1.5-.743,2.923,2.923,0,0,1,.907-.162,12.354,12.354,0,0,0,2.592-.167,2.043,2.043,0,0,1,.475.017c1,.385,2-.244,3-.035.52.142,1.059.191,1.585.306a13.283,13.283,0,0,0,1.773.284,39.146,39.146,0,0,1,5.339,2.672,15.132,15.132,0,0,1,5.061,5.214,9,9,0,0,0,2.07,2.738,6.054,6.054,0,0,0,.768.094.508.508,0,0,0,.443-.374c.759-2.5,2.592-4.1,4.628-5.531.294-.206.62-.377.636-.8.468-.616,1.551.005,1.863-.925.851-.586,2.094-.09,2.817-1.024,1.361-.322,2-1.567,2.882-2.432a11.084,11.084,0,0,1,3.6-2.55c1.293-.535,2.795-.388,4-1.219a.852.852,0,0,1,.964.26c.2.212.272.7.509.669.426-.058.174-.688.519-.912,1.253-2.1,1.3-4.526,1.607-6.809.527-3.856,1.468-7.63,1.974-11.482.364-2.775,1.126-5.478,1.507-8.25a1.5,1.5,0,0,1,.3-.851,2.057,2.057,0,0,0,.315-1.249.542.542,0,0,1,.594-.106c.4.629.894.607,1.449.222a.767.767,0,0,1,.783.23,1.027,1.027,0,0,1,.111.413c0,.251-.028.552.232.671.344.158.4-.182.487-.392a6.714,6.714,0,0,1,.792-1.455c.211-.283.474-.371.714,0a2.539,2.539,0,0,1-.112,2.093c-1.157,3.031-1.437,6.267-1.986,9.4-.629,3.594-2.108,7.034-2.03,10.753-.833,4.3-2.059,8.524-2.534,12.9-.124,1.143-.919,2.189-.521,3.417-.679,2.014-.4,2.16-2.763,1.5a10.471,10.471,0,0,0-9.569,1.877,7.824,7.824,0,0,0-1.4,1.612c-.247.435-.874.7-.621,1.365-.362.594-.312,1.391-.923,1.861-.942.216-1.05,1.035-1.141,1.754a4.343,4.343,0,0,1-2.946,3.6c-.952.4-1.138,1.349-1.685,2.024-.675.833-1.158,1.153-1.837.091a3.011,3.011,0,0,0-1.485-1.042c-1.348-.533-2.346-1.651-3.7-2.191a55.654,55.654,0,0,0-9.905-2.511c-.152-.031-.344-.082-.454,0-2.085,1.5-4.8.994-7.054,2.24.427-.167.777-.3,1.127-.039.125.97-.83.643-1.209,1.007l-.928.3c-1.98-.546-2.907,1.17-4.122,2.077a24.128,24.128,0,0,0-2.711,2.86c-.3.314-.9.694-.259,1.256a.961.961,0,0,1-.622.929,1.706,1.706,0,0,1-1.065-.032,15.331,15.331,0,0,0-9.641-.414c-1.485.347-2.01-.139-1.757-1.544a16.817,16.817,0,0,0,0-6.865c-.047-.2-.111-.525.052-.58,1.352-.453.174-1.036-.005-1.364a48.68,48.68,0,0,1-2.791-5.981c-.155-.817-.838-1.449-.828-2.325-.015-.3.2-.681-.007-.9-1.342-1.457-1.937-3.564-4.017-4.4a28.4,28.4,0,0,1-2.572-1.374c-1.959-1.033-3.922-.628-5.884,0-.492.217-1.048.049-1.541.26a1.958,1.958,0,0,1-2.075-.748c-.5-3.452-1.458-6.745-4.121-9.181-2.545-2.329-5.445-4.012-9.085-3.792-1.619.1-3.256-.283-4.856.468-.929.436-.908-.649-1.015-1.123a22.8,22.8,0,0,0-1.221-3.923c-3.007-7.11-8.352-11.292-15.924-12.326-2.587-.354-3.5-1.4-4.022-3.8-.584-2.674-.829-5.433-1.766-8.029a.527.527,0,0,1-.026-.674,12.908,12.908,0,0,1,2.492.684,1.705,1.705,0,0,0,1.237.6,2.468,2.468,0,0,1,2.454.954,1.6,1.6,0,0,0,1.254.923.8.8,0,0,1,.531.6c1.1,2.12,2.045,2.348,4.008.969.449-.316.866-.812,1.486-.3.325.549.617,1.216,1.255.249.365-.552.959-.483,1.523-.537,2.248-.214,4.5.3,6.742.006.141-.018.272.11.422.044a.347.347,0,0,1-.24-.475,1.256,1.256,0,0,1,1.445-.159c2.4,1.335,4.915,2.519,6.537,4.893.481,1.268,1.537,2.193,1.781,3.675.219,1.331,2.677,1.078,3.777-.353A.277.277,0,0,1-2809.3-1452.49Z",
    fill: "#d6eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63988",
    "data-name": "Path 63988",
    d: "M-2689.421-1447.54a9.07,9.07,0,0,1-.61-2.735c-.075-.328-.158-.569-.494-.666-.392-.936.438-1.382.8-2.014a4.2,4.2,0,0,0,1.256-1.872,2.471,2.471,0,0,1,.2-.387c.286-.322.537-.778,1.048-.293.215.548-.16,1.085-.027,1.635.093.387.15.783.16.852-.417-.642.164-1.726-.256-2.7.029-.59-.22-1.33.763-1.4,1.272,3.017,1.486,6.279,2.1,9.441a10.086,10.086,0,0,0,1.271,3.665c-.317,1.152.3,2.266.169,3.423-.018.156.175-.5.48-.187a1.426,1.426,0,0,1,.485,1.222,27.078,27.078,0,0,0,.915,7.751c.367,1.517,1.237,2.922.924,4.584-.039.207.223.307.454.285.556.207.933.7,1.472.93a.428.428,0,0,1-.176.645.963.963,0,0,0-.087.064.981.981,0,0,1,.254-.095c2.435-.908,4.827-.374,7.239.12,3.323.68,5.527,2.931,7.243,5.539a12.533,12.533,0,0,1,2.318,6.995c-.006.6-.183,1.246.3,1.764.159.138.318.275.485.4,1.423.586,2.988.62,4.425,1.156.63.235.915-.321,1.237-.685a16.811,16.811,0,0,1,5.751-4.709,3.4,3.4,0,0,1,1.367-.231c1.9-.022,3.691-.715,5.589-.888a17.522,17.522,0,0,1,10.757,2.234c.524.306,1.008.736,1.691.576a.849.849,0,0,1,.848.642c.58.944.973.917,1.659-.073a24.268,24.268,0,0,1,3.18-4.317,4.45,4.45,0,0,0,.873-.908,16.012,16.012,0,0,1,2.721-2.269c.412-.3.818-.662,1.4-.405.632.589.2,1.018-.25,1.385-1.737,1.422-2.405,3.457-3.08,5.456a8.983,8.983,0,0,0,1.1,7.756,7.32,7.32,0,0,0,3.508,3.4,2.693,2.693,0,0,1,1.874,1.892,1.287,1.287,0,0,1-.86,1.012,10.368,10.368,0,0,0-3.581,3.117c-.626.7-1.271.984-2.034.069a17.792,17.792,0,0,0-13.072-6.375,21.56,21.56,0,0,0-7.148.76c-.389.106-1,.07-.913.782-1.487,1.152-3.368,1.675-4.75,3.007-.516.5-1.1.092-1.55-.16-3.189-1.764-6.459-3.24-10.215-3.169-.391.007-.737-.1-.769-.56-.083-1.174-.7-2.248-.641-3.447.806-.413-.023-.99.149-1.483a1.492,1.492,0,0,0-.941-2.157c-.66-.308-1.132-1.279-1.57-1.947a3.425,3.425,0,0,0-2.63-1.495,1.286,1.286,0,0,1-.571-.328c-.449-.379-1.134-.519-1.249-1.235a1.23,1.23,0,0,1,1.214.3,16.041,16.041,0,0,0-9.835-2.355c-1.156.1-1.158.073-1.714-.926-.576.221-.138.925-.68,1.267-1.445.912-1.867.766-2.293-.947-.483-1.941-.531-3.954-1.028-5.9a2.335,2.335,0,0,0-.652-1.115,23.117,23.117,0,0,1-1.169-6.023,4.9,4.9,0,0,0-.592-1.739c-.585-1.629-.6-3.385-1.036-5a57.914,57.914,0,0,0-1.833-6.763,7.663,7.663,0,0,1-.56-2.685C-2688.626-1446.677-2688.7-1447.287-2689.421-1447.54Z",
    fill: "#d7eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63989",
    "data-name": "Path 63989",
    d: "M-2600.767-1423.436c-1.4,1.164-3.014,2.1-4.009,3.709-.594.4-.954.948-1.769-.05a5.374,5.374,0,0,0-4.1-1.872c-2.066-.117-4.156-.011-6.218-.281a.86.86,0,0,1-.631-.264c-.007-.633.512-.761.935-.981a25.183,25.183,0,0,1,6.109-1.269,2.206,2.206,0,0,0,1.726-.786c.293-.188.7-.092.768-.71a11.443,11.443,0,0,1,6.1-8.972.652.652,0,0,0,.32-.644,1.856,1.856,0,0,1,.382-1.168c.2-.141.361-.022.523.084a.941.941,0,0,0-.3-.371c-.18-.173-.346-.358-.522-.536-1.071-1.272-.936-3-1.66-4.407-.137-.266.1-.541.336-.783a2.014,2.014,0,0,0,.382-2.466,7.994,7.994,0,0,1-.029-1.76,3.925,3.925,0,0,0,.16,1.955.657.657,0,0,1,.1.586c-.233.511.127,1.544-.664,1.477-.891-.076-.8-1.057-.709-1.766.286-2.251-.095-4.608,1.061-6.725a1.276,1.276,0,0,0-.021-.9c.152-1.7,1.3-2.716,2.526-3.676.8.1,1.271-.462,1.818-.894.735-.581,1.409-1.315,2.49-1.176a1.056,1.056,0,0,0,1.4-.057,2.831,2.831,0,0,1,2.746-.532,17.907,17.907,0,0,0,4.135.23,7.7,7.7,0,0,1,3.324.437c.335.158.706.25.84-.283.537-.5.964-.1,1.287.245a1.418,1.418,0,0,0,1.633.377.866.866,0,0,1,.957.7c.07.18-.427.34-.011.559a1.6,1.6,0,0,1,.941.906c-.3.712-.879,1.388-.28,2.215a5.644,5.644,0,0,0,.785,6.176,1.172,1.172,0,0,0,1.354.629c.837-.143,1.492.592,2.181,1.027.092.058,0,.285-.111.4a.973.973,0,0,1-.616.92.839.839,0,0,1-.818.205c-1.174.05-2.1-.729-3.2-.948-.339-.068-.439-.367-.582-.65a3.564,3.564,0,0,0-5.7-.806c-2.223,2.256-2.239,5.548.595,7.49a1.982,1.982,0,0,1,1.1,1.843,1.952,1.952,0,0,1-1.221.493,3.858,3.858,0,0,1-1.674-.07c-.374-.173-.741-.365-.625-.91.242-1.141-.185-1.992-1.333-2.124-1.742-.2-3.6-.634-4.881,1.251a4.315,4.315,0,0,1-1.64,1.375,1.582,1.582,0,0,0-.9,1.284,2.492,2.492,0,0,0,2.433-1.113c1.1-1.583,2.938-1.17,4.4-1.742.413-.161.721.42.637.844-.13.653.235,1.193.265,1.8a.769.769,0,0,1-.569.536c-.087-.005-.251-.062-.254-.055-.1.19.182.239.164.413a1.6,1.6,0,0,1-.555,1.227,29.837,29.837,0,0,0-3.609,3.933c-.37.471-.673.723-.644,1.418a2.186,2.186,0,0,1-1.744,2.376,20.2,20.2,0,0,0-3.908,1.331C-2599.922-1424.449-2600.755-1424.355-2600.767-1423.436Z",
    fill: "#d6eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63990",
    "data-name": "Path 63990",
    d: "M-2616.822-1422.2c.638-.236,1.3-.737,1.825.2a.441.441,0,0,0,.422.07c1.839-1.437,3.664.447,5.6.034,1.1-.235,2.221,1.255,3.055,2.258.569.684.745-.484,1.14-.09-.861.885-.914,2.254-1.849,3.1a1.92,1.92,0,0,1-.923-1.49c0,.716.5,1.378.317,2.128-.1.414-.217.853-.7.9s-.543-.42-.587-.749a3.233,3.233,0,0,0-2.634-3,9.553,9.553,0,0,0-4.2-.3c-2.122.509-2.7,1.957-3.294,3.665a5.679,5.679,0,0,0-.266,4.161A5.74,5.74,0,0,0-2616-1408.4a7.651,7.651,0,0,1,1.805-6.533c.7-.914,1.327-.852,2.024-.143a3.941,3.941,0,0,1,.938,3.143,9.625,9.625,0,0,1-1.889,4.793,4.727,4.727,0,0,0-.566,1.556,2.2,2.2,0,0,0,.588,2.45,2.413,2.413,0,0,1-.657-2.351c.3-.7.666-1.367.957-2.069a.915.915,0,0,1,.753-.667,4.585,4.585,0,0,0,2.453-1.145.87.87,0,0,1,1.473.227c-.262-.582-.938-1.2-.551-1.437.794-.479.3-1.166.561-1.685.119-.234.224-.462.554-.362.229,3.091.273,6.223,2.129,8.932.269.393.461.959-.35.937-3.321-.093-6.2,1.407-9.2,2.487-.387-.2-.911.154-1.233-.306a6.043,6.043,0,0,0-2.533-1.848,4.347,4.347,0,0,1-2.814-2.873c-.284-.889-.958-1.687-1.338-2.64a8.492,8.492,0,0,1,.855-7.789c.355-.613-.325-.794-.218-1.281h1.125c.061-.144.151-.294.129-.313-.672-.569-.795-.847.214-1.312.585-.269,1.8-.466,1.49-1.715C-2618.871-1421.495-2617.555-1421.456-2616.822-1422.2Z",
    fill: "#d7eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63991",
    "data-name": "Path 63991",
    d: "M-2613.734-1405.516a1.418,1.418,0,0,1,.22-1.752c1.356-1.858,2.361-3.917,1.752-6.373a2.121,2.121,0,0,0-1.256-1.646c-.921-.315-.818.74-1.143,1.143-1.251,1.55-2.137,3.2-1.307,5.357.3.776-.46.852-1.072.621-1.785-.674-3.956-4.285-2.807-6.66a31.019,31.019,0,0,0,2.017-4.375c.041-.132.182-.234.276-.35,1.281,1.1,2.4-1.022,3.78-.14,1.06.675,2.69-.078,3.631,1.282.2.285.453-.417,1.052-.676-.82,1.585.951,2.4.5,3.781,1.369-1.1-.953-3.057,1.354-4.07a2.616,2.616,0,0,0,.112,2.742c0,.1,0,.2-.006.3-.707,1.026-.529,2.291-.922,3.4,0,.1,0,.2,0,.3-.567.558-.071,1.345-.368,1.869-.159.281-.792.321-.326.831a2.626,2.626,0,0,1,.54,1.779c-.528-.025-.608-.386-.679-.646-.207-.751-.544-.8-1.035-.26a3.239,3.239,0,0,1-2.409,1.177c-.483.005-.538.2-.7.569C-2612.818-1406.65-2612.862-1405.789-2613.734-1405.516Z",
    fill: "#d7eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63992",
    "data-name": "Path 63992",
    d: "M-2564.616-1450.922c-.1,0-.2,0-.307-.006-1.353-.428-2.695.335-4.048.043a1.807,1.807,0,0,1-1.428-1c-.569-1.143-1.792-1.721-2.434-2.834-.263-.454-.919.1-1.4-.024a.988.988,0,0,1-.381-.168c-.674-.5-1.436-.984-.43-1.874.272-.354.475-.936,1.019-.769,1.088.334,1.584-.3,2.116-1.043a5.4,5.4,0,0,1,1.375-1.428,1.889,1.889,0,0,0,.788-2.673c.714-1.095,1.754-.642,2.711-.577.141.053.34.1.385.221a11.631,11.631,0,0,0,2.673,3.986,5.108,5.108,0,0,1,1.3,1.529c.039.1.123.216.091.289C-2563.462-1455.206-2562.9-1452.7-2564.616-1450.922Z",
    fill: "#d7eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63993",
    "data-name": "Path 63993",
    d: "M-2576.046-1444.134l.938.005a.973.973,0,0,1-.624.924c-.475.525-.346,1.254-.623,1.846-.7.318-.607.957-.62,1.552-.944,1.111-.12,2.515-.615,3.7-.308.095-.612.5-.927.011a10.5,10.5,0,0,0-2.728-.172c-.4-.046-1.079.251-1.038-.507.031-.6.622-.366,1-.4a2.882,2.882,0,0,1,.529-.014,2.374,2.374,0,0,1-2.313-1.013c-.7-.748-1.455-1.451-2.1-2.258a3.859,3.859,0,0,1-.126-4.714,4.226,4.226,0,0,1,5-.417c.8.627,1.94,1.131,1.734,2.505-.009.062,0,.312.048.209.343-.813,1.108.23,1.434-.35C-2576.829-1443.659-2576.745-1444.23-2576.046-1444.134Z",
    fill: "#d6eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63994",
    "data-name": "Path 63994",
    d: "M-2574.6-1454.9c1.986-1.073,2.546.7,3.542,1.566.752.655.94,1.88,2.123,2.094-.071.894,1,.645,1.234,1.234a19.2,19.2,0,0,0-6.788,4.955c-.044-.423-.26-.754-.69-.54-.552.276-.863.528-.715-.423.053-.339-.627-.362-.732-.2-.835,1.3-1.075,0-1.346-.353a8.413,8.413,0,0,1-1.715-3.591,3.96,3.96,0,0,1,.866-3.245,4.95,4.95,0,0,1,3.51-3.6c.285.057.636.052.507.516-.419.535-.439.577.043.806.388.184.2.486.161.785-.935.865-1.543,1.955-2.476,2.783-.649.575-.439,2.609.235,3.467a2.056,2.056,0,0,0,2.653.472,6.037,6.037,0,0,0,1.581-.95c1.5-1.247,1.48-1.215-.059-2.38A5.6,5.6,0,0,1-2574.6-1454.9Z",
    fill: "#d6eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63995",
    "data-name": "Path 63995",
    d: "M-2576.046-1444.134c-1.052.44-.416,1.737-1.154,2.342-.665-.2-.187-.854-.53-1.172-.654.033-.647.684-.98,1.11-.114-.208-.329-.423-.285-.545.583-1.636-.634-2.35-1.657-3.013a3.818,3.818,0,0,0-3.648-.009c-1.515.634-1.8,3.124-.813,4.483.784,1.076,1.89,1.911,2.753,2.938.715.851,1.671.579,2.7.725-.827.513-1.687-.019-2.486.515,1.169.843,2.587-.16,3.633.665l-4.941-.01a2.2,2.2,0,0,1-.308-.924c-.517-1.276-1.844-1.795-2.647-2.854a5.193,5.193,0,0,1-.27-5.486,5.2,5.2,0,0,1,3.825-2.413,3.107,3.107,0,0,1,3.449,2.154c.072.424.247.459.612.445C-2577.741-1445.222-2577.089-1444.16-2576.046-1444.134Z",
    fill: "#d6eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63996",
    "data-name": "Path 63996",
    d: "M-2588.4-1435.792c-.238-.618-1.225-1.073-.374-1.943.14-.143-.056-.738-.432-.536-1.547.83-3.734.443-4.675,2.429-.018.037-.088.048-.134.071-.819.417-1.977,1.138-2.474.317-.4-.666.467-1.619,1.482-2.042a5.685,5.685,0,0,0,1.663-1.441,4.848,4.848,0,0,1,6.8.23c.584.724.88,1.353-.484,1.4.482.992,1.431.118,2.023.587a.344.344,0,0,1-.058.407c-.213.209-1.028.461.058.522l-4.326,2.469c-.427-.682.244-.889.564-1.2a15.348,15.348,0,0,1,1.354-1.011C-2587.723-1435.732-2588.145-1435.455-2588.4-1435.792Z",
    fill: "#ddf1f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63997",
    "data-name": "Path 63997",
    d: "M-2616.205-1400.573c.426.042.908-.143,1.233.306a22.033,22.033,0,0,0-5.752,4.765c-.558.674-.875.778-1.519.042a19.135,19.135,0,0,0-8.708-5.979,17.214,17.214,0,0,0-9.777-.479c-.982.267-1.976.488-2.964.731-.287-.039-.687.086-.781-.294s.237-.524.549-.6a22.459,22.459,0,0,1,3.945-.919c5.169-.294,10.185.062,14.556,3.434a19.481,19.481,0,0,1,3.267,3.008c.232.282.446.8.738.39.658-.912,2.141-1.236,2-2.719-.027-.277.107-.381.342-.318C-2617.727-1398.845-2617.125-1400.039-2616.205-1400.573Z",
    fill: "#d7eaeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63998",
    "data-name": "Path 63998",
    d: "M-2787.045-1412.621a35.561,35.561,0,0,0,2.745,5.828c.232.37,1.595,1.337-.1,1.823a.833.833,0,0,0,.028.392,11.951,11.951,0,0,1,.051,6.729c-.293,1.152.243,1.772,1.4,1.365,2.13-.75,4.343-.414,6.494-.567,1.366-.1,2.811.911,4.22,1.423-.166.857-.83.718-1.315.517a12.6,12.6,0,0,0-11.685.561,2.3,2.3,0,0,1-.586.153,1.1,1.1,0,0,1-.133-1.024,23.909,23.909,0,0,0-.182-12.572l-1.244-3.074C-2787.418-1411.618-2787.97-1412.269-2787.045-1412.621Z",
    fill: "#d7eaeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63999",
    "data-name": "Path 63999",
    d: "M-2683.243-1423.743c.542-.294,1.035-.075,1.028.45a41.468,41.468,0,0,0,.846,6.4,11.408,11.408,0,0,0,.468,1.538c.4-.638.689-1.376,1.539-.635-.4-1.348-.4-1.348,1.419-1.767-.377,1.24-.378,1.234.933,1.13a17.169,17.169,0,0,1,10.926,3.012c-.717.306-.717.306-2.345-.541-1.87-.32-3.531-1.563-5.544-1.248a13.766,13.766,0,0,0-6.15.921c-1.368.619-1.548.34-2.058-1.1a50.9,50.9,0,0,1-1.06-5.072l-.008-.614a1.771,1.771,0,0,1-.278-1.26A3.834,3.834,0,0,1-2683.243-1423.743Z",
    fill: "#d4ebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64000",
    "data-name": "Path 64000",
    d: "M-2762.328-1403.971c-.824-.176-1.455.731-2.52.458a10.445,10.445,0,0,1,5.318-2.023c.811-.1,1.765.025,2.262-.954.185-.364.644-.293.989-.25a17.518,17.518,0,0,1,5.359,1.289c1.238.58,2.665.212,4,.854,1.658.8,3.127,1.844,4.675,2.788-.1.311-.393.422-.617.6-1.12-.635-2.065-1.593-3.394-1.844a22.122,22.122,0,0,0-12.1-1.538c-.785.112-1.432.534-2.193.627C-2761.146-1403.888-2761.74-1403.555-2762.328-1403.971Z",
    fill: "#d7eaec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64001",
    "data-name": "Path 64001",
    d: "M-2683.243-1423.743c.09.311.487.625-.011.929-.962-.268-.837-1.219-.975-1.849a67.574,67.574,0,0,1-1.484-7.115q-1.584-6.537-3.163-13.076c-.213-.888-.365-1.79-.545-2.686.053-.248.157-.637.433-.407a1.716,1.716,0,0,1,.79,1.427c-.227,2.433,1.374,4.448,1.533,6.787.1,1.452.774,2.756.961,4.229a18.694,18.694,0,0,0,1.352,4.867c.617,1.45.387,3.4.875,5.076A6.107,6.107,0,0,1-2683.243-1423.743Z",
    fill: "#d8e9ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64002",
    "data-name": "Path 64002",
    d: "M-2738.593-1652.761a36.452,36.452,0,0,1,8.113-5.615c1.915-1.037,3.892-1.959,5.841-2.932.681-.405,1.467-.565,2.166-.928l.581-.03c.715-.344,1.483-.556,2.2-.9a46.887,46.887,0,0,1,5.521-1.193.9.9,0,0,1,.732.626c-.539,1.009-1.63.6-2.428.949a37.724,37.724,0,0,0-7.36,2.3c-1.866.779-3.718,1.589-5.513,2.524a6.024,6.024,0,0,0-2.2,1.15,11.874,11.874,0,0,1-1.773,1.014,8.134,8.134,0,0,0-.827.542c-.515.3-.952.717-1.443,1.055-.526.337-.91.855-1.461,1.162a3.383,3.383,0,0,0-1.277,1c-.389.429-.832.734-1.436.367C-2739.437-1652.272-2738.706-1652.356-2738.593-1652.761Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64003",
    "data-name": "Path 64003",
    d: "M-2745.668-1645.9a.917.917,0,0,1,.6-.591q1.056-1.182,2.208-2.271a1.037,1.037,0,0,1,.408-.131c.758.162,1.139.453.535,1.24a25.436,25.436,0,0,1-2.521,3.472c-.707.66-.3,1.641-.6,2.452-.324.872-1.013,1.7-.522,2.808.217.488-.266.693-.762.534a.9.9,0,0,1-.5-.349c-.757-1.237-1.768-1.237-2.916-.629a1.123,1.123,0,0,1-.249-.844,1.353,1.353,0,0,1,.309-.819,4.448,4.448,0,0,0,.971-1.082,2.718,2.718,0,0,1,.241-.332c.454-.72,1.487-.941,1.647-1.915a1.42,1.42,0,0,1,.139-.372A3.618,3.618,0,0,0-2745.668-1645.9Z",
    fill: "#e4b027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64004",
    "data-name": "Path 64004",
    d: "M-2715.372-1432.7c.226-1.862.472-3.721.663-5.586.06-.585.5-.941.656-1.5.962-3.585,1.371-7.269,2.071-10.9.275-1.426,1.374-2.671.934-4.253q-.141-.315.2-.349c.857.693.317,1.46.117,2.209a22.411,22.411,0,0,1-.9,5.694c-.806,3.843-1.483,7.706-2.19,11.564-.14.762-.737,1.377-.629,2.2-.331.282.061.923-.535,1.073A.5.5,0,0,1-2715.372-1432.7Z",
    fill: "#d8e9eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64005",
    "data-name": "Path 64005",
    d: "M-2588.4-1435.792c.659-.039,1.295-.627,2.056-.049-.936.945-2.36,1.277-2.984,2.52-1.92,1.848-3.658,3.8-4.108,6.579-.126.778-.69,1.065-1.539,1.179a13.666,13.666,0,0,0-5.791,2.127c-.24-.055-.6-.033-.7-.182-.216-.327.188-.327.359-.473,1.568-1.339,3.534-1.768,5.428-2.3a1.914,1.914,0,0,0,1.54-2.61c-.139-.593-.353-1.107.612-.774.023.008.092-.053.109-.095.926-2.215,3.359-3.179,4.4-5.3-.079-.068-.1-.137-.078-.2s.052-.1.079-.1Z",
    fill: "#d9ebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64006",
    "data-name": "Path 64006",
    d: "M-2787.045-1412.621c-.516.434-.229,1.031-.314,1.553-2.9-4.451-6.651-7.818-11.854-9.353-.486-.144-.95-.36-1.425-.543-.459-.38-1.083.059-1.545-.31.434-.51,1.025-.233,1.546-.307a3.5,3.5,0,0,1,3.047.312c1.059.489,2.115,1.374,3.143,1.492,2.148.246,2.854,2.133,4.288,3.143a8.868,8.868,0,0,1,2.187,1.849C-2787.988-1413.924-2787.113-1413.446-2787.045-1412.621Z",
    fill: "#dcedec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64007",
    "data-name": "Path 64007",
    d: "M-2563.069-1457.418c-1.076-.784-1.292-2.312-2.831-2.833-.826-.28-.316-1.869-.878-2.728.512-1.117,1.305-.632,2.06-.366a6.5,6.5,0,0,1,1.285,1.664c.605,1.109,1.285,1.145,2.219.557.111,1.532-.719,2.862-.929,4.325C-2562.689-1456.651-2562.667-1457.352-2563.069-1457.418Z",
    fill: "#d6eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64008",
    "data-name": "Path 64008",
    d: "M-2742.866-1401.2a.56.56,0,0,1,.617-.6,2.184,2.184,0,0,1,1.813,1.249c.125.288.354.732.584.385.468-.707,1.529-1.558,1.4-1.994-.35-1.163.383-.611.733-.676,1.121-.206,2.852-1.8,2.826-2.917a9.452,9.452,0,0,1,.706-2.443c.054-.246.142-.545.47-.495.386.059.392.416.433.72q-.466,2.156-.932,4.31a12.763,12.763,0,0,0-4.877,4.221c-.742.934-1.156.925-1.86.164-.414-.447-.893-.83-1.29-1.295Z",
    fill: "#d8ebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64009",
    "data-name": "Path 64009",
    d: "M-2715.372-1432.7h.309a4.1,4.1,0,0,1,0,2.475c-.619,3.3-1.3,6.593-1.826,9.909-.23,1.462-1.276,2.729-.953,4.3a.191.191,0,0,1-.312,0c-.727-1.811.425-3.476.416-5.257-.01-2.228.868-4.369,1.275-6.56C-2716.165-1429.436-2715.682-1431.065-2715.372-1432.7Z",
    fill: "#d7eaeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64010",
    "data-name": "Path 64010",
    d: "M-2718.153-1416.02h.312l-.008.619c-.332.576-.3,1.272-.609,1.857-.129.188-.329.3-.516.175-4.038-2.736-9-1.222-12.155,1.982a2.383,2.383,0,0,1-.733.392l-.193-.082c.438-1.67,1.8-2.346,3.164-3.123,3.12-1.774,6.288-1.453,9.508-.463.43.132.573-.027.6-.392A1.038,1.038,0,0,1-2718.153-1416.02Z",
    fill: "#d6e9ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64011",
    "data-name": "Path 64011",
    d: "M-2666.569-1412.929c1.085.242,2.5-.069,2.725,1.617,1.422-.126.738,2.285,2.341,1.941-.137.606,1.243.8.375,1.74-.321.348.14,1.351.11,2.049-.039.863-.392.058-.6.066l-1.231-2.475c-.9-.815-1.052-2.166-2.086-2.882a1.424,1.424,0,0,0-.991-.912C-2666.257-1412.1-2666.986-1412.193-2666.569-1412.929Z",
    fill: "#d8e9ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64012",
    "data-name": "Path 64012",
    d: "M-2771.592-1396.557c-.281.081-.546.388-.854.15-.427-.332.024-.509.18-.708a20.254,20.254,0,0,1,4.521-4.7,1.959,1.959,0,0,0,.559-.485,1.618,1.618,0,0,1,2.686-.447A19.2,19.2,0,0,0-2771.592-1396.557Z",
    fill: "#d8ebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64013",
    "data-name": "Path 64013",
    d: "M-2710.437-1457.1c-.092,1.147.631,2.22.311,3.388l-.6.63c-.138-.718.278-1.517-.318-2.168a4.62,4.62,0,0,0-1.159,1.78.718.718,0,0,1-.907.387c-.3-.109-.275-.379-.1-.621l0-.009c.161-.509-.19-1.02.006-1.53a5.246,5.246,0,0,1,1.761-2.609.926.926,0,0,1,.685-.018C-2710.482-1457.684-2710.263-1457.474-2710.437-1457.1Z",
    fill: "#d6eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64014",
    "data-name": "Path 64014",
    d: "M-2689.481-1452.8l-1.044,1.855-.135.314a6.22,6.22,0,0,1-1.2,2.174.19.19,0,0,0-.082.209c-.021.17-.113.228-.275.175a1.113,1.113,0,0,1-.419-.947,1.487,1.487,0,0,1,.279-.552,6.642,6.642,0,0,0,.8-1.6c.343-.687.688-1.374,1-2.074.457-.855.849-1.743,1.32-2.589.3-.538.632-1.061,1.331-1.148a.639.639,0,0,1,.415.186c.337.85-.658,1.151-.752,1.824l.01-.015A7.525,7.525,0,0,1-2689.481-1452.8Z",
    fill: "#d6502b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64015",
    "data-name": "Path 64015",
    d: "M-2563.069-1457.418c.479-.048.607.428.926.619-.407,1.714-.817,3.428-1.219,5.143-.163.693-.3,1.4-1.254.733.25-1.4,1.39-2.6.844-4.188-.062-.182.353-.575.6-.808A1.066,1.066,0,0,0-2563.069-1457.418Z",
    fill: "#d6e9e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64016",
    "data-name": "Path 64016",
    d: "M-2561.214-1461.124c-.525.186-.036,1.185-.789,1.089-.629-.08-1.263-.258-1.446-1.112-.153-.711-1.188-.948-1.163-1.831a1.193,1.193,0,0,1,1.67-.11c.549.52,1.245.385,1.8.709a.608.608,0,0,1-.066.64Z",
    fill: "#d6ebec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64017",
    "data-name": "Path 64017",
    d: "M-2742.561-1648.665l-.316.051c-.11.114-.205.1-.288-.031a6.176,6.176,0,0,1,2.438-2.213c.139.043.067.34.182.264.152-.1.139-.35.124-.55a4.252,4.252,0,0,1,1.828-1.617q-.294.513-.586,1.026a2.275,2.275,0,0,1-2.034,2.913C-2741.663-1648.774-2742.134-1648.921-2742.561-1648.665Z",
    fill: "#f0bc45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64018",
    "data-name": "Path 64018",
    d: "M-2567.705-1450c-.594-.228-1.621-.024-1.234-1.234,1.08.255,2.111-.231,3.183-.223.483,0,.776,0,.833.533a2.09,2.09,0,0,1-1.233.309c-.441.4-1.113.2-1.548.615Z",
    fill: "#d6e9e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64019",
    "data-name": "Path 64019",
    d: "M-2585-1435.79c-.228-.041-.634-.041-.655-.13-.114-.493.539-.435.655-.8a2.1,2.1,0,0,1,1.237-.31c.8.076.483.524.308.924Z",
    fill: "#d9ebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64020",
    "data-name": "Path 64020",
    d: "M-2802.183-1421.274c.52.076,1.112-.2,1.545.31-.858,0-1.716-.009-2.575,0-.641.006-1.08-.218-1.134-.925A3.515,3.515,0,0,0-2802.183-1421.274Z",
    fill: "#ddf1f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64021",
    "data-name": "Path 64021",
    d: "M-2743.165-1648.645l.288.031a6.018,6.018,0,0,1-2.191,2.12A5.726,5.726,0,0,1-2743.165-1648.645Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64022",
    "data-name": "Path 64022",
    d: "M-2607.553-1412.926c.092-1.193-.014-2.439.922-3.4C-2607.016-1415.216-2606.9-1413.967-2607.553-1412.926Z",
    fill: "#ddf1f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64023",
    "data-name": "Path 64023",
    d: "M-2715.062-1430.227v-2.475l.615-.926A9.446,9.446,0,0,1-2715.062-1430.227Z",
    fill: "#d6eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64024",
    "data-name": "Path 64024",
    d: "M-2760.812-1622.437l.363-.55.863-.041.342.327a.626.626,0,0,1-.309.62l-.92.31h0Z",
    fill: "#a6d8db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64025",
    "data-name": "Path 64025",
    d: "M-2577.59-1436.106c.28-1.221-.621-2.639.615-3.7C-2577.583-1438.64-2576.912-1437.261-2577.59-1436.106Z",
    fill: "#d6eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64026",
    "data-name": "Path 64026",
    d: "M-2718.458-1413.544a2.05,2.05,0,0,1,.61-1.857A2.075,2.075,0,0,1-2718.458-1413.544Z",
    fill: "#d6eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64027",
    "data-name": "Path 64027",
    d: "M-2721.566-1662.568c.641.021,1.21-.468,1.876-.265a2.925,2.925,0,0,1-2.2.567Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64028",
    "data-name": "Path 64028",
    d: "M-2567.7-1450c.313-.718.951-.614,1.548-.615C-2566.472-1449.909-2567.106-1450-2567.7-1450Z",
    fill: "#ddf1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64029",
    "data-name": "Path 64029",
    d: "M-2740.421-1651.144c.621.783-.247.851-.538,1.333-.293-.552.273-.711.232-1.047Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64030",
    "data-name": "Path 64030",
    d: "M-2576.355-1441.359c.061-.665-.236-1.451.623-1.846A2.92,2.92,0,0,1-2576.355-1441.359Z",
    fill: "#d6eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64031",
    "data-name": "Path 64031",
    d: "M-2732.364-1409.841c-.426-.544-.562-1.016.309-1.236a.729.729,0,0,1,0,.922Z",
    fill: "#d6e9ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64032",
    "data-name": "Path 64032",
    d: "M-2746.6-1644.648q.033-.289.066-.579.433-.337.866-.676A1.309,1.309,0,0,1-2746.6-1644.648Z",
    fill: "#e3ba50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64033",
    "data-name": "Path 64033",
    d: "M-2732.055-1410.155v-.922l.926-.31Z",
    fill: "#d6eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64034",
    "data-name": "Path 64034",
    d: "M-2742.561-1648.665c.541-1.041,1.888-.347,2.645-1.316.451-.578,1.082-.726.385-1.48l.352-.274a1.23,1.23,0,0,0,1.331-.731,1.392,1.392,0,0,1,1.465-.819c.332.275.609.276.786-.167a3.831,3.831,0,0,1,.458-1.061c.562-.229.823-.955,1.538-.932.887-.009.392.743.651,1.127.218-.9.916-1.317,1.81-1.685-.553.167-.91.494-1.348.582-.5.1-.815-.05-.492-.638l1.853-.933c.9-.579,1.484.382,2.324.446-.794-.51-.829-1.075-.158-1.674a24.9,24.9,0,0,1,5.552-2.475,30.778,30.778,0,0,0,4.409-1.228c.984-.472,2.057-.713,3.014-1.242.778-.384,1.727-.083,2.468-.616a11,11,0,0,1,5.057-.7c3.814.346,7.639.453,11.464.576.817.027,1.637-.028,2.453.026.556.038,1.215.046,1.262.81.049.782-.662.6-1.1.739-.147.047-.3.083-.443.118-.557.1-1.127.057-1.687.118-.4.044-.98.026-1,.513-.018.581.6.438.958.441a11.029,11.029,0,0,1,2.74.366c.56.146,1.154.369,1,1.113-.145.723-.733.692-1.34.68-1.349-.026-2.567-.769-3.932-.665a4.2,4.2,0,0,1-1.946-.312,2.735,2.735,0,0,0-1.848-.289c-1.855.435-3.75.148-5.614.315-1.631.146-3.361-.078-4.838.921a.952.952,0,0,1-1.036.35c-.816-.733-1.644-.215-2.415.05a28.317,28.317,0,0,0-3.692,1.869,13.335,13.335,0,0,0-1.658,1.255,12.382,12.382,0,0,0-5.341,5.5c-.332.7-.65,1.42-.067,2.159a2.554,2.554,0,0,1-.069,1.812c-.7.537-.56-.155-.708-.452.513,1.876.748,3.9,2.682,5.029a1.665,1.665,0,0,1,.316.344c1.464,1.922,3.635,2.775,5.723,3.709,3.075,1.377,6.372,1.654,9.692,2.021a50.772,50.772,0,0,1,7.366,1.349c2.653.7,5.427.935,7.979,2.045,2.94,1.022,5.731,2.4,8.6,3.593.959.4.934.457.24.948a3.483,3.483,0,0,1,3.033.967,50.763,50.763,0,0,1,5.762,4.505,4.467,4.467,0,0,1,.915,1.214c.282.4.587.727,1.133.424a.79.79,0,0,1,.714.906c-.235,1.1.79,1.52,1.224,2.258a26.117,26.117,0,0,1,1.326,2.461c.573,2.567,2.4,4.614,2.981,7.181.089.4.433.858.281,1.167-.636,1.3.47.995,1.026,1.206a1.6,1.6,0,0,1,.518,1.88c-.639,1.106-.158,2.28.118,3.269a44.844,44.844,0,0,1,1.291,8.313,33.9,33.9,0,0,1-.654,11.45,18.341,18.341,0,0,0-.669,3.128c0,.046-.049.089-.074.133a.216.216,0,0,0,.279-.078c.592-.234.1,1.032.832.587a15.187,15.187,0,0,0,1.711-3.424c1.571-3.264,3.284-6.461,4.711-9.794a3.94,3.94,0,0,0,.39-1,19.541,19.541,0,0,1,1-1.752,75.774,75.774,0,0,0,2.886-9.019,3.116,3.116,0,0,1,.726-1.82c.841-.12,1.3-.877,2.131-1.33-.507-.135-1.008.619-1.331,0-.3-.574.206-.9.422-1.351a8.365,8.365,0,0,0,.644-4.149c-.027-.466-.456-.483-.764-.632a3.409,3.409,0,0,1-.536-2.179,3.712,3.712,0,0,0-.788-2.418,1.281,1.281,0,0,1-.345-.571,1.494,1.494,0,0,1,.024-.675c.8-1.363-.021-2.612-.345-3.856a57.061,57.061,0,0,0-3.712-10.413c-1.291-1.775-1.9-3.94-3.266-5.673.04-.821-.638-1.223-1.047-1.779a76.592,76.592,0,0,0-4.813-6.1,1.669,1.669,0,0,0-1.163-.631.9.9,0,0,1-.708-.729c-.033-.811-.687-1.217-1.159-1.728a32.78,32.78,0,0,0-9.347-6.5c-.157-.133-.013.085-.129-.081-.662-.946-1.348-1.793-2.718-1.563a.626.626,0,0,1-.711-.632c.036-.354.456-.341.783-.495a6,6,0,0,0-1.482-.771c.459.233.489.511.246.833a.816.816,0,0,1-1.075.34,8.536,8.536,0,0,0-3.838-.818c-.876-.727-2.063-.58-3.021-1.073-.523-.269-1.36-.38-1.2-1.166s.954-.611,1.554-.646c.256-.015.513-.012.77-.023.173.112.127-.273.041-.085-.023.048-.066.024-.153,0a.49.49,0,0,1-.417-.548c.517-.445.991-.995,1.795-.737.469-.155-.434.965.437.466a1.267,1.267,0,0,1,.753-.053c.473.05.974.16,1.082.682.121.585-.35.768-.814.907.929-.292,1.713-1.1,2.48-.842-.541-.068-1.562.173-1.83-1.083a.612.612,0,0,1,.23-.4c1.3-.517,2.314.285,3.4.736.983,1.309,2.668,1.81,3.633,3.168.251.354.773.175,1.063-.179a.962.962,0,0,1,1.238-.207,31.434,31.434,0,0,0,3.33,1.7c.949.994,2.467,1.316,3.133,2.646.015.4-.261.668-.456.972-1.574.405-2.142-1.029-3.114-1.719-.152-.108-.187-.361-.441-.4,1.188,1.405,2.869,2.278,4.13,4,0-.942-1.064-1.153-.575-1.9.237-.282.451-.6.886-.578,1.151.343,1.838,1.4,2.9,1.881a15.668,15.668,0,0,1,1.593,1.425,2.684,2.684,0,0,1,.4.746c-.264,1.481-.264,1.481,1.681,1.556,1.593,1.5,3.3,2.906,4.114,5.046.007.324-.494.539-.225.889.06.077.291-.19.468-.264.727.011,1.063.565,1.416,1.056a36.285,36.285,0,0,1,4.094,7.355,2.875,2.875,0,0,1,.247.352,16.487,16.487,0,0,0,1.014,1.872,24.009,24.009,0,0,1,1.535,4.167c.286.977.642,1.931.948,2.9l.278.324a31.233,31.233,0,0,1,1.861,10.185c-.484,1.642.08,3.362-.367,5a.639.639,0,0,1-.329.325c-1.047-.429-.229-1.383-.611-1.808a16.975,16.975,0,0,1-.1,3.259c-.494,1.181-.877,2.261-.069,3.578.845,1.377.219,3.266-1.188,4.682-1.2.21-.859,1.155-.909,1.913a1.581,1.581,0,0,0,.183,1.159c.427,1.121.1,1.469-1.177,1.35-.052.709.425,1.233.655,1.847a.748.748,0,0,1-.647.783c-.745-.079-1.407-.056-1.17,1.005a3.618,3.618,0,0,1-.318,1.953c-.415,1.274-1.119,1.6-2.322,1.019-.39-.187-.82-.515-1.033,0-.285.689.379.5.722.552,1.226.182,1.286,1.324,1.767,2.123a3.569,3.569,0,0,1-.139,1.339c-1.3,3.393-3.283,6.425-5.012,9.593a.826.826,0,0,1-.861.509c-.487-1.593.764-2.625,1.316-3.862.326-.73.827-1.406,1.187-2.142.672-1.374.668-1.376-.841-1.486a1.808,1.808,0,0,1,.238,2.478,1.917,1.917,0,0,1-2.33.976c-.367-.9.211-1.633.341-2.2-.064.627-1.028,1.275-.584,2.292a1.754,1.754,0,0,1,.584,2.481c-.226.442-.531,1.03.107,1.473a.731.731,0,0,1,.082.625,28.953,28.953,0,0,1-2.36,4.156,2.273,2.273,0,0,1-.946.54c-1.088-.173-1.331-1.367-2.163-1.715a2.468,2.468,0,0,1,.627,1.662c-.15.477-.135,1.068-.81,1.185-.486-.293-.623-.831-.928-1.273.254.792-.213,1.7.436,2.423a2.923,2.923,0,0,1,.91,1.943c0,.155.024.35-.07.45-1.2,1.284-1.378,3.049-2.151,4.533-.224.429-.445.824-1.021.774-.933-.324-1.047-1.316-1.683-1.923.265.691.518,1.389.791,2.078.332.839-.36,1.541-.263,2.376.068.586-.113,1.289-1.052.99-.367-.274-.3-.838-.735-1.111a2.686,2.686,0,0,0,.265,2.039,1.206,1.206,0,0,1-.562,1.281c-.736.019-.316.466-.207.691a1.817,1.817,0,0,1-.054,2.1,1.925,1.925,0,0,1-.489.415c-1.557.98-1.83,1.548-1.508,3.147a1.235,1.235,0,0,0-.239,1.125c-.067.494-.084,1.017-.7,1.182-.67-.109-.5-1.167-1.294-1.133a2.327,2.327,0,0,0-.044,2.064c.157.486.413.941.17,1.468a2.571,2.571,0,0,1-.838.8,3.748,3.748,0,0,1-3.547,1.229,42.9,42.9,0,0,0-5.5-.054c-1.314.026-2.175-.407-2.372-1.794a35.635,35.635,0,0,1,.529-9.426c.063-.885.016-1.772.06-2.657a22.779,22.779,0,0,1,.478-2.405c-.092-.584.649.192.6-.376-.059-.744.016-1.549.8-1.824.9-.318,1.147.643,1.628,1.12.11.109.23.208.623.053-.584-1.6-2.026-2.658-2.682-4.174a1.091,1.091,0,0,1,.058-.649,4.49,4.49,0,0,0,.967-2.527c.087-.393.167-.853.683-.9.534-.051.621.44.819.781.736,1.267.2,2.866.978,3.761-.568-1.877-.831-4.189-1.611-6.06.048-.526-.217-.472-.011-.468.01,0,.017.046,0,.135-.075.484.276,1.242-.727,1.132a1.527,1.527,0,0,1-.541-.954,1.6,1.6,0,0,1,.285-1.25,1.361,1.361,0,0,1,.29-.273,1.175,1.175,0,0,0,.611-.867,1.6,1.6,0,0,1,.168-.341,4.173,4.173,0,0,0,.853-1.493,1.984,1.984,0,0,1,.672-.779,10.428,10.428,0,0,0,2.172-2.121,1.278,1.278,0,0,0,.377-1.406,4.569,4.569,0,0,1-.015-2.557c.431-2.787,2.048-5.137,2.854-7.784.458-.76.388-1.787,1.188-2.376.783-.216.893-.879,1.01-1.537a1.594,1.594,0,0,1,.189-.361c.449-.857,1.409-1.551.853-2.724.339-1.659,1.627-2.966,1.738-4.708.513-.818,1.236-1.625.1-2.511-.853-.992-1.831-.6-2.8-.251a1.51,1.51,0,0,1-.4.07c-1.118.628-.718,1.732-.838,2.672-.1.405-.311.675-.78.612a1.014,1.014,0,0,1-.313-.575c-.067-.351-.1-.709-.2-1.055-.122-.544-.724-1.029-.148-1.695-.912.586-1.57,1.747-2.818,1.064-.547-.3-.129-.77.13-1.174a6.725,6.725,0,0,1-2.485,1.109c-.76-.148-1.492.332-2.257.1-.26-.645.14-.931.726-1.222-.827.174-1.271.785-1.88,1.116-.815.443-1.544.577-2.018-.472-.057-.126.006-.527-.294-.326-.141.095-.011.488-.2.7a1.118,1.118,0,0,1-.842.147c-1.672.2-3.37-.033-5.031.325-.489.127-1,.122-1.484.287-.489.123-.987.21-1.469.361-1.35.043-1.576,1.559-2.62,2-.764.134-1-.482-1.349-.942a2.127,2.127,0,0,0-1.709-1.356,1.639,1.639,0,0,1-.383-.187.771.771,0,0,1-.3-.711c-.014-.07.228-.277-.007-.2-.294.1-.512.415-.857.489a19.462,19.462,0,0,1-2.906.105,6.955,6.955,0,0,1-1.662-.068c-.483-.731-.928-1.418-2.012-.783a2.279,2.279,0,0,1-1.913-.133,4.141,4.141,0,0,0-3.377.094c-.545.226-1.21.212-1.583.788a.776.776,0,0,1-.388.135,1.772,1.772,0,0,1-.972-.351c-.225-.553-.855-.325-1.211-.623-.224-.243.058-.417.088-.626-.107.179-.322.222-.456.372a1.454,1.454,0,0,0-.382.792,2.75,2.75,0,0,1-.288.759c-.167.3-.254.658-.591.838-.542-.078-.6-.545-.749-.936a.955.955,0,0,1,.058-.621c.1-.148.411-.239.3-.425-.084-.14-.1.181-.231.194a1.337,1.337,0,0,1-.568.2,2.149,2.149,0,0,1-.84-.074c-.667-.2-.627-1.513-1.7-1.077a1.107,1.107,0,0,1-.962-.759,1.786,1.786,0,0,0-.471-1.069,4.449,4.449,0,0,1-1.4,1.042c-.436.262-.911.61-.919,1.159a2.887,2.887,0,0,1-.774,2.509c-.279.238.5,1.849.9,1.851,1.365.008,1.259.944,1.142,1.8a18.685,18.685,0,0,1-.622,2.235c1.5-1.2,2.045-.8,2.845,2.037.092-.373-.327-.762.06-1.1,1.266.15.817,1.494,1.455,2.082a4.184,4.184,0,0,1,.259,1.332,3.156,3.156,0,0,1-.086.6,3.5,3.5,0,0,0,.816,3.079c.328.367.26.894.511,1.254.235.334.188-.16.321-.207.582-.313.775.4,1.219.454a.721.721,0,0,1,.317.718c-.338,1.222.412,2.046,1.068,2.9a1.433,1.433,0,0,1,.208.359,3.782,3.782,0,0,0,.659,2.68,11,11,0,0,1,1.13,3.276,2.477,2.477,0,0,1-.433,1.268c-.419.82-.443,1.525.608,1.912.526.2.626.721.826,1.193a3.05,3.05,0,0,0,1.184,1.536,1.887,1.887,0,0,1,.648,1.625c-.43,1.23.218,2.339.4,3.5a5.185,5.185,0,0,0,.311,1.973,35.3,35.3,0,0,1-.564,3.491c-.353,1.385.224,2.763.468,4.091a68.632,68.632,0,0,1,.713,8.739,3.306,3.306,0,0,0,.492,1.892,1.1,1.1,0,0,1-.233,1.636,2.075,2.075,0,0,1-1.3.376c-3.579-.009-7.158.113-10.734-.061a2.755,2.755,0,0,1-1.361-1.568,2.328,2.328,0,0,0-.365-2.069c-.651-.794.012-1.827.433-2.683a4.042,4.042,0,0,0-1.78.118,1.036,1.036,0,0,1-.337-.905c.5-.61.312-1.523.931-2.084-.658.543-.431,1.468-.927,2.081a.316.316,0,0,1-.233-.066,2.971,2.971,0,0,1-.843-2.231.534.534,0,0,1,.2-.218c.121-.076.283-.106.315-.281-.226-.021-.187.276-.375.311-1.06-.89-.949-2.31-1.553-3.405a.605.605,0,0,1,.019-.411c.259-1.129.141-1.422-.75-1.854-.048.032-.1.06-.143.088a20.881,20.881,0,0,1-1.907-4.009c1.137-.02,1.07,1.168,1.713,1.756.645-.77,1.425-1.432.591-2.509-.364-1.4.581-2.629.479-4.041-.15-2.065-.036-2.07-1.995-2.718a8.922,8.922,0,0,0-2.565-.85c-.143,1.038,1.1,1.83.26,2.816-.811.122-.856-.679-1.262-1.033a17.4,17.4,0,0,0,1.154,2.072,4.58,4.58,0,0,1,.631,1.747.5.5,0,0,1-.238.324,31.986,31.986,0,0,1-3.046-5.291l.005.005c-.689-.3-.667-1.15-1.2-1.571a7.54,7.54,0,0,1-1.367-2.673.37.37,0,0,1,.572-.044c.117.082.237.162.359.237a2.99,2.99,0,0,1,.747,1.128c.233.485.564.515.989.288.452-.18.661.435,1.157.332a11.084,11.084,0,0,0,.1-2.095c-.551.042-.628.562-.979.736a2,2,0,0,1-.363.225c-.919.4-1-1.107-1.87-.818a3.775,3.775,0,0,1-.671-1.3c0,.381.453.755.1,1.2-.667.252-.823-.4-1.189-.673a3.492,3.492,0,0,1-.976-1.855.451.451,0,0,0-.042-.24,46.861,46.861,0,0,1-4.166-7.222.42.42,0,0,1,.3-.286c1.456.882,2.1,2.415,2.975,3.755.329.5.415,1.195,1.1,1.392a.587.587,0,0,0,.732-.418,2.006,2.006,0,0,0-.548-1.848c-.528-.682-1.34-1.212-.681-2.261-.263.283-.4.6-.619.861s-.473.593-.888.487a.858.858,0,0,1-.637-.948,4.259,4.259,0,0,0-.661-2.643c-.5-.9-1.281-1.69-1.093-2.851a1.793,1.793,0,0,0,.021-2.132c-.553-.9-.729-2.02-1.646-2.857a1.821,1.821,0,0,1,.469,1.871c-.269.544-.411,1.2-1.149,1.339-.553-.1-.728-.541-.885-1,.081-1.515-.789-2.607-1.656-3.7-.491-.308.205-1.324-.794-1.331a.19.19,0,0,1-.082-.224c-.27-.856-.053-1.876-.858-2.553a3.17,3.17,0,0,1-.663-2.145l.2-.063a.678.678,0,0,1,.429.583c.309-.619.634-1.184.223-1.915a.937.937,0,0,1,.4-1.438c.788-.313,1.068.388,1.367.911.262.458.124,1.011.275,1.468a5.026,5.026,0,0,0-.643-2.416c-.378-.61.066-1.01.452-1.462s.979-1.116-.365-1.14c-.471-.008-.663-.448-.645-.9.044-1.139-.56-.955-1.123-.491-1.181.974-1.792.618-2.075-1.074a8.186,8.186,0,0,1,.186-3.814c-.123.326-.058.833-.631.708a.656.656,0,0,1-.465-.856c.242-.956.34-1.942.571-2.887a4.542,4.542,0,0,0,.2-1.643c-.272-2.132.327-4.177.614-6.246a6.271,6.271,0,0,1,1.4-3.155c.623-.775-.079-2.2.457-3.359.442-.959.826-1.194,1.881-.539a6.788,6.788,0,0,1-.911-2.72c.181-2.073,1.465-3.7,2.259-5.523.31-.711.744-.558,1.156-.137a1.267,1.267,0,0,1-.063-1.824c.431-.509.438-1.4,1.351-1.47,1.808-2.429,2.538.413,3.855.9.093-.86-.71-1.058-.9-1.646.564.029.742-.093.85-.784.427-2.722,2.152-4.843,3.64-7.056.115-.171.546-.182.218-.5C-2742.128-1648.588-2742.37-1648.6-2742.561-1648.665Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64035",
    "data-name": "Path 64035",
    d: "M-2790.135-1604.471a8.85,8.85,0,0,1,3,7.537c-.421,3.132-1.28,6.3-4.185,8.309a3.454,3.454,0,0,0-.6.474c-1.1,1.2-2.325,1.739-3.917.917a2.1,2.1,0,0,0-1.922-.214l1.546.839c-1.319.9-4.271.892-6.118.068a12.937,12.937,0,0,1-4.483-3.408.492.492,0,0,1-.113-.6,30.843,30.843,0,0,0,3.975-3.817c.537-.233.822-.752,1.251-1.108,1.431-1.064,2.431-2.65,4.12-3.4.474.047.685.222.67.784a7.533,7.533,0,0,1-1.706,4.921,2.916,2.916,0,0,0-.78,2.917c.248.55.3,1.2.829,1.607-.58-.443-.535-1.206-.927-1.745a3.619,3.619,0,0,1,2.343-3.629c3.322-1.58,4.2-4,3.177-7.6a1.025,1.025,0,0,1,.025-.447,15.471,15.471,0,0,1,2.864-2.372A.684.684,0,0,1-2790.135-1604.471Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64036",
    "data-name": "Path 64036",
    d: "M-2753.992-1630.423a3.252,3.252,0,0,0,.713,1.977c.344.426.419,1.136.062,1.422-.588.471-.636-.284-.857-.622s-.748-.259-.7-.03c.182.893-.927,1.358-.6,2.307.3.87.483,1.832-.656,2.408-.218.11-.348.5-.413.788a29.235,29.235,0,0,0-.978,7.517c.024.717.488,1.655-.525,2.164.777,1.108-.651,2.076-.263,3.223.756-.061.321-.784.739-1.1.275,1.949-.281,3.909.6,5.784a7.34,7.34,0,0,0,1.284-.775,1.1,1.1,0,0,1,1.4-.116c.727.355.231.724.034,1.1a.465.465,0,0,0,.226.647.366.366,0,0,0,.527-.137.891.891,0,0,1,.857-.472c-.192.968.446,2.148-1.021,2.615a.3.3,0,0,0-.164.495c.9.873.386,2.184,1,3.139.186.288.5.69-.025.87-.432.149-.6-.333-.7-.657-.232-.82-.107-1.744-.78-2.43-.181-.184-.315-.456-.608-.267-.152.1-.359.419-.325.46.985,1.19-.126,2.459.242,4.024l-.9-1.305a.664.664,0,0,0-.015-.8c-.095-.15-.176.141-.291.193l-.047.033a29.914,29.914,0,0,1-1.8-6.292c-.276-1.13-.459-2.329-.78-3.421-.791-2.688-.18-5.3-.023-7.939.167-2.82,1.079-5.518,1.333-8.324q.468-1.077.935-2.155a18.937,18.937,0,0,0,.623-1.945.16.16,0,0,1,.051-.213c.418-.386.359-1.015.723-1.429C-2754.774-1629.992-2754.657-1630.623-2753.992-1630.423Z",
    fill: "#e5b028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64037",
    "data-name": "Path 64037",
    d: "M-2738.233-1474.408a2.861,2.861,0,0,0,3.178,1.826,3.234,3.234,0,0,0,2.508-3.068c.025-.249-.1-.561.006-.746.307-.523.7-1.23,1.295-1.163.553.064.6.775.621,1.388a4.924,4.924,0,0,1-2.366,4.752,4.646,4.646,0,0,1-4.693.23c-2.775-1.54-3.479-4.636-1.686-7.684,1.1-1.866,4.676-2.243,6.793-.749.847.6.935,1.063.274,1.987-1.072,1.5-2.673,2.378-3.849,3.735-.9,1.036-1.283-.731-2.082-.508.05-.954.984-1.207,1.456-1.827.451-.592,1.16-.973,1.524-1.706C-2737.262-1478.258-2738.6-1476.612-2738.233-1474.408Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64038",
    "data-name": "Path 64038",
    d: "M-2745.03-1465.758c.8,1.371,1.976.905,3.086.61,1.238-.329,1.478-1.435,1.753-2.467.072-.272-.125-.626-.033-.883.208-.581.516-1.277,1.228-1.19.667.082.684.867.72,1.375.168,2.326-1.847,4.648-4.468,5.249a5.064,5.064,0,0,1-4.549-2.293,5.242,5.242,0,0,1,1.283-6.614c1.678-1.485,4.98-1,6.382.836.394.517.253.613-.116.913-1.42,1.156-2.275,2.84-3.761,3.965a2.358,2.358,0,0,1-1.524.5,1.647,1.647,0,0,1,.229-2.423,19.259,19.259,0,0,0,2.067-2.274,2,2,0,0,0-2.342.754c-.55.706-1.272,1.427-.717,2.458A6.761,6.761,0,0,0-2745.03-1465.758Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64039",
    "data-name": "Path 64039",
    d: "M-2771.291-1442.8a3.663,3.663,0,0,0,1.263,2.381c.759.821,1.525,1.641,2.347,2.4.382.353.478.639.167,1.038-.341.439-.9.834-1.314.452-1.575-1.468-3.264-2.879-4.022-5.005a4.435,4.435,0,0,1,1.108-4.792,4.53,4.53,0,0,1,5.626-.908,11.819,11.819,0,0,1,3.924,3.6c.462.615.341.973-.184,1.383s-.864.256-1.295-.2a14.66,14.66,0,0,0-3.285-3.079C-2769.1-1446.763-2771.337-1444.717-2771.291-1442.8Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64040",
    "data-name": "Path 64040",
    d: "M-2782.256-1435.468c2.062-1.763,3.081-4.861,6.653-4.673a4.646,4.646,0,0,1,4.122,6.68,8.1,8.1,0,0,1-2.352,3.148c-.341.26-.692.57-1.061.15-.295-.336-.56-.746-.181-1.24q.832-1.088,1.612-2.215a2.872,2.872,0,0,0-.545-4.165,2.912,2.912,0,0,0-3.527.009,8.2,8.2,0,0,0-1.309,1.055C-2780.147-1435.431-2780.137-1435.42-2782.256-1435.468Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64041",
    "data-name": "Path 64041",
    d: "M-2759.859-1457.108a1.612,1.612,0,0,1-.628,2.1,9.657,9.657,0,0,0-2.985,3.609,2.288,2.288,0,0,0,.411,2.684,3.271,3.271,0,0,0,3,1.141c1.369-.153,1.927-1.412,3.02-1.9.672,1.755.35,2.505-1.328,3.153-2.781,1.074-4.609.819-5.866-.818-1.949-2.539-1.821-4.5.43-6.857.855-.9,1.284-2.154,2.481-2.783a2.945,2.945,0,0,1,1.463-.329Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64042",
    "data-name": "Path 64042",
    d: "M-2794.481-1524.458c-.238.054-.559.231-.7.137-.31-.209-.168-.534.026-.8,1.727-2.369,3.625-4.461,6.929-4.284.368.019.827-.022.839-.473.028-1.131,1.154-1.725,1.3-2.871.05-.4,1.282-.782,2.022-.93,2.06-.412,4.151-.76,6.053.6.43.307.694.119,1.012-.258,1.714-2.026,3.971-2.426,6.5-2.281a4.928,4.928,0,0,1,3.144,1.338c.961.92,2.234,1.771,2.277,3.413.021.808.641.959,1.35.744a4.076,4.076,0,0,1,3.565.752c.288.191.227.413-.031.6a21.66,21.66,0,0,0-4.378-.182c-.763.061-1.094-.455-1.3-1.059a7,7,0,0,0-1.578-2.579,5.865,5.865,0,0,0-8.741-.029c-.885.951-1.529,1.2-2.724.43a4.821,4.821,0,0,0-5.987.481c-1.109.734-1.436,2.028-2.167,3.033a2.8,2.8,0,0,1-1.327.309,6.824,6.824,0,0,0-5.3,3.228A1.21,1.21,0,0,1-2794.481-1524.458Z",
    fill: "#a4d5e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64043",
    "data-name": "Path 64043",
    d: "M-2846.678-1467.615a1.069,1.069,0,0,1,0-.282c-.363-.583.1-1.3-.3-1.875h0c-.4-.786.124-1.69-.312-2.472l0,0c-.414-1,.138-2.1-.308-3.1a1.225,1.225,0,0,1,0-.29,38.426,38.426,0,0,1-.459-7.939,2.987,2.987,0,0,0-.155-1.657c-.237-2.8.012-5.595-.01-8.393a109.9,109.9,0,0,1,1.892-20.013c.7,1.609.209,3.226-.052,4.81-.416,2.523-.6,5.079-.82,7.608a130.721,130.721,0,0,0-.253,19.228,148.066,148.066,0,0,0,1.719,16.225c-.165.156-.247.472-.581.3l-.049-.585C-2846.714-1466.521-2846.284-1467.149-2846.678-1467.615Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64044",
    "data-name": "Path 64044",
    d: "M-2766.97-1566.137c1.348.35,2.159,1.477,3.063,2.423a53.76,53.76,0,0,0,3.831,3.809,47.222,47.222,0,0,1,3.554,3.535c2.191,2.322,4.506,4.522,6.747,6.789a62.637,62.637,0,0,1,4.932,5.016c.6.763,1.393,1.372,2.027,2.112.3.356,1.292.433.894.991-.522.732-.986-.169-1.31-.487-2.871-2.83-5.7-5.709-8.543-8.563q-3.681-3.688-7.386-7.355c-1.038-1.025-2.114-2.011-3.171-3.017-.074-.07-.139-.229-.2-.223-1.565.145-1.25-1.512-2.039-2.129-.979-.764-1.863-1.649-2.787-2.481Z",
    fill: "#a9e0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64045",
    "data-name": "Path 64045",
    d: "M-2722.787-1425.285l-.922-.291c-1.005.347-1.99.91-3.086.292-.7-.162-.42-.392-.035-.6a5.19,5.19,0,0,1,3.319-.278c1.6.219,2.01-.514,2.312-1.88.561-2.541.79-5.122,1.191-7.681s.918-5.075,1.4-7.6c.313-1.656.353-3.341.755-4.978.365-1.492,1.237-2.866,1.064-4.492-.008-.077.317-.19.487-.286-.405,4.109-1.271,8.146-1.956,12.211-.768,4.563-1.549,9.123-2.405,13.67-.135.716.164,1.892-1.186,1.946A.671.671,0,0,1-2722.787-1425.285Z",
    fill: "#a5d8e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64046",
    "data-name": "Path 64046",
    d: "M-2794.481-1524.458c1.459-3.18,4.067-4.4,7.419-4.339l.072.21c-.136.5-.512.587-1.1.552.433.07.836-.1.986.233.13.29-.17.438-.417.524a6,6,0,0,1-1.529.159,4.544,4.544,0,0,0-3.434,1.481c-.227.314-.323.619.05.9a57.613,57.613,0,0,0,13.337.235,10.888,10.888,0,0,1,2.609.035,8.8,8.8,0,0,0,2.9.184c4.043-.023,8.085.092,12.124-.06a6.516,6.516,0,0,1,1.955.067c.6-.006,1.23.1,1.664-.48a.347.347,0,0,1,.433-.008c.259,1.327-.629,1.227-1.488,1.226q-10.627-.012-21.255-.006H-2793.1C-2793.758-1523.542-2794.515-1523.406-2794.481-1524.458Z",
    fill: "#edfcfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64047",
    "data-name": "Path 64047",
    d: "M-2833.075-1459.888c-.717.006-1,.664-1.493.995a2.411,2.411,0,0,1-2.706.347,2.145,2.145,0,0,1-1.355-1.962.94.94,0,0,1,1.092.359c.8.958,1.468.594,2.359.054s1.769-1.451,3.032-1.041a5.422,5.422,0,0,0,1.866-.6c1.5-.958,3.171-.632,4.776-.555a10.078,10.078,0,0,1,3.566.862,13.443,13.443,0,0,1,5.256,3.1c.423.361.635.911,1.1,1.232a1.2,1.2,0,0,1,.542.849.872.872,0,0,1-.432.68c-2.157-2.3-4.442-4.4-7.722-4.944a3.39,3.39,0,0,1-1.662-.044,14.389,14.389,0,0,0-6.894.618A1.648,1.648,0,0,1-2833.075-1459.888Z",
    fill: "#d3f2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64048",
    "data-name": "Path 64048",
    d: "M-2750.852-1466.906c.559.272.983.836.726,1.333-1.553,2.995.844,4.343,2.416,6.04.277.3.631.529.894.839.451.53.095.923-.266,1.33-.39.44-.707.475-1.128.021-1.17-1.261-2.423-2.448-3.54-3.753a5.131,5.131,0,0,1-.174-4.963A1.645,1.645,0,0,1-2750.852-1466.906Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64049",
    "data-name": "Path 64049",
    d: "M-2732.367-1517.974c1.069-.859,1.174-1.612-.1-2.44-1.489-.968-1.03-2.705-1.427-4.1,1.1-.251.414-1.887,1.795-2.124,1.122-.194.866-1.021.1-1.648a4,4,0,0,1-.043-6.543c.88-.742.467-1.7.638-2.567.063-.323-.561-1.2.552-.944.913,1.768.633,3.632-.673,4.494-.189.139-.375.287-.568.419-.892,1.031-.465,2.191-.315,3.318.62.739,1.957.584,2.216,1.773a5.283,5.283,0,0,1,.1,1.156,2.247,2.247,0,0,1-.259,1.153c-.361.455-.98.34-1.411.639-.706.482-.447,1.226-.508,1.882a4.832,4.832,0,0,0,.157,1.825,1.615,1.615,0,0,0,.442.419c.546.22,1.239.206,1.465.928a4.264,4.264,0,0,1-.043,2.222,1.253,1.253,0,0,1-.95.741,1.5,1.5,0,0,1-.725-.067A.716.716,0,0,1-2732.367-1517.974Z",
    fill: "#b6e4ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64050",
    "data-name": "Path 64050",
    d: "M-2756.178-1448.654a2.249,2.249,0,0,0-.728-2.1c-.932-1.013-1.891-2-2.852-2.989-.26-.267-.8-.413-.247-.9.382-.34.834-.911,1.3-.435,1.58,1.631,3.725,2.825,4.314,5.261a5.977,5.977,0,0,1-.5,3.736c-.159.384-.3,1.074-1.062.6-.5-.305-.982-.484-.63-1.26A3.06,3.06,0,0,0-2756.178-1448.654Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64051",
    "data-name": "Path 64051",
    d: "M-2774.81-1427c-1.881-1.05-2.949-2.812-4.466-4.088-1.053-.886-2-1.9-2.986-2.866-.175-.172-.407-.358-.288-.653s.421-.238.666-.251c1.137-.058,2.179-.078,2.946,1.1.915,1.408,2.367,2.369,3.416,3.7A3.156,3.156,0,0,1-2774.81-1427Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64052",
    "data-name": "Path 64052",
    d: "M-2744.731-1410.467l-.6-.318c-.8-.58-.9-1.585-1.407-2.351a21.034,21.034,0,0,0-9.788-7.9,6.767,6.767,0,0,1-1.092-.567,6.741,6.741,0,0,0-2.568-.641.75.75,0,0,1-.358-.3c.083-.463.334-.494.686-.27,3.535.071,6.4,1.811,9.146,3.764a17.457,17.457,0,0,1,5.255,6.1c.564,1.047,1.1-.135,1.19-.421.439-1.411,1.649-2.183,2.493-3.247.423-.534.976-.973,1.685-.335a.592.592,0,0,1-.15.423A16.126,16.126,0,0,0-2744.731-1410.467Z",
    fill: "#a7d8e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64053",
    "data-name": "Path 64053",
    d: "M-2789.516-1426.214l-.032-.312a2.634,2.634,0,0,1,1.276-2.78c.77.889-.146,1.49-.4,2.31a20.807,20.807,0,0,1,7.272,3.769,14.931,14.931,0,0,1,3.537,4.163c.527,1.011.832.767,1.406.138a5.072,5.072,0,0,1,1.211-.927c.427-.249.5.121.563.437-.486,1.109-1.547,1.554-2.478,2.149a1.34,1.34,0,0,1-1.168-.858,15.9,15.9,0,0,0-6.868-6.529A9.562,9.562,0,0,1-2789.516-1426.214Z",
    fill: "#a5d8e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64054",
    "data-name": "Path 64054",
    d: "M-2732.367-1517.974l.326.355c.087.454-.308.73-.4,1.117a4.791,4.791,0,0,0,.065,2.761,2.725,2.725,0,0,0,.913.788c.379.218.877.223,1.145.639a3.932,3.932,0,0,1,.223,1.948,8.18,8.18,0,0,0,1.3,4.159,9.227,9.227,0,0,0,6.19,4.361,3.67,3.67,0,0,1,.57.286c.38.278.99.207,1.188.768a.472.472,0,0,1-.4.432,10.709,10.709,0,0,1-7.215-3.391,9.422,9.422,0,0,1-2.88-6.39,3.028,3.028,0,0,0-1.192-2.316C-2733.783-1513.565-2733.622-1516.855-2732.367-1517.974Z",
    fill: "#bfecf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64055",
    "data-name": "Path 64055",
    d: "M-2818.559-1576.049l1.041-.745c1.074,1.862.5,3.614-.515,5.136-.908,1.357-2.579,1.486-4.094,1.654-.556.061-.388-.472-.447-.791-.23-.4.064-.693.219-1.013a1.106,1.106,0,0,1,.715-.471c1.7-.037,1.986-.3,2.357-2.248C-2819.163-1575.093-2819.472-1575.863-2818.559-1576.049Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64056",
    "data-name": "Path 64056",
    d: "M-2800.319-1452.18l-.624-.314a1.969,1.969,0,0,1,2.243-.126,17.4,17.4,0,0,1,7.589,5.286,16.767,16.767,0,0,1,3.5,6.308,1.055,1.055,0,0,1-.351,1.217,1.536,1.536,0,0,1-.613-1.55c-.021-.334.035-.7-.326-.908-1.1-.6-1.182-1.886-1.875-2.785-2.2-2.856-4.681-5.271-8.2-6.414A3.226,3.226,0,0,1-2800.319-1452.18Z",
    fill: "#a5d9e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64057",
    "data-name": "Path 64057",
    d: "M-2821.645-1572.033l-.618.311a.471.471,0,0,1-.012-.641c1.434-2.335,3.249-4.39,4.841-6.608a4.7,4.7,0,0,0,1.072-1.989c1.128-.243,1.5-1.311,2.178-2.035.865-.927,1.625-1.953,2.43-2.936l.878-.634c.206-.132.313-.489.664-.294-.652,1.831-2.291,2.884-3.414,4.342-1.654,2.149-3.709,3.992-4.933,6.468-.553.543-.206,1.235-.306,1.854-.61.045-.5-.311-.415-.567C-2820.239-1574.091-2820.309-1572.525-2821.645-1572.033Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64058",
    "data-name": "Path 64058",
    d: "M-2750.643-1454.031a.894.894,0,0,1-.645.97c-.276.128-.523.291-.82-.022-1.263-1.33-2.531-2.657-3.829-3.952-.528-.527-.671-1.063-.161-1.614.591-.639,1.125-.23,1.57.24a24.634,24.634,0,0,0,3.315,3.185C-2750.8-1454.926-2750.841-1454.4-2750.643-1454.031Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64059",
    "data-name": "Path 64059",
    d: "M-2845.743-1516.73a73.883,73.883,0,0,1,1.653-7.942c.589-2.226,1.167-4.456,1.772-6.678a4.32,4.32,0,0,1,.887-2.1c.1.071.138.146.109.223s-.06.119-.092.119c.146,2.635-1,5.006-1.686,7.441-.537,1.908-.843,3.855-1.351,5.761-.491,1.84-.684,3.76-1.012,5.671-.533-.157-.514-.592-.6-.967l0,.011C-2845.658-1515.641-2846.111-1516.27-2845.743-1516.73Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64060",
    "data-name": "Path 64060",
    d: "M-2721.608-1484l.669-.891c.229.328.614.5.839.833.015,1.365-.342,2.732.134,4.1.154.439-.316.844-.4,1.286-.02.113-.785.418.04.493a3.649,3.649,0,0,1,.815,1.054,1.255,1.255,0,0,1-.022.924c-.734,1.833.032,3.564.447,5.288a9.213,9.213,0,0,1,.424,2.217,3.524,3.524,0,0,1-.032.747c-.074.371-.044.889-.563.9-.431.012-.466-.456-.537-.782a9.866,9.866,0,0,1-.284-1.159,37.841,37.841,0,0,0-1.455-5.758,8.584,8.584,0,0,1-.168-1.518,19.373,19.373,0,0,1-.017-6.975A1.494,1.494,0,0,1-2721.608-1484Z",
    fill: "#f65627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64061",
    "data-name": "Path 64061",
    d: "M-2788.576-1441.359a3.4,3.4,0,0,1,.613,1.55c.356.787.084,1.727.607,2.472a6.32,6.32,0,0,1-.009,4.314,18.767,18.767,0,0,0-.907,3.717q-.638,1.389-1.276,2.78c-.382-.053-.882.171-1.094-.3s.159-.757.54-.94c.654-.315.557-1.048.9-1.535a23.963,23.963,0,0,1,.366-3.524,20.028,20.028,0,0,0-.22-5.84c-.127-.688-.4-1.42.162-2.068A.642.642,0,0,1-2788.576-1441.359Z",
    fill: "#d4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64062",
    "data-name": "Path 64062",
    d: "M-2759.858-1457.107c-.307-1.9,1.625-2.259,2.426-3.392.416-.589.812-1.393,1.714-1.64a1.09,1.09,0,0,1,1.24.251c.337.378-.011.629-.256.893-1.151,1.24-2.325,2.46-3.426,3.743-.574.669-1.148-.023-1.7.144Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64063",
    "data-name": "Path 64063",
    d: "M-2791.987-1522.908h-2.352a1.94,1.94,0,0,1,1.49-.3q16.934-.018,33.866,0c.538,0,1.142-.206,1.595.3-2.217.636-4.488.254-6.725.275-8.644.08-17.289.036-25.934.026A2.906,2.906,0,0,1-2791.987-1522.908Z",
    fill: "#95d3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64064",
    "data-name": "Path 64064",
    d: "M-2791.987-1522.908l34.6,0c-.223.362-.588.3-.927.31a9.451,9.451,0,0,1-3.705,0h-.31a1.725,1.725,0,0,1-1.048.147q-13.781,0-27.562,0a1.7,1.7,0,0,1-1.046-.148C-2791.987-1522.7-2791.987-1522.806-2791.987-1522.908Z",
    fill: "#9adfee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64065",
    "data-name": "Path 64065",
    d: "M-2757.416-1524.762c-.094,0-.188,0-.282,0a.41.41,0,0,1-.4.1,1.872,1.872,0,0,1-1.157-1.2,6.871,6.871,0,0,0-.372-1.155c-.192-.478-.645-.634-1.048-.849-.432-.209-.842-.46-1.277-.661-.988-.421-1.893.187-2.842.232-1.322-.263-2.267-.859-2.281-2.4-.007-.744-.9-1.287-.547-2.142a.3.3,0,0,1,.387.022,4.1,4.1,0,0,1,1.578,2.334c.235.881.555,1.316,1.649,1.138a4.911,4.911,0,0,1,3.809.574l.949.614a1.124,1.124,0,0,1,.916.927C-2758.167-1526.353-2757.237-1525.763-2757.416-1524.762Z",
    fill: "#e9fafb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64066",
    "data-name": "Path 64066",
    d: "M-2721.247-1500.36l.32-.313a.572.572,0,0,1,.619-.133,1.037,1.037,0,0,1,.476.468,1.548,1.548,0,0,1,.1.434,7.06,7.06,0,0,0,2.25,5.8c1.106,1.027,2.041,2.211,3.814,1.649a.617.617,0,0,1,.742.424c.162.518-.3.579-.615.692-.387.14-.759.318-1.154.44a1.39,1.39,0,0,1-.66.011,13.276,13.276,0,0,1-1.8-.861,9.475,9.475,0,0,1-3.163-3.874c-.121-.341-.289-.666-.052-1.019C-2721-1497.8-2720.731-1499.175-2721.247-1500.36Z",
    fill: "#9aa9b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64067",
    "data-name": "Path 64067",
    d: "M-2715.523-1454.339h-.468l-.289-.613a.412.412,0,0,1-.042-.6,34.615,34.615,0,0,0-1.867-4.833c-1.014-1.812-.435-4.171-2.119-5.692-.385-.365-.1-.892-.321-1.3a20.378,20.378,0,0,1-.627-2.812c0-.07.008-.14.013-.209.155-.957-.374-1.83-.342-2.773a.228.228,0,0,1,.111-.382c1.054,1.023.818,2.544,1.44,3.735.1,1.854.943,3.494,1.521,5.209.258,1.133.843,2.159,1.1,3.292.3,1.088.676,2.153,1.05,3.218.2.641.4,1.279.633,1.908C-2715.725-1455.564-2714.919-1455.028-2715.523-1454.339Z",
    fill: "#b5dbe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64068",
    "data-name": "Path 64068",
    d: "M-2791.986-1522.6h29.656c-.255.333-.623.308-.982.308h-30.013C-2792.841-1522.775-2792.377-1522.516-2791.986-1522.6Z",
    fill: "#a2e3f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64069",
    "data-name": "Path 64069",
    d: "M-2834.6-1551.288a94.39,94.39,0,0,1,5.819-10.865c.305-.223.35-.852.953-.608-.313,1.672-1.531,2.889-2.284,4.332-1.109,2.126-2.266,4.236-3.4,6.356C-2833.719-1551.673-2833.729-1550.839-2834.6-1551.288Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64070",
    "data-name": "Path 64070",
    d: "M-2733.908-1419.418c-.733,1.283-1.977.872-3.081.929-.252.025-.628.164-.732.051-.238-.256.084-.558.276-.547,3.352.2,3.887-3.2,5.975-4.594.86-.572,1.557-1.431,2.621-1.671.147-.034.548-.252.476.233-.019.129-.183.237-.281.354a.35.35,0,0,1-.063.417A31.916,31.916,0,0,0-2733.908-1419.418Z",
    fill: "#a5d8e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64071",
    "data-name": "Path 64071",
    d: "M-2777.164-1417.267c.567-1.014,1.666-1.417,2.477-2.149a.958.958,0,0,0,.924-.622,3.017,3.017,0,0,1,1.97-1.307c1.209.1,2.356-.769,3.593-.234a1.992,1.992,0,0,1-1.5.925,11.057,11.057,0,0,0-5.345,2.946C-2775.347-1417.411-2776.292-1416.547-2777.164-1417.267Z",
    fill: "#d8f1f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64072",
    "data-name": "Path 64072",
    d: "M-2827.825-1562.761l-.952.608a2.156,2.156,0,0,1,.642-1.55,39.945,39.945,0,0,0,4.042-6.455l1.818-2.205q.006.32.012.641l-.311.927c-.6,1.21-1.718,2.087-2.162,3.4a10.072,10.072,0,0,1-2.473,4.018Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64073",
    "data-name": "Path 64073",
    d: "M-2744.731-1410.467a10.294,10.294,0,0,1,4.642-6.494l1.237-.6c.9.416.053.713-.132.86-.872.692-1.708,1.417-2.541,2.154a6.579,6.579,0,0,0-2.242,3.707C-2743.925-1410.072-2744.275-1410.243-2744.731-1410.467Z",
    fill: "#d6f4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64074",
    "data-name": "Path 64074",
    d: "M-2756.611-1594.067c.743.5,1.411.955.7,1.94a1.713,1.713,0,0,0,.347,2.246c.708.774.914,1.459.066,2.229-.437.4-.269.961-.413,1.438-.074.243-.23.487-.541.43-.338-.061-.288-.368-.307-.611a1.49,1.49,0,0,1,.337-.993,1.8,1.8,0,0,0,.157-1.905C-2757.218-1590.849-2756.541-1592.456-2756.611-1594.067Z",
    fill: "#a3dcfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64075",
    "data-name": "Path 64075",
    d: "M-2815.467-1455.563a.645.645,0,0,1,.306-.618c.536-.116.57.257.609.625l.632.911c.1.023.238.046.267.123.731,1.913,2.041,2.678,4.056,2.074.374,1.781-1.333,1.236-2.005,1.549-1.138.529-2.322-.613-2.362-1.949C-2814-1454.012-2815.4-1454.418-2815.467-1455.563Z",
    fill: "#d3f3f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64076",
    "data-name": "Path 64076",
    d: "M-2720.068-1485.881c-.146-.592.556-.732.639-1.2,1-1.963,2.854-2.882,4.683-3.833.408-.145.77-.539,1.263-.238a.786.786,0,0,1-.129,1.02c-.57.5-1.271.821-1.833,1.334-.244.215-.484.438-.744.635a2.345,2.345,0,0,0-.8.784,2.872,2.872,0,0,1-.239.316,23.88,23.88,0,0,1-1.886,1.879A.826.826,0,0,1-2720.068-1485.881Z",
    fill: "#d5481d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64077",
    "data-name": "Path 64077",
    d: "M-2821.65-1461.109c-2.841-.708-5.689-1.308-8.63-.627-.339-.052-.715.108-1.015-.176.1-.466.514-.471.834-.521a17.8,17.8,0,0,1,8.539.5c.133.045.187.327.278.5a.2.2,0,0,1,.075.219C-2821.6-1461.145-2821.623-1461.109-2821.65-1461.109Z",
    fill: "#a4d7ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64078",
    "data-name": "Path 64078",
    d: "M-2730.215-1545.44c.54-1.155,1.629-.222,2.381-.681a6.583,6.583,0,0,0-.66,1.724c-.172.7-.8,1.5.582,1.751.346.063.648.566.082.93a1.012,1.012,0,0,0-.514.885l-.192.063c-.38-.121-.453-.468-.575-.779-.183-.361-.266-.762-.457-1.12Z",
    fill: "#e3b028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64079",
    "data-name": "Path 64079",
    d: "M-2821.65-1461.109l.006-.326a4.64,4.64,0,0,1,3.3,1.286c1.171,1.043,2.448,1.97,3.584,3.048.352.333,1.508.864.207,1.545l-.609-.625-.614-.643c-.3-.415-.39-.984-.932-1.208A26.077,26.077,0,0,0-2821.65-1461.109Z",
    fill: "#a3d7e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64080",
    "data-name": "Path 64080",
    d: "M-2832.146-1461.136a8.04,8.04,0,0,0-2.863,1.335c-1.1.779-1.984,1.132-2.9-.174a2.847,2.847,0,0,0-.725-.533c-.106-.2-.211-.4-.317-.606-.021-.177-.245-.379,0-.516.092-.05.281.047.415.1,2.36,1.009,2.359,1.01,5.041,0C-2832.548-1461.884-2832.441-1461.853-2832.146-1461.136Z",
    fill: "#a3d8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64081",
    "data-name": "Path 64081",
    d: "M-2733.908-1419.418c1.1-2.4,3.236-3.764,5.254-5.245l.922-.015c.08.07.107.14.081.211s-.052.106-.078.106c-.094.944-1.08.54-1.541,1.031-1.135,1.206-2.537,2.152-3.461,3.576A.863.863,0,0,1-2733.908-1419.418Z",
    fill: "#d2f2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64082",
    "data-name": "Path 64082",
    d: "M-2744.412-1568.631c.32.728.981.593,1.579.632.267.017.527.11.513.434-.019.425-.36.2-.571.251-2.278.557-3.751-.409-3.677-2.432.014-.374-.146-.916.454-.958.517-.035.412.472.5.791a1.015,1.015,0,0,0,.584.664A.726.726,0,0,1-2744.412-1568.631Z",
    fill: "#a6dde6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64083",
    "data-name": "Path 64083",
    d: "M-2836.763-1546.691l1.832-3.714c1.192-.091.556.629.4,1.011-.545,1.333-1.4,2.52-1.83,3.917-.264.854-.695,1.656-1.037,2.487-.09.218-.08.592-.43.387-.146-.087-.129-.451-.186-.689Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64084",
    "data-name": "Path 64084",
    d: "M-2759.858-1422.818a.647.647,0,0,0-.618.306.657.657,0,0,1-.521.28c-3.223-.351-6.357.346-9.511.8-.182-.425-.182-.425.764-.764a1.738,1.738,0,0,1,1.677-.865c2.513-.09,5.031-.058,7.546-.045C-2760.3-1423.109-2760.079-1422.92-2759.858-1422.818Z",
    fill: "#a7dbe9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64085",
    "data-name": "Path 64085",
    d: "M-2759.947-1610.437c.418,2.545,1.382,4.959,1.617,7.517.022.241.086.587-.2.657a.543.543,0,0,1-.66-.489c-.061-.454-.026-.92-.05-1.38s.114-1.112-.132-1.337C-2761.039-1606.988-2759.411-1608.837-2759.947-1610.437Z",
    fill: "#a0e1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64086",
    "data-name": "Path 64086",
    d: "M-2775-1615.582l6.8-3.687a.384.384,0,0,1,0,.588,15.827,15.827,0,0,1-5.075,2.942,3.79,3.79,0,0,0-1.415,1.077c-.175.132-.377.2-.532.011C-2775.536-1615.041-2775.121-1615.282-2775-1615.582Z",
    fill: "#a7d9e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64087",
    "data-name": "Path 64087",
    d: "M-2768.2-1618.681v-.589c1.16-.588,2.5-.833,3.437-1.843l3.038-.973c-.141.524.674,1.681-1.037,1.116-.7-.232-1.854.809-2.761,1.339A4.36,4.36,0,0,1-2768.2-1618.681Z",
    fill: "#a6d8e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64088",
    "data-name": "Path 64088",
    d: "M-2733.29-1559.056c.859.158.745.853.506,1.294a5.573,5.573,0,0,1-1.384,1.545c-.143.117-.5-.307-.589-.6a3.052,3.052,0,0,0-1.066-1.61,1.393,1.393,0,0,1-.588-1.17.77.77,0,0,1-.07-.669.611.611,0,0,1,.62-.178c.869.422.864,1.76,1.993,1.9C-2733.61-1558.638-2733.751-1559.192-2733.29-1559.056Z",
    fill: "#e2b024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64089",
    "data-name": "Path 64089",
    d: "M-2721.57-1483.4c.008,1.526.043,3.052.013,4.577a8.272,8.272,0,0,0,.309,2.571c-.385.352.138,1-.428,1.295a1.745,1.745,0,0,1-.649-2.036c-.1-1.924-.758-3.859.126-5.76l.359-.584C-2721.782-1483.5-2721.693-1483.525-2721.57-1483.4Z",
    fill: "#ec4c0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64090",
    "data-name": "Path 64090",
    d: "M-2748.777-1580.648c1.111,1.958,2.23,3.913,3.329,5.878.271.485.48,1,.717,1.507-1.222-.3-1.706-.952-2.006-2.3a7.477,7.477,0,0,0-1.995-3.7,1.828,1.828,0,0,1-.578-1.8A.439.439,0,0,1-2748.777-1580.648Z",
    fill: "#a7dfd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64091",
    "data-name": "Path 64091",
    d: "M-2751.826-1588.092l.618.925a1.308,1.308,0,0,1-.019,1.883,34.929,34.929,0,0,1-3.334-7.765c.3-.153.293-.658.9-.69v1.957A8.983,8.983,0,0,1-2751.826-1588.092Z",
    fill: "#deb22a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64092",
    "data-name": "Path 64092",
    d: "M-2720.374-1496.646a9.23,9.23,0,0,0,3.456,4.656c.383.77-.176.984-.714,1.21l-.213,0c-.238-.087-.881-.034-.647-.272,1-1.022-.009-1.469-.51-1.923a6.956,6.956,0,0,1-1.786-2.775C-2720.966-1496.21-2720.951-1496.552-2720.374-1496.646Z",
    fill: "#b2e0ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64093",
    "data-name": "Path 64093",
    d: "M-2802.184-1452.776l-.617-.006a35.206,35.206,0,0,1-4.32-.037c-.523-.567-1.3-.025-1.934-.465,2.208-.739,4.429-.333,6.615-.406.582-.02.862.3.568.9C-2801.97-1452.654-2802.075-1452.656-2802.184-1452.776Z",
    fill: "#a9d9e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64094",
    "data-name": "Path 64094",
    d: "M-2782.41-1610.942l5.253-3.415c.348-.173.5.038.618.314-1.355,1.2-2.98,2.012-4.436,3.066a2.261,2.261,0,0,1-1.433.333c-.093-.065-.124-.131-.094-.2S-2782.441-1610.942-2782.41-1610.942Z",
    fill: "#a1d3e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64095",
    "data-name": "Path 64095",
    d: "M-2809.6-1452.448c-2.815.822-2.815.822-4.2-1.921-.045-.09-.083-.184-.124-.276.088-.513.67-.811.741-.361.368,2.322,2.128,2.228,3.773,2.414.039.005.073.067.109.1Z",
    fill: "#a8d9e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64096",
    "data-name": "Path 64096",
    d: "M-2751.227-1585.284l.019-1.883q.464-.619.925-1.239a.8.8,0,0,1,.537.858c.17,1.1-.9,2.375.455,3.319a1.476,1.476,0,0,1,.205.408c.019,1.308-.066,1.4-.907.983Z",
    fill: "#e9ad22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64097",
    "data-name": "Path 64097",
    d: "M-2790.154-1605.445l.659-.871c1.771-.83,3.061-2.421,4.92-3.113.2.579-.356.666-.615.946l-4.943,3.707C-2790.593-1604.9-2790.593-1604.9-2790.154-1605.445Z",
    fill: "#aad7e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64098",
    "data-name": "Path 64098",
    d: "M-2720.312-1467.3c.55.408-.117.82,0,1.23a1.982,1.982,0,0,1-1.241-.3c-.592-.87-.3-1.839-.313-2.775.183-1.063-.578-1.866-.917-2.911,1.009.26.927,1.27,1.536,1.671l0,0C-2720.681-1469.438-2721.086-1468.193-2720.312-1467.3Z",
    fill: "#9ee0e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64099",
    "data-name": "Path 64099",
    d: "M-2723.1-1479.692c0,.512.02,1.024-.008,1.534-.017.319.134.817-.424.793-.339-.015-.5-.379-.47-.7a13.079,13.079,0,0,0,0-3.457c-.052-.3.073-.685.439-.691s.448.361.455.675c.014.613,0,1.227,0,1.841Z",
    fill: "#9de0ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64100",
    "data-name": "Path 64100",
    d: "M-2776.539-1614.043l-.618-.314a9.569,9.569,0,0,1,2.16-1.225c.109.305-.5.849.308.92-.317.743.848,1.8-.074,2.142C-2775.364-1612.3-2775.847-1613.6-2776.539-1614.043Z",
    fill: "#b4e0f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64101",
    "data-name": "Path 64101",
    d: "M-2827.209-1563.382a17.32,17.32,0,0,1,2.473-4.018C-2824.346-1565.8-2825.854-1563.353-2827.209-1563.382Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64102",
    "data-name": "Path 64102",
    d: "M-2714.725-1490.791a37.468,37.468,0,0,0-4.7,3.708c-.742-1.173.617-1.243.968-1.843.244-.8,1.045-1.091,1.521-1.678.607.049.945-.755,1.614-.516l.588-.025a.255.255,0,0,1,.073.234Q-2714.694-1490.791-2714.725-1490.791Z",
    fill: "#b2e0ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64103",
    "data-name": "Path 64103",
    d: "M-2841.414-1533.106c-.006-.114-.011-.227-.017-.341a7.506,7.506,0,0,1,1.229-3.685c.833.522.674,1.073.316,1.9C-2840.257-1534.37-2840.372-1533.443-2841.414-1533.106Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64104",
    "data-name": "Path 64104",
    d: "M-2760.473-1621.771v6.047c-.886-.26-.582-.818-.606-1.2-.075-1.177-.1-2.359-.117-3.539,0-.548-.069-1.176.722-1.3Z",
    fill: "#9ae0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64105",
    "data-name": "Path 64105",
    d: "M-2810.212-1586.859l-.664.294a19.243,19.243,0,0,1,4.056-4.335q.147.107.1.219c-.03.076-.061.114-.092.114l-.007.618C-2808.093-1589.078-2808.7-1587.476-2810.212-1586.859Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64106",
    "data-name": "Path 64106",
    d: "M-2787.365-1433.023q0-2.157.009-4.314v-1.784c1.225,2.808.362,5.359-.009,7.913Z",
    fill: "#a4d5e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64107",
    "data-name": "Path 64107",
    d: "M-2721.57-1483.4q-.135.035-.27.063c-.623-.762-.652.619-1.168.295-.193-.43.139-.754.317-1.093.4-.76,1.1-1.473.068-2.291-.19-.149.042-.365.209-.477a.54.54,0,0,1,.806.106,1.541,1.541,0,0,1,.219,1.579c-.153.379-.663.731-.219,1.226Z",
    fill: "#9de0ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64108",
    "data-name": "Path 64108",
    d: "M-2749.993-1582.838c1.283.137.338-.872.638-1.241,1.3.282,1.229,1.678,1.965,2.417.274,1.3-.976.514-1.323.965l-.064.049-.533-.417Q-2749.652-1581.952-2749.993-1582.838Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64109",
    "data-name": "Path 64109",
    d: "M-2744.412-1568.631l-.62-.618c.012-.543-.518-1.028-.177-1.638a2.432,2.432,0,0,1,1.359.929c.232.388.976.505.794,1.01C-2743.272-1568.349-2743.947-1568.728-2744.412-1568.631Z",
    fill: "#a6dafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64110",
    "data-name": "Path 64110",
    d: "M-2731.106-1546.426c.053.349.488.73-.134,1.06a12.43,12.43,0,0,0-1.511-2.613c-.49-.5-.284-1.13.377-1.5A4.411,4.411,0,0,1-2731.106-1546.426Z",
    fill: "#9be3f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64111",
    "data-name": "Path 64111",
    d: "M-2839.868-1538.347c.071-1.265.918-2.244,1.255-3.412.172-.036.527-.173.479.021a12.228,12.228,0,0,1-1.138,3.713c-.112.18-.215.545-.52.256C-2839.9-1537.873-2839.848-1538.15-2839.868-1538.347Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64112",
    "data-name": "Path 64112",
    d: "M-2790.154-1605.445c.018.222-.325.456.021.669,0,.1,0,.2,0,.305-1.495.434-2.414,1.731-3.7,2.474a.4.4,0,0,1-.343-.333A17.945,17.945,0,0,1-2790.154-1605.445Z",
    fill: "#b1d8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64113",
    "data-name": "Path 64113",
    d: "M-2840.2-1462.037l-2.454-.954-.507-.9a23.226,23.226,0,0,1,2.8.744C-2840.035-1463.013-2839.142-1462.559-2840.2-1462.037Z",
    fill: "#a3d8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64114",
    "data-name": "Path 64114",
    d: "M-2769.744-1422.2l-.927.621c-.175.655-.88.276-1.214.621-.8-.058-1.079.966-1.878.92-.433-.381-.356-.754.126-.956C-2772.381-1421.52-2771.229-1422.406-2769.744-1422.2Z",
    fill: "#a5d8e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64115",
    "data-name": "Path 64115",
    d: "M-2727.729-1424.361l0-.317.937-.606c1.041.035,2.028-.5,3.086-.292.054.226.241.517-.161.584A18.762,18.762,0,0,1-2727.729-1424.361Z",
    fill: "#d4f4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64116",
    "data-name": "Path 64116",
    d: "M-2759.553-1622.081a.657.657,0,0,1,.309-.62c.4.037,1.037.011.84.573-.391,1.115.085,2.382-.709,3.508C-2759.468-1619.81-2758.92-1621.029-2759.553-1622.081Z",
    fill: "#9ae1fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64117",
    "data-name": "Path 64117",
    d: "M-2731.106-1546.426q-.633-1.527-1.268-3.052c-.089-1.1-.962-1.981-.888-3.129a.2.2,0,0,1,.286.032l1.536,3.719v0c-.06.89.837,1.523.66,2.445Z",
    fill: "#bbd4b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64118",
    "data-name": "Path 64118",
    d: "M-2754.247-1588.928a3.541,3.541,0,0,1,1.137,2.171.514.514,0,0,1-.336.739.61.61,0,0,1-.781-.551C-2754.295-1587.277-2754.247-1588-2754.247-1588.928Z",
    fill: "#9ae0f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64119",
    "data-name": "Path 64119",
    d: "M-2846.323-1465.459l.581-.3c.146,1.125,1.242,1.441,1.851,2.172a2.952,2.952,0,0,1-2.45-.643Q-2846.332-1464.844-2846.323-1465.459Z",
    fill: "#a3d8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64120",
    "data-name": "Path 64120",
    d: "M-2729.568-1542.667c.42.3.457.791.594,1.23.191.864,1.337,1.54.515,2.606a1.3,1.3,0,0,1-1.741-.221l-.178-.554c2.35.026.8-1.455.88-2.3A4.023,4.023,0,0,0-2729.568-1542.667Z",
    fill: "#c8eaeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64121",
    "data-name": "Path 64121",
    d: "M-2807.121-1452.819c1.441-.052,2.885-.594,4.32.037-1.827.673-3.72.141-5.575.3C-2808.044-1452.913-2807.547-1452.735-2807.121-1452.819Z",
    fill: "#d3f2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64122",
    "data-name": "Path 64122",
    d: "M-2722.2-1482.757c-.455,1.961-.02,3.92.018,5.879-.1.1-.184.1-.265-.018C-2722.725-1478.865-2723.368-1480.849-2722.2-1482.757Z",
    fill: "#bfc2bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64123",
    "data-name": "Path 64123",
    d: "M-2742.561-1570.471c.224,1.008,1.146,1.7,1.262,2.755-1.149-.772-1.45-2.23-2.5-3.083-.2-.352.093-.454.3-.6l.923.91Z",
    fill: "#b7d8bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64124",
    "data-name": "Path 64124",
    d: "M-2785.19-1608.483l.615-.945a7.508,7.508,0,0,1,2.165-1.514c0,.1,0,.2,0,.3C-2783.154-1609.691-2783.874-1608.7-2785.19-1608.483Z",
    fill: "#a6d5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64125",
    "data-name": "Path 64125",
    d: "M-2720.068-1485.881l.912.675.13.165a.794.794,0,0,1-.282.545,1.315,1.315,0,0,1-1,.19c-.723.362-.6-.187-.63-.581C-2720.78-1485.334-2720.631-1485.788-2720.068-1485.881Z",
    fill: "#e54a15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64126",
    "data-name": "Path 64126",
    d: "M-2721.862-1469.153a7.284,7.284,0,0,1,.313,2.776c-.654.536-.963-.093-.841-.445C-2722.123-1467.59-2722.435-1468.476-2721.862-1469.153Z",
    fill: "#acdbfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64127",
    "data-name": "Path 64127",
    d: "M-2716.916-1490.47c-.073.956-1.014,1.045-1.545,1.544-.82-.958.5-1.208.616-1.856h0C-2717.407-1491.059-2717.118-1490.894-2716.916-1490.47Z",
    fill: "#95e6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64128",
    "data-name": "Path 64128",
    d: "M-2732.041-1534c1.283-.326,1.3-1.3,1.221-2.345-.048-.663-.026-1.332-.035-2a.681.681,0,0,1,.379-.615,1.847,1.847,0,0,1,.262.434,7.4,7.4,0,0,1,.125,1.765,9.957,9.957,0,0,1-.138,2.516,1.116,1.116,0,0,1-.462.577A1.23,1.23,0,0,1-2732.041-1534Z",
    fill: "#a6d6db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64129",
    "data-name": "Path 64129",
    d: "M-2755.5-1595.826c.709-.005,1.189.134.934,1.05a6.614,6.614,0,0,0-.075,1.5A5.634,5.634,0,0,1-2755.5-1595.826Z",
    fill: "#deb22a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64130",
    "data-name": "Path 64130",
    d: "M-2758.329-1527.228l-.916-.927c.257-1.026.683-.383,1-.071S-2757.311-1527.471-2758.329-1527.228Z",
    fill: "#9ad4e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64131",
    "data-name": "Path 64131",
    d: "M-2722.446-1476.9a2.343,2.343,0,0,0,.265.018l.579,1.914a.523.523,0,0,1,.244.353.95.95,0,0,1-.154,1.055l-.072.39c-.493-.644-.278-1.574-.882-2.173a1.777,1.777,0,0,1-.025-1.529Z",
    fill: "#b1dce1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64132",
    "data-name": "Path 64132",
    d: "M-2743.494-1571.4c-.1.2-.2.4-.3.6-.5-.662-1.518-1.113-.893-2.224Z",
    fill: "#a7dfd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64133",
    "data-name": "Path 64133",
    d: "M-2762.02-1522.6h3.705A4.844,4.844,0,0,1-2762.02-1522.6Z",
    fill: "#a2e3f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64134",
    "data-name": "Path 64134",
    d: "M-2716.322-1455.549l.042.6c-.091.247.148.685-.339.7a.512.512,0,0,1-.542-.448C-2717.218-1455.3-2716.849-1455.511-2716.322-1455.549Z",
    fill: "#93ebfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64135",
    "data-name": "Path 64135",
    d: "M-2732.976-1552.575l-.286-.031-.654-1.809.055-.039c1.021.252,1.277.89.927,1.834Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64136",
    "data-name": "Path 64136",
    d: "M-2722.491-1476.868q.012.765.024,1.529c-.07.114-.193.507-.256.2A1.712,1.712,0,0,1-2722.491-1476.868Z",
    fill: "#9eeffe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64137",
    "data-name": "Path 64137",
    d: "M-2730.477-1538.632c0-.109,0-.218,0-.327a.994.994,0,0,0,.276-.092l1.8.055c.043.061.087.121.131.182a.5.5,0,0,1-.245.354,1.832,1.832,0,0,1-.436.134A1.907,1.907,0,0,1-2730.477-1538.632Z",
    fill: "#799195"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64138",
    "data-name": "Path 64138",
    d: "M-2736.377-1560.29q-.018.348-.034.7a1.512,1.512,0,0,1-.644-1.267l.081-.065c.318-.13.514.045.686.277A.319.319,0,0,1-2736.377-1560.29Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64139",
    "data-name": "Path 64139",
    d: "M-2802.184-1452.776l.312-.012c.219.362.59.29.924.324C-2801.455-1452.193-2802.032-1451.643-2802.184-1452.776Z",
    fill: "#d3f2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64140",
    "data-name": "Path 64140",
    d: "M-2787.972-1414.785c-.887.379-1.626-.589-1.756-.832-.729-1.358-2.783-1.536-2.907-3.346a.248.248,0,0,0-.2-.135c-2.045.513-3.19-1.334-4.841-1.869-.981-.318-1.986-.364-2.962-.614l.013-.57c2.1.065,4.247-.788,6.289.509.93.591,2.261.877,2.963,1.475a15.763,15.763,0,0,1,3.65,4.684C-2787.644-1415.335-2787.881-1415.022-2787.972-1414.785Z",
    fill: "#ddf1f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64141",
    "data-name": "Path 64141",
    d: "M-2771.885-1420.958l1.214-.621c1.533-.31,3.076-.574,4.595-.941,1.877-.454,3.734-.064,5.6.008a2.111,2.111,0,0,0,.3.009,16.666,16.666,0,0,1,2.789.624c3.372,1.542,6.656,3.23,9.082,6.15,1.237,1.488,2.572,2.943,2.976,4.944-.149.576-.286.786-.657.083a37.732,37.732,0,0,0-3.624-5.238c-1.876-2.443-4.646-3.275-7.108-4.673-.352-.2-.652-.439-.976-.66-.569-.4-1.283.078-1.854-.307-.521-.076-1.112.2-1.545-.308-1.03-.42-2.059.2-3.089,0h-.309a5.834,5.834,0,0,0-2.78.31l-.927,0A16.327,16.327,0,0,1-2771.885-1420.958Z",
    fill: "#d5f2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64142",
    "data-name": "Path 64142",
    d: "M-2833.075-1459.888c3.229-1.255,6.5-1.857,9.886-.619.2.139.574.277.575.418,0,.394-.372.145-.575.2-2.415.711-4.87-.137-7.3.16-.431.052-.831-.048-.964.43-.141.507-.174,1.072-.92.9C-2833.216-1458.592-2833.045-1459.3-2833.075-1459.888Z",
    fill: "#d9edea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64143",
    "data-name": "Path 64143",
    d: "M-2788.9-1440.735c.3,2.327.88,4.642.595,7-.179,1.492-.024,3.073-.9,4.429a2.508,2.508,0,0,1-.574-2.568,21.948,21.948,0,0,0,.029-6.681C-2789.841-1439.238-2790.562-1440.571-2788.9-1440.735Z",
    fill: "#dbedec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64144",
    "data-name": "Path 64144",
    d: "M-2800.319-1452.18c5.343,1.2,8.746,4.686,11.118,9.4.089.178.2.344.3.516-.016.26-.039.561-.3.655-.344.123-.433-.231-.481-.437-.852-3.622-3.843-5.487-6.4-7.659-1.1-.938-2.765-.928-4.008-1.782C-2800.462-1451.745-2800.427-1451.888-2800.319-1452.18Z",
    fill: "#d3f2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64145",
    "data-name": "Path 64145",
    d: "M-2715.523-1454.339c-.078-.633-.542-1.172-.449-1.846.012-.3.057-.583.4-.689.5.141.566.611.747.994.166.355.236.93.739.207a21.27,21.27,0,0,1,1.945-2.549,1.821,1.821,0,0,1,.222-.21c.518-.389,1.164-1.163,1.673-.758.675.537-.007,1.018-.6,1.266-.182.076-.4.068-.491.291l-1.59,2.373c-.278.42-.333,1.006-.9,1.214l-.885.987C-2715.454-1453.28-2715.183-1453.99-2715.523-1454.339Z",
    fill: "#de4d29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64146",
    "data-name": "Path 64146",
    d: "M-2789.516-1426.214a16.018,16.018,0,0,1,4.316,1.56c-1.631.6-2.969-.475-4.43-.816C-2789.919-1425.538-2789.8-1425.993-2789.516-1426.214Z",
    fill: "#d4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64147",
    "data-name": "Path 64147",
    d: "M-2713.212-1453.7c.626.332.695.356.9-.219a1.812,1.812,0,0,1,1.27-1.327c0,.1,0,.2,0,.308-.321.621-.667,1.232-.954,1.869-.2.437-.393.958-.944.7A.759.759,0,0,1-2713.212-1453.7Z",
    fill: "#d3ede3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64148",
    "data-name": "Path 64148",
    d: "M-2764.184-1421.89a3.461,3.461,0,0,1,3.089,0C-2762.125-1422.091-2763.155-1421.051-2764.184-1421.89Z",
    fill: "#d8f1f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64149",
    "data-name": "Path 64149",
    d: "M-2767.273-1421.581a2.209,2.209,0,0,1,2.78-.31C-2765.374-1421.375-2766.342-1421.65-2767.273-1421.581Z",
    fill: "#d8f1f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64150",
    "data-name": "Path 64150",
    d: "M-2722.787-1425.285l.934.023c.067.327.581.483.371.9a.545.545,0,0,1-.648.257C-2722.767-1424.254-2722.79-1424.766-2722.787-1425.285Z",
    fill: "#d4f4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64151",
    "data-name": "Path 64151",
    d: "M-2755.289-1407.341c-.594.452-1.185.21-1.852.29C-2756.308-1407.695-2756.308-1407.695-2755.289-1407.341Z",
    fill: "#d7eaec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64152",
    "data-name": "Path 64152",
    d: "M-2713.822-1454.046a2.315,2.315,0,0,1,.9-1.215c-.036.527.225,1.108-.285,1.547Z",
    fill: "#d3ede3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64153",
    "data-name": "Path 64153",
    d: "M-2759.55-1421.58c.618.1,1.311-.25,1.854.307C-2758.315-1421.371-2759.008-1421.023-2759.55-1421.58Z",
    fill: "#d8f1f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64154",
    "data-name": "Path 64154",
    d: "M-2678.61-1425.288l.31-.609c.577-.883,1.5-.716,2.338-.736a16.36,16.36,0,0,1,2.58.062c.332.043.64.191.972.237a14.711,14.711,0,0,1,5.93,2.588c.179.147.351.3.525.455A14.92,14.92,0,0,1-2660.8-1413a1.892,1.892,0,0,1,0,.47c-.174.586.017,1.279-.514,1.761-.311.1-.619.2-.616-.321,0-.667.031-1.337,0-2a15.267,15.267,0,0,0-1.424-4.762,15.2,15.2,0,0,0-2.536-3.752c-1.816-2.331-4.339-3.238-7.055-3.631-1.616-.233-3.333-.741-4.958.189C-2678.048-1424.967-2678.371-1425.2-2678.61-1425.288Z",
    fill: "#d7f3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64155",
    "data-name": "Path 64155",
    d: "M-2616.515-1422.827l-.923.629a1.951,1.951,0,0,1-1.035.852,18.192,18.192,0,0,0-5.357,3.923,30.933,30.933,0,0,0-3.733,5.008c-.683.973-1.07,1-1.61.1a.966.966,0,0,0-.635-.6c-1.332-.134-2.2-1.108-3.25-1.769-.463-.872.08-1.015.736-.911a4.354,4.354,0,0,1,2.562,1.286c.717.764,1.258.718,1.769-.21a21.3,21.3,0,0,1,6.558-6.961c1.129-.812,2.049-1.829,3.568-1.858.456-.008.906-.178,1.332.112a.286.286,0,0,1,.083.26C-2616.47-1422.872-2616.491-1422.827-2616.515-1422.827Z",
    fill: "#a6d8e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64156",
    "data-name": "Path 64156",
    d: "M-2632.888-1414.785a16.955,16.955,0,0,1,3.08,1.874c-.465.472-.911.3-1.376-.015-4.621-3.083-9.626-3.209-14.835-1.984-.623.147-1.3.768-2,.129a1.066,1.066,0,0,1,.911-.9c1.26-.183,2.358-.893,3.618-1.056,1.518-.038,3.037-.06,4.555-.005C-2636.84-1416.349-2634.633-1416.282-2632.888-1414.785Z",
    fill: "#d2f2f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64157",
    "data-name": "Path 64157",
    d: "M-2661.009-1412.638a2.4,2.4,0,0,1,0-.278,7.266,7.266,0,0,1-.144-2.22c.789-.778.9.089,1.036.5a10.316,10.316,0,0,1,.26,2.129,2.721,2.721,0,0,0,3.891,1.919c1.592-.882,2.51-2.545,4.064-3.478.82-.493,1.482-1.293,2.565-1.241.568.23.512.516.074.835a17.37,17.37,0,0,0-5.64,4.8c-.553.678-.945,1.083-1.959.535a10.3,10.3,0,0,0-3.1-.7c-.447-.078-.957.042-1.053-.608A10.066,10.066,0,0,1-2661.009-1412.638Z",
    fill: "#a7d8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64158",
    "data-name": "Path 64158",
    d: "M-2683.552-1443.824c-1.845-2.184-1.46-5.034-1.987-7.547-.394-1.881-1.173-3.756-1.11-5.746a.9.9,0,0,1-.213-.938.619.619,0,0,1,.558-.418c.631.175.6.739.71,1.218.254,1.134.308,2.307.646,3.425a4.474,4.474,0,0,1,.173.439,6.981,6.981,0,0,1,.348,1.14c.438,2.643,1.084,5.246,1.494,7.9a1.17,1.17,0,0,1-.178.467A.31.31,0,0,1-2683.552-1443.824Z",
    fill: "#d4eef7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64159",
    "data-name": "Path 64159",
    d: "M-2673.051-1426.209c-1.751.081-3.527-.262-5.249.312-.843.225-1.191-.36-1.541-.941-.707-3.66-2.191-7.171-2.112-10.982a.517.517,0,0,1,.43-.209c1.407,1.6,1.683,3.621,2.074,5.587.346,1.74.213,3.544.627,5.276.367.558.908.284,1.385.282a17.816,17.816,0,0,1,4.076.118C-2673.142-1426.644-2672.971-1426.5-2673.051-1426.209Z",
    fill: "#aadae9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64160",
    "data-name": "Path 64160",
    d: "M-2681.713-1437.944c-.1,2.275.812,4.376,1.15,6.578a22.952,22.952,0,0,1,.722,4.528c-.023.2.02.45-.083.594-.194.269-.363.014-.448-.139-.147-.265-.384-.589-.333-.839.45-2.215-1.05-4.016-1.246-6.068s-.926-4.1-.38-6.207A1.875,1.875,0,0,1-2681.713-1437.944Z",
    fill: "#d7f3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64161",
    "data-name": "Path 64161",
    d: "M-2623.943-1417.579a14.619,14.619,0,0,1,6.505-4.619l.616,0c-.375,1.217-1.731,1.125-2.473,1.852-1.579.579-2.593,1.974-4.015,2.78a.411.411,0,0,1-.5.121Z",
    fill: "#d4f4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64162",
    "data-name": "Path 64162",
    d: "M-2629.173-1412.31c.613.9.873.3,1.272-.237,1.276-1.71,2.094-3.785,3.958-5.031l.017.015a.685.685,0,0,1,0,.925,19.768,19.768,0,0,0-3.136,4.362c-.611,1.068-1.817,1.339-2.474.5C-2629.883-1412.217-2629.455-1412.239-2629.173-1412.31Z",
    fill: "#d4f4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64163",
    "data-name": "Path 64163",
    d: "M-2649.261-1414.473c.026-.207.341-.413,0-.62,0-.051-.027-.138-.008-.149,1.8-.985,3.583-2.044,5.764-1.864.4.376.069.568-.2.777-1.381.685-3,.7-4.324,1.548Z",
    fill: "#a8d9e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64164",
    "data-name": "Path 64164",
    d: "M-2681.713-1437.944a1.994,1.994,0,0,1-.618-1.553q-.148-.618-.3-1.236c-.383-.616-.745-1.236-.339-1.987.473-.411.987-.242,1.106.228.374,1.487,1.062,2.995.162,4.537Z",
    fill: "#aadae9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64165",
    "data-name": "Path 64165",
    d: "M-2687.258-1455.563a13.772,13.772,0,0,1,.738,3.673c-1.6-1.151-.983-2.444-.74-3.671Z",
    fill: "#c6f5e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64166",
    "data-name": "Path 64166",
    d: "M-2682.933-1442.589a5.77,5.77,0,0,1,.306,1.856c-.139.2-.274.571-.415.574-.4.007-.162-.369-.2-.569-.191-1.022-.741-2.012-.31-3.1h.3A1.02,1.02,0,0,1-2682.933-1442.589Z",
    fill: "#d7f3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64167",
    "data-name": "Path 64167",
    d: "M-2686.674-1458.064q.014.474.025.947l-.609,1.554,0,0c-.481-.058-.6.475-.973.6-.088-.731.66-1.141.7-1.824a1.615,1.615,0,0,1,.489-1.268A.355.355,0,0,1-2686.674-1458.064Z",
    fill: "#efe4d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64168",
    "data-name": "Path 64168",
    d: "M-2661.009-1412.638a2.77,2.77,0,0,1,0,2.2l-.3-.327C-2661.2-1411.39-2661.539-1412.085-2661.009-1412.638Z",
    fill: "#aad9e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64169",
    "data-name": "Path 64169",
    d: "M-2689.481-1452.8a5.388,5.388,0,0,1,1.258-2.184A2.392,2.392,0,0,1-2689.481-1452.8Z",
    fill: "#efe4d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64170",
    "data-name": "Path 64170",
    d: "M-2664.072-1418.926c-.538.934-.982,1.144-1.705.957C-2665.259-1418.259-2664.838-1418.495-2664.072-1418.926Z",
    fill: "#d7f3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64171",
    "data-name": "Path 64171",
    d: "M-2628.8-1403.217c.043.212.063.444-.232.347a.733.733,0,0,1-.355-.415.321.321,0,0,1,.253-.441C-2628.777-1403.754-2628.918-1403.38-2628.8-1403.217Z",
    fill: "#d7eaeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64172",
    "data-name": "Path 64172",
    d: "M-2678.6-1425.25c-.234.3-.38.548-.679.452a.441.441,0,0,1-.209-.345c0-.306.213-.272.425-.214C-2678.912-1425.317-2678.762-1425.288-2678.6-1425.25Z",
    fill: "#d7f3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64173",
    "data-name": "Path 64173",
    d: "M-2623.929-1416.638l0-.925h.616A.936.936,0,0,1-2623.929-1416.638Z",
    fill: "#ddf1f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64174",
    "data-name": "Path 64174",
    d: "M-2682.933-1442.589l-.319-1.234c.007-.106.014-.213.022-.319a24.021,24.021,0,0,0-1.555-8.332l-.315-.923c.514-.648.272-1.369.179-2.076.029.7.334,1.427-.179,2.075-.7-1.278-.635-2.731-.921-4.1-.073-.352-.06-.711-.409-.93-.27-.684.3-1.207.343-1.833a2.5,2.5,0,0,1,.208-.616c.507-.586.792-1.393,1.633-1.646a.589.589,0,0,1,.309.091c0-.079-.066-.112-.074-.179.512-1.148,1.226-.513,1.9-.231.1,0,.224.087.288-.038.027-.052-.063-.142-.137-.2a.872.872,0,0,1-.206-.316.833.833,0,0,1,.088-.577c.476-.732-.13-1.468,0-2.2-.174-1.366.983-2.2,1.36-3.371a19.531,19.531,0,0,1,1.7-4.434c.494-.8.023-1.609.023-2.413,0-4.169-1.928-7.6-4.132-10.959a24.338,24.338,0,0,0-2.576-2.884c-.436-.481-1.31-1.121-.2-1.855a3.41,3.41,0,0,0,1.1.368c.2.05.095-.237.076-.032a2.31,2.31,0,0,1-.972-.257c.361-1.158,1.409-1.888,1.85-3.008a2.659,2.659,0,0,0,.344-2.022,2.318,2.318,0,0,1-.02-.691c.321-.877-.057-1.943.727-2.7a20.737,20.737,0,0,0,5.409-2.093,9.535,9.535,0,0,0,3.228-3.633,7.114,7.114,0,0,0,1.319-4.023,2.546,2.546,0,0,1,1.146-2.342c1.5-1.08,1.431-4.162-.022-5.312-1.419-1.123-1.442-1.7-.114-2.8,1.458-1.215,1.4-4.122-.116-5.447-1.042-.914-1.1-1.754-.173-2.566a4.057,4.057,0,0,0,.5-5.551,1.538,1.538,0,0,1-.158-.416c-.275-.2.55-.815-.442-.9-.439-.035-.233-1.183-.4-1.81a1.907,1.907,0,0,1,0-.435c.117-.434.08-1.026.586-1.168s.581.476.854.746a15.612,15.612,0,0,0,1.648,1.615c.306.225.594.751,1.008.282.321-.363-.111-.624-.344-.885-.786-.881-1.566-1.767-2.375-2.628-1.489-1.584-1.505-2.818-.091-4.621a3.224,3.224,0,0,1,4.182-.612,4.936,4.936,0,0,1,1.539,1.261,11.716,11.716,0,0,0,1.7,1.56c.341.281.806.47,1.115.135.421-.455-.141-.737-.417-.938-.922-.675-1.592-1.6-2.453-2.336-1.989-1.692-3.581-1.8-5.815-.422-.516.319-.949,1.034-1.726.5-.425-1.5.584-2.76.672-4.172a4.559,4.559,0,0,1,.15-.944c.841-2.252,1.8-4.459,2.715-6.681a3.786,3.786,0,0,1,1.5-2.03c.423.558.183,1.16.123,1.756a2.042,2.042,0,0,0,.473,1.99c-1.188-1.129.171-2.629-.639-3.813a3.557,3.557,0,0,1,1.293-2.744c.814,1.09.244,2.468.753,3.634a6.447,6.447,0,0,1,.238,1.361c.331-.251.239-.6.348-.872.275-1.363-.428-2.678-.2-4.038a.865.865,0,0,1,.328-.55c.509-.4,1.169-.738.54-1.536a1.306,1.306,0,0,1-.635-.823,1.373,1.373,0,0,1,.67-1.558.792.792,0,0,1,.4.006c.619.465.724-.307.892-.5.812-.919,1.58-1.331,2.538-.139a4.415,4.415,0,0,0-.051-1.471c-.054-.753-.046-1.459.853-1.732.652-.2.552-.71.372-1.117-.25-.564-.172-1.437-1.14-1.454a.411.411,0,0,1,.015-.585l.051-.572-.008.018a67.807,67.807,0,0,0,5.559-10.212c.691-1.266.987-2.711,1.786-3.93.267-.408.31-.975.853-1.183.529-.053.791.276,1.053.7-1.057-1.345-.065-2.507.265-3.73.038-.14.086-.276.134-.412.187-.558.3-1.141.522-1.687.963-2.131,1.241-4.507,2.359-6.582.918-.824.959-2.033,1.137-3.087a14.12,14.12,0,0,0,.4-3.444c-.016,1.1-.016,1.1-.689,1.245a4.457,4.457,0,0,1-.225-2.4c.17-2.29-.221-4.56-.153-6.842.886-1.067,0-2.342.4-3.467.688-.485.529.259.713.5a1.922,1.922,0,0,1,.393,1.286,9.3,9.3,0,0,0-.989-2.966,3.72,3.72,0,0,1-.532-.322.742.742,0,0,1-.212-.341c-.057-.374.247-.92-.472-.984-.5-.339-.712-.792-.3-1.289.318-.387.681-.113,1.083.044a125.812,125.812,0,0,1,13.366,6.427c.937.093,1.5,1.2,2.563.951l.593,0q.177.287.356.571c.763,1.4,2.316,1.8,3.524,2.549,3.1,1.918,6.141,3.911,9.091,6.048.209.152.469.211.675.368a1.994,1.994,0,0,1,.278.014c-.12.907-1.065.6-1.517,1.032-3.7,3.542-5.031,7.177-3.11,12.571,1.416,3.976,5.993,6.519,10.3,5.969.043-.006.081-.05.225-.143a21.373,21.373,0,0,1-1.758-1.455,3.8,3.8,0,0,1-.853-4.417c.72-1.685,1.665-3.279,2.3-5.011.992-.181,1.079-1.617,2.215-1.606.9.1,1.383.789,1.938,1.376a1.213,1.213,0,0,1,.089.657,6.877,6.877,0,0,1-3.471,3.5,2.956,2.956,0,0,0-.871,4.943,3.4,3.4,0,0,0,4.674.657,9.754,9.754,0,0,0,3.905-3.978c.61-.128,1.083.54,1.716.3a2.727,2.727,0,0,1,1.286.7c1.417,1.709,3.207,3.081,4.468,4.932,1.337,1.621,2.967,2.974,4.247,4.647.408,1.061,1.346,1.719,1.974,2.611.31.439.778.8.8,1.4a1.9,1.9,0,0,1-.406.812c-.967,1.435-1.134,1.294-2.345.191-1.877-1.709-3.236-3.907-5.154-5.257-.273-.323-.339.033-.229-.141.016-.026.058,0,.129.079,2.209,2.446,4.613,4.695,6.994,6.968,1.1,1.054,1.878,2.45,3.282,3.2a2.27,2.27,0,0,1,.362.638,1.827,1.827,0,0,0-.361-.639,8.741,8.741,0,0,1-1.727-1.472,3.142,3.142,0,0,1-.464-.773c-.067-.174.684-.906-.4-.523-.465.165-.807-.7-.6-1.277.194-.551.441-1.157,1.162-1.278,1.767.761,2.212,2.463,2.864,4.018.613.905,1.544,1.726.814,2.995l1.066,1.523a4.224,4.224,0,0,1,2.825,2.78c.067.173.342.2.525.294,1.351.7,1.282,2.406,2.34,3.316.115.269.339.471.463.736,2.151,3.928,4.1,7.957,6.085,11.972a2.056,2.056,0,0,1,.2.391,8.618,8.618,0,0,0,1.5,3.311,13.143,13.143,0,0,0,1.661,3.993l0,.006c1.25,3.923,2.727,7.773,3.794,11.754a29.021,29.021,0,0,0,.905,3.062,1.566,1.566,0,0,1,.085.479,171.455,171.455,0,0,1,3.627,19.759c.329,3.2.586,6.411.981,9.607.26,4.383.093,8.771.14,13.156.019,1.773-.463,3.525-.506,5.311-.011.418-.084.811.233,1.147q-.008,1.23-.014,2.459c-.1.016-.193.029-.29.038-.341-.316-.408-.651-.223-.856.1,1-.61,2.107-.1,3.305q-.009,1.534-.017,3.069c-.094.016-.188.027-.282.034a2.051,2.051,0,0,1-.783-1.211c-.823.046-.847.04-1.033.87a6.328,6.328,0,0,0,.7,4.713c.166.67-.249,1.1-.64,1.535a.6.6,0,0,1-.778-.1c-.343-.656-.721-.316-1.1-.037a1.3,1.3,0,0,1-1.406-.4,1.392,1.392,0,0,1,.128-1.577.524.524,0,0,0-.136-.8c-.437-.266-.63.1-.857.374-.5.607-.229,1.54-.888,2.079a2.147,2.147,0,0,1-1.736.342c-1.336-.873-2.563-.264-3.645.451a24.8,24.8,0,0,0-2.284,1.753,8.59,8.59,0,0,0-3.391,3.233c-.59.967-1.184,1.043-1.943.254-1.426-1.482-3.352-1.919-5.2-2.53-.486-.16-.772.157-1.149.262-1.692.238-3.383-.364-5.1.106a12.5,12.5,0,0,1-2.667.5c-2.25-.349-3.758.872-5.106,2.421a1.777,1.777,0,0,1-.08.4,1.013,1.013,0,0,1-.76.627,10.1,10.1,0,0,0-2.486,3.392,2.8,2.8,0,0,1-.254,1.339,13.736,13.736,0,0,0-.408,10.181,1.936,1.936,0,0,1,.056.915,3.637,3.637,0,0,0,.591,2.594c.675,1.23.644,1.676-.645,2.437a15.267,15.267,0,0,0-3.967,3.516,4.815,4.815,0,0,0-1.082,2.6,6.9,6.9,0,0,0-.925,3.025c-.06,1.1-.609,1.274-1.367,1.434-1.488.314-3.024.316-4.51.669a4.563,4.563,0,0,0-1.685.645c-1.139-.238-2.075.819-3.286.478-.347-.1-.065.8-.723,1.175a18.17,18.17,0,0,0-7.127,7.145c-.866,1.6-1.119,1.621-2.379.274a5.388,5.388,0,0,0-2.567-1.287c-.524-.164-.379.267-.291.557a33.344,33.344,0,0,0-5.87-1.549,4.949,4.949,0,0,0-2.762-.375c-.638.049-1.3.251-1.871-.238-2.115.118-3.891,1.307-5.87,1.854-2.15.7-3.567,2.37-5.162,3.826-1.835,1.674-3.192,1.814-5.229.666-.526-.3-.572-.769-.651-1.39-.145-1.137.461-2.48-.7-3.412-.722-.964-.761-2.2-1.282-3.245a10.663,10.663,0,0,0-3.976-4.474l-.311-.31c-.125-.854-.867-1.109-1.486-1.375-1.392-.6-2.732-1.49-4.379-1.116a.622.622,0,0,1-.617-.286l-.306-.315c-1.454-.556-2.95-.127-4.426-.175-.487-.015-.989.224-1.443-.135-.206-1.806-.419-3.612-.618-5.419a16.833,16.833,0,0,0-1.854-5.7c.2-1.385-.328-2.712-.329-4.084C-2682.028-1442.628-2682.344-1442.877-2682.933-1442.589Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64175",
    "data-name": "Path 64175",
    d: "M-2583.15-1458.344c.28.471.693,1.3-.352.874-2.664-1.083-5.478-.1-8.143-.835a2.3,2.3,0,0,0-2.622.692c-.672.8-1.231.459-1.549-.421.154-.5.588-.686,1.015-.867a15.494,15.494,0,0,1,10.079-.563A2.016,2.016,0,0,1-2583.15-1458.344Z",
    fill: "#dbedec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64176",
    "data-name": "Path 64176",
    d: "M-2603.23-1439.807c-.115-1.78-1.045-3.374-.971-5.239a15.745,15.745,0,0,1,1.882-7.436c1.034.927.056,1.865-.223,2.577a5.165,5.165,0,0,0-.411,2.747,4.977,4.977,0,0,1-.166,2.276,1.67,1.67,0,0,0,.3,1.844,5.383,5.383,0,0,0,.519-2.022c.36.9.785,1.791-.293,2.533-.14.1-.3.421-.253.489.98,1.311.612,3.167,1.782,4.392a.848.848,0,0,1-.65.28C-2602.892-1437.763-2602.991-1438.828-2603.23-1439.807Z",
    fill: "#d8f1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64177",
    "data-name": "Path 64177",
    d: "M-2583.15-1458.344a14.273,14.273,0,0,0-12.666.31,12.661,12.661,0,0,0-2.879,2.09c-.334.349-.727.576-1.138.07l.613-.62c.368-.322.54-.795.88-1.141,1.241-.886,2.4-1.941,4.061-1.957a18.353,18.353,0,0,1,8.348-.6,8.919,8.919,0,0,1,5.046,1.783c.322.227.665.495.522.991-.55.4-1.055.809-1.561-.116A1.407,1.407,0,0,0-2583.15-1458.344Z",
    fill: "#d5f3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64178",
    "data-name": "Path 64178",
    d: "M-2580.363-1457.419c-1.26-1.45-3.039-1.9-4.763-2.439-.282-.089-.61-.042-.8-.335.043-.438.283-.725.711-.535,1.977.878,4.339.98,5.791,2.936.419.564.836.517,1.239-.227a7,7,0,0,1,3.69-3.413.615.615,0,0,1,.157.393c-.22.739-.886,1.123-1.339,1.677a10.246,10.246,0,0,0-2,2.646c-.643.925-1.221.987-1.756-.086A.956.956,0,0,0-2580.363-1457.419Z",
    fill: "#a8d9e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64179",
    "data-name": "Path 64179",
    d: "M-2603.23-1439.807c.508.723.64,1.711,1.525,2.169a1.8,1.8,0,0,1,.629.923,1.837,1.837,0,0,1-.3,1.228,19.112,19.112,0,0,0-4.436,4,9.225,9.225,0,0,1-1.952,2.629.59.59,0,0,1-.408-.139c-.5-1.614.742-2.617,1.546-3.561a10.253,10.253,0,0,1,3.5-2.788c.838-.381,1.478-1,.4-2.094A1.994,1.994,0,0,1-2603.23-1439.807Z",
    fill: "#a8d8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64180",
    "data-name": "Path 64180",
    d: "M-2607.862-1428.994a22.535,22.535,0,0,1,3.457-4.583,7.74,7.74,0,0,1,3.027-1.91c.575.288.515.515-.03.8a11.23,11.23,0,0,0-6.265,9.113c-.113.933-.332.777-.811.289-.884-1.285.138-2.337.433-3.476C-2608.029-1428.851-2607.927-1428.918-2607.862-1428.994Z",
    fill: "#d5f3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64181",
    "data-name": "Path 64181",
    d: "M-2607.862-1428.994c-.009,1.269-.854,2.4-.622,3.707a1.265,1.265,0,0,1-1.317,1.221,29.036,29.036,0,0,0-6.714,1.239v-.3c.048-.733.565-.784,1.152-.96,1.76-.528,3.648-.163,5.375-.848.4-.159,1.408-.045.276-.75.911-.919.47-2.466,1.538-3.312Z",
    fill: "#a7d8eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64182",
    "data-name": "Path 64182",
    d: "M-2594.1-1431.333c-.512-.572-.649-1.437-1.5-1.675-.707-.2-.66-.961-.974-1.448-.16-.248.228-.411.481-.392.682.049,1.443-.271,2,.4C-2593.269-1433.467-2592.585-1432.483-2594.1-1431.333Z",
    fill: "#ddf1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64183",
    "data-name": "Path 64183",
    d: "M-2575.426-1456.8a8.657,8.657,0,0,0-3.4,3.4c-1.466-.945-.28-1.511.309-2.162a28.275,28.275,0,0,0,2.03-2.927c.452-.311.706-.944,1.4-.866C-2574.04-1458.35-2575.39-1457.662-2575.426-1456.8Z",
    fill: "#d7eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64184",
    "data-name": "Path 64184",
    d: "M-2576.353-1458.344c-.611,1.013-.783,2.366-2.163,2.781a9.178,9.178,0,0,1-1.144-.71c-.362-.3-.194-.494.222-.528.658.566,1.066.651,1.6-.3.518-.929.867-2.126,2.1-2.5C-2575.575-1459-2576.1-1458.738-2576.353-1458.344Z",
    fill: "#d3f3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64185",
    "data-name": "Path 64185",
    d: "M-2612.738-1423.369c.85-.124,1.7-.274,2.551-.358.4-.04.925.016.907.553-.017.514-.549.367-.858.342-.888-.072-1.771-.213-2.656-.327Z",
    fill: "#ddf1f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64186",
    "data-name": "Path 64186",
    d: "M-2601.076-1436.715c-.612-.034-.612-.484-.629-.923l.638-.008c.434.562.992,1.084.692,1.955C-2601-1435.83-2600.578-1436.576-2601.076-1436.715Z",
    fill: "#d5f3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64187",
    "data-name": "Path 64187",
    d: "M-2602.393-1445.037a3.054,3.054,0,0,1,0-2.149Z",
    fill: "#d8f1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64188",
    "data-name": "Path 64188",
    d: "M-2589.019-1435.482c0,.1,0,.205,0,.307-.235-.047-.613-.026-.674-.156-.119-.251.155-.474.388-.536C-2589.019-1435.944-2589.052-1435.662-2589.019-1435.482Z",
    fill: "#ddf1f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64189",
    "data-name": "Path 64189",
    d: "M-2613.8-1405.606c.306,1.057.087,2.332,1.794,2.31-.554.5-1.074.794-1.445.273A2.4,2.4,0,0,1-2613.8-1405.606Z",
    fill: "#d7eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64190",
    "data-name": "Path 64190",
    d: "M-2575.426-1456.8c-.136-.615-.423-1.228.389-1.669.334-.181-.006-.533-.082-.8-.24-.3-.179-.531.166-.692,1.049.9.969.859,1.7-.465a6.011,6.011,0,0,0,.576-1.319,2.248,2.248,0,0,1,3.119-.615c1.123.774,1.037,1.426-.472,2.445a7.828,7.828,0,0,0-1.851,1.936c-.542.732-.937,1.452-2.043.767-.68-.421-.459.628-.885.724A.638.638,0,0,0-2575.426-1456.8Z",
    fill: "#d6eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64191",
    "data-name": "Path 64191",
    d: "M-2569.183-1458.6c.983,1.479,2.5,2.294,3.7,3.459.717.7.62,1.13.073,1.781-.629.747-1.09.453-1.6-.119a15.108,15.108,0,0,0-2.88-3.07c-.3-.193-.35-.668-.032-.733C-2569.1-1457.452-2569.787-1458.223-2569.183-1458.6Z",
    fill: "#d6eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64192",
    "data-name": "Path 64192",
    d: "M-2574.807-1459.888a.642.642,0,0,0-.312.618c-.541.136-.57.954-1.234.926-.047-.541.459-.812.614-1.254.164-.711.921-.935,1.244-1.515,1.661-1.515,3.473-2.678,5.855-2.509a5.009,5.009,0,0,0,1.864-.282,1.414,1.414,0,0,1,1.852,0,2.418,2.418,0,0,0,1.541.283.644.644,0,0,1,.921.031.656.656,0,0,0,.63.289c.411-.224.649.075.912.3l-.3.639c-.631-.023-1.491.944-1.843-.477-.042-.165-1.012-.1-1.552-.142a1.921,1.921,0,0,0-2.166,0c-.911.273-2.078-.6-2.779.618-1.131-.028-2.258-.039-3.09.93C-2573.2-1460.677-2573.677-1459.829-2574.807-1459.888Z",
    fill: "#d5f3f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64193",
    "data-name": "Path 64193",
    d: "M-2559.054-1496.957a2.777,2.777,0,0,1-.575-1.857,73,73,0,0,0-1.036-10.276c-.348-2.715-.829-5.438-1.376-8.141-.627-3.1-1.7-6.157-1.647-9.385a.191.191,0,0,1,.314,0,115.29,115.29,0,0,1,4.332,25.311A13.284,13.284,0,0,1-2559.054-1496.957Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64194",
    "data-name": "Path 64194",
    d: "M-2559.054-1496.957q.006-2.175.012-4.35a1.064,1.064,0,0,1,.282.844c.069,5.73.609,11.458.252,17.184a34.141,34.141,0,0,1-.537,6.091c-1.215-.55-.7-1.69-.56-2.411.766-3.945.408-7.929.474-11.886C-2559.1-1493.3-2559.016-1495.133-2559.054-1496.957Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64195",
    "data-name": "Path 64195",
    d: "M-2563.374-1526.618l-.314,0h0c-.661-.816-.3-2.085-1.233-2.781-.288-2.278-1.4-4.324-1.862-6.547-.389-1.876-1.852-3.451-1.521-5.518.989.874,1,2.187,1.449,3.3,1.368,3.413,2.287,6.977,3.375,10.484A5.164,5.164,0,0,1-2563.374-1526.618Z",
    fill: "#a9d7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64196",
    "data-name": "Path 64196",
    d: "M-2568.3-1541.469l-.427.111c-.284-1.438-1.674-2.486-1.448-4.1a.7.7,0,0,1,0-.893A15.915,15.915,0,0,1-2568.3-1541.469Z",
    fill: "#a7d6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64197",
    "data-name": "Path 64197",
    d: "M-2570.178-1546.355l0,.893a7.347,7.347,0,0,1-1.546-3.4c.6-.188.347.48.623.616C-2570.7-1547.659-2570.75-1546.855-2570.178-1546.355Z",
    fill: "#a2d4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64198",
    "data-name": "Path 64198",
    d: "M-2571.1-1548.242l-.623-.616v0a.733.733,0,0,1,0-.926c.1,0,.2.007.3.014Q-2571.258-1549.007-2571.1-1548.242Z",
    fill: "#a7d6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64199",
    "data-name": "Path 64199",
    d: "M-2848.218-1485.223c.43.344.309.829.309,1.271a65.731,65.731,0,0,0,.3,8.325c-.913-2.472-.513-5.053-.618-7.591C-2848.249-1483.885-2848.221-1484.554-2848.218-1485.223Z",
    fill: "#abd9e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64200",
    "data-name": "Path 64200",
    d: "M-2847.6-1475.337c.637.979.177,2.067.308,3.1C-2847.873-1473.225-2847.494-1474.305-2847.6-1475.337Z",
    fill: "#abd9e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64201",
    "data-name": "Path 64201",
    d: "M-2847.293-1472.244c.627.758.185,1.651.312,2.472C-2847.546-1470.538-2847.183-1471.421-2847.293-1472.244Z",
    fill: "#abd9e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64202",
    "data-name": "Path 64202",
    d: "M-2846.981-1469.772c.566.55.221,1.247.3,1.875C-2847.184-1468.457-2846.914-1469.142-2846.981-1469.772Z",
    fill: "#abd9e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64203",
    "data-name": "Path 64203",
    d: "M-2846.678-1467.615c.528.44.251,1.038.306,1.571C-2846.832-1466.5-2846.626-1467.082-2846.678-1467.615Z",
    fill: "#abd9e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64204",
    "data-name": "Path 64204",
    d: "M-2845.743-1516.73c-.073.521.212,1.115-.319,1.541C-2845.991-1515.71-2846.223-1516.294-2845.743-1516.73Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64205",
    "data-name": "Path 64205",
    d: "M-2575.435-1447.537a1.687,1.687,0,0,1-2.064-1.452c-.194-1.2-1.31-2.651.416-3.678a5.1,5.1,0,0,0,1.716-2.053c.447-.823.651-.381.87-.063.968,1.4,1.439,3.246,3.462,3.7.292.065.5.759.272.9C-2572.264-1449.263-2573.226-1447.389-2575.435-1447.537Z",
    fill: "#d6eef1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64206",
    "data-name": "Path 64206",
    d: "M-2683.242-1660.7a7.1,7.1,0,0,0-3.4-.921.611.611,0,0,1-.639-.152c-.954-.68-2.12-.633-3.188-.919-.63-.17-1.325-.164-1.787-.74a.421.421,0,0,1,.092-.446,2.246,2.246,0,0,1,1.434.093,45.72,45.72,0,0,1,13.039,4.665,20.123,20.123,0,0,1,4.423,2.712.479.479,0,0,1-.707.041,8.083,8.083,0,0,1-3.4-1.548c-.117-.165-.224-.41-.431-.4C-2680.006-1658.228-2681.439-1659.885-2683.242-1660.7Z",
    fill: "#d8a729"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64207",
    "data-name": "Path 64207",
    d: "M-2673.976-1656.366l.706-.041c.691.13,1.14.686,1.736.983.674.68,1.669.976,2.194,1.834l.92.9c.353.389,1.042.529.931,1.261-1.19-.223-1.759-1.377-2.779-1.855-.231-.18-.507-.316-.624-.612C-2671.827-1654.833-2673.215-1655.208-2673.976-1656.366Z",
    fill: "#d7a827"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64208",
    "data-name": "Path 64208",
    d: "M-2690.731-1663.784l-1.476,0a24.257,24.257,0,0,1-5.784-.48,1.89,1.89,0,0,1-.962-.321.319.319,0,0,1-.045-.452c2.416-.13,4.732.632,7.116.787C-2691.524-1664.029-2691.01-1664.2-2690.731-1663.784Z",
    fill: "#d6ac29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64209",
    "data-name": "Path 64209",
    d: "M-2611.571-1597.363a20.545,20.545,0,0,1-2.245,4.963c-.989,1.775.264,4.3,2.584,5.505.215.111.445.193.723.313-1.745,1.022-5.055.743-7.2-.435a10.227,10.227,0,0,1-5.467-7.247,10.982,10.982,0,0,1,2.893-10,5.814,5.814,0,0,1,2.84-1.74,5.494,5.494,0,0,1,1.84,1.236,3.137,3.137,0,0,1-.8.678c-2.236,1.049-2.749,3.091-2.805,5.24a4.427,4.427,0,0,0,3.2,4.634c-1.383-2.594.77-4.057,1.642-5.913a1.492,1.492,0,0,1,1.892-.674,2.246,2.246,0,0,1,1.2,2.133A1.54,1.54,0,0,1-2611.571-1597.363Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64210",
    "data-name": "Path 64210",
    d: "M-2617.725-1606.021c-.73.071-1.2-.383-1.762-.759-3.3-2.2-6.652-4.325-9.962-6.513-.592-.392-1.543-.257-1.779-1.184a.417.417,0,0,1,.213-.508,115.433,115.433,0,0,1,12.024,7.646A8.438,8.438,0,0,1-2617.725-1606.021Z",
    fill: "#a2d5e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64211",
    "data-name": "Path 64211",
    d: "M-2616.511-1604.47c.215-.361.572-.293.9-.3,1.371,1.093,2.968,1.913,4.044,3.359.177.211.529.358.27.73a.636.636,0,0,1-.71-.065C-2613.543-1601.943-2615.4-1602.749-2616.511-1604.47Z",
    fill: "#a3d3e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64212",
    "data-name": "Path 64212",
    d: "M-2611.263-1600.758l-.3-.654c1.066.153,1.378,1.436,2.425,1.617.161.727,1.054.813,1.293,1.474a.467.467,0,0,1-.019.65l-1.855-1.234C-2610.8-1599.053-2611.532-1599.487-2611.263-1600.758Z",
    fill: "#a5d4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64213",
    "data-name": "Path 64213",
    d: "M-2715.986-1663.165c.036.217.528.449.221.567-.727.281-1.975-.505-2.03,1.073-1.575-.554-2.7,1.13-4.239.843a7.6,7.6,0,0,0-1.375-.013C-2721.144-1662.147-2718.5-1662.446-2715.986-1663.165Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64214",
    "data-name": "Path 64214",
    d: "M-2708.58-1664.094c-1.676-.369-3.266.612-4.938.313l-.65-.327c.331-.446.813-.28,1.246-.31.477-.341,1.1.093,1.569-.3l.618-.276,3.371-.055a.385.385,0,0,1,.078.383C-2707.585-1664.176-2708.191-1664.381-2708.58-1664.094Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64215",
    "data-name": "Path 64215",
    d: "M-2728.961-1658.22c-.1.56-.5,1.191.512,1.393.3.061.747.425.553.792-.295.557-.659,0-1.012-.071-.8-.159-1.358-.905-2.219-.886A3.35,3.35,0,0,1-2728.961-1658.22Z",
    fill: "#e8b021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64216",
    "data-name": "Path 64216",
    d: "M-2732.98-1656.059c.146.836.585.248.89.166.538-.146,1.022-.805,1.756-.04-1.239.392-2.547.724-2.2,2.418-1.1-.235-.638-1.33-1.072-1.93Z",
    fill: "#e8b021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64217",
    "data-name": "Path 64217",
    d: "M-2735.139-1654.513c-.12.686.341,1.548-.6,1.984-.23.106-.484.231-.7.048-.319-.27,0-.537.061-.8A3.166,3.166,0,0,1-2735.139-1654.513Z",
    fill: "#e7b21b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64218",
    "data-name": "Path 64218",
    d: "M-2648.322-1600.768a60.032,60.032,0,0,1-2.182,6.8.26.26,0,0,1-.378.008c-.28-.6.037-1.156.125-1.729a2.431,2.431,0,0,1,.169-.409,7.654,7.654,0,0,0,.637-3,4.782,4.782,0,0,1,.607-1.879,43.111,43.111,0,0,0,.95-5.423c.254-2.718.116-5.429.152-8.134a31.038,31.038,0,0,0-1.315-8.305c-.1-.383-.367-.766.086-1.1a.627.627,0,0,0,.218-.039,126.642,126.642,0,0,1,14.829,7.145c-.183.2.147.416-.008.622a40.763,40.763,0,0,1-6.442-3.249c-2.406-1.377-5.21-1.834-7.477-3.467a.346.346,0,0,0-.511.182c-.165.487.129.768.525.974.408.336-.121.907.311,1.236h0a9.186,9.186,0,0,1,.334,4.929,73.6,73.6,0,0,1,.291,9.591A7.724,7.724,0,0,1-2648.322-1600.768Z",
    fill: "#a2d4e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64219",
    "data-name": "Path 64219",
    d: "M-2649.471-1623.935c-.015,1.758.659,3.393.947,5.1a54.237,54.237,0,0,1,.421,13.908c-.128,1.437-.1,3.011-1.129,4.252-.361-2.125.371-4.168.465-6.261.525-2.339.09-4.733.42-7.081a54.975,54.975,0,0,0-1.3-8.4,6.608,6.608,0,0,1-.234-1.8Z",
    fill: "#e6b12d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64220",
    "data-name": "Path 64220",
    d: "M-2651.424-1627.329a28.323,28.323,0,0,0-1.553-4.323,1.354,1.354,0,0,1-.127-1.107c.056-.053.113-.106.169-.16a24.137,24.137,0,0,1,2.5,6.51C-2651.18-1626.271-2651.039-1627.082-2651.424-1627.329Z",
    fill: "#d6a82f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64221",
    "data-name": "Path 64221",
    d: "M-2651.424-1627.329q.5.459.988.92a2.488,2.488,0,0,1,.279,1.864A7.125,7.125,0,0,1-2651.424-1627.329Z",
    fill: "#d5aa2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64222",
    "data-name": "Path 64222",
    d: "M-2653.9-1634.988a1.445,1.445,0,0,1,.262.03c-.09.792.778,1.254.7,2.039l-.059.046c-.552.146-.63-.379-.9-.635v0A1.089,1.089,0,0,1-2653.9-1634.988Z",
    fill: "#d6a82f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64223",
    "data-name": "Path 64223",
    d: "M-2753.992-1630.423l-.925.93a.95.95,0,0,1-.029-1l.662-2.058c.528-.871.429-2.034,1.284-2.753h.009c1.325-1.557,1.869-3.617,3.293-5.111q.019.52.039,1.041c-.838,1.089-2.04,2.077-.852,3.732-.579-.044-1.065-1.143-1.369-.121C-2752.43-1633.916-2753.872-1632.43-2753.992-1630.423Z",
    fill: "#d8a824"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64224",
    "data-name": "Path 64224",
    d: "M-2748.466-1642.188a7.075,7.075,0,0,1,1.865-2.46C-2746.043-1642.934-2747.876-1643.032-2748.466-1642.188Z",
    fill: "#e3ba50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64225",
    "data-name": "Path 64225",
    d: "M-2749.437-1640.963a2.155,2.155,0,0,1,.971-1.224A1.175,1.175,0,0,1-2749.437-1640.963Z",
    fill: "#e3ba50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64226",
    "data-name": "Path 64226",
    d: "M-2589.025-1577.278c-.7-.858-1.377-1.738-2.112-2.566a1.781,1.781,0,0,1-.662-1.454c.351-.19.45.147.634.3l.579.32c.97,1.818,2.521,3.2,3.677,4.871,2.209,3.2,4.374,6.426,6.557,9.642.88,1.15,1.065,2.7,2.145,3.735.121.376.459.826-.307.9-.618-1.2-.982-2.559-2.163-3.4-1-1.779-2.511-3.181-3.613-4.884-.594-.918-.523-2.22-1.64-2.837-.934-1.335-1.225-3.114-2.778-4.022C-2588.989-1576.78-2589.19-1576.934-2589.025-1577.278Z",
    fill: "#a5d3e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64227",
    "data-name": "Path 64227",
    d: "M-2754.946-1630.495l.029,1c-.442.309-.278,1.067-.913,1.233A6.026,6.026,0,0,1-2754.946-1630.495Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64228",
    "data-name": "Path 64228",
    d: "M-2755.881-1628.047a2.349,2.349,0,0,1-.623,1.945A2.952,2.952,0,0,1-2755.881-1628.047Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64229",
    "data-name": "Path 64229",
    d: "M-2634.432-1616.207c.17-.2-1.032-.428.008-.622.974.123,1.61.9,2.46,1.268-.064.39-.014,1.208-.645.566A21.762,21.762,0,0,0-2634.432-1616.207Z",
    fill: "#a2d2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64230",
    "data-name": "Path 64230",
    d: "M-2607.864-1597.671c.006-.217.012-.433.019-.65,2.155,1.417,3.646,3.613,5.841,4.984l.3.61c-.3.234-.719.14-1.01.392-.649-.177-.9-.8-1.355-1.2-1.122-1.33-2.669-2.2-3.794-3.525Z",
    fill: "#b0dae8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64231",
    "data-name": "Path 64231",
    d: "M-2591.165-1580.994l-.634-.3c-1.529-1.086-2.392-2.9-4.132-3.774-.166-.083-.134-.564-.194-.86-.006-.312-.335-.624,0-.935A42.112,42.112,0,0,1-2591.165-1580.994Z",
    fill: "#a7d5e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64232",
    "data-name": "Path 64232",
    d: "M-2596.122-1586.867c-.107.311.353.624,0,.935-1.37-1.711-3.251-2.974-4.327-4.941a.227.227,0,0,1,.361-.027A32.169,32.169,0,0,1-2596.122-1586.867Z",
    fill: "#a4d5e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64233",
    "data-name": "Path 64233",
    d: "M-2600.091-1590.9l-.361.026a1.707,1.707,0,0,1-1.234-.62c-.418-.2-1.109-.126-.928-.926.066-.809.608-.2.91-.307A7.746,7.746,0,0,1-2600.091-1590.9Z",
    fill: "#a9d3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64234",
    "data-name": "Path 64234",
    d: "M-2695.04-1442.6l-.62,1.844a2.118,2.118,0,0,0-.572,1.228c-.667.873-.345,2.289-1.567,2.859a1.9,1.9,0,0,1-.242-.883,5.53,5.53,0,0,1,.327-1.31,14.643,14.643,0,0,0,.521-1.657c.5-.866.682-1.952,1.693-2.47A.434.434,0,0,1-2695.04-1442.6Z",
    fill: "#e14c28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64235",
    "data-name": "Path 64235",
    d: "M-2797.55-1598.6l-4.017,3.394c-.246-.129-.126-.435-.291-.6l0-.305c1.968-1.177,3.365-3.042,5.229-4.345l.166.171C-2796.048-1599.225-2796.732-1598.868-2797.55-1598.6Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64236",
    "data-name": "Path 64236",
    d: "M-2794.182-1602.33l.343.333c0,.1,0,.2,0,.307-.276.521-.592.965-1.29.657a.5.5,0,0,1,.062-.642Z",
    fill: "#9dd0e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64237",
    "data-name": "Path 64237",
    d: "M-2795.071-1601.675l0,.6c-.291.748-.751,1.084-1.535.63l-.015-.017A4.377,4.377,0,0,1-2795.071-1601.675Z",
    fill: "#addae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64238",
    "data-name": "Path 64238",
    d: "M-2806.81-1590.567l-.01-.333a22.013,22.013,0,0,1,3.709-3.686.368.368,0,0,1,.313.322A8.765,8.765,0,0,1-2806.81-1590.567Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64239",
    "data-name": "Path 64239",
    d: "M-2802.8-1594.264l-.313-.322,1.253-1.223a.613.613,0,0,1,.291.6C-2801.975-1594.888-2802.113-1594.218-2802.8-1594.264Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64240",
    "data-name": "Path 64240",
    d: "M-2664.711-1411.071a2,2,0,0,1-.923-.932A.864.864,0,0,1-2664.711-1411.071Z",
    fill: "#d7eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64241",
    "data-name": "Path 64241",
    d: "M-2653.9-1634.988l.007,1.478c-.947-1.173-1.324-2.654-2.108-3.91-1.035-1.66-1.811-3.519-3.451-4.741-.274-.116-.473-.271-.314-.61-1.072-1.866-2.721-3.264-4.017-4.948a2.257,2.257,0,0,1-1.852-1.853.648.648,0,0,1-.309-.616.253.253,0,0,1,.379-.035,43.714,43.714,0,0,1,8.116,9.178,9.561,9.561,0,0,0,.7.806Z",
    fill: "#d9ab2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64242",
    "data-name": "Path 64242",
    d: "M-2665.566-1650.223l-.379.035c-.5-.424-1.208-.6-1.544-1.237q-.465-.631-.931-1.261C-2667.122-1652.267-2666.455-1651.116-2665.566-1650.223Z",
    fill: "#d5af2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64243",
    "data-name": "Path 64243",
    d: "M-2571.718-1549.786l0,.926a55.778,55.778,0,0,1-3.834-7.632c-.464-1.357-1.631-2.325-2.1-3.7a3.226,3.226,0,0,1-.245-1.026.2.2,0,0,1,.328-.008,41.949,41.949,0,0,1,2.968,5.316,2.774,2.774,0,0,0,1,1.5c.321.467.356,1.056.649,1.535h0Z",
    fill: "#a2d4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64244",
    "data-name": "Path 64244",
    d: "M-2577.574-1561.224l-.328.008a.635.635,0,0,1-.612-.311c.353-.214.3-.568.307-.9A1.766,1.766,0,0,1-2577.574-1561.224Z",
    fill: "#a5d5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64245",
    "data-name": "Path 64245",
    d: "M-2706.056-1449.991l-.37-.638a1.439,1.439,0,0,1-.13-1.141c.648-.555.953-.026,1.327.4,1,1.134,1.63,2.527,2.636,3.683.675.775-.15,1.177-.945,1.256-.317-.093-.457-.357-.6-.617C-2704.444-1448.248-2705.529-1448.938-2706.056-1449.991Z",
    fill: "#fa5827"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64246",
    "data-name": "Path 64246",
    d: "M-2710.437-1457.1l-.187-.654c.152-.413.507-.431.688-.151,1.108,1.713,2.659,3.2,2.85,5.4a.719.719,0,0,1-.267.374Z",
    fill: "#dd5432"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64247",
    "data-name": "Path 64247",
    d: "M-2706.056-1449.991a4.316,4.316,0,0,1,2.1,2.77c-.35.2-.45-.174-.661-.292l-.533-.4a1.746,1.746,0,0,0-.884-1.2Z",
    fill: "#d4522d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64248",
    "data-name": "Path 64248",
    d: "M-2707.353-1452.134l.025-.342c.68-.346.834.094.929.621l-.027,1.226A2.963,2.963,0,0,1-2707.353-1452.134Z",
    fill: "#cb4421"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64249",
    "data-name": "Path 64249",
    d: "M-2706.4-1451.855c-.33-.177-.448-.669-.929-.621a10.31,10.31,0,0,0-3.3-5.279l-.71.122c.193-.579,1.054-.626,1.123-1.4-1.828.543-2.438,2.244-3.518,3.448-.282.314-.319,1.057-.8.983-.568-.087-.518-.766-.545-1.267a3.164,3.164,0,0,1,.489-1.114c.383-.762.48-1.456-.418-1.968-.763-.436-.522-.863.064-1.25.176-.351.136-.764.314-1.116a.439.439,0,0,1,.334-.2c.689.3.759,1.169,1.39,1.511.318.7.381-.469.657-.1,1.364-.014,1.987-.812,1.991-2.556a.637.637,0,0,1,.334-.513,5.586,5.586,0,0,1,1.005-.311,1.427,1.427,0,0,1,.631.009,1.864,1.864,0,0,1,.735.417,2.074,2.074,0,0,1,.414.735,1.043,1.043,0,0,1-.065.8c-.251.35-.562-.086-.827.064-.118.027-.222.116-.177.189s.183.068.285.1a.789.789,0,0,1,.18.349c.125.756-.893,1.183-.519,2.117.348-.18.724-1.041,1.092-.361.594,1.094,1.889,1.94,1.385,3.5-.092.284-.487.951.509.67.361-.1.415.6.406,1.011,0,.206.008.41.019.616.094-.213.025-.49.218-.657.3-.259.685-.15,1.033-.211a1.4,1.4,0,0,1,1.016,1.26c-.025.6-.741,1.474.618,1.507a.7.7,0,0,1,.414.438c.184.566-.141,1.033-.327,1.574.35-.264.356-.695.628-.952.666-.2.7.426.94.753.506.688.843,1.517,1.671,1.92.4.318.889-.151,1.288.149a.465.465,0,0,1,.069.411c-.01.026.1.005.111-.122a1.431,1.431,0,0,1,.763-1.2c.706-.4,1.229.179,1.833.338a1.821,1.821,0,0,1,1.3,1.12,18.577,18.577,0,0,1-2.028,4.035c-.886.594-.922,1.717-1.538,2.479-.244.351-.507.53-.795.051-.25-.415-.02-.845,0-1.178-.649.384-.585,1.552-1.672,1.58-.6-.089-.724-.66-1.049-1.028a.97.97,0,0,1-.011-.432c.115-.718,1.138-.906,1.021-1.972a1.622,1.622,0,0,1-1.279,1.542,2.791,2.791,0,0,1-1.261-1.949c1.044-1-.035-2.173.234-3.178-.643.615.114,1.53-.367,2.234-1.162.2-.841-1.246-1.628-1.463a.3.3,0,0,1,.026-.39c.934-.277,1.424-.427.3-1.376a12,12,0,0,1-2.177-3.174C-2705.73-1451.554-2705.939-1451.824-2706.4-1451.855Z",
    fill: "#ee5b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64250",
    "data-name": "Path 64250",
    d: "M-2703.625-1446.309c1.089-.046.73,1.328,1.532,1.562a.7.7,0,0,1,.33.922l1.218,1.853c.281.115.478.273.319.615,0,.1,0,.206,0,.308a.49.49,0,0,1-.057.726,53.183,53.183,0,0,1-3.39-5.563A.282.282,0,0,1-2703.625-1446.309Z",
    fill: "#d14c2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64251",
    "data-name": "Path 64251",
    d: "M-2700.288-1440.323l.057-.726.916.937a4.787,4.787,0,0,1,.9.889,1.745,1.745,0,0,1,.351,1.658.4.4,0,0,1-.415-.017l-1.106-1.365C-2699.587-1439.525-2700.39-1439.693-2700.288-1440.323Z",
    fill: "#d84c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64252",
    "data-name": "Path 64252",
    d: "M-2703.625-1446.309l-.053.423a3.593,3.593,0,0,1-.934-1.627l.661.292.333.613C-2703.624-1446.508-2703.626-1446.408-2703.625-1446.309Z",
    fill: "#cb5334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64253",
    "data-name": "Path 64253",
    d: "M-2707.341-1664.711c-.008-.113-.015-.225-.023-.337l0,.012a48.336,48.336,0,0,1,7.807-.011l.556.013,0,.324a1.61,1.61,0,0,1-1.258.465c-1.994.016-3.987.005-5.981-.022A1.431,1.431,0,0,1-2707.341-1664.711Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64254",
    "data-name": "Path 64254",
    d: "M-2699.554-1665.047l-7.807.011A24.874,24.874,0,0,1-2699.554-1665.047Z",
    fill: "#dbab25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64255",
    "data-name": "Path 64255",
    d: "M-2685.662-1460.677l-.025.469c-.392.4-.519.969-.889,1.383-.54.606-.722,1.445-1.307,2.022-1.4.857-1.415,2.626-2.453,3.72a.959.959,0,0,1-.633-.177,1.058,1.058,0,0,1-.242-.36,1.418,1.418,0,0,1,.422-1.624c.5-.38.363-.878.315-1.365-.577-.8-.963.617-1.51.131-.523-.538-.331-1.1-.023-1.639.394-.69.692-1.426,1.065-2.124.264-.511,1.066-.872.45-1.631-.1-.51.186-.783.6-.977,1.471-.872,1.555-2.686,2.59-3.825.7-.774.344-2.159,1.587-2.555a8.111,8.111,0,0,1,1.058,1.3,4.543,4.543,0,0,1-.88-2.309c.72-1.9,1.554-3.748,2.28-5.644,1.008-1.191.611-2.809,1.241-4.116a1.659,1.659,0,0,1,.675-.676.828.828,0,0,1,.788.493,12.239,12.239,0,0,1-.719,4.9,9.824,9.824,0,0,0-.467,6.053,9.471,9.471,0,0,1-1.095,3.323c-.223.486-.484.907-1.067.991-.593.031-.829-.443-1.22-1.081.224,1.038.569,1.745.79,2.492C-2684.407-1462.386-2685.386-1461.7-2685.662-1460.677Z",
    fill: "#ef5b29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64256",
    "data-name": "Path 64256",
    d: "M-2693.45-1446.908l-1.225-.932a.578.578,0,0,1-.041-.573,4.343,4.343,0,0,0,.018-4.023,1.038,1.038,0,0,1,.423-1.026c.92.045.765,1.006,1.228,1.44a1.72,1.72,0,0,1,.187.393,3.652,3.652,0,0,1,.05,1.77c-.1.4.128.552.3.782l.3.857-.314.385C-2692.878-1447.575-2692.946-1447.022-2693.45-1446.908Z",
    fill: "#ed5920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64257",
    "data-name": "Path 64257",
    d: "M-2691.287-1450.937c-.325.507-.21,1.275-.921,1.554-1.059-.543-.321-1.755-.92-2.471v0c-.674-.8-.346-1.408.363-1.948.479-.132.714.1.806.543A2.791,2.791,0,0,0-2691.287-1450.937Z",
    fill: "#ed5920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64258",
    "data-name": "Path 64258",
    d: "M-2691.287-1450.937c-.927-.454-1.492-1.062-.915-2.155.426-.046.938.253,1.234-.309a.664.664,0,0,1,.632.318Z",
    fill: "#f6592d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64259",
    "data-name": "Path 64259",
    d: "M-2693.128-1451.854c.858.619.413,1.722.92,2.471l-.3.306c-.1-.3-.72.393-.641-.369A23.556,23.556,0,0,0-2693.128-1451.854Z",
    fill: "#f05d31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64260",
    "data-name": "Path 64260",
    d: "M-2687.883-1456.8a2.964,2.964,0,0,1,1.241-2.166c.168.405-.193.677-.257,1.024a2.283,2.283,0,0,1-.636,1.156Z",
    fill: "#d55526"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64261",
    "data-name": "Path 64261",
    d: "M-2693.45-1446.908c.238-.381.313-.927.931-.927a25.249,25.249,0,0,1-2.521,5.236l-.261-.305C-2695.061-1444.413-2694.083-1445.581-2693.45-1446.908Z",
    fill: "#d74d28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64262",
    "data-name": "Path 64262",
    d: "M-2711.353-1664.717c-.443.522-1.035.255-1.569.3.026-.086.053-.172.08-.258Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64263",
    "data-name": "Path 64263",
    d: "M-2559.672-1472.242c-.169-.09-.49-.192-.485-.27.08-1.164.2-2.324.35-3.831a2.361,2.361,0,0,1,.457,1.652Q-2559.51-1473.466-2559.672-1472.242Z",
    fill: "#a5d5e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64264",
    "data-name": "Path 64264",
    d: "M-2560.92-1463l-.912-.3q.308-.768.613-1.535a.793.793,0,0,1-.263-.688c.364-1.611.2-3.319.886-4.87a1.749,1.749,0,0,1,.625,1.252q-.17,1.685-.338,3.368A13.289,13.289,0,0,0-2560.92-1463Z",
    fill: "#a6d7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64265",
    "data-name": "Path 64265",
    d: "M-2698.48-1437.582l.409-.083c.115-.11.214-.1.3.039l.039.882-.277.266Z",
    fill: "#a84033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64266",
    "data-name": "Path 64266",
    d: "M-2653.573-1616.524l-.022.631c-.169,3.173.141,6.339.145,9.51a3.032,3.032,0,0,0,.142.59,1.839,1.839,0,0,1-.234,1.613,3.81,3.81,0,0,0-1.032,4.407c.036.369.019.718-.358.924-.249-.067-.4-.067-.538.253-.578,1.357-.8,2.834-1.438,4.17a1.252,1.252,0,0,0,.085,1.044,1.437,1.437,0,0,1-.136,1.04c-.25.5-.5.993-.793,1.468a5.651,5.651,0,0,0-.279.79c-.377.475-.3,1.3-1.094,1.452-.8-.413-.888.25-.964.715-.313,1.9-1.551,3.328-2.425,4.94-.48.884-1.057,1.117-1.684.1a.882.882,0,0,1,.054-.446c.676-.851.388-1.866.481-2.816a23.042,23.042,0,0,0,.071-6.444c-.565-2.9-.35-5.938-1.465-8.74-.59-1.483-.672-3.1-1.158-4.619a22.715,22.715,0,0,0-1.948-4.75c-.241-.407-.169-.908-.4-1.319a31.185,31.185,0,0,0-4.225-7.768,1.413,1.413,0,0,0-1.192-.6.74.74,0,0,1-.7-.429c-.019-.834-.15-1.571-1.264-1.458a1.1,1.1,0,0,1-.963-1.038c-.433-1.537-1.885-2.153-2.988-2.9a47.953,47.953,0,0,0-13.943-6.689c-.595-.167-1.219-.2-1.8-.421a29.4,29.4,0,0,0-7.747-1.856,25.772,25.772,0,0,1-4.085-1.027c.293.487,1.623-.244,1.158,1.046a14.732,14.732,0,0,1-4.123-.516c-.07-.282.063-.627-.49-.67-1.44-.111-2.8-.736-4.213-.9-2.495-.293-4.5-1.691-6.688-2.679a3.019,3.019,0,0,1-1.383-1.409,3.24,3.24,0,0,0-.976-2.9,3.139,3.139,0,0,1-1.235-2.952c.071-.33-.331-.474-.547-.679a3.525,3.525,0,0,1-.676-.825,1.086,1.086,0,0,1,.5-1.254c.282-.06.62.013.791-.329a23.059,23.059,0,0,1,6.569-6.009c2.228-.267,4.025-1.836,6.261-2.083,1,.5,2.115.312,3.16.553.875.2.969-.532,1.183-1.1,1.217-.564,2.452-.972,3.719-.175a.856.856,0,0,0,.838.176c2.865-1.085,5.672-.058,8.4.492a72.513,72.513,0,0,1,7.682,2.03c1.386.442,2.694,1.364,4.278,1,.579,0,1.105.1,1.322.742-.117.277-.348.347-.825.332,5.77,1.786,10.13,5.42,14.375,9.232a16.29,16.29,0,0,1,1.3,1.714c.418.486.7,1.192,1.543,1.082a5.9,5.9,0,0,1,2.284,3.1c-.112,1.846,1.095,2.886,2.379,3.878a.943.943,0,0,1,.361.539,6.7,6.7,0,0,0,.9,2.731c2.149,4.137,4.129,8.35,4.761,13.045a9.879,9.879,0,0,0,.54,1.78c-.029-.139.272-.387.08-.312-.066.026-.085-.01-.118-.079-.228-.47-.237-.88.287-1.162C-2653.22-1618.156-2653.3-1617.362-2653.573-1616.524Z",
    fill: "#fce133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64267",
    "data-name": "Path 64267",
    d: "M-2736.377-1560.29l-.006-.31a.582.582,0,0,1-.151-.518c.19-.209.167-.338-.148-.355-.406-.542-.627-1.2-1.073-1.711-.072-.293-.132-.583.142-.814.642-.687.055-1.282-.263-1.76-.389-.585-.562-1.2-.182-1.676s.745.276,1.176.351c1.138.2,2.066,1.061,3.312,1.009a.827.827,0,0,1,.875.886c-.145,1.543.473,3.156-.421,4.633a3.039,3.039,0,0,0-.174,1.5l-.309.619c-.789.036-.765-.684-.935-1.12-.244-.628-.589-.875-1.231-.732Z",
    fill: "#e6b02a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64268",
    "data-name": "Path 64268",
    d: "M-2668.413-1612.192c.822.306.977,1.343,1.1,1.805.66,2.388,1.672,4.659,2.181,7.109.611,2.942,1.045,5.91,1.6,8.837.627,3.3-.052,6.489.311,9.709.065.576-.012,1.374-.876,1.58-.465-.4-.323-.933-.307-1.433a71.59,71.59,0,0,0-.8-13.419,30.079,30.079,0,0,1-.847-4.184,1.97,1.97,0,0,1,.087-1.047,3.035,3.035,0,0,0-.592-1.873,1.413,1.413,0,0,1-.63-1.007c-.391-1.847-1.42-3.508-1.587-5.424A1.013,1.013,0,0,1-2668.413-1612.192Z",
    fill: "#fde43a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64269",
    "data-name": "Path 64269",
    d: "M-2710.432-1635.977c1.395.538,2.908.257,4.327.624,3.029-.109,5.874.838,8.763,1.531.745.15,1.444.458,2.174.662a2.208,2.208,0,0,1,.575.292c.421.323,1.082.362,1.226,1.019-.024.065-.047.13-.071.194-1.043-.049-1.942-.694-2.9-.848-3.4-.545-6.733-1.427-10.13-2.012-4.239-.73-8.7-.54-12.665-2.585a20.515,20.515,0,0,1-5.027-3.084,1.23,1.23,0,0,1-.47-1.056c1.475-.062,2.384,1.1,3.5,1.736a26.926,26.926,0,0,0,9.733,3.14A1.348,1.348,0,0,1-2710.432-1635.977Z",
    fill: "#deaf1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64270",
    "data-name": "Path 64270",
    d: "M-2727.4-1590.881c.017.74.691,1.522-.27,2.455a5.571,5.571,0,0,0-.795-3.208c-.411-.717-.905-1.07-1.35.01-.126.307-.137.819-.656.646a.688.688,0,0,1-.287-1.044c.4-.615.32-1.36.678-1.963a1.19,1.19,0,0,0-.212-1.553c-.57-.525-.792.429-1.434.435a1.2,1.2,0,0,0-.327-1.726c-.732-.462-.561-.93,0-1.286a1.435,1.435,0,0,0,.64-1.785c-.234-1.106.677-1.6,1.452-2.06.292-.171.7-.156.887-.518.169-.324.127-.912.783-.613-.447.646,1.507.946.247,1.71a1.589,1.589,0,0,1-1.112.672,1.091,1.091,0,0,0-.859,1.465,2.344,2.344,0,0,1,0,.42,15.536,15.536,0,0,0,2.14,5.556,4.468,4.468,0,0,0,.625,1.424,1.453,1.453,0,0,1,.216.332A.552.552,0,0,1-2727.4-1590.881Z",
    fill: "#eab024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64271",
    "data-name": "Path 64271",
    d: "M-2665.958-1603.235a77.364,77.364,0,0,1,1.556,7.941,113.59,113.59,0,0,1,.311,12.142q-.012.153-.009.306a7.533,7.533,0,0,1-.277,3.941c-.315.644-.231,1.488-.955,1.93l-.751.988a16.392,16.392,0,0,1,.735-4.987,36.726,36.726,0,0,0,.487-11.383,37.123,37.123,0,0,0-.824-5.882c-.357-1.47-.459-2.991-.941-4.424C-2666.922-1603.542-2666.633-1603.572-2665.958-1603.235Z",
    fill: "#e0b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64272",
    "data-name": "Path 64272",
    d: "M-2707.341-1664.711H-2699l.938.014c1.024,1.154,2.437.439,3.647.716a9.548,9.548,0,0,1,2.212.507c1.429.307,2.856.63,4.291.91a1.132,1.132,0,0,1,.956.639,1.052,1.052,0,0,1-.825.356,4.651,4.651,0,0,0-2.732.465c-.917.508-1.9-.553-2.939-.544-.509-.3-1.392.024-1.535-.9a1.645,1.645,0,0,1,1.529-.144c-.121-.944-.721-.8-1.168-.774-4.007.2-7.992-.435-11.995-.307a8.585,8.585,0,0,1-1.963-.322A1.735,1.735,0,0,1-2707.341-1664.711Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64273",
    "data-name": "Path 64273",
    d: "M-2694.983-1662.547c.363.585,1.181.032,1.545.617a1.025,1.025,0,0,1-.1.109,1.138,1.138,0,0,1-.126.078c.978.419,2.1.411,3.005,1.052.193.444.788.133,1.063.615a2.034,2.034,0,0,1-1.831.405c-.365-.133-.787-.114-.862.34-.061.369.346.424.637.515a9.661,9.661,0,0,0,2.034.648c.532.05,1.293.039,1.433.871a.259.259,0,0,1-.126.407c-1.739.092-3.293-.7-4.915-1.114-2.188-.558-4.445-.709-6.617-1.308a.407.407,0,0,1-.137-.448c.587-.4,1.321.088,1.908-.315,1.424-.175,2.66.718,4.07.712.432,0,.852.186.956-.374.113-.61-.4-.566-.8-.655a13.108,13.108,0,0,0-3.358-.312c-.484.017-1.137.147-1.133-.652a1.106,1.106,0,0,1,1.044-1.145C-2696.533-1662.586-2695.755-1662.538-2694.983-1662.547Z",
    fill: "#e4b125"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64274",
    "data-name": "Path 64274",
    d: "M-2710.432-1635.977a23.606,23.606,0,0,1-12-3.867c-.74-.459-1.472-.93-2.207-1.4l0,0c-1.179-.838-1.634-2.184-2.327-3.357a1.037,1.037,0,0,1,.148-1.278q0-1.078.009-2.156c-.207-.361-.211-.621.308-.619a.566.566,0,0,1,.618.618c.417,1.336.1,2.828.944,4.087.566.841,1.442,1.436,1.836,2.4a16.842,16.842,0,0,0,7.689,3.791c2.014.411,3.992,1.031,6.12,1.256C-2709.6-1635.784-2710.077-1636.065-2710.432-1635.977Z",
    fill: "#fde33b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64275",
    "data-name": "Path 64275",
    d: "M-2715.063-1539.9c.068-.192.253-.487.188-.561-1.881-2.125-.732-4.72-1.07-7.074s-.548-4.752-1.089-7.086c-.343-1.475.714-2.72.6-4.15a4.022,4.022,0,0,1,.133-.905c.874.158.7.883.719,1.438.042,1.526.023,3.055.06,4.582a3,3,0,0,0,.45,2.038,1.178,1.178,0,0,1,.176,1.114c-.109.318.021.529.317.535-.018,2.135.186,4.261.261,6.393.022.634-.212,1.362.436,1.863a2.066,2.066,0,0,1,.173,1.855C-2714.175-1539.329-2714.632-1539.186-2715.063-1539.9Z",
    fill: "#e3b326"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64276",
    "data-name": "Path 64276",
    d: "M-2657.279-1592.419l.279-.929c-.088-.124-.2-.278-.139-.412.74-1.687,1.051-3.541,2.011-5.141.34-.231.3-.589.312-.93a8.5,8.5,0,0,1,.933-4.3c.478-.451.246-1.037.3-1.569-.266-1.614.22-3.2.191-4.81-.019-1.078-.383-2.1-.332-3.171a3.575,3.575,0,0,1,.429-1.9c1.09.481.944,1.661.979,2.423.039.852.3,1.67.278,2.516.013.074.026.148.04.222.06.828.044,1.66.158,2.487a26.841,26.841,0,0,1-1.126,4.7,45.61,45.61,0,0,0-1.523,5.261,45.975,45.975,0,0,1-2.18,5.866A.688.688,0,0,1-2657.279-1592.419Z",
    fill: "#deaf21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64277",
    "data-name": "Path 64277",
    d: "M-2648.346-1606.648q-.443,2.986-.886,5.972c.179.655-.326,1.168-.368,1.776-.34,1.027-.491,2.1-.858,3.124l.015-.024a5.557,5.557,0,0,0-.718,2.243,1.456,1.456,0,0,1-.181.38,1.041,1.041,0,0,1-.7.446c-1.082-.951-1.146-1.225-.663-2.884.606-.053.162,1.274.914.8.795-.5.065-.876-.3-1.284-.409-.46-.312-.844.358-.957a7.436,7.436,0,0,1,.928-2.161c1.109-1.29,1.893-3.063.97-4.334-.886-1.221-.352-2.091-.336-3.128,0-.373.258-.529.6-.57.048.04.095.08.138.113a.506.506,0,0,1,.1.225c.11-.12.065-.267.075-.412.052-.505-.17-1.061.308-1.469l.3-.006C-2648.243-1608.123-2648.739-1607.323-2648.346-1606.648Z",
    fill: "#ebae20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64278",
    "data-name": "Path 64278",
    d: "M-2676.755-1623.313a1.874,1.874,0,0,0,.931.914.444.444,0,0,1,.119.495c-.04.046-.082.091-.123.136-.429-.057-.878.12-1.219-.4-1.438-2.2-3.995-3.02-5.906-4.652a2.669,2.669,0,0,0-2.631-.285c.148-.818.872-.286,1.064-.63l-8.918-3.917h0a.927.927,0,0,1,.694-.582,10.741,10.741,0,0,1,3.935,1.243,44.16,44.16,0,0,1,11.109,6.52C-2677.308-1624.144-2676.853-1623.877-2676.755-1623.313Z",
    fill: "#ddae1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64279",
    "data-name": "Path 64279",
    d: "M-2665.636-1642.148c-.389,1.02-.663.276-.984-.057-1.233-1.279-2.083-2.836-3.538-4-3.629-2.893-7.181-5.848-11.66-7.37a3.306,3.306,0,0,1-1.156-.753c.28-.354.657-.116.97-.192.817-.475,1.428.24,2.143.366a36.364,36.364,0,0,1,9.924,6.763c.459.451,1.058.823,1.19,1.539l.636.6A6.472,6.472,0,0,1-2665.636-1642.148Z",
    fill: "#fde33c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64280",
    "data-name": "Path 64280",
    d: "M-2748.713-1580.7c.077-.35-.235-1.153.656-.546.429.293.493-.055.556-.364a.676.676,0,0,1,0-.928c.443.837,1.069,1.617.649,2.682a.6.6,0,0,0,.314.784c.406.151.481-.254.641-.492.057-.085.095-.2.175-.25.516-.315.279-1.578,1.019-1.257.772.334-.053,1.012-.24,1.536a.644.644,0,0,0,.384.889c1.037.327.891,1.388,1.3,2.084a.971.971,0,0,1-.64,1.356c-.447.122-.971.354-1.364-.447-.653-1.327-1.595-2.51-2.371-3.781A3.189,3.189,0,0,0-2748.713-1580.7Z",
    fill: "#e6b227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64281",
    "data-name": "Path 64281",
    d: "M-2719.7-1572.33l-1.233-3.4a.814.814,0,0,1,.878.151,50.456,50.456,0,0,1,2.284,4.8c1.286,3.647,2.821,7.22,3.3,11.106a4.185,4.185,0,0,1,.027,1.747,1.091,1.091,0,0,1-.252.439.7.7,0,0,1-.859-.347c-.255-1.1-.433-2.226-.71-3.327a13.46,13.46,0,0,1-.659-3.759l-.621-1.546C-2718.618-1568.291-2719.843-1570.059-2719.7-1572.33Z",
    fill: "#e9be3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64282",
    "data-name": "Path 64282",
    d: "M-2687.866-1556.273a6.705,6.705,0,0,1-.32,2.464,5.294,5.294,0,0,0,0,2.785c-.767,3.155-.614,6.37-.62,9.574-.224.621.381,1.427-.427,1.919-.718-.331-.577-1-.606-1.586a6.45,6.45,0,0,0-.232-1.955c-.317-2.2.139-4.376.313-6.547a46.021,46.021,0,0,1,.526-5.616c.347-1.1-.061-2.413.945-3.324a.648.648,0,0,1,.522.152A1.961,1.961,0,0,1-2687.866-1556.273Z",
    fill: "#eabb39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64283",
    "data-name": "Path 64283",
    d: "M-2679.859-1653.876c-.8.085-1.383-.587-2.146-.64a1.7,1.7,0,0,0-1.242-.608,10.546,10.546,0,0,1-4.939-1.883v-.29a4.014,4.014,0,0,1,3.475.475c.377.289.944.526,1.142-.087.214-.662-.58-.241-.8-.518-.125-.156-.322-.257-.24-.655,1.1.5,2.4.4,3.387,1.56l-1.685.31c.893.205,1.411.729,2.188.136.876-.667,1.238.32.982.723-.545.859.436.744.515,1.142A.724.724,0,0,1-2679.859-1653.876Z",
    fill: "#e3b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64284",
    "data-name": "Path 64284",
    d: "M-2655.121-1585.314a4.66,4.66,0,0,1-.738-.956c-.27-.633-.507-1.089-1.325-.686a.659.659,0,0,1-.956-.485c-.163-.616.3-.952.742-1.195.295-.161.585-.527,1.028.005.807.972,1.557.8,1.89-.38.207-.731.806-1.414.145-2.28-.358-.469.294-.776.579-1.1.521-.586.762.057,1.1.276.44.446.172.97.167,1.467C-2653.23-1588.8-2653.745-1586.844-2655.121-1585.314Z",
    fill: "#e8b022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64285",
    "data-name": "Path 64285",
    d: "M-2653.573-1616.524a5.441,5.441,0,0,0-.626-2.164c-.939-1.506-1.094-3.285-1.673-4.919-.737-2.077-1.756-4.039-2.4-6.149a1.85,1.85,0,0,1,.228-1.225.3.3,0,0,1,.441-.055c1.379,2.049,1.9,4.456,2.743,6.721.689,1.848,1.057,3.813,1.662,5.695A1.783,1.783,0,0,1-2653.573-1616.524Z",
    fill: "#ddaf1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64286",
    "data-name": "Path 64286",
    d: "M-2683.861-1599.529c.589-.6,1.7-.373,2.077-1.369.094-.254.59-.244.809,0s.415.658-.074.86c-.309.129-.631.184-.345.582.171.24.444.123.7.055a3.3,3.3,0,0,0,1.69-1.239c.377-.472.749-.371,1.02-.065.481.542-.176.487-.418.633-.379.227-.414.4.04.583.573.237.122.584.063.887a.819.819,0,0,1-.685,1.132c.394.131.611-.444.993-.2l0,.62a1.034,1.034,0,0,1,.208,1.146c-.367.577-.966.841-1.343.229A11.048,11.048,0,0,0-2683.861-1599.529Z",
    fill: "#e6b024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64287",
    "data-name": "Path 64287",
    d: "M-2659.149-1588.721c.6-.341.434-1.135.918-1.545.575-.032.512.264.321.626-1.162,2.52-2.258,5.074-3.51,7.549a44.347,44.347,0,0,0-2.589,5.542.727.727,0,0,1-.7.5c-.4-.521-.1-1.051-.02-1.578a58.88,58.88,0,0,1,4-8.409C-2660.25-1586.944-2660.3-1588.2-2659.149-1588.721Z",
    fill: "#ddaf1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64288",
    "data-name": "Path 64288",
    d: "M-2679.859-1653.876a.665.665,0,0,1,.632-.335,28.252,28.252,0,0,1,10.509,7.59c.193.226.881.553-.029.772a44.3,44.3,0,0,0-8.47-6.526A8.508,8.508,0,0,1-2679.859-1653.876Z",
    fill: "#deae1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64289",
    "data-name": "Path 64289",
    d: "M-2660.961-1573.852c-1.29-.2-.723-1.315-.475-1.623.836-1.039.215-1.542-.491-2.115.119-.277.276-.479.618-.31.589-.444,1.517-.143,1.941-1.05.482-1.032.569-.991-.82-3.075.645-.386,1.3,1.12,2.027.008a1.111,1.111,0,0,1,.5,1.48c-.963,1.742-1.879,3.51-2.8,5.274a2.645,2.645,0,0,0-.513,1.428Z",
    fill: "#e6ae25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64290",
    "data-name": "Path 64290",
    d: "M-2668.116-1559.07c-1.509,2.21-2.21,4.789-3.279,7.2-.225.509-.465,1.011-.7,1.516a.7.7,0,0,1-.275-.365,3.619,3.619,0,0,1,.176-1.6,4.46,4.46,0,0,1,.426-1.072,12.029,12.029,0,0,0,1.611-3.928,1.8,1.8,0,0,1,.816-1.427c1.144-.821,1.323-2.16,1.658-3.357.136-.488-.458-1.178.7-.947.152.031.481-.821.728-1.264a3.725,3.725,0,0,1,.13-1.521c.795-.845.982-2.133,2.031-2.8a1.032,1.032,0,0,1,.649-.612c.311,1.328-.529,2.177-1.278,3.064a2.207,2.207,0,0,0-.64,1.543,5.88,5.88,0,0,1-1.512,2.782,6.767,6.767,0,0,0-1.24,2.782Z",
    fill: "#e2b32e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64291",
    "data-name": "Path 64291",
    d: "M-2730.221-1599.219c-.648-.965-.1-1.475.735-1.81a9.965,9.965,0,0,1,1.45-.352l.926.613c1.035.093,1.023,1.111,1.505,1.695.1.271.189.545.28.819a4.825,4.825,0,0,0,.668,1.642c.376.519.548.1.733-.194a2.592,2.592,0,0,1,.484-.724c.5-.309.92-.864,1.625-.5.353.648-.119,1.044-.46,1.471a13.2,13.2,0,0,0-1.618,2.388.886.886,0,0,1-1.032.325c-.7-.693-.628-1.808-1.369-2.477a1.689,1.689,0,0,1-.22-.594,2.224,2.224,0,0,0-.56-1.442c-.488-.542-.736-1.254-1.265-1.765-.682-.441-1.122-.129-1.472.467A1,1,0,0,1-2730.221-1599.219Z",
    fill: "#e4c140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64292",
    "data-name": "Path 64292",
    d: "M-2668.43-1611.543c.319,2.235,1.522,4.211,1.88,6.435-.055.242-.04.548-.185.71-.168.188-.371.022-.406-.216-.191-1.288-.746-.336-1.378-.05,1.613-2.161.178-3.845-.574-5.5a20.053,20.053,0,0,1-1.793-4.5c-.122-.325.09-.381.332-.413C-2669.075-1614.364-2669-1612.8-2668.43-1611.543Z",
    fill: "#dfaf22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64293",
    "data-name": "Path 64293",
    d: "M-2687.866-1556.273l-.009-2.169a3.752,3.752,0,0,1,.927-2.776c1.3.977,1.91,2.471,2.814,3.742.283.4.311.906-.291,1.12-.506.179-.817,0-1.05-.545-.2-.473-.447-1.249-1.058-1.113-.632.141-.7.939-.7,1.527C-2687.246-1555.659-2687.536-1555.986-2687.866-1556.273Z",
    fill: "#e5b224"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64294",
    "data-name": "Path 64294",
    d: "M-2689.1-1539.608c.072-.618-.256-1.3.3-1.842.225,1.022.845,1.278,1.88,1.274a48.971,48.971,0,0,1,6.431.111c.725.092,1.833.141,2.052-1.231.107-.67.482.125.756.16.321.189.523.54.9.656.134.042.261.09.393.136.328.215,1.017.041.848.788-.6.521-1.343.345-2.039.4-3.582-.032-7.163.062-10.745-.046A1.14,1.14,0,0,1-2689.1-1539.608Z",
    fill: "#e9af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64295",
    "data-name": "Path 64295",
    d: "M-2652.97-1603.235a20.513,20.513,0,0,1,.928-4.939,4.32,4.32,0,0,1,0-2.473h0c1.265-.668,1.177.55,1.182,1.038.011,1.138-.641,2.23-.306,3.431.073.26-.239.4-.494.492-.423.145-.863.5-.581.878.445.592.4-.31.655-.341.357-.042.547.252.665.519.1.216.315.669-.309.421.213.821-1.254.374-1.033,1.394C-2652.206-1602.557-2652.884-1602.746-2652.97-1603.235Z",
    fill: "#e6b12d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64296",
    "data-name": "Path 64296",
    d: "M-2665.636-1642.148a25.077,25.077,0,0,1-2.475-3.1c.474-.32.8-.157,1.174.24,2.184,2.339,3.74,5.191,6.067,7.417.142.137-.078.651-.129.989.1.3-.082.39-.318.445a5.008,5.008,0,0,1-2.137-2.93A12.436,12.436,0,0,0-2665.636-1642.148Z",
    fill: "#ddb01d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64297",
    "data-name": "Path 64297",
    d: "M-2685.634-1568.317l-.328.017a.317.317,0,0,1-.428.006c-.368-.9.348-1.644.347-2.491.262-1.246,1.2-2.206,1.454-3.457a1.79,1.79,0,0,1,.423-1.227c.989-.852.963-2.175,1.481-3.247a5.213,5.213,0,0,1,1.254-2.031.546.546,0,0,1,.437.062,1.106,1.106,0,0,1,.225.651,14.063,14.063,0,0,1-.986,3.078c-.944,1.647-1.382,3.514-2.244,5.2-.472.68-.523,1.571-1.092,2.2h0C-2685.388-1569.194-2685.147-1568.6-2685.634-1568.317Z",
    fill: "#35322c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64298",
    "data-name": "Path 64298",
    d: "M-2712.593-1658.222c-2.035.79-3.874,2.141-6.178,2.162-.35.258-.575.15-.705-.239.066-.447.4-.659.749-.859,1.663-.788,3.268-1.754,5.208-1.689.344,0,.7.042.944-.285a5.587,5.587,0,0,1,2.713-.632c.507.032,1.039-.166,1.516.157a.428.428,0,0,1,.157.446c-.731.587-1.7.5-2.5.882A4.218,4.218,0,0,1-2712.593-1658.222Z",
    fill: "#fce03c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64299",
    "data-name": "Path 64299",
    d: "M-2668.43-1611.543c-1.035-.944-.958-2.583-2.147-3.431-.631-.737-.954-1.68-1.608-2.4a9.365,9.365,0,0,1-1.153-1.939.971.971,0,0,0-.642-.9.211.211,0,0,1-.074-.2c.016-.071.034-.107.054-.107,1.73-.476,2,1.166,2.654,2.01,1.29,1.673,1.734,3.858,3.01,5.582.109.147-.045.491-.077.743Z",
    fill: "#fce03c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64300",
    "data-name": "Path 64300",
    d: "M-2675.552-1539.9c-.416-.04-.888.14-1.2-.305a2.006,2.006,0,0,1,.325-1.517,3.343,3.343,0,0,1,.244-.3c.427-.449.19-.949.107-1.439a.8.8,0,0,1,.25-.759l.614-1.239a1.959,1.959,0,0,1,.155-.4,8.822,8.822,0,0,1,1.7-3.924l.311-.31c.269-.119.4.049.513.248a1.679,1.679,0,0,1,.04.875,1.619,1.619,0,0,1-.179.4,7.726,7.726,0,0,0-.926,3.46,2.067,2.067,0,0,1-.322,1.022,4.715,4.715,0,0,0-.668,1.516C-2675.116-1541.763-2674.815-1540.645-2675.552-1539.9Z",
    fill: "#eaad24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64301",
    "data-name": "Path 64301",
    d: "M-2709.808-1659.459l-2.768.327c-.466-.5-.066-.566.322-.641a28.247,28.247,0,0,1,5.448-.615,20.279,20.279,0,0,0,5.027-.306c.532.616,1.274-.024,1.853.309.542.558,1.235.207,1.853.31-.547.561-1.249.2-1.871.316-1.43.784-2.971.224-4.455.35C-2706.2-1659.256-2708-1659.654-2709.808-1659.459Z",
    fill: "#e0b122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64302",
    "data-name": "Path 64302",
    d: "M-2715.99-1561.223c.562,1.069.233,2.3.621,3.4a17.4,17.4,0,0,1,1.019,5.043c.005.554.164,1.283-.713,1.447-.923.075-.937-.532-.932-1.2q.023-2.849,0-5.7c0-.492.168-1.041-.3-1.444-.282-.48-.821-.91-.307-1.549A.421.421,0,0,1-2715.99-1561.223Z",
    fill: "#e9af2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64303",
    "data-name": "Path 64303",
    d: "M-2683.861-1599.529a6.308,6.308,0,0,1,4.779,3.406c.308.548.608.617,1.084.293a.282.282,0,0,1,.411.052,1.808,1.808,0,0,1-.267,1.584c-.8.8-1.219.222-1.607-.454a6.459,6.459,0,0,0-3.458-3.469,4.446,4.446,0,0,0-2.788-.284,2.15,2.15,0,0,1-1.456-.09c-.235-.239-.308-.523-.051-.755a.866.866,0,0,1,1.189.016A2.163,2.163,0,0,1-2683.861-1599.529Z",
    fill: "#e4bf46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64304",
    "data-name": "Path 64304",
    d: "M-2653.3-1615.586c-.129,2.8.782,5.588.025,8.387-.133.491-.21,1-.313,1.495a4.5,4.5,0,0,1-.408-2.741,8.732,8.732,0,0,0-.033-3.639,5.255,5.255,0,0,1,.433-3.81Z",
    fill: "#fce139"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64305",
    "data-name": "Path 64305",
    d: "M-2686-1566.155c.961-.166.394-1.026.7-1.538a23.683,23.683,0,0,1,1.963,8.352c-1.312-1.7-.814-4.027-1.98-5.91-.947,1.115-.023,2.854-1.629,3.415a.689.689,0,0,1-.171-.645,4.7,4.7,0,0,0,.426-2.207A2.154,2.154,0,0,1-2686-1566.155Z",
    fill: "#e4b223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64306",
    "data-name": "Path 64306",
    d: "M-2726.494-1648.646a.69.69,0,0,0-.308.619c-.868-.141-.559-.666-.372-1.147a10.626,10.626,0,0,1,5.037-5.987,9.375,9.375,0,0,0,.9-.59.231.231,0,0,1,.361-.015,1.344,1.344,0,0,1-.66,1.434,19.891,19.891,0,0,0-4.016,4.168.8.8,0,0,1-.328.266A1.8,1.8,0,0,0-2726.494-1648.646Z",
    fill: "#ddae20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64307",
    "data-name": "Path 64307",
    d: "M-2682.048-1577.047l.993-2.949c.279-1.9,1.274-3.546,1.917-5.316a1.127,1.127,0,0,1,.716-.753.551.551,0,0,1,.436.135,6.458,6.458,0,0,1-1.195,3.421,26.782,26.782,0,0,0-1.591,4.61,5.685,5.685,0,0,0-.649,1.85c-.011.349-.123.882-.737.5A2.233,2.233,0,0,1-2682.048-1577.047Z",
    fill: "#dfbb36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64308",
    "data-name": "Path 64308",
    d: "M-2669.34-1558.746a23.431,23.431,0,0,1-2.162,5.56.884.884,0,0,1-.262-.363,2.116,2.116,0,0,1,.095-1.333l.165-.157c.335-.023.67-.173.668-.505-.005-1.548.632-3.173-.562-4.6-.265-.316-.631-.853-.052-1.181.611-.346.7.252.912.657C-2670.185-1560-2669.744-1559.383-2669.34-1558.746Z",
    fill: "#e4b221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64309",
    "data-name": "Path 64309",
    d: "M-2724.011-1582.843c-.1.312.216.773-.2.916-.132.045-.819-.066-.719-.552.234-1.126-.681-1.322-1.31-1.756-.721-.5-1.535-.978-.262-1.76.573-.352.062-1.129.609-1.48a4.933,4.933,0,0,1,1.193,1.6C-2724.518-1584.852-2723.582-1584-2724.011-1582.843Z",
    fill: "#e6b022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64310",
    "data-name": "Path 64310",
    d: "M-2686.025-1599.23c-.33.179-1.2-.406-.918.642.079.413-.231.493-.511.6a11.124,11.124,0,0,1-1.515.165,1.34,1.34,0,0,1-.766-.346.742.742,0,0,1-.146-.378,5.672,5.672,0,0,1,.151-.983c-.07-.476-.925-1.04-.112-1.388.719-.308.748.431.879.995.2.855.814.764,1.416.379s1.168-.8,1.763-1.183a.987.987,0,0,1,1.511.266C-2684.707-1599.849-2686.053-1600.446-2686.025-1599.23Z",
    fill: "#e6b023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64311",
    "data-name": "Path 64311",
    d: "M-2682-1575.418c.452-.806.346-1.888,1.228-2.482-.028.819-.464,1.61.2,2.455.341.433-.168,1.142-.521,1.5-.772.783-1.358,1.8-2.462,2.218C-2684.007-1573.367-2682.836-1574.322-2682-1575.418Z",
    fill: "#e5b11e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64312",
    "data-name": "Path 64312",
    d: "M-2717.843-1600.144c1.066-1.143,2.353-.686,3.52-.349a2.866,2.866,0,0,0,2.436-.072c1.409-.748,1.387.436,1.458,1.348-.067.034-.135.069-.2.1-.35.063-.747-.1-1.045.039a3.108,3.108,0,0,1-3.538-.62C-2716.091-1599.846-2717.063-1599.442-2717.843-1600.144Z",
    fill: "#e7b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64313",
    "data-name": "Path 64313",
    d: "M-2719.7-1572.33q1.08,2.931,2.158,5.862c-.184.005-.461.089-.536,0-.743-.877-.857-2.08-2.023-2.826C-2721.624-1570.267-2720.091-1571.33-2719.7-1572.33Z",
    fill: "#e7ae22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64314",
    "data-name": "Path 64314",
    d: "M-2683.242-1660.7c2.155.512,3.957,1.767,5.871,2.785a2.517,2.517,0,0,0-.547-.183c-.9,1.518-1.583,1-2.443-.113a6.487,6.487,0,0,0-2.071-1.517C-2682.877-1659.97-2683.226-1660.158-2683.242-1660.7Z",
    fill: "#e4b120"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64315",
    "data-name": "Path 64315",
    d: "M-2717.226-1546.1c1,1.776.38,3.319.724,4.75.063.264-.216.462-.512.417-3.344-.5-6.723.025-10.075-.508,2.64,0,5.283-.087,7.917.032,1.6.073,2.134-.516,1.961-2.036A26.325,26.325,0,0,1-2717.226-1546.1Z",
    fill: "#e3b326"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64316",
    "data-name": "Path 64316",
    d: "M-2671.2-1652.971c0,.634.468.856.935,1.092.322.162.72.353.509.794s-.624.13-.959.128c-.818-.007-1.094-.642-1.459-1.187-.539-.8-1.213-1.647-2.164-1.693-1.106-.054-.5-.882-.82-1.255-.226-.267.031-.3.213-.371.791-.284.691.475,1,.8.757.791,1.471,1.72,2.747,1.7Z",
    fill: "#e5b021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64317",
    "data-name": "Path 64317",
    d: "M-2749.972-1587.478l-.311-.928a1.935,1.935,0,0,0-.775-1.87c-.176-.147-.438-.373-.079-.589a.689.689,0,0,1,.553-.067c.731.333,2.59,4.244,2.453,5.059a.618.618,0,0,1-.608.56c-.259.1-.4-.054-.517-.245A7.138,7.138,0,0,0-2749.972-1587.478Z",
    fill: "#e1b424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64318",
    "data-name": "Path 64318",
    d: "M-2690.66-1660.691l-4.28-.784c.509-.669,1.05-.362,1.5-.455a2.89,2.89,0,0,1,1.883.41c.457.342,1.269.443,1.5-.075.358-.8.733-.511,1.279-.4a10.683,10.683,0,0,0,1.821.071l.309.3v.309a1.956,1.956,0,0,1-2.161,0C-2689.558-1661.509-2689.908-1660.5-2690.66-1660.691Z",
    fill: "#e4b134"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64319",
    "data-name": "Path 64319",
    d: "M-2664.1-1568.63c-.583.948-.75,2.172-1.846,2.78l-.148-.158a1.147,1.147,0,0,1-.095-.415c.09-.735.595-1.425.242-2.209a2.331,2.331,0,0,0-.975-1.634.573.573,0,0,1-.069-.923c.311-.253.5.114.706.33C-2665.563-1570.106-2664.826-1569.372-2664.1-1568.63Z",
    fill: "#e5b221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64320",
    "data-name": "Path 64320",
    d: "M-2673.054-1597.668c.215,1.953-1.176,3.312-1.825,4.945.365,1.157-.8,1.791-.948,2.773l0,0a.3.3,0,0,1-.422-.039,1.533,1.533,0,0,1-.252-.9c.294-2.335,1.688-4.234,2.529-6.354a1.3,1.3,0,0,1,.49-.477A.484.484,0,0,1-2673.054-1597.668Z",
    fill: "#e8ba3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64321",
    "data-name": "Path 64321",
    d: "M-2655.121-1585.314q1.232-2.78,2.464-5.561a14.222,14.222,0,0,1,1.213-2.474l.012-.019a.286.286,0,0,1,.412.054c.048.308.15.622-.121.886l.008-.013a16.432,16.432,0,0,1-1.54,3.394c-.623,1.323-1.257,2.641-1.864,3.971a2.238,2.238,0,0,1-.873,1.03Q-2655.266-1584.679-2655.121-1585.314Z",
    fill: "#c9bc69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64322",
    "data-name": "Path 64322",
    d: "M-2713.519-1658.847l-5.237,1.866a.7.7,0,0,1-.944-.007,22.236,22.236,0,0,1,5.509-2.564C-2713.382-1659.8-2713.261-1659.541-2713.519-1658.847Z",
    fill: "#deae1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64323",
    "data-name": "Path 64323",
    d: "M-2661.314-1636.287l.315-.311c1.288.465,1.215,1.883,1.911,2.776a17.418,17.418,0,0,1,1.484,2.786h-.308a.632.632,0,0,1-.635.146c-1.291-.966-1.566-2.493-2.13-3.861l-.3-.311A1,1,0,0,1-2661.314-1636.287Z",
    fill: "#e0b320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64324",
    "data-name": "Path 64324",
    d: "M-2688.8-1661.308l2.161,0c.507,1.077,1.786.27,2.56,1.357-1.64-.613-2.707,1.591-4.429.452.066-.107.094-.216.15-.233.5-.154,1.44.225,1.43-.453-.011-.825-.955-.425-1.5-.492C-2688.9-1660.737-2689.5-1660.607-2688.8-1661.308Z",
    fill: "#e5b121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64325",
    "data-name": "Path 64325",
    d: "M-2695.6-1599.227a3.947,3.947,0,0,1,2.892-.286c.73.118,1.413-1.1,2.048-.012.421.649-.366,1.226-.109,1.866a.741.741,0,0,1-.194.358c-1.141.144-1.641-1.3-2.8-1.121a3.765,3.765,0,0,1-1.215-.275A1.144,1.144,0,0,1-2695.6-1599.227Z",
    fill: "#eab121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64326",
    "data-name": "Path 64326",
    d: "M-2740.086-1569.868c.749-.232.48-1.783,1.5-1.4.891.336-.022,1.279.184,1.917a1.335,1.335,0,0,1-.062,1.173c-.155.264-.263.615-.6.631-.435.019-.367-.4-.443-.674-.083-.3-.317-.369-.577-.411C-2740.247-1569.044-2739.853-1569.456-2740.086-1569.868Z",
    fill: "#e6b02a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64327",
    "data-name": "Path 64327",
    d: "M-2723.712-1596.744c.154.594-.269.828-.69.96-.568.178-.433-.39-.591-.653a2.664,2.664,0,0,1-.58-1.851,6.309,6.309,0,0,1,.933-1.544h.615a.191.191,0,0,1,.072.2c-.022.069-.045.1-.069.1v.619A5.416,5.416,0,0,1-2723.712-1596.744Z",
    fill: "#eab022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64328",
    "data-name": "Path 64328",
    d: "M-2715.063-1539.9a.985.985,0,0,0,1.225-.005.529.529,0,0,1-.1.786,2.68,2.68,0,0,1-1.486.262q-5.281.016-10.562,0c-.6,0-1.242.078-1.718-.442q-.012-.148-.024-.3,5.44,0,10.882,0A3.243,3.243,0,0,0-2715.063-1539.9Z",
    fill: "#f8cc30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64329",
    "data-name": "Path 64329",
    d: "M-2726.811-1645.871c-.077,1.923,1.65,3,2.179,4.635a4.842,4.842,0,0,1-2.785-4.11c-.02-.457,0-.917,0-1.594Z",
    fill: "#ddae20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64330",
    "data-name": "Path 64330",
    d: "M-2673.36-1549.789l-1.549,4.321a.665.665,0,0,1,.006-.922C-2675.893-1547.641-2675.1-1549.394-2673.36-1549.789Z",
    fill: "#e9af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64331",
    "data-name": "Path 64331",
    d: "M-2722.818-1581.6l-.27-.643a.865.865,0,0,1-.29-.67.833.833,0,0,1,.32-.644c.2-.053.483-.1.558.073.76,1.758,2.094,3.293,2.112,5.343-.318.526-.6.293-.872-.046a3.7,3.7,0,0,0-.288-.337l0,.005A6.34,6.34,0,0,1-2722.818-1581.6Z",
    fill: "#342e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64332",
    "data-name": "Path 64332",
    d: "M-2682-1575.418c-.137,1.391-1.777,2.148-1.554,3.69l-.612.628a.619.619,0,0,1-.041-.713,24.019,24.019,0,0,1,2.16-5.234Q-2682.024-1576.233-2682-1575.418Z",
    fill: "#d9b346"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64333",
    "data-name": "Path 64333",
    d: "M-2710.429-1599.217a2.546,2.546,0,0,1,1.541-.308c.133.607-.471.587-.728.864-.406.28-.735.653-1.132.945a5.867,5.867,0,0,0-.481.361c-1.5,1.48-2.339,1.211-2.9-.924,1.373.242,2.437-.745,3.7-.937Z",
    fill: "#e7b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64334",
    "data-name": "Path 64334",
    d: "M-2676.14-1541.757c-.383.445-.129,1.143-.612,1.549l-.007-.006a1.386,1.386,0,0,1-.31-1.539c-.1-1.1-.88-2.052-.638-3.245.094-.465.157-.672.64-.464A4.8,4.8,0,0,1-2676.14-1541.757Z",
    fill: "#e9af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64335",
    "data-name": "Path 64335",
    d: "M-2664.725-1566.178l1.278-3.064c1.009-1.228,1.349-2.858,2.435-4.038l.019.632c.01.071.019.142.03.212-.168,1.628-1.17,2.866-1.963,4.2-.5.682-.595,1.654-1.477,2.06Z",
    fill: "#bbd6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64336",
    "data-name": "Path 64336",
    d: "M-2686.947-1562.443l0,.607q0,.309,0,.618a6.878,6.878,0,0,1-.927,2.776l-.376-.013a5.784,5.784,0,0,1,.83-4.937.549.549,0,0,1,.506-.028A.784.784,0,0,1-2686.947-1562.443Z",
    fill: "#e0b940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64337",
    "data-name": "Path 64337",
    d: "M-2717.843-1600.144l3.088,0c.268.394.081.647-.263.852-.658.257-1.389.136-2.047.4-.8.055-1.626.306-2.323-.335C-2719.446-1600.489-2718.489-1600.056-2717.843-1600.144Z",
    fill: "#e8b032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64338",
    "data-name": "Path 64338",
    d: "M-2648.951-1608.791q0,.926,0,1.851c-.355.2-.444-.142-.618-.309h0a12.788,12.788,0,0,1,.282-5.084C-2648.74-1610.916-2649.053-1609.832-2648.951-1608.791Z",
    fill: "#e6b12d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64339",
    "data-name": "Path 64339",
    d: "M-2676.14-1541.757c-.605-1.161-.51-2.5-.927-3.705.037-.273-.09-.667.272-.745.334-.072.277.3.358.514.19.495.406.98.611,1.469v.925c.239.583.3,1.13-.311,1.542Z",
    fill: "#e0b232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64340",
    "data-name": "Path 64340",
    d: "M-2721.769-1597.94c-.673-.168-1,.63-1.636.577a.428.428,0,0,1-.007-.618c.018-.337-.046-.7.313-.923.967.35,1.466-1.139,2.474-.632.339.019.706-.043.93.316a.9.9,0,0,1-.167.553,1.344,1.344,0,0,1-.461.365C-2720.8-1598.16-2721.178-1597.621-2721.769-1597.94Z",
    fill: "#e1b61a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64341",
    "data-name": "Path 64341",
    d: "M-2710.737-1597.976a2.013,2.013,0,0,1,.913-.941c1.758-.46,3.517-.891,5.273.007l.3.007c.282.291.994.365.526,1.037a1.345,1.345,0,0,1-1.16-.159,4.741,4.741,0,0,0-4.095-.047c-.566.167-1.063.59-1.707.475a.25.25,0,0,1-.111-.243C-2710.785-1597.93-2710.763-1597.976-2710.737-1597.976Z",
    fill: "#deb440"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64342",
    "data-name": "Path 64342",
    d: "M-2661.309-1577.9l-.618.31c-.179-.5.569-3.318.951-3.455a.81.81,0,0,1,.555.09.343.343,0,0,1,.079.615C-2661.256-1579.744-2660.936-1578.69-2661.309-1577.9Z",
    fill: "#e2b21c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64343",
    "data-name": "Path 64343",
    d: "M-2676.2-1590.966l.067,1.024c.306.785-.232,1.287-.619,1.84-.954.415-.4,1.687-1.233,2.172l-.359-.016c-.554-1.107.389-1.9.588-2.856C-2677.242-1589.525-2677.2-1590.592-2676.2-1590.966Z",
    fill: "#d6b73a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64344",
    "data-name": "Path 64344",
    d: "M-2749.047-1585.623l.308.31a6.922,6.922,0,0,0,1.239,2.778v.928c-1.028-.517-.926-1.881-1.854-2.472a7.092,7.092,0,0,1-.588-1.021c-.213-.3-.311-.676.071-.9S-2749.243-1585.926-2749.047-1585.623Z",
    fill: "#e9ad22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64345",
    "data-name": "Path 64345",
    d: "M-2667.18-1566.16c-1.246-1.014-.24-2.3-.477-3.452.493.707,1.116,1.311,1.1,2.216,0,.069,0,.138,0,.207a1.73,1.73,0,0,1-.446.921C-2667.061-1566.231-2667.12-1566.2-2667.18-1566.16Z",
    fill: "#e5b221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64346",
    "data-name": "Path 64346",
    d: "M-2651.734-1621.459c.046-.793-.967-1.064-.917-1.858.022-.341-.077-.783.426-.834.407-.042.5.31.475.621a3.229,3.229,0,0,0,.545,1.7c.247.53.546,1.232-.524,1.3A.64.64,0,0,1-2651.734-1621.459Z",
    fill: "#efae1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64347",
    "data-name": "Path 64347",
    d: "M-2723.106-1582.826l.018.582c-.85.636-.467-.629-.923-.6-.227-1.053-.957-1.953-.942-3.08a.5.5,0,0,1-.035-.651c1.384.551,1.322,1.936,1.732,3.04C-2723.176-1583.319-2723.287-1583.037-2723.106-1582.826Z",
    fill: "#d9b646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64348",
    "data-name": "Path 64348",
    d: "M-2672.129-1554.114c-1.225-.826-.4-1.906-.532-3.057a2.05,2.05,0,0,1,1.157,2.132h0C-2671.846-1554.821-2671.76-1554.313-2672.129-1554.114Z",
    fill: "#e4b221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64349",
    "data-name": "Path 64349",
    d: "M-2672.739-1549.788l-.31-.311a1.416,1.416,0,0,0-.069-1.8,1.53,1.53,0,0,1-.23-1.15c.008-.238-.01-.6.313-.562.385.051.258.462.3.738a3.671,3.671,0,0,0,.647.362,3.305,3.305,0,0,1,.271.259q-.165.774-.329,1.548C-2672.51-1550.505-2671.928-1549.7-2672.739-1549.788Z",
    fill: "#e9af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64350",
    "data-name": "Path 64350",
    d: "M-2676.144-1600.453c1.263-1.031,2.661-.892,3.093.309l-.2.087c-1.245-.422-2.18-.181-2.581,1.206a.812.812,0,0,1-.516.359,1,1,0,0,1-.58-.233c-.318-.31-.181-.6.028-.9C-2676.64-1599.9-2676.408-1600.189-2676.144-1600.453Z",
    fill: "#dfb849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64351",
    "data-name": "Path 64351",
    d: "M-2665.636-1649.572a9.237,9.237,0,0,0,1.852,1.853c-.15.007-.3,0-.451.021-.593.068-1.179.633-1.762-.136S-2665.67-1648.98-2665.636-1649.572Z",
    fill: "#e4b51e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64352",
    "data-name": "Path 64352",
    d: "M-2720.625-1599.536c-.624.011-.937.5-1.322.871-.517.494-.866.31-1.152-.239l.312-.621a1.2,1.2,0,0,1,.929-.617C-2721.478-1599.876-2720.555-1600.715-2720.625-1599.536Z",
    fill: "#e8b032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64353",
    "data-name": "Path 64353",
    d: "M-2715.99-1561.223h-.616c-.114-1.232-1.241-2.379-.315-3.7C-2716.27-1563.775-2716.366-1562.44-2715.99-1561.223Z",
    fill: "#eab519"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64354",
    "data-name": "Path 64354",
    d: "M-2740.086-1569.868c1.327.411.2.824,0,1.236-.151.724-.384,1.207-.945.242-.335-.576-.607-1.188-.908-1.784.483-.335.727-.024.954.348.321.524.618.406.9-.041Z",
    fill: "#ecad17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64355",
    "data-name": "Path 64355",
    d: "M-2751.826-1588.092c-.912-1.081-1.208-2.467-1.833-3.69A3.653,3.653,0,0,1-2751.826-1588.092Z",
    fill: "#edad16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64356",
    "data-name": "Path 64356",
    d: "M-2721.548-1578.525a1.653,1.653,0,0,0,.233.029c.382,1,1.7,1.691,1.029,3.052l-.647-.289c-.388-.007-.095-.79-.644-.584-.783.294-.506-.2-.305-.45C-2721.441-1577.31-2721.59-1577.927-2721.548-1578.525Z",
    fill: "#e3b639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64357",
    "data-name": "Path 64357",
    d: "M-2726.327-1581.206c-.167.021-.237.052-.261.03a2.19,2.19,0,0,1-.43-2.254.278.278,0,0,1,.483-.112C-2725.9-1582.794-2726.2-1581.987-2726.327-1581.206Z",
    fill: "#e5b037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64358",
    "data-name": "Path 64358",
    d: "M-2648.346-1606.648c-.575-.649-.173-1.436-.3-2.149.168-1.736-.339-3.512.3-5.22Q-2648.347-1610.333-2648.346-1606.648Z",
    fill: "#eaab0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64359",
    "data-name": "Path 64359",
    d: "M-2722.818-1581.6a9.01,9.01,0,0,1,1.273,3.081C-2722.535-1579.313-2723.53-1580.1-2722.818-1581.6Z",
    fill: "#e3b639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64360",
    "data-name": "Path 64360",
    d: "M-2737.613-1564v.927c.094.07.124.139.091.207s-.064.1-.1.1a6.173,6.173,0,0,1-1.565-2.908C-2738.054-1565.537-2738.028-1564.576-2737.613-1564Z",
    fill: "#eba924"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64361",
    "data-name": "Path 64361",
    d: "M-2650.8-1599.216a2.146,2.146,0,0,1-.928,2.161C-2651.963-1598.008-2652.833-1599.234-2650.8-1599.216Z",
    fill: "#eaac35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64362",
    "data-name": "Path 64362",
    d: "M-2732.934-1552.62a2.432,2.432,0,0,0-.927-1.833,1.516,1.516,0,0,1,.27-1.228C-2733.433-1554.493-2731.485-1554.029-2732.934-1552.62Z",
    fill: "#e4ad19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64363",
    "data-name": "Path 64363",
    d: "M-2690.967-1597.676c-.683-.748.173-1.238.31-1.849l.927,0c.4.312.393.623,0,.933-.237.37-.369.826-.831,1.01A.4.4,0,0,1-2690.967-1597.676Z",
    fill: "#eeac37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64364",
    "data-name": "Path 64364",
    d: "M-2686.327-1568.323l.365.023c.059.444-.473.745-.3,1.219a2.962,2.962,0,0,1-.549,2.241c-.251.224-.505.435-.857.181A3.539,3.539,0,0,1-2686.327-1568.323Z",
    fill: "#372e28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64365",
    "data-name": "Path 64365",
    d: "M-2676.746-1599.522c-.037.208-.352.408-.016.626.367.7-.138.958-.625,1.225-.628-1.075.039-2.048.344-2.993.2-.6.506-.2.6.215C-2676.269-1600.05-2676.529-1599.794-2676.746-1599.522Z",
    fill: "#e6b024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64366",
    "data-name": "Path 64366",
    d: "M-2673.054-1597.668l-.279-.014c-.338-.323-.182-.713-.148-1.087a2.221,2.221,0,0,1,.352-1.309l.078-.066C-2671.753-1599.475-2671.754-1598.774-2673.054-1597.668Z",
    fill: "#dfb849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64367",
    "data-name": "Path 64367",
    d: "M-2675.648-1588c.223.118.347.141.386.211.319.573.8,1.11.6,1.837a.293.293,0,0,1-.5.128A1.848,1.848,0,0,1-2675.648-1588Z",
    fill: "#e7b31d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64368",
    "data-name": "Path 64368",
    d: "M-2675.827-1589.95c-.244-1.116.7-1.827.948-2.773.327.039.668.2.531.542A3.772,3.772,0,0,1-2675.827-1589.95Z",
    fill: "#e6b21a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64369",
    "data-name": "Path 64369",
    d: "M-2677.387-1597.671l.625-1.225.334.354c.409.807-.273,1.4-.409,2.1-.2.308-.32.718-.823.623l-.338-.01q0-.611.009-1.222A1.019,1.019,0,0,0-2677.387-1597.671Z",
    fill: "#e5b435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64370",
    "data-name": "Path 64370",
    d: "M-2730.548-1546.348c-.2-.983.78-1.76.475-2.78-.067-.224.218-.3.431-.2.266.125.747.416.53.577-.841.621-.473,1.913-1.44,2.407Z",
    fill: "#e3b028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64371",
    "data-name": "Path 64371",
    d: "M-2664.4-1577.59l-.314,1.543c-.243-.068-.6,1.173-.732-.061a3.778,3.778,0,0,1,.109-.867c.232-.612.178-1.318.617-1.861C-2664.243-1578.515-2664.773-1577.936-2664.4-1577.59Z",
    fill: "#f9c83a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64372",
    "data-name": "Path 64372",
    d: "M-2742.824-1574.622c.392.843-.441,1.3-.345,2.122C-2745.224-1573.782-2742.747-1573.919-2742.824-1574.622Z",
    fill: "#eaac1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64373",
    "data-name": "Path 64373",
    d: "M-2651.734-1621.459c0,.308,0,.616,0,.924-.419.474-.809.325-1.093-.118a.973.973,0,0,1-.027-1.132C-2652.368-1622.308-2652.135-1621.5-2651.734-1621.459Z",
    fill: "#dfb234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64374",
    "data-name": "Path 64374",
    d: "M-2673.338-1619.315a2.542,2.542,0,0,1,1.227,1.847c.089.078.116.154.083.227s-.064.109-.095.109c-.825-.141-.949-1.078-1.643-1.439C-2674.124-1618.756-2673.629-1619.129-2673.338-1619.315Z",
    fill: "#dbaf1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64375",
    "data-name": "Path 64375",
    d: "M-2672.123-1617.132c0-.112.008-.224.012-.335a3.261,3.261,0,0,1,1.534,2.493l-.309.309C-2671.2-1615.536-2672.183-1616.073-2672.123-1617.132Z",
    fill: "#dab01f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64376",
    "data-name": "Path 64376",
    d: "M-2674-1620.527l.02.309c-.075.345.1,1.151-.621.5a3.1,3.1,0,0,1-1.227-2.052l.016-.016c.735-.132.96.419,1.226.916Z",
    fill: "#dcaa1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64377",
    "data-name": "Path 64377",
    d: "M-2725.877-1598.9l-1.233-1.864c.056-.3.109-.653.529-.449a1.475,1.475,0,0,1,1.013,1.383C-2725.335-1599.412-2725.187-1599.019-2725.877-1598.9Z",
    fill: "#eab024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64378",
    "data-name": "Path 64378",
    d: "M-2687.018-1564.914q.38-1.083.76-2.167c.3.249.22.6.256.925q-.165.764-.332,1.526c-.3.371-.132.975-.627,1.247h-.319C-2687.816-1564-2687.209-1564.422-2687.018-1564.914Z",
    fill: "#d8b241"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64379",
    "data-name": "Path 64379",
    d: "M-2724.922-1586.607q-.015.341-.031.683a2.07,2.07,0,0,1-.938-1.551q-.15-.621-.3-1.243a.483.483,0,0,1,.436-.134A1.816,1.816,0,0,1-2724.922-1586.607Z",
    fill: "#dfbd42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64380",
    "data-name": "Path 64380",
    d: "M-2665.943-1568.632c1.117.826.04,1.647-.006,2.47-1.248.107-.749-.653-.611-1.234h0Z",
    fill: "#efaa3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64381",
    "data-name": "Path 64381",
    d: "M-2704.551-1598.91c-1.757-.615-3.515-.2-5.273-.007l.936-.608,3.405-.007a.4.4,0,0,1,.609.021Z",
    fill: "#f4c62c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64382",
    "data-name": "Path 64382",
    d: "M-2701.174-1596.452c.735-.823,1-2.2,2.488-2.143a.492.492,0,0,1,.147.389,5.91,5.91,0,0,1-2.033,1.906.874.874,0,0,1-.434-.009Z",
    fill: "#d2be3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64383",
    "data-name": "Path 64383",
    d: "M-2670.6-1599.034c0,.4-.089.7-.48.68-.479-.024-.691-.352-.708-.806-.011-.329.091-.627.478-.611A.73.73,0,0,1-2670.6-1599.034Z",
    fill: "#e9b315"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64384",
    "data-name": "Path 64384",
    d: "M-2672.126-1552.261a.56.56,0,0,1-.613-.615l.61-1.238c0-.446,0-.9.624-.925l0,1.548C-2671.861-1553.154-2671.9-1552.659-2672.126-1552.261Z",
    fill: "#f5ad2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64385",
    "data-name": "Path 64385",
    d: "M-2703.671-1597.894q-.293-.5-.584-1.009c.981.073,1.793.351,1.863,1.531a.685.685,0,0,1-.6.235C-2703.4-1597.228-2703.681-1597.43-2703.671-1597.894Z",
    fill: "#e2c024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64386",
    "data-name": "Path 64386",
    d: "M-2740.087-1569.867c-.159.8-.587.72-1.043.278-.248-.239-.389-.592-.808-.585l-.005-.006c-.09-.071-.118-.139-.086-.207s.063-.1.094-.1c.5-.058,1.342-1.114,1.261.474C-2740.694-1569.626-2740.313-1569.816-2740.087-1569.867Z",
    fill: "#e6b02a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64387",
    "data-name": "Path 64387",
    d: "M-2725.843-1588.724l-.346.006c-.924-.43-.271-1.741-1.207-2.163l.255-.635C-2725.827-1590.995-2725.615-1589.961-2725.843-1588.724Z",
    fill: "#d8b841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64388",
    "data-name": "Path 64388",
    d: "M-2725.843-1583.29c.278.132.342.141.36.174a3.47,3.47,0,0,1,.2,2c0,.021-.222.073-.262.033C-2726.181-1581.718-2725.779-1582.469-2725.843-1583.29Z",
    fill: "#e6b022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64389",
    "data-name": "Path 64389",
    d: "M-2719.7-1656.988l.944.007-.623.639c-.331.647-.745,1.087-1.525.6l-.337-.014C-2720.907-1656.388-2720.206-1656.567-2719.7-1656.988Z",
    fill: "#dab01b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64390",
    "data-name": "Path 64390",
    d: "M-2659.767-1642.771l.313.611c-.039.371.088.849-.515.877-.274.013-.554-.163-.525-.4C-2660.441-1642.14-2660.48-1642.731-2659.767-1642.771Z",
    fill: "#eeab3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64391",
    "data-name": "Path 64391",
    d: "M-2725.877-1598.9c.36-.225.3-.589.309-.93l.928,0a1.242,1.242,0,0,1-.932,1.544A.647.647,0,0,1-2725.877-1598.9Z",
    fill: "#e8b032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64392",
    "data-name": "Path 64392",
    d: "M-2721.858-1600.142a.948.948,0,0,1-.929.617c-.261-1.411.779-1.113,1.837-1.353Z",
    fill: "#e5b01a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64393",
    "data-name": "Path 64393",
    d: "M-2737.617-1562.764c0-.1,0-.2,0-.307.757.24.789,1.056,1.231,1.546.079.067.106.135.081.2s-.052.1-.078.1l-.005.618-.591-.326Q-2737.3-1561.845-2737.617-1562.764Z",
    fill: "#e2b024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64394",
    "data-name": "Path 64394",
    d: "M-2700.095-1599.644c-.43.035-.517-.3-.6-.579-.145-.447.184-.518.511-.519s.666.079.673.458C-2699.51-1599.951-2699.818-1599.776-2700.095-1599.644Z",
    fill: "#ebb119"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64395",
    "data-name": "Path 64395",
    d: "M-2703.006-1597.365l.614-.007c.529.144.555.954,1.218.92l.1.1a.545.545,0,0,1-.092.63,1.034,1.034,0,0,1-.433.138A1.693,1.693,0,0,1-2703.006-1597.365Z",
    fill: "#d7be41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64396",
    "data-name": "Path 64396",
    d: "M-2677.069-1541.753a2.44,2.44,0,0,1,.31,1.539c-.689.075-.984-.247-.928-.922A.567.567,0,0,1-2677.069-1541.753Z",
    fill: "#deb33c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64397",
    "data-name": "Path 64397",
    d: "M-2651.444-1593.349c-.342.855-.372,1.863-1.213,2.474-.324-.411.146-.824,0-1.236a1.049,1.049,0,0,0,.615-.62Z",
    fill: "#e5af2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64398",
    "data-name": "Path 64398",
    d: "M-2677.992-1597.672c-.543.411-1.089,1.313-1.62-.137.662.15,1.244.048,1.312-.79C-2677.939-1598.376-2678-1598.012-2677.992-1597.672Z",
    fill: "#e5b435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64399",
    "data-name": "Path 64399",
    d: "M-2719.975-1598.8l.28-.417c.1,0,.205,0,.307,0l2.483-.008c.384-.2.65-.175.646.349a1.347,1.347,0,0,1-.913.364C-2718.1-1598.652-2719.1-1598.1-2719.975-1598.8Z",
    fill: "#d9bd3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64400",
    "data-name": "Path 64400",
    d: "M-2731.44-1548.856c.083-.462-.174-1,.276-1.429a1.355,1.355,0,0,1,.432,1.417c-.1.993-.456-.017-.709.009Z",
    fill: "#e9ad1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64401",
    "data-name": "Path 64401",
    d: "M-2754.318-1621.307c.005.341-.006.669-.416.7-.3.026-.447-.188-.465-.474-.02-.313,0-.664.346-.758C-2754.434-1621.948-2754.387-1621.576-2754.318-1621.307Z",
    fill: "#e3b518"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64402",
    "data-name": "Path 64402",
    d: "M-2657.279-1592.419a.626.626,0,0,1,.606.311l-.933,1.54c-.284.072-.433.01-.312-.318Z",
    fill: "#ddaf1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64403",
    "data-name": "Path 64403",
    d: "M-2665.942-1565.85a2.5,2.5,0,0,1-.315,1.536l-.923-1.846h0c.47-.134.825.2,1.234.308Z",
    fill: "#e5b221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64404",
    "data-name": "Path 64404",
    d: "M-2756.117-1598c.015-.447-.162-.919.236-1.431a1.66,1.66,0,0,1,.07,2.042Z",
    fill: "#d8b813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64405",
    "data-name": "Path 64405",
    d: "M-2676.753-1588.1c-.178-.743.6-1.165.618-1.84.1,0,.2-.005.3-.005C-2675.915-1589.22-2675.5-1588.247-2676.753-1588.1Z",
    fill: "#e6b21a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64406",
    "data-name": "Path 64406",
    d: "M-2684.207-1571.813c.013.237.027.475.041.713a1.5,1.5,0,0,1-.925,1.546A4.692,4.692,0,0,1-2684.207-1571.813Z",
    fill: "#daaa4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64407",
    "data-name": "Path 64407",
    d: "M-2653.182-1622.274c-.481-.7-.506-1.09-.113-1.566C-2652.8-1623.412-2653-1622.99-2653.182-1622.274Z",
    fill: "#dfb234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64408",
    "data-name": "Path 64408",
    d: "M-2724.022-1599.526l0-.307-.66-.828c.848.073,1.226.42,1.229,1.017C-2723.453-1599.247-2723.809-1599.485-2724.022-1599.526Z",
    fill: "#e8b032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64409",
    "data-name": "Path 64409",
    d: "M-2723.412-1597.981l.007.618a.645.645,0,0,1-.307.619,3.91,3.91,0,0,1-.31-2.163Z",
    fill: "#e8b032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64410",
    "data-name": "Path 64410",
    d: "M-2704.874-1599.511l-.609-.021c.381-.733.967-.671,1.648-.5C-2704.044-1599.423-2704.5-1599.571-2704.874-1599.511Z",
    fill: "#deb440"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64411",
    "data-name": "Path 64411",
    d: "M-2741.935-1570.486c0,.1-.006.2-.008.306l-.618-.292-.01-.015c-.092-.425-.183-.849-.317-1.471A1.849,1.849,0,0,1-2741.935-1570.486Z",
    fill: "#ecad17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64412",
    "data-name": "Path 64412",
    d: "M-2688.186-1551.024a2.776,2.776,0,0,1,0-2.784Z",
    fill: "#f5c419"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64413",
    "data-name": "Path 64413",
    d: "M-2653.893-1633.508l.9.635q.007.611.016,1.221A3.538,3.538,0,0,1-2653.893-1633.508Z",
    fill: "#d9ab2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64414",
    "data-name": "Path 64414",
    d: "M-2699.926-1660.385c-.643.051-1.39.723-1.853-.309C-2701.161-1660.595-2700.468-1660.944-2699.926-1660.385Z",
    fill: "#e4b125"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64415",
    "data-name": "Path 64415",
    d: "M-2754.035-1596.876c.3-.019.3.212.326.4s-.01.434-.238.484c-.292.062-.3-.2-.324-.392A.425.425,0,0,1-2754.035-1596.876Z",
    fill: "#eeaf12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64416",
    "data-name": "Path 64416",
    d: "M-2674.9-1546.39l-.006.922-.3.005c-.261-.15-.6-.3-.477-.662S-2675.185-1546.352-2674.9-1546.39Z",
    fill: "#e0b232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64417",
    "data-name": "Path 64417",
    d: "M-2695.6-1599.227a.635.635,0,0,1,.61.349,1.818,1.818,0,0,1-2,.141c-.061-.064-.121-.13-.181-.195C-2696.715-1599.4-2696.125-1599.146-2695.6-1599.227Z",
    fill: "#d9b131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64418",
    "data-name": "Path 64418",
    d: "M-2740.1-1566.146c.056-.274-.086-.629.277-.772.057-.023.264.139.279.235.064.416-.257.474-.561.531Z",
    fill: "#eba91d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64419",
    "data-name": "Path 64419",
    d: "M-2728.344-1540.831c.272.379.942.559.615,1.236l0,.007c-.873-.077-.87-.595-.626-1.237Z",
    fill: "#e3b028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64420",
    "data-name": "Path 64420",
    d: "M-2698.678-1598.238l-.008-.357a2.69,2.69,0,0,1,1.516-.337l.069.088c-.069.572-.566.584-.959.734A.7.7,0,0,1-2698.678-1598.238Z",
    fill: "#d9b131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64421",
    "data-name": "Path 64421",
    d: "M-2657.918-1590.886l.313.318c-.006.341.055.7-.3.928a.655.655,0,0,0-.321-.626C-2658.127-1590.472-2658.022-1590.679-2657.918-1590.886Z",
    fill: "#deaf21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64422",
    "data-name": "Path 64422",
    d: "M-2670.892-1653.892a1.032,1.032,0,0,1,.624.612l-.927.309h0Z",
    fill: "#e5b021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64423",
    "data-name": "Path 64423",
    d: "M-2685.634-1568.317a2.105,2.105,0,0,1,.543-1.238C-2685.144-1569.086-2684.9-1568.486-2685.634-1568.317Z",
    fill: "#daaa4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64424",
    "data-name": "Path 64424",
    d: "M-2751.306-1635.062c.148.25.26.363.273.486.012.1-.093.218-.146.328-.1-.081-.242-.146-.275-.248S-2751.4-1634.728-2751.306-1635.062Z",
    fill: "#d8a824"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64425",
    "data-name": "Path 64425",
    d: "M-2676.746-1599.522q.152-.464.3-.927c.1,0,.2,0,.3,0C-2676.129-1600-2676.129-1599.564-2676.746-1599.522Z",
    fill: "#e5b435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64426",
    "data-name": "Path 64426",
    d: "M-2796.611-1600.442c.642.108,1.053-.347,1.535-.63l1.233-.618c1.337,2.1.656,5.518-1.128,6.651a13.287,13.287,0,0,1-2.84,1.737c-1.316.444-1.3,1.9-1.591,3.044-.595-.778-.2-1.5.032-2.3a11.666,11.666,0,0,1,1.463-2.52c.7-1.2.176-2.387.658-3.47l-.3-.055A1.773,1.773,0,0,0-2796.611-1600.442Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64427",
    "data-name": "Path 64427",
    d: "M-2799.379-1590.4c.546.905.813,1.714,1.522,2.188A1.753,1.753,0,0,1-2799.379-1590.4Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64428",
    "data-name": "Path 64428",
    d: "M-2800.746-1593.491c-.231.037-.387.109-.49.063-.085-.038-.107-.217-.157-.333.089-.03.2-.109.26-.079A2.266,2.266,0,0,1-2800.746-1593.491Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64429",
    "data-name": "Path 64429",
    d: "M-2755.136-1604.7a7.285,7.285,0,0,0,.995,1.7.705.705,0,0,1-.186,1.079c-.588.342-.711-.262-.8-.593C-2755.31-1603.157-2755.839-1603.811-2755.136-1604.7Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64430",
    "data-name": "Path 64430",
    d: "M-2738.233-1474.408c-.2-.03-.554-.03-.565-.094a3.912,3.912,0,0,1,2.712-4.088,1.19,1.19,0,0,1,1.376.337c.45.592-.243.744-.536,1.023-.989.947-1.991,1.882-2.988,2.822Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64431",
    "data-name": "Path 64431",
    d: "M-2745.03-1465.758c-.765-.678-1.7-1.326-1.333-2.531a3.352,3.352,0,0,1,3.256-2.714c.336.011.779-.163.975.227.21.418-.23.625-.457.866-.524.559-1.077,1.092-1.62,1.634a2.212,2.212,0,0,0-.82,2.518Z",
    fill: "#a7dcee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64432",
    "data-name": "Path 64432",
    d: "M-2767.23-1532.815l-.358.022c-.832.178-1.456-.383-2.16-.633a4.672,4.672,0,0,0-5.237.963c-1.528,1.438-3.168,1.823-4.934.292a5.579,5.579,0,0,0-3.85.2c-.451.2-.919.483-1.423.1a5.084,5.084,0,0,1,6.678-.545c.809.623,1.154.554,1.813-.243C-2774.24-1535.636-2769.412-1535.717-2767.23-1532.815Z",
    fill: "#e7fbfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64433",
    "data-name": "Path 64433",
    d: "M-2785.192-1531.87c1.8-.718,3.591-1.466,5.562-.618a.9.9,0,0,1-.808.356c-2.384-.281-3.846,1.22-5.322,2.708-.351.353-.662.8-1.274.654l-.028-.027A3.933,3.933,0,0,1-2785.192-1531.87Z",
    fill: "#edfcfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64434",
    "data-name": "Path 64434",
    d: "M-2787.034-1528.77c.964-.439,1.415-1.425,2.13-2.12a6.113,6.113,0,0,1,5.274-1.6c1.544,1.186,2.677,1.22,4.048.121,3.075-2.466,4.728-2.554,7.994-.426.251.977,1.077,1.683,1.01,2.877-.043.763,1.072,1.07,1.776,1.443,1.031-.089,2.019-.611,3.09-.308l1.236.62c.557.764.428,1.184-.579,1.231-.636.029-1.244-.18-1.794-.16a7.421,7.421,0,0,0,3.607-.145l.309,1.235a3.492,3.492,0,0,1-2.506.495q-13.176.018-26.351.01a27.329,27.329,0,0,0-4.154.152c-.332.051-.845.3-.971-.348,1.33-2.082,3.52-1.769,5.615-1.908-.407-.441-.873-.113-1.527-.517C-2788.012-1528.183-2787.3-1528.086-2787.034-1528.77Z",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64435",
    "data-name": "Path 64435",
    d: "M-2792.915-1525.691a32.127,32.127,0,0,1,6.816-.3q13.584-.024,27.166-.007c-.026.664.792.694.929,1.234-1.453.7-3.026.386-4.523.4q-7.3.06-14.615-.035c-3.993-.046-7.995.122-11.994.083a11.523,11.523,0,0,1-4.087-.445C-2793.214-1525.1-2793.275-1525.467-2792.915-1525.691Z",
    fill: "#f6fef8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64436",
    "data-name": "Path 64436",
    d: "M-2793.223-1524.764q15.721,0,31.442.013c1.259,0,2.518-.449,3.777-.015l.306,0c.082.9-.5.91-1.167.936a7.532,7.532,0,0,1-2.229-.318,41.562,41.562,0,0,1-6.572.129,80.87,80.87,0,0,1-8.875-.129,121.79,121.79,0,0,1-12.529.287,32.968,32.968,0,0,1-3.483-.333A.89.89,0,0,1-2793.223-1524.764Z",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64437",
    "data-name": "Path 64437",
    d: "M-2776.541-1524.145h15.447c-.3.381-.732.3-1.132.3q-6.593.006-13.183,0C-2775.809-1523.842-2776.239-1523.765-2776.541-1524.145Z",
    fill: "#f6fef8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64438",
    "data-name": "Path 64438",
    d: "M-2816.707-1458.032c.788.035.959.545.932,1.208C-2816.342-1457.029-2816.442-1457.594-2816.707-1458.032Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64439",
    "data-name": "Path 64439",
    d: "M-2730.491-1528.468c-.432-.977-1.8-.269-2.234-1.245a12.209,12.209,0,0,1,.033-3.681c.28-.176.424,0,.552.212a2.512,2.512,0,0,1,.145,1.033c0,.205,0,.445.2.508.1.031-.1-.339.179-.369a2.19,2.19,0,0,0,2.617-.695,3.248,3.248,0,0,1,1.916-.807c10.523-.119,21.042-.029,31.561-.05,3.586-.008,7.171-.027,10.752-.016,1.487.2,2.261,1.422,3.17,2.373a2.455,2.455,0,0,0,2.092.874c.471.518.759,1.031-.024,1.529a6.278,6.278,0,0,1-1.993.148q-23.009,0-46.014,0c-.422,0-.847-.017-1.271-.009a2.432,2.432,0,0,0-.655.109C-2729.8-1528.468-2730.13-1528.27-2730.491-1528.468Z",
    fill: "#3f4143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64440",
    "data-name": "Path 64440",
    d: "M-2731.431-1517.637l.921-.331a1.793,1.793,0,0,1,1.022-.126c3.715.011,7.429-.063,11.143-.081a.667.667,0,0,1,.365.354,5.115,5.115,0,0,0,2.192,2.854c.554.354,1.07.779.809,1.471-.234.618-.918.56-1.478.568-1.232.018-2.437-.27-3.673-.3-3.223-.077-6.43.5-9.652.185a1.031,1.031,0,0,1-.424-.182c-.333-1.282.968-1.014,1.457-1.516.162-.167.394.093.6.046-.163-.123-.216-.338-.328-.467-.26-.3-.244.126-.283.2-.358.7-1.525.489-1.619,1.461a.391.391,0,0,1-.277.293c-1.4-.233-1.995-1.794-1.238-3.364C-2731.72-1516.921-2731.424-1517.21-2731.431-1517.637Z",
    fill: "#404143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64441",
    "data-name": "Path 64441",
    d: "M-2730.5-1520.436c-.364-.613-1.187-.038-1.568-.606.369-.321.244-.641,0-.964a5.091,5.091,0,0,1-.121-1.983c.029-1.631,1.537-1.523,2.511-2.041a11.611,11.611,0,0,1,2.5.122c1.984.924,3.1,2.8,4.644,4.219a.747.747,0,0,1-.089.936c-.949.713-2.052.418-3.095.454-1.166.039-2.335.033-3.5-.009A2.62,2.62,0,0,1-2730.5-1520.436Z",
    fill: "#404244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64442",
    "data-name": "Path 64442",
    d: "M-2731.431-1517.637c-.094.349,1.44.217.264.883-1.157.656-.434,1.725-.543,2.595-.108.851.785.559,1.2.825-.043.921-.6.831-1.222.625-.439-.015-.581-.448-.9-.638a7.918,7.918,0,0,1-.091-3.378c-.041-.5.566-.51.678-.894Z",
    fill: "#293335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64443",
    "data-name": "Path 64443",
    d: "M-2729.594-1525.7c-2.327,1-2.327,1-2.174,3.738a.515.515,0,0,1-.652.01c-.256-.5.116-1.1-.264-1.574-.037-.8-.445-1.7.638-2.167.423-.416,1.167.209,1.509-.467l.038-1.077c.772.01.634.8,1,1.161A.348.348,0,0,1-2729.594-1525.7Z",
    fill: "#2d383f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64444",
    "data-name": "Path 64444",
    d: "M-2729.59-1526.015c-.9.037-.42-.952-.909-1.221l.008-1.232a1.156,1.156,0,0,1,.881-.266c.8.428.476,1.762,1.724,1.96.466.074.174.763-.369.9C-2728.707-1525.754-2729.138-1526.019-2729.59-1526.015Z",
    fill: "#030709"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64445",
    "data-name": "Path 64445",
    d: "M-2730.5-1520.436a1.281,1.281,0,0,1,.914-.283c.814.665.509,1.741.888,2.591.219.493-.856.063-1.193.454l-.616-.294Q-2730.507-1519.2-2730.5-1520.436Z",
    fill: "#0d1617"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64446",
    "data-name": "Path 64446",
    d: "M-2732.439-1533.519c-.567,1.233-.2,2.537-.286,3.806-.234-1.368-.852-2.77.355-4.01q.107.111.04.165A.171.171,0,0,1-2732.439-1533.519Z",
    fill: "#a6d6db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64447",
    "data-name": "Path 64447",
    d: "M-2732.439-1533.519c.02-.069.043-.138.069-.2l.329-.277a1.53,1.53,0,0,1,1.214.22c.133.723-.52.81-.9,1.12a.618.618,0,0,1-.634-.136Z",
    fill: "#1c2124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64448",
    "data-name": "Path 64448",
    d: "M-2732.369-1521.995l.6.033c.144.359.844.206.757.6-.116.525-.705.18-1.061.317l-.312-.3A.508.508,0,0,1-2732.369-1521.995Z",
    fill: "#162227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64449",
    "data-name": "Path 64449",
    d: "M-2732.369-1521.995c-.005.218-.01.437-.014.655-.636-.655-.374-1.433-.3-2.185C-2732.157-1523.1-2732.44-1522.512-2732.369-1521.995Z",
    fill: "#404244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64450",
    "data-name": "Path 64450",
    d: "M-2730.537-1526.159c-.308.787-.994.352-1.509.467C-2731.643-1526.17-2730.959-1525.743-2730.537-1526.159Z",
    fill: "#3f3f41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64451",
    "data-name": "Path 64451",
    d: "M-2757.389-1421.879a7.368,7.368,0,0,1-2.789-.624A3.805,3.805,0,0,1-2757.389-1421.879Z",
    fill: "#a7dbe9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64452",
    "data-name": "Path 64452",
    d: "M-2722.6-1501.554a8.354,8.354,0,0,1-6.413-4.238c-.074-.289-.2-.586.14-.8.7-.019.877.621,1.241,1.006a8.235,8.235,0,0,0,2.76,2.133c.277.124.546.261.821.389.466.2.98.192,1.453.362,6.124.129,12.246.038,18.367.049,6.533.013,13.066.039,19.6-.042,3.187.358,6.035-.272,8.179-2.875a9.434,9.434,0,0,0,2.061-6.43c.581-.781.914-.429,1.07.276a12.757,12.757,0,0,1,.088,2.283,5.965,5.965,0,0,1-.8,3.2,12.692,12.692,0,0,1-4.918,4.334,7.289,7.289,0,0,1-2.974.743q-18.664.023-37.322.007A10.779,10.779,0,0,1-2722.6-1501.554Z",
    fill: "#0a1213"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64453",
    "data-name": "Path 64453",
    d: "M-2720.315-1500.66l-.613-.013c-.26-.486-.983-.11-1.214-.651a2.794,2.794,0,0,1,1.218-.108q19.3,0,38.6,0c.747.961-.488.643-.654,1.017a2.286,2.286,0,0,1-.588.148c-11.659.079-23.319.017-34.979.036A3.309,3.309,0,0,1-2720.315-1500.66Z",
    fill: "#cbcacf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64454",
    "data-name": "Path 64454",
    d: "M-2682.028-1501.285l-37.808-.025c-.769,0-1.538-.009-2.307-.014l-.455-.23q17.329-.023,34.659-.044c2.207,0,4.414.029,6.622.045C-2681.43-1501.134-2681.662-1501.033-2682.028-1501.285Z",
    fill: "#161718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64455",
    "data-name": "Path 64455",
    d: "M-2728.658-1506.535c-.289.167-.306.462-.353.743-1.483-1.977-1.634-4.262-1.53-6.606a.616.616,0,0,1,.394-.469.944.944,0,0,1,.8.195c.294.269.8.366.757.916-1.311,1.182-.091,2.52-.2,3.779C-2728.833-1507.52-2728.391-1507.052-2728.658-1506.535Z",
    fill: "#161718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64456",
    "data-name": "Path 64456",
    d: "M-2732.719-1516.725q.047,1.689.091,3.378A3.938,3.938,0,0,1-2732.719-1516.725Z",
    fill: "#b6e4ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64457",
    "data-name": "Path 64457",
    d: "M-2730.2-1512.728l-.337.33-1.19-.311c.5-.028,1-.056,1.222-.625l0-.005c.1-.136.2-.134.3.005A.4.4,0,0,1-2730.2-1512.728Z",
    fill: "#404143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64458",
    "data-name": "Path 64458",
    d: "M-2821.645-1572.033c.8-.6.839-1.676,1.552-2.373.651-.637.915-.427,1.228.211C-2819.581-1571.971-2819.971-1571.668-2821.645-1572.033Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64459",
    "data-name": "Path 64459",
    d: "M-2720.309-1484.306c.2-.339.529-.288.841-.3.647.555.194,1.162.089,1.753-.467,1.034-.053,2.012.2,3a3.276,3.276,0,0,1,.112.436,8.854,8.854,0,0,0,.537,3.083c.12.428.2.866.323,1.293a12.9,12.9,0,0,0,.591,2.084c.131.41.258.821.362,1.239a5.071,5.071,0,0,0,.531,1.836,3,3,0,0,1,.154.428c.549,2.032,1.3,4,1.982,5.982.226.654.689,1.309.172,2.034l-.068.047c-.126.22-.273.4-.567.29a20.305,20.305,0,0,1-2.836-7.394,15.274,15.274,0,0,0-1.1-3.163c-.644-.782.063-1.936-.855-2.742-.415-.363-.311-1.264.142-1.863l-.011-.921c-.414-.178-.04-.868-.613-.942l-.41.609C-2719.933-1479.733-2721.064-1482.076-2720.309-1484.306Z",
    fill: "#e2521d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64460",
    "data-name": "Path 64460",
    d: "M-2719.7-1476.261c-.311,1.276.595,2.272.786,3.431.066.4.1.8.146,1.2a4.313,4.313,0,0,1,.513,2.367c-.176.324-.409.536-.813.411-.416-2.014-.757-4.049-1.285-6.033C-2720.567-1475.689-2720.368-1476.015-2719.7-1476.261Z",
    fill: "#eb5e31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64461",
    "data-name": "Path 64461",
    d: "M-2719.068-1468.852l.605-.3a8.617,8.617,0,0,1,.827,2.706c-.057.521-.58.33-.834.549-.1.468.161,1.015-.307,1.4a20.814,20.814,0,0,1-1.552-5.265c.616-.2.357.477.629.622l.436,1.835.2-.005Z",
    fill: "#e45e2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64462",
    "data-name": "Path 64462",
    d: "M-2719.7-1469.148l-.629-.622q-.591-1.893-1.183-3.786c-.013-.382-.026-.765-.039-1.147q.149-.277.323-.016A21.18,21.18,0,0,1-2719.7-1469.148Z",
    fill: "#e94e22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64463",
    "data-name": "Path 64463",
    d: "M-2720.324-1478.124c.063-.236.056-.6.2-.682.365-.2.387.174.4.4.028.406.007.816.007,1.224C-2720.33-1477.226-2720.315-1477.683-2720.324-1478.124Z",
    fill: "#f0462f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64464",
    "data-name": "Path 64464",
    d: "M-2721.228-1474.719l-.323.015a.2.2,0,0,1-.051-.26c.114-.432-.1-.953.354-1.292Q-2721.237-1475.488-2721.228-1474.719Z",
    fill: "#da3d11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64465",
    "data-name": "Path 64465",
    d: "M-2759.242-1527.235c-1.39.893-2.866.642-4.523.488.83-.761.825-.723,2.055-.555.6.082,1.563.479,1.234-.859C-2760.024-1527.906-2759.466-1527.793-2759.242-1527.235Z",
    fill: "#f6fef8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64466",
    "data-name": "Path 64466",
    d: "M-2761.712-1528.781a11.312,11.312,0,0,1-3.09.308C-2763.8-1528.843-2762.823-1529.492-2761.712-1528.781Z",
    fill: "#f6fef8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64467",
    "data-name": "Path 64467",
    d: "M-2714.725-1490.791c0-.118-.009-.236-.013-.354.408-.519,1.077-.465,1.645-.841-1.227-.3-2.733.685-3.686-.882-.7-1.147-2.234-1.653-2.584-3.116-.32-1.337-1.357-2.564-.643-4.066a1.88,1.88,0,0,1,1.319-.3q17.172,0,34.345.007a2.261,2.261,0,0,1,.606.088c.825.641.415,1.5.409,2.291a8.644,8.644,0,0,1-2.291,4.438c-.429.489-1.092.81-1.224,1.538a2.042,2.042,0,0,1-.273.834c-.426.377-.972.139-1.444.286a.891.891,0,0,1-.6-.159c-.267-.834-1.032-.6-1.5-.5a3.255,3.255,0,0,1-2.584-.458c-1.517-1.974-3.765-3.213-5.237-5.232.949,1.351,2.41,2.242,3.259,3.686.238.405.588.778.252,1.249-.375.525-.715.154-1.164-.007-.523-.188-.975.452-1.509.612a10.789,10.789,0,0,1-4.709.265,1.252,1.252,0,0,0-1.312.461,1.2,1.2,0,0,1-1.043.08c-.359.076-.44-1.017-.967-.225a2.689,2.689,0,0,1-.678.655.8.8,0,0,1-.376.087,2.632,2.632,0,0,1-.738-.266,1.171,1.171,0,0,1-.574-.517c.042-.63-.426-.546-.812-.576.29.184.908.17.476.792a2.182,2.182,0,0,1-1.106.245,18.73,18.73,0,0,0-2.732.123c-.488-.028-.807-.474-1.287-.526Z",
    fill: "#a6a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64468",
    "data-name": "Path 64468",
    d: "M-2720.315-1500.66l37.072,0a.3.3,0,0,1-.237.44q-17.661.033-35.321.005a2.08,2.08,0,0,1-1.205-.143Z",
    fill: "#afafb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64469",
    "data-name": "Path 64469",
    d: "M-2720.006-1500.356l36.755-.008c.085.283-.006.4-.3.316l-36.453,0Z",
    fill: "#a2a2a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64470",
    "data-name": "Path 64470",
    d: "M-2716.916-1490.47l-.928-.313c.293-.414.978-.529.926-1.207l1.591.871C-2715.892-1490.99-2716.181-1490.185-2716.916-1490.47Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64471",
    "data-name": "Path 64471",
    d: "M-2718.777-1464.505c.249-.625-.5-1.253.006-1.876,1.269,1.223,1.356,2.868,1.6,4.46-.071.331-.108.688-.546.752A11.709,11.709,0,0,1-2718.777-1464.505Z",
    fill: "#da5127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64472",
    "data-name": "Path 64472",
    d: "M-2717.719-1461.169l.187-.577a.343.343,0,0,1,.363-.092.991.991,0,0,1,.423.418c.186.414.124.888.316,1.3.065.111.127.223.194.332.286.439.694.851.328,1.437-.375-.136-.562.1-.729.37A11.715,11.715,0,0,1-2717.719-1461.169Z",
    fill: "#e65328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64473",
    "data-name": "Path 64473",
    d: "M-2716.637-1457.98c0-.493.244-.571.646-.375,1.265.279.71.935.324,1.557a.677.677,0,0,1-.3.612A3.211,3.211,0,0,1-2716.637-1457.98Z",
    fill: "#d6591e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64474",
    "data-name": "Path 64474",
    d: "M-2720.312-1467.3a3.5,3.5,0,0,1-.929-3.087C-2720.285-1469.557-2720.82-1468.274-2720.312-1467.3Z",
    fill: "#a8e3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64475",
    "data-name": "Path 64475",
    d: "M-2716.343-1488.432l.638-.52a.47.47,0,0,1,.772.216,1.079,1.079,0,0,1-.243.879c-.67.544-.724,1.466-1.271,2.087-.788,1.073-.011,2.421-.617,3.525-.934.576-1.337.38-1.116-.714-.16.242-.056.623-.292.891a.464.464,0,0,1-.424-.113c-.643-1.18.137-2.188.384-3.261.256-.76.94-1.246,1.262-1.965l0,.007C-2716.993-1487.781-2716.595-1488.042-2716.343-1488.432Z",
    fill: "#f0eb2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64476",
    "data-name": "Path 64476",
    d: "M-2717.25-1487.407c.019.779-.559,1.269-.906,1.871-.224.311-.433.666-.892.316l-.107.013A5.3,5.3,0,0,1-2717.25-1487.407Z",
    fill: "#f8d23b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64477",
    "data-name": "Path 64477",
    d: "M-2715.051-1488.648l-.654-.3a4.41,4.41,0,0,1,1.851-1.268.3.3,0,0,1,.4.056C-2713.588-1489.237-2714.008-1488.615-2715.051-1488.648Z",
    fill: "#f8d23b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64478",
    "data-name": "Path 64478",
    d: "M-2713.469-1490.168l-.385-.051q.174-.43.349-.86c.467-.443.778-.333.954.266C-2712.647-1490.3-2712.777-1489.833-2713.469-1490.168Z",
    fill: "#d5973a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64479",
    "data-name": "Path 64479",
    d: "M-2716.343-1488.432a1.3,1.3,0,0,1-.911,1.032C-2717.191-1487.956-2716.779-1488.2-2716.343-1488.432Z",
    fill: "#f8d23b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64480",
    "data-name": "Path 64480",
    d: "M-2728.353-1540.825c-.013.524.064,1,.626,1.237.456.5,1.057.293,1.6.3,4.1.017,8.2.01,12.293.011a.359.359,0,0,1-.162.5,3.69,3.69,0,0,1-1.8.235q-5.279.013-10.559,0a2.612,2.612,0,0,1-1.9-.37.392.392,0,0,0-.135-.08c.079-.878-.7-1.553-.578-2.441Z",
    fill: "#e2c23f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64481",
    "data-name": "Path 64481",
    d: "M-2735.765-1560.289l.954-.9a15.85,15.85,0,0,0,1.212,2.752c-.26.414-.455,1.32-.973.185C-2734.9-1558.976-2735.767-1559.378-2735.765-1560.289Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64482",
    "data-name": "Path 64482",
    d: "M-2749.047-1585.623c-.19-.064-.415-.225-.566-.173-.453.157-.13.389.02.549.327.348.2.771.238,1.168-.9-.492-1.658-1.053-.795-2.172.3-.4-.38-.9.178-1.227C-2748.936-1587.222-2749.088-1586.375-2749.047-1585.623Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64483",
    "data-name": "Path 64483",
    d: "M-2719.048-1485.22l.892-.316c-.075,1.157-.9,2.18-.612,3.4-.019.5.015,1,.014,1.858.056-.861-.174-1.43.292-1.859a2.019,2.019,0,0,1,.422-1.59c.6.371-.727,1.773.814,1.593q.053.094.107.189c.592,2.019-.031,4.269,1.312,6.175.557.79-.2,1.652-.515,2.467,1.065-.4,1.689-.107,1.419.756-.337,1.073.241,1.466.887,1.955a5.759,5.759,0,0,1-.157,2.29c-.178.4-.224,1.005-.793.952-.463-.042-.514-.582-.555-.977-.072-.7-.5-1.287-.635-1.967.116,1,1.005,1.884.531,2.981-1.217-.4-.79-1.676-1.307-2.451h-.007c-.279-.6-.362-1.257-.6-1.866a1.538,1.538,0,0,1-.332-1.182c-.25-.721-.186-1.543-.7-2.18-.314-.362-.216-.8-.227-1.221-.471-1.1-.272-2.317-.622-3.437l.007.009c-.072-1.06-.55-2.081-.313-3.172-.155-.634.473-1.153.261-1.794Z",
    fill: "#f6ed35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64484",
    "data-name": "Path 64484",
    d: "M-2731.754-1532.805c-.041-.659.754-.521.928-.975l.219-.27a.746.746,0,0,1,.393-.166.69.69,0,0,1,.378.178c.212.169-.279.9.471.621.63-.235,1.188-.312,1.635.312-.376.225-.883.361-1.107.69-.815,1.2-1.717,1.533-2.907.546A.666.666,0,0,1-2731.754-1532.805Z",
    fill: "#3f3f41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64485",
    "data-name": "Path 64485",
    d: "M-2730.206-1534.052l-.4,0q.067-1.387.136-2.776c.217-.2.039-.944.716-.53a4.576,4.576,0,0,1,.539,2.264,1.556,1.556,0,0,1-.189.67C-2729.582-1534.106-2729.97-1534.243-2730.206-1534.052Z",
    fill: "#070d0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64486",
    "data-name": "Path 64486",
    d: "M-2729.9-1537.43l-.574.6q0-.9-.006-1.8l1.826.038a.494.494,0,0,1,.145.381.606.606,0,0,1-.232.339A5.837,5.837,0,0,1-2729.9-1537.43Z",
    fill: "#050e16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64487",
    "data-name": "Path 64487",
    d: "M-2728.642-1538.359l-.009-.234.295-.1c5.026-.181,10.052-.224,15.078.024-.027.891-.761.716-1.238.722-4.284.056-8.569.043-12.854.018A1.734,1.734,0,0,1-2728.642-1538.359Z",
    fill: "#1e0f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64488",
    "data-name": "Path 64488",
    d: "M-2713.213-1538.644l-15.143-.054a.363.363,0,0,1,.095-.218l14.435-.082a.555.555,0,0,1,.336-.157.6.6,0,0,1,.339.158l.036.189Z",
    fill: "#967d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64489",
    "data-name": "Path 64489",
    d: "M-2715.667-1456.8c-.187-.5.549-1.2-.324-1.557.2-.67-.6-.943-.606-1.53.18-.221.455-.364.545-.672-.261.165-.324.484-.56.657-.513-.43-.224-1.018-.3-1.533.78-1.7-.814-2.911-.923-4.429,0-.07-.006-.14-.009-.21-.263-1.016-.89-1.96-.616-3.084q-.153-1.236-.305-2.474c1,.5,1,1.64,1.143,2.412a29.4,29.4,0,0,0,2.852,8.1c.372.336-.03.879.327,1.22-.162.344-.5.217-.878.206,1.924,1.284,1.955,2.113.253,3.818Q-2715.37-1456.332-2715.667-1456.8Z",
    fill: "#f45a2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64490",
    "data-name": "Path 64490",
    d: "M-2666.258-1423.122a1.74,1.74,0,0,1,1.416.48c2.021,2.018,3.633,4.258,3.842,7.239q0,1.243-.007,2.486c-.455-1.485-.6-3.035-1.194-4.508A18.164,18.164,0,0,0-2666.258-1423.122Z",
    fill: "#aad9e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64491",
    "data-name": "Path 64491",
    d: "M-2672.434-1425.923c-.1-.306-.187-.7.307-.576,2.01.488,4.076.845,5.691,2.333.445.41.556.6-.133.734A15.924,15.924,0,0,0-2672.434-1425.923Z",
    fill: "#a9d9e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64492",
    "data-name": "Path 64492",
    d: "M-2643.391-1416.947c1.3.132,2.594-.53,3.918-.02.363.14.676.191.715.633l-4.942,0Z",
    fill: "#a9dae8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64493",
    "data-name": "Path 64493",
    d: "M-2684.785-1452.474c.187,0,.523-.044.538.007a27.69,27.69,0,0,1,1.263,7.952c0,.124-.161.249-.246.373C-2683.781-1446.913-2684.5-1449.653-2684.785-1452.474Z",
    fill: "#a2d7e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64494",
    "data-name": "Path 64494",
    d: "M-2686.9-1457.945a1.611,1.611,0,0,1,.257-1.024c.267-.453.38-1.024.955-1.239-.016.689-.513,1.177-.743,1.776l-.244.368Z",
    fill: "#df613a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64495",
    "data-name": "Path 64495",
    d: "M-2679.226-1426.834c1.534-.1,3.067-.192,4.6-.3a1.117,1.117,0,0,1,1.269.607,38.781,38.781,0,0,0-5.009.142C-2678.774-1426.318-2679.207-1426.173-2679.226-1426.834Z",
    fill: "#a9d9e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64496",
    "data-name": "Path 64496",
    d: "M-2607.863-1597.055a12.053,12.053,0,0,1,4.015,3.4c-.1.723.61,1.172.619,1.858-.483,2.191-2.3,3.256-3.963,4.255-2.243,1.352-4.736.365-5.987-2.025-.621-1.187.25-3.9,1.634-4.272C-2609.7-1594.333-2608.893-1595.766-2607.863-1597.055Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64497",
    "data-name": "Path 64497",
    d: "M-2640.61-1563.379a4.3,4.3,0,0,1-4.933.6,5.209,5.209,0,0,1-3.1-5.259,5.769,5.769,0,0,1,3.47-3.961c1.923-.457,4.263.269,5.129,1.529a.578.578,0,0,1-.079.8c-1.366,1.5-2.721,3.019-4.163,4.446-.556.549-.883-.284-1.226-.537-.591-.437-.137-.976.183-1.317.556-.593,1.236-1.068,1.833-1.627.336-.313.744-.757.543-1.185-.263-.559-.924-.312-1.391-.263a3.087,3.087,0,0,0-2.443,3.012,2.978,2.978,0,0,0,2.732,2.72c2.419.038,2.685-.23,3.168-2.64.176-.879.642-2.146,1.543-1.937.826.193.9,1.484.488,2.4a4.375,4.375,0,0,0-.211,1.664C-2639.324-1564.153-2639.553-1563.353-2640.61-1563.379Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64498",
    "data-name": "Path 64498",
    d: "M-2636.129-1579.754a4.419,4.419,0,0,1,2.008.347c2.21.728,2.422,1.57.767,3.2-1,.986-2.1,1.875-3.058,2.894a1.01,1.01,0,0,1-1.449.114c-.7-.407-.171-.756.042-1.225.538-1.187,1.8-1.578,2.548-2.542.594-.768.209-.83-.4-.931a2.9,2.9,0,0,0-3.378,2.343,2.832,2.832,0,0,0,2.6,3.612,3.248,3.248,0,0,0,3.259-2.391c.191-.851.146-2.245,1.264-2.079.925.137.571,1.489.563,2.322a3.71,3.71,0,0,1-2.306,3.39c-1.877.835-3.894,1.2-5.661-.539-1.184-1.167-2.2-4.038-1.75-5.332C-2640.54-1578.112-2638.034-1579.759-2636.129-1579.754Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64499",
    "data-name": "Path 64499",
    d: "M-2611.263-1600.758c.149.923.89,1.351,1.544,1.853-.918.152-.532,1.872-1.852,1.542-.191-.721.188-1.452-.394-2.221-.863-1.143-1.514-1.278-2.269-.033a16.1,16.1,0,0,1-1.277,1.97c-1.069,1.3-.466,2.726.185,4.113a5.551,5.551,0,0,1-4.415-4.636c-.183-2.666,1.246-5.453,3.23-6.3C-2614.684-1603.342-2613.22-1601.7-2611.263-1600.758Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64500",
    "data-name": "Path 64500",
    d: "M-2673.061-1545.157a9.675,9.675,0,0,1,4.394-2.11,3.239,3.239,0,0,1,2.434.981c1.584,1.265,2.987,2.756,4.5,4.194-2.021.908-2.287.865-3.989-1.209a5,5,0,0,0-2.148-1.657,2.533,2.533,0,0,0-3.167.742c-1.177,1.638-1.313,2.988-.2,3.906,1.208,1,1.9,2.486,3.289,3.292.618.357.121.7-.148.96s-.459,1.086-1.009.491c-.955-1.032-2.239-1.762-2.88-3.1-.251.263-.048.738-.438.928a3.175,3.175,0,0,1-.818-.391c-.263-.42-.725-.507-1.14-.675-1.084-.8-.748-1.695-.048-2.48.338-.38.865-.574.6-1.222a14.953,14.953,0,0,1,.176-2.058C-2673.581-1544.887-2673.514-1545.213-2673.061-1545.157Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64501",
    "data-name": "Path 64501",
    d: "M-2602.628-1555.039c.16,1.238-.418,1.577-1.608,1.575q-22.221-.045-44.442-.024c-.659,0-1.566.285-1.5-.934a2.811,2.811,0,0,1,.654-1.938,1.877,1.877,0,0,1,.581-.615.648.648,0,0,1,.7.39,1.084,1.084,0,0,1-.247.844c-.47.632.075.727.463.913a10.152,10.152,0,0,0,4.14.091,25.407,25.407,0,0,1,5.238-.048,62.837,62.837,0,0,0,10.635.026c1.3-.1,2.559.185,3.847.18,6.074-.025,12.148-.016,18.222-.011a3.213,3.213,0,0,0,1.8-.286c.48-.618.223-.89-.455-.97a4,4,0,0,1-1.621-.351c-.266-.155-.531-.346-.492-.7.046-.418.411-.454.691-.382.807.206,1.21-.256,1.565-.846C-2603.133-1557.606-2602.654-1556.8-2602.628-1555.039Z",
    fill: "#effcfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64502",
    "data-name": "Path 64502",
    d: "M-2657.5-1549.1a3.87,3.87,0,0,1-3.714,4.334,5.024,5.024,0,0,1-4.648-3.714c-.747-2.036.04-3.673,1.548-5.049,1.086-.99,2.185-1.965,3.322-2.986,1,.657.935,1.463-.167,2.393a29.953,29.953,0,0,0-2.169,2.183,2.819,2.819,0,0,0-.237,3.913c1.492,1.647,2.712,1.832,4.182.418C-2658.825-1548.141-2657.909-1547.931-2657.5-1549.1Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64503",
    "data-name": "Path 64503",
    d: "M-2687.243-1491.181l-.011-.833c1.827-1.256,2.751-3.25,4.037-4.948.5,1.975-.95,3.121-1.918,4.465a2.968,2.968,0,0,1-.579.479h0c-.986.49-.181,1.1.09,1.291.568.407.7,1.628,1.8,1.115.275-.129.479-.178.657.068.165.227-.026.385-.187.508-.641.488-.1.771.184,1.1,1.681,1.942,2.612,4.331,3.861,6.529.225.4.026,1.016.1,1.52.032.211-.495,1.3.555.479.107-.085.294.337.226.613a7.885,7.885,0,0,0,.088,3.951,1.171,1.171,0,0,1-.1.89c-1.179,1.531-1.482,3.4-2.09,5.155-.324.935-1.455,1.531-1.167,2.734-.32.225-.4.812-.977.648a.893.893,0,0,1-.191-.38c.212-1.121.89-2.074,1.146-3.179a2.627,2.627,0,0,1,.171-.383,17.113,17.113,0,0,0,1.1-3.111,3.647,3.647,0,0,1,.127-.411c.261-1.5.865-2.965.529-4.537a3.1,3.1,0,0,1-.093-.436,5.676,5.676,0,0,0-.273-1.946c-1.078-2.241-1.552-4.768-3.206-6.734-.221-.365-.446-.729-.693-1.077a6.6,6.6,0,0,0-1.874-1.946C-2686.465-1490.021-2687.159-1490.355-2687.243-1491.181Z",
    fill: "#afe1ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64504",
    "data-name": "Path 64504",
    d: "M-2674.367-1506.26a5.529,5.529,0,0,0,.733-2.989c.163-.276.113-.607.227-.9.172-.843-.132-1.726.215-2.554,1.737-.995,2.12-2.4,1.167-4.3-.46-.367-1.158-.358-1.482-.938a7.869,7.869,0,0,1-.072-2.392c.253-.593.863-.673,1.345-.938a4.233,4.233,0,0,0,.544-.552,3.331,3.331,0,0,0,.311-.494,4.775,4.775,0,0,0,.033-2.053,2.621,2.621,0,0,0-.263-.482q-.173-.2-.353-.4c-.125-.127-.242-.261-.362-.394-.092-.081-.179-.166-.27-.248a1.419,1.419,0,0,1-.779-1.043,11.913,11.913,0,0,0-.18-1.187,1.281,1.281,0,0,1,.012-.405c.246-.652.974-.632,1.411-1.017a2.385,2.385,0,0,0,.469-.578c.1-.167.192-.335.273-.512a2.9,2.9,0,0,0-.112-2.058,2.165,2.165,0,0,1-.295-1.059.815.815,0,0,1,.3-.6,1.681,1.681,0,0,1,1.118,1.347,5.376,5.376,0,0,1-1.6,4.671,1.03,1.03,0,0,0,.039,1.791,3.953,3.953,0,0,1-.025,6.442c-.652.529-.938,1.127.118,1.713a3.868,3.868,0,0,1,.165,6.331c-.81.5-.755,1.121-.749,1.83a6.033,6.033,0,0,1-1.538,4.316A.468.468,0,0,1-2674.367-1506.26Z",
    fill: "#bae8ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64505",
    "data-name": "Path 64505",
    d: "M-2654.838-1547.916c.3.986-.4,1.788-.762,2.664-.162.387-.516.867-1.085.5-.4-.258-.76-.652-.506-1.163,1.581-3.177-.84-4.741-2.652-6.5a3.053,3.053,0,0,1-.88-1.336c-.094-.363.487-.584.859-.76.187-.088.428-.209.558-.01,1.136,1.743,3.228,2.62,4.121,4.592A3.912,3.912,0,0,1-2654.838-1547.916Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64506",
    "data-name": "Path 64506",
    d: "M-2649.569-1557.2a12.387,12.387,0,0,0-1.868-2.1c-1.742-1.25-1.79-4.269-.908-5.9.272-.5.548-1.195,1.4-.647.674.436.783.725.116,1.366a1.929,1.929,0,0,0-.132,2.178,8.278,8.278,0,0,0,3.248,3.872.477.477,0,0,1,.584-.09c.146.938-.7,1.041-1.2,1.433-.305.061-.621-.143-.923.036A.331.331,0,0,1-2649.569-1557.2Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64507",
    "data-name": "Path 64507",
    d: "M-2602.628-1555.039a6.715,6.715,0,0,0-1.819-3.11l-.209-.076a7.34,7.34,0,0,0-7.862-1.869.836.836,0,0,1-.389-.185c-.755-1.865-1.236-3.889-2.982-5.186-.1-.092-.2-.191-.3-.291-.543-.659-1.443-.808-2.025-1.41-.222-.245-.623-.394-.463-.847,2.255.153,5.4,2.843,5.837,5.085.21,1.085.665,1.582,1.828,1.414a7.94,7.94,0,0,1,7.71,3.313,6.27,6.27,0,0,1,1.436,4.3C-2602.523-1554.108-2602.122-1554.846-2602.628-1555.039Z",
    fill: "#a3d4e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64508",
    "data-name": "Path 64508",
    d: "M-2649.905-1553.1h47v.281h-46.987Z",
    fill: "#a3d2e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64509",
    "data-name": "Path 64509",
    d: "M-2648.656-1557.223l1.553-1.218a4.239,4.239,0,0,1,4.641-1.563l.92.012c.189-.209.311-.466.5-.679a7.317,7.317,0,0,1,5.278-5.218c1.612-.351,3.217-.622,4.73.347.212.346.564.307.9.325.392.429,1.584.161,1.147,1.315a2.644,2.644,0,0,1-2.485-.293c-1.432-.956-2.856-.521-4.232.013-1.543.6-2.863,1.444-3.258,3.3-.226,1.056-1.284,1.364-2.211,1.682a8.32,8.32,0,0,0-2.384.071,8.113,8.113,0,0,0-1,.327,19.218,19.218,0,0,0-3.169,2.026,1.147,1.147,0,0,1-.6.2l-.572-.309C-2649.09-1557.2-2648.948-1557.27-2648.656-1557.223Z",
    fill: "#effcfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64510",
    "data-name": "Path 64510",
    d: "M-2589.025-1577.278q.159.3.317.609c-.147.141-.306.271-.438.425-.485.565-.767,1.343-.067,1.725.629.343.627-.691,1.021-1,.093.062.249.16.247.164-.973,1.625-.044,2.546,1.21,3.377.131.086.129.372.188.565l0,0a1.532,1.532,0,0,1-1.354-.579c-1.294-1.41-2.516-2.9-3.928-4.181-.978-.888-1.913-1.821-2.9-2.693a22.535,22.535,0,0,1-3.115-3.727c1.358,1.059,3.045,1.7,3.865,3.388.709,1.459,2.392,1.993,3.281,3.3.324.477.61.2.833-.107C-2589.565-1576.419-2589.3-1576.854-2589.025-1577.278Z",
    fill: "#a8e1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64511",
    "data-name": "Path 64511",
    d: "M-2664.4-1566.174a10.283,10.283,0,0,1,1.23-2.153,9.255,9.255,0,0,0,2.176-4.314l0-.007c.229-.044.3-.531.58-.3a4.461,4.461,0,0,1,1.205,2.873c.021.107-.137.362-.191.356-2.568-.277-.942,1.562-1.189,2.424-.091.315.436.811-.145,1.035-.489.188-.728-.208-.881-.623-.219-.595-.823-.708-1.054-.3-.442.782-1.486,1.04-1.566,2.062C-2664.931-1565.445-2664.484-1565.827-2664.4-1566.174Z",
    fill: "#a2def3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64512",
    "data-name": "Path 64512",
    d: "M-2651.115-1553.183c-.5.848-.842,1.25-1.84.286-1.24-1.2-2.457-2.433-3.758-3.566-.688-.6-.169-.96.069-1.416.33-.631.769-.36,1.145-.092a8.621,8.621,0,0,1,1.617,1.822c.511.644,1.051,1.514,2.235.57-.531.989-.6,1.742.526,2.088.082.067.11.135.085.2S-2651.088-1553.183-2651.115-1553.183Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64513",
    "data-name": "Path 64513",
    d: "M-2654.836-1560.728a1.978,1.978,0,0,1-.72,1.234,13,13,0,0,0-3.249,3.2c-.311.372-.542.686-.918.191-.29-.382-1.187-.605-.588-1.314a17.057,17.057,0,0,1,4.163-4.09C-2655.53-1561.87-2655.1-1561.241-2654.836-1560.728Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64514",
    "data-name": "Path 64514",
    d: "M-2674.367-1506.26l.4.354c-1.7,3.691-4.9,5.06-8.654,5.547-.291.074-.442.014-.312-.321l.905-.6.711-.268a8.733,8.733,0,0,0,5.672-3.22C-2675.2-1505.253-2674.792-1505.763-2674.367-1506.26Z",
    fill: "#bde7ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64515",
    "data-name": "Path 64515",
    d: "M-2628.882-1563.994c-.2-.632-1.02-.629-1.26-1.223,1.644.609,2.688-.518,3.61-1.469,2.339-2.414,5.106-1.688,7.857-1.327l.618.6a.939.939,0,0,1-.878.269,7.761,7.761,0,0,0-8.443,2.794,1.124,1.124,0,0,1-1.327.5Z",
    fill: "#acd6e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64516",
    "data-name": "Path 64516",
    d: "M-2560.6-1470.391c.252,1.9-.437,3.7-.623,5.558-.223.044-.5.259-.6-.142-.414-1.664-.875-3.355-.282-5.038.2-.569.847-.985,1.312-1.448a.4.4,0,0,1,.379.084C-2560.176-1471.01-2560.484-1470.713-2560.6-1470.391Z",
    fill: "#ade2f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64517",
    "data-name": "Path 64517",
    d: "M-2585.93-1572.647a.887.887,0,0,1,.867.524c.952,2.263,2.6,4.067,3.947,6.072a5.485,5.485,0,0,1,.439,1.125.8.8,0,0,1-.961-.717,2.714,2.714,0,0,0-2.531-2.209c-1.129-.112-.241-.8-.336-1.174-.522-.409-.763.556-1.261.188-.186-.489.339-.682.467-1.045.3-.842.693-1.662-.615-2.044C-2586.426-1572.077-2585.941-1572.4-2585.93-1572.647Z",
    fill: "#a8e1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64518",
    "data-name": "Path 64518",
    d: "M-2666.877-1561.853a6.838,6.838,0,0,1,1.512-2.782l.656.637a2.044,2.044,0,0,1-.614,1.852l-.311.309a5.82,5.82,0,0,0,.309,4.018,9.216,9.216,0,0,1-.061,1.224.55.55,0,0,1-.649.506.5.5,0,0,1-.424-.555C-2666.295-1558.405-2667.205-1560.08-2666.877-1561.853Z",
    fill: "#a2deef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64519",
    "data-name": "Path 64519",
    d: "M-2644.8-1605.923q0-5.313,0-10.626C-2644.238-1615.74-2644.036-1608.2-2644.8-1605.923Z",
    fill: "#a9d9f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64520",
    "data-name": "Path 64520",
    d: "M-2673.667-1542.377c1.092.389.639.943,0,1.158-1.443.481-1.162,1.3-.622,2.256a.7.7,0,0,1-.944.007c-.476-1.3.378-2.428.488-3.653a12.412,12.412,0,0,1,.519-1.606,1.1,1.1,0,0,0,.262-.921,15.187,15.187,0,0,1,1.244-3.721l0,.015c.24-.189.023-.763.578-.685-.039,1.512-.967,2.838-.912,4.37a.656.656,0,0,0-.3.619A3.859,3.859,0,0,0-2673.667-1542.377Z",
    fill: "#aeddd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64521",
    "data-name": "Path 64521",
    d: "M-2635.983-1565.568c-2.584.878-3.963,2.885-4.939,5.27a.665.665,0,0,1,0-.918,2.945,2.945,0,0,1,.31-2.163c.775-.255.835-1.223,1.541-1.547l2.784-1.233C-2636.125-1565.992-2635.806-1565.906-2635.983-1565.568Z",
    fill: "#a7d6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64522",
    "data-name": "Path 64522",
    d: "M-2564.924-1463.9l-1.852,0c.26-.739-.019-1.626.693-2.254.366-.322.5-1.28,1.168-.535.311.348,1.737.865.266,1.662C-2565.076-1464.8-2564.882-1464.293-2564.924-1463.9Z",
    fill: "#ade2f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64523",
    "data-name": "Path 64523",
    d: "M-2681.367-1469.143l-1.265,3.389c-.239.441-.092.983-.364,1.416a20.123,20.123,0,0,1-1.277,1.933c-.585.478-.644,1.379-1.389,1.728.007-1.129.818-1.934,1.179-2.92a1.624,1.624,0,0,1,.311-1.543c1.382-.55,1.293-2,1.833-3.057.145-.286-.014-.717.332-.965A.448.448,0,0,1-2681.367-1469.143Z",
    fill: "#d8562f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64524",
    "data-name": "Path 64524",
    d: "M-2648.322-1600.768q.461-2.622.919-5.244c.595-.51.1-1.283.458-1.948.624,2.378-.08,4.563-.513,6.765C-2647.551-1600.722-2647.972-1600.788-2648.322-1600.768Z",
    fill: "#9be3f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64525",
    "data-name": "Path 64525",
    d: "M-2568.64-1463.622a18.669,18.669,0,0,0-5.855,2.509l0-.319a9.612,9.612,0,0,1,4.5-2.811A1.127,1.127,0,0,1-2568.64-1463.622Z",
    fill: "#a9d9e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64526",
    "data-name": "Path 64526",
    d: "M-2683.217-1496.962c-.865,2.042-1.777,4.045-4.038,4.948.046-.242.007-.616.149-.706,1.824-1.161,2.582-3.086,3.555-4.858q.155-.216.309,0Z",
    fill: "#9aaab0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64527",
    "data-name": "Path 64527",
    d: "M-2642.462-1560a8.24,8.24,0,0,0-4.641,1.563l-.615,0c1.293-1.534,2.807-2.536,4.947-2.175C-2642.282-1560.53-2642.347-1560.317-2642.462-1560Z",
    fill: "#a3d3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64528",
    "data-name": "Path 64528",
    d: "M-2594.279-1459.592a30.24,30.24,0,0,0-4.008,2.191c-.277.253-.366.8-.931.6-.087-.171-.293-.4-.242-.5.469-.923,3.894-2.62,4.956-2.481C-2594.422-1459.774-2594.353-1459.659-2594.279-1459.592Z",
    fill: "#a8d7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64529",
    "data-name": "Path 64529",
    d: "M-2635.983-1565.568l-.3-.591a11.022,11.022,0,0,1,5.425-.047c.226.058.683.157.407.585-.069.107-.383.056-.584.079A10.217,10.217,0,0,0-2635.983-1565.568Z",
    fill: "#a5d4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64530",
    "data-name": "Path 64530",
    d: "M-2671.5-1534.347l-.024.676a1.235,1.235,0,0,1-1.5-.162,1.2,1.2,0,0,1-.314-.45c-.113-1.27-.484-2.563.312-3.758.353-.2.606-.2.6.305,0,.1,0,.2,0,.306.41.893-.313,2.162.923,2.781C-2671.5-1534.549-2671.5-1534.448-2671.5-1534.347Z",
    fill: "#c7f3f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64531",
    "data-name": "Path 64531",
    d: "M-2665.325-1557.819a2.865,2.865,0,0,1-.309-4.018C-2665.44-1560.505-2664.926-1559.2-2665.325-1557.819Z",
    fill: "#a6e0e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64532",
    "data-name": "Path 64532",
    d: "M-2668.117-1559.071c.567.558.24,1.267.315,1.907.058.488-.127,1.079.632,1.2.343.053.619.206.39.607a1.385,1.385,0,0,1-1.114.742c-.378.022-.366-.329-.437-.651-.289-1.3.3-2.527.215-3.8Z",
    fill: "#a2deef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64533",
    "data-name": "Path 64533",
    d: "M-2647.694-1615.6c.06-1.655-.518-3.266-.334-4.929h.62a1.179,1.179,0,0,1,0,1.541c-.085.619.25,1.185.26,1.769C-2647.133-1616.66-2646.7-1615.854-2647.694-1615.6Z",
    fill: "#9ce4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64534",
    "data-name": "Path 64534",
    d: "M-2647.4-1618.99l0-1.541a7.976,7.976,0,0,1,1.161,5.323C-2647.171-1616.545-2646.425-1618.038-2647.4-1618.99Z",
    fill: "#add8e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64535",
    "data-name": "Path 64535",
    d: "M-2651.115-1553.183c0-.1,0-.206-.006-.308,0-1.454,1.055-2.466,1.552-3.711h.308a.77.77,0,0,1,0,.933l-.915,1.848C-2650.711-1554.179-2650.248-1553.176-2651.115-1553.183Z",
    fill: "#a3d5e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64536",
    "data-name": "Path 64536",
    d: "M-2652.673-1589.047a12.3,12.3,0,0,1,1.54-3.394c-.232,1.559-1.159,3.052.074,4.913C-2652.234-1587.926-2651.971-1588.9-2652.673-1589.047Z",
    fill: "#a1dfe4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64537",
    "data-name": "Path 64537",
    d: "M-2603.229-1591.8c-.721-.448-1.415-.905-.619-1.858.606.219.785.864,1.234,1.239l.928.926C-2602.439-1590.4-2602.724-1591.651-2603.229-1591.8Z",
    fill: "#a9e4fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64538",
    "data-name": "Path 64538",
    d: "M-2684.273-1462.405a5.563,5.563,0,0,1,1.044-2.122c1.258-.422.659.98,1.22,1.242h0a.664.664,0,0,1,0,.925c-.617.116-1.231-1.481-1.851,0l-.011.01Z",
    fill: "#a0e2e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64539",
    "data-name": "Path 64539",
    d: "M-2685.1-1453.4c.324-.94-.717-1.914.112-3.042.584,1.163.968,2.121-.112,3.043Z",
    fill: "#94dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64540",
    "data-name": "Path 64540",
    d: "M-2665.323-1562.146a3.57,3.57,0,0,1,.614-1.852c.092-.425.455-.769.521-.153C-2664.1-1563.37-2664.136-1562.348-2665.323-1562.146Z",
    fill: "#abdbe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64541",
    "data-name": "Path 64541",
    d: "M-2682.588-1465.442c.286-.224.414-.672.889-.626a5.182,5.182,0,0,0,.287,1.744c.1.525-.164.606-.593.417C-2682.289-1464.385-2683.072-1464.673-2682.588-1465.442Z",
    fill: "#a0e2e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64542",
    "data-name": "Path 64542",
    d: "M-2683.242-1497.578h-.309q0-1.234,0-2.47l.3-.316c0-.1.007-.2.008-.294l.31-.022.312.321C-2683.177-1499.51-2682.679-1498.426-2683.242-1497.578Z",
    fill: "#97a8b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64543",
    "data-name": "Path 64543",
    d: "M-2682.588-1465.442c-.107.626.643.926.583,1.535l0,.622c-.884.056-.349-1.284-1.22-1.242a1.641,1.641,0,0,1,.6-1.227Z",
    fill: "#b1d5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64544",
    "data-name": "Path 64544",
    d: "M-2564.921-1529.4c.3-.1.544-.212.634.288.151.84.394,1.663.6,2.493C-2564.79-1527.238-2564.249-1528.587-2564.921-1529.4Z",
    fill: "#a1d6e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64545",
    "data-name": "Path 64545",
    d: "M-2671.5-1534.649c-1.492-.534-.745-1.812-.923-2.781C-2672.327-1536.434-2671.444-1535.7-2671.5-1534.649Z",
    fill: "#b1e3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64546",
    "data-name": "Path 64546",
    d: "M-2685.714-1492.018h2.311a1.47,1.47,0,0,1-2.313,0Z",
    fill: "#afe1ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64547",
    "data-name": "Path 64547",
    d: "M-2650.515-1586.6c-.02.255-.031.525-.35.592a.377.377,0,0,1-.5-.4.547.547,0,0,1,.523-.62C-2650.568-1587.048-2650.56-1586.8-2650.515-1586.6Z",
    fill: "#a7dddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64548",
    "data-name": "Path 64548",
    d: "M-2648.026-1620.531c-.738-.252-.309-.8-.311-1.236.163-.231.392-.367.646-.22.3.173.149.4.016.638A7.612,7.612,0,0,0-2648.026-1620.531Z",
    fill: "#9ce4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64549",
    "data-name": "Path 64549",
    d: "M-2682-1462.361l0-.925c.432.085,1.065.114,1.025.632S-2681.645-1462.443-2682-1462.361Z",
    fill: "#b1d5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64550",
    "data-name": "Path 64550",
    d: "M-2650.662-1591a.78.78,0,0,1-.234,1.173.278.278,0,0,1-.253-.1C-2651.344-1590.43-2651.1-1590.742-2650.662-1591Z",
    fill: "#a1dfe4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64551",
    "data-name": "Path 64551",
    d: "M-2562.462-1463.587l-.921-.03c-.124-.307-.2-.625.291-.581C-2562.76-1464.168-2562.2-1464.268-2562.462-1463.587Z",
    fill: "#a6d7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64552",
    "data-name": "Path 64552",
    d: "M-2640.92-1561.216l0,.918a.575.575,0,0,1-.62.306C-2641.921-1560.7-2641.379-1560.936-2640.92-1561.216Z",
    fill: "#a3d3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64553",
    "data-name": "Path 64553",
    d: "M-2586.547-1571.414a.971.971,0,0,1,.493,1.372c-.681-.342-.431-.906-.5-1.37Z",
    fill: "#a8e1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64554",
    "data-name": "Path 64554",
    d: "M-2683.856-1462.365c.747.154.651.57.4,1.119-.6-.28-.327-.752-.414-1.109Z",
    fill: "#a0e2e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64555",
    "data-name": "Path 64555",
    d: "M-2672.149-1549.527l-.578.685c0-.315-.008-.631-.012-.946q.3-.459.589-.919c.019.118.038.235.056.352Q-2672.121-1549.941-2672.149-1549.527Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64556",
    "data-name": "Path 64556",
    d: "M-2651.141-1592.428l-.015-.935c-.11-.338-.219-.675.36-.6.1,0,.195,0,.292,0C-2650.883-1593.522-2650.609-1592.808-2651.141-1592.428Z",
    fill: "#a1dfe4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64557",
    "data-name": "Path 64557",
    d: "M-2599.218-1456.8l.931-.6a.861.861,0,0,1-.933.907C-2599.218-1456.6-2599.218-1456.7-2599.218-1456.8Z",
    fill: "#d6eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64558",
    "data-name": "Path 64558",
    d: "M-2574.807-1459.888l2.16-1.543c-.217.308,1.688,1.173-.271,1.039-.057,0-.212.244-.181.306.553,1.116-.558,1.459-1.041,1.541C-2574.644-1458.459-2574.641-1459.382-2574.807-1459.888Z",
    fill: "#d7eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64559",
    "data-name": "Path 64559",
    d: "M-2692.2-1663.473a18.393,18.393,0,0,0-4.683-.307c-.649.008-1.276.022-1.176-.916l5.851.915C-2692.2-1663.678-2692.2-1663.576-2692.2-1663.473Z",
    fill: "#e3b00d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64560",
    "data-name": "Path 64560",
    d: "M-2650.458-1595.776a5.623,5.623,0,0,1,.858-3.124A4.53,4.53,0,0,1-2650.458-1595.776Z",
    fill: "#e5af2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64561",
    "data-name": "Path 64561",
    d: "M-2650.8-1593.964l-.36.6c-.092,0-.184,0-.276-.005a2.916,2.916,0,0,1,.989-2.432Q-2650.62-1594.882-2650.8-1593.964Z",
    fill: "#e5af2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64562",
    "data-name": "Path 64562",
    d: "M-2698.693-1439.182a.994.994,0,0,1-.622-.93l1.749-2.112c.533.5-.621,1.615.727,1.8a3.024,3.024,0,0,1-.617,1.543C-2697.915-1438.788-2698.255-1439.188-2698.693-1439.182Z",
    fill: "#f65a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64563",
    "data-name": "Path 64563",
    d: "M-2698.693-1439.182c.671-.969.9-.109,1.237.3a2.114,2.114,0,0,1-.319,1.256,2.274,2.274,0,0,1-.3-.038Z",
    fill: "#eb571e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64564",
    "data-name": "Path 64564",
    d: "M-2703.633-1454.016c.079.736-2.14-.1-.255,1.874-1.505-.97-1.16-1.847-1.373-2.531-.561-.1-.4.516-.9.778.2-1.952-.018-3.726-1.436-5.13-.591.188.3.931-.3,1.077-.281.068-.555-.2-.715-.492-.257-.473-.45-.977-.052-1.428.334-.378.82-.636.705-1.254.472-.162.607.25.844.49a10.619,10.619,0,0,0,1.671,2.364,1.893,1.893,0,0,1,.23.361C-2704.886-1456.529-2703.737-1455.484-2703.633-1454.016Z",
    fill: "#f45a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64565",
    "data-name": "Path 64565",
    d: "M-2709.812-1462.978l-.314.3a5.7,5.7,0,0,1-2.161,2.784,1.526,1.526,0,0,0-.2.2c-.173.26-.182.859-.6.648-.538-.268.262-.586.138-.937-.253-1.01.6-1.509,1.026-2.2.45-.726,1.077-1.32,1.556-2.026a12.985,12.985,0,0,1,.971-1.074c.135-.157.269-.315.394-.481,1.405-1.505,2.458-3.343,4.238-4.495,1.239.279.647.953.225,1.409-1.116,1.2-2.008,2.588-3.132,3.78C-2708.38-1464.356-2709.076-1463.647-2709.812-1462.978Z",
    fill: "#db4f15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64566",
    "data-name": "Path 64566",
    d: "M-2710.046-1464.184c-.781,1.534-2.26,2.585-2.912,4.208-1.379.4-.736-1.209-1.457-1.46-.7-2.131-1.409-4.259-2.1-6.394a4.567,4.567,0,0,1-.419-1.931c.7.675.452,1.832,1.246,2.46a10.667,10.667,0,0,1,1.754,4.167c.415,1.4.462,1.41,1.611.51a5.15,5.15,0,0,1,1.884-1.7A.493.493,0,0,1-2710.046-1464.184Z",
    fill: "#fbdd40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64567",
    "data-name": "Path 64567",
    d: "M-2703.633-1454.016c-.7-1.315-1.771-2.459-1.82-4.063.6-.271.829.179,1.1.553,1.843,3.27,3.836,6.451,5.8,9.65a.675.675,0,0,1-.091.648c-1.429-.546-1.737-2.007-2.516-3.084-.609.2-.346-.479-.619-.618l-.323-.308a1.687,1.687,0,0,1-.62-1.538Z",
    fill: "#d95011"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64568",
    "data-name": "Path 64568",
    d: "M-2694.368-1452.482a3.884,3.884,0,0,1-.307,4.642c-.588.258-.934-.692-1.547-.309C-2696.6-1449.4-2695.65-1451.624-2694.368-1452.482Z",
    fill: "#f45a2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64569",
    "data-name": "Path 64569",
    d: "M-2694.368-1452.482c-.672,1.421-1.727,2.678-1.854,4.333-.734.263-.535,1.164-1.043,1.608-.324-.322-.122-.695-.211-1.013a.593.593,0,0,1-.176-.347,1.459,1.459,0,0,1,.053-.4,5.618,5.618,0,0,1,.346-.962c.722-1.136,1.081-2.446,1.732-3.616.592-.825.67-1.993,1.69-2.532a.763.763,0,0,1,.433.1c.33.537.067,1.024-.126,1.519a.734.734,0,0,1-.538.381C-2694.41-1453.182-2694.354-1452.82-2694.368-1452.482Z",
    fill: "#df4f12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64570",
    "data-name": "Path 64570",
    d: "M-2707.3-1462.345a.635.635,0,0,1-.356-.633,1.676,1.676,0,0,1,.819-1.368c.392-.322.815-.615.795-1.205.079-1.09.982-1.231,1.754-1.525a1.47,1.47,0,0,1,.737.723c-.256,1.072-1.272,1.619-1.751,2.538C-2705.913-1463.254-2706.267-1462.338-2707.3-1462.345Z",
    fill: "#e6561c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64571",
    "data-name": "Path 64571",
    d: "M-2707.3-1462.345l1.708-1.6a.32.32,0,0,1,.4-.037c.2.3.048.567-.082.836-.96,1.385-.953,1.981.076,3.428.353.5.862.9.928,1.565a1.457,1.457,0,0,1-.046.442.762.762,0,0,1-.271.348c-.339-.179-.392-.7-.87-.717l0,.037a22.282,22.282,0,0,1-1.689-2.809.909.909,0,0,1-.115-.6Z",
    fill: "#fcde44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64572",
    "data-name": "Path 64572",
    d: "M-2701.763-1443.825l-.33-.922a4.667,4.667,0,0,1-.194-1.78c.145-.484.461-.93.318-1.495.223.021.38,0,.406.045C-2700.748-1446.48-2700.848-1444.515-2701.763-1443.825Z",
    fill: "#f85621"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64573",
    "data-name": "Path 64573",
    d: "M-2712.287-1459.891a11.639,11.639,0,0,1,2.161-2.784c1.05.849-.219,1.522-.173,2.3C-2711-1460.355-2711.416-1459.208-2712.287-1459.891Z",
    fill: "#f45631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64574",
    "data-name": "Path 64574",
    d: "M-2705.789-1465.453c.552.564-.033.868-.349,1.039a6.372,6.372,0,0,0-1.515,1.436.635.635,0,0,1-.612-.306c-.136-.778.662-1.134.8-1.789C-2707.018-1465.7-2706.489-1465.956-2705.789-1465.453Z",
    fill: "#e75d31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64575",
    "data-name": "Path 64575",
    d: "M-2700.226-1441.357l-.319-.615c.317-.62,1.586-.974.179-2.152C-2698.48-1443.211-2698.484-1443.166-2700.226-1441.357Z",
    fill: "#f65a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64576",
    "data-name": "Path 64576",
    d: "M-2701.776-1450.93l.619.618a1.34,1.34,0,0,1-1.083,1.627C-2702.774-1449.582-2701.506-1450.109-2701.776-1450.93Z",
    fill: "#f15836"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64577",
    "data-name": "Path 64577",
    d: "M-2702.719-1452.776c.294.477.753.889.62,1.538-.258.056-.476.691-.68.277C-2703.044-1451.5-2703.765-1452.221-2702.719-1452.776Z",
    fill: "#f75938"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64578",
    "data-name": "Path 64578",
    d: "M-2709.812-1462.978c.225-1.056,1.107-1.552,1.847-2.169a.237.237,0,0,1,.363-.023c.077.966-.843,1.257-1.275,1.878C-2709.1-1462.928-2709.468-1462.988-2709.812-1462.978Z",
    fill: "#f75835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64579",
    "data-name": "Path 64579",
    d: "M-2708.877-1463.292c.011-.879.947-1.142,1.226-1.843.266-.062.44-.029.316.308.2.824-.711.974-.93,1.543Z",
    fill: "#e6561c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64580",
    "data-name": "Path 64580",
    d: "M-2697.536-1447.841a1.477,1.477,0,0,1,.06.287c-.311.386-.591.88-1.165.326l-.108-.563c.048-.061.1-.121.145-.183A.833.833,0,0,1-2697.536-1447.841Z",
    fill: "#fce444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64581",
    "data-name": "Path 64581",
    d: "M-2707.259-1461.454l.253.313a.736.736,0,0,1-.344.641l-.607-.622,0,0a.416.416,0,0,1-.005-.616C-2707.562-1462.058-2707.574-1461.353-2707.259-1461.454Z",
    fill: "#e6561c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64582",
    "data-name": "Path 64582",
    d: "M-2707.965-1461.741l.005.616-.864.513C-2708.729-1461.251-2708.585-1461.674-2707.965-1461.741Z",
    fill: "#f45a31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64583",
    "data-name": "Path 64583",
    d: "M-2714.446-1459.893c-.451-.316-.266-.8-.327-1.22l.29-.276Q-2714.465-1460.641-2714.446-1459.893Z",
    fill: "#d54206"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64584",
    "data-name": "Path 64584",
    d: "M-2685.726-1469.164a50.163,50.163,0,0,1-3.212,6.127c-.171.3-.285.9-.829.329-.391-.723.113-1.263.43-1.8.543-.91,1.028-1.847,1.489-2.8.131-.268.265-.535.4-.8a55.837,55.837,0,0,0,3.233-7.2,2.139,2.139,0,0,1,.923-1.344.478.478,0,0,1,.443.095.983.983,0,0,1-.083.913,34.055,34.055,0,0,1-2.466,5.561A.693.693,0,0,1-2685.726-1469.164Z",
    fill: "#dc5212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64585",
    "data-name": "Path 64585",
    d: "M-2681.367-1469.143l-.64-.019c-.926-2.1-.5-4.047.345-6.125a23.431,23.431,0,0,0,.889-4.995c.011-.413.217-.447.4-.138a8,8,0,0,0,.612,1.049,2.313,2.313,0,0,1,.039.885,8.764,8.764,0,0,0-.213.878c-.309,2.1-1.4,4.04-1.03,6.315a3.633,3.633,0,0,1-.415,2.151Z",
    fill: "#f0592a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64586",
    "data-name": "Path 64586",
    d: "M-2690.968-1453.4c-.019.389.085.9-.392,1.021s-.474-.565-.842-.712a.563.563,0,0,0-.616-.616c-.034-.067-.069-.135-.1-.2-.039-.684.042-1.364.048-2.048.17-.463.137-1.307.979-.532.638.017.892-2.278,1.855-.309a18.693,18.693,0,0,1-.949,1.682c-.389.511-.684,1.157.022,1.717Z",
    fill: "#e95e2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64587",
    "data-name": "Path 64587",
    d: "M-2687.566-1467.3c-.4,1.691-1.717,2.942-2.2,4.593a1.112,1.112,0,0,0-.582.964c.175.3,0,.554-.121.813-.634.5-.475,1.738-1.629,1.757a.686.686,0,0,1-.26-.331,1.691,1.691,0,0,1,.235-1.021c.244-.488.572-.927.84-1.4a6.185,6.185,0,0,0,.419-.941c.671-1.708,1.272-3.461,2.886-4.575A.607.607,0,0,1-2687.566-1467.3Z",
    fill: "#fce144"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64588",
    "data-name": "Path 64588",
    d: "M-2679.872-1479.348c-.735.108-.33-.884-.9-.934l-.608-.312c-.567-.532-.356-1.306-.608-1.935-.235-1.36-1.277-2.4-1.513-3.758a.675.675,0,0,1,.31-.568c1.82,1.961,2.434,4.507,3.351,6.906A.386.386,0,0,1-2679.872-1479.348Z",
    fill: "#e45025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64589",
    "data-name": "Path 64589",
    d: "M-2692.13-1459.216c.917-.294.783-1.41,1.473-1.882a.641.641,0,0,1,0,.9c-.124,1.334-1.616,2.211-1.238,3.713-.744-.345-.593.22-.617.607-.269.263-.314.851-.916.631l-.349-.011c-.322-.411-.092-.816.009-1.224a3.633,3.633,0,0,1,.445-.911,5.424,5.424,0,0,0,.592-.724c.141-.275.2-.582.318-.865A.465.465,0,0,1-2692.13-1459.216Z",
    fill: "#e24f1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64590",
    "data-name": "Path 64590",
    d: "M-2681.7-1482.745a4.023,4.023,0,0,1,.323,2.151.665.665,0,0,1-.319.624c-.33.088-.671.22-.855-.233-.21-.821-.132-1.675-.3-2.5a1.1,1.1,0,0,1,.12-.416C-2682.1-1483.79-2681.914-1483.229-2681.7-1482.745Z",
    fill: "#f75d3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64591",
    "data-name": "Path 64591",
    d: "M-2690.967-1453.4c-.684.014-1.123-.172-.743-.966a6.334,6.334,0,0,1,1.67-2.433c-.02.739.221,1.507-.747,1.98C-2691.189-1454.623-2690.923-1453.889-2690.967-1453.4Z",
    fill: "#f6592d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64592",
    "data-name": "Path 64592",
    d: "M-2684.172-1465.14c-.063.523.206,1.113-.311,1.543a1.093,1.093,0,0,1-.635-1.1c-.019-.591-.96-1.336-.09-1.7C-2684.6-1466.655-2684.641-1465.492-2684.172-1465.14Z",
    fill: "#f95233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64593",
    "data-name": "Path 64593",
    d: "M-2685.726-1469.164q.162-.459.325-.919c.563.577.564,1.474,1.183,2.042a.554.554,0,0,1-.144.788c-.284.12-.562-.1-.7-.42C-2685.277-1468.172-2685.5-1468.667-2685.726-1469.164Z",
    fill: "#f25937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64594",
    "data-name": "Path 64594",
    d: "M-2682.3-1479.979c.2-.027.405-.329.6.009-.549,1.4-.1,3.091-1.235,4.326l.005-.927a4.454,4.454,0,0,1,.186-2.833A1.069,1.069,0,0,1-2682.3-1479.979Z",
    fill: "#ef4b2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64595",
    "data-name": "Path 64595",
    d: "M-2685.557-1462.76a15.2,15.2,0,0,1-1.27,1.128c-.117.085-.626-.141-.431-.353.379-.412.26-1.279,1.1-1.264C-2685.878-1463.244-2685.688-1463.1-2685.557-1462.76Z",
    fill: "#f55437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64596",
    "data-name": "Path 64596",
    d: "M-2690.657-1460.2v-.9l.309-.645c.263-.071.66-.276.563.253A1.591,1.591,0,0,1-2690.657-1460.2Z",
    fill: "#dc5212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64597",
    "data-name": "Path 64597",
    d: "M-2694.062-1453.411l.3-.3a.667.667,0,0,1,.936,0l0,0c-.086.621-.7,1.152-.311,1.852C-2694.081-1451.99-2693.6-1452.985-2694.062-1453.411Z",
    fill: "#e95e2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64598",
    "data-name": "Path 64598",
    d: "M-2708.268-1659.149l0-.307a48.121,48.121,0,0,1,8.351-.01c4.04.2,7.876,1.372,11.729,2.459a30.9,30.9,0,0,1,4.939,1.883c-.95.9-1.984.08-2.7-.2-2.058-.8-4.179-1.353-6.283-1.956a74.213,74.213,0,0,0-9.983-1.843c-.49-.07-.69.3-1.009.552-.506.393-1.093.8-1.465-.241-.206-.576-.847-.417-1.21-.29a14.1,14.1,0,0,1-2.06.26.259.259,0,0,1-.353.043A.254.254,0,0,1-2708.268-1659.149Z",
    fill: "#fde23b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64599",
    "data-name": "Path 64599",
    d: "M-2676.755-1623.313a49.283,49.283,0,0,0-15.16-8.489,6.026,6.026,0,0,0-.9-.174c-.615-.22-1.229-.442-1.862-.607l-.312-.3c-.174-.224-.558-.111-.676-.424l.06-.2a17.2,17.2,0,0,1,7.729,2.561,14.525,14.525,0,0,0,3.024,1.385c3.18,1.112,5.555,3.428,8.182,5.367C-2676.25-1623.888-2675.867-1623.519-2676.755-1623.313Z",
    fill: "#fde23d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64600",
    "data-name": "Path 64600",
    d: "M-2660.677-1634.751c1.119,1.006,1.2,2.615,2.159,3.715.569.235.324.863.6,1.239,1.052,2.591,2.173,5.156,2.986,7.837a11.3,11.3,0,0,1,.733,3.272v1.732a3.621,3.621,0,0,1-1.056-2.171,40.656,40.656,0,0,0-5.227-13.564A2.3,2.3,0,0,1-2660.677-1634.751Z",
    fill: "#fde13b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64601",
    "data-name": "Path 64601",
    d: "M-2664.4-1577.59c-.461-.324-.261-.819-.32-1.246.523-1.288.02-2.734.616-4.01.551.267.934.415,1.325-.377.874-1.766,2.243-3.292,2.435-5.38a.875.875,0,0,1,.893-.882c.388.03.262.478.3.764Q-2661.772-1583.156-2664.4-1577.59Z",
    fill: "#fde43a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64602",
    "data-name": "Path 64602",
    d: "M-2697.157-1633.5l-8.948-1.85c-.633-.628-1.562-.521-2.3-.965,2.263.343,4.518.63,6.755,1,1.863.308,3.691.83,5.525,1.293.205.052.351.339.524.517h0A1.826,1.826,0,0,1-2697.157-1633.5Z",
    fill: "#fde33b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64603",
    "data-name": "Path 64603",
    d: "M-2723.1-1641.539c-2.524-1.9-3.351-3.75-2.78-6.489.633.222,1.5.03.842,1.36-.611,1.234.987,1.969,1.634,2.777A1.875,1.875,0,0,1-2723.1-1641.539Z",
    fill: "#f6e32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64604",
    "data-name": "Path 64604",
    d: "M-2720.9-1655.737c.636.12,1.028-.375,1.525-.606a.643.643,0,0,0,.608.283c-1.581,1.451-3.35,2.677-4.867,4.22-.61.62-.854,1.5-1.621,1.958-.348.2-.439-.113-.592-.3a14.276,14.276,0,0,1,3.784-4.17A4.52,4.52,0,0,0-2720.9-1655.737Z",
    fill: "#fce13e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64605",
    "data-name": "Path 64605",
    d: "M-2708.267-1658.84h.309c.2,1.428-.5,1.918-1.732,1.4-.949-.4-2.2.41-2.9-.78.543-.558,1.237-.208,1.855-.31C-2709.917-1658.661-2709.157-1659.27-2708.267-1658.84Z",
    fill: "#f4e52d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64606",
    "data-name": "Path 64606",
    d: "M-2655.128-1598.9c-.218,1.988-1.182,3.725-1.872,5.553-.475-.052-.57-.28-.409-.726.583-1.614,1.126-3.243,1.712-4.856C-2655.533-1599.381-2655.284-1599.56-2655.128-1598.9Z",
    fill: "#fce139"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64607",
    "data-name": "Path 64607",
    d: "M-2661.314-1636.287l.336,1.225c-1.714-.72-2.939-2.709-2.476-4.021C-2662.494-1638.34-2662.174-1637.106-2661.314-1636.287Z",
    fill: "#fde23e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64608",
    "data-name": "Path 64608",
    d: "M-2653.883-1604.135a14.914,14.914,0,0,1-.933,4.3c-.462-1.08-.179-4.158.525-4.732C-2654-1604.8-2653.961-1604.346-2653.883-1604.135Z",
    fill: "#fce139"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64609",
    "data-name": "Path 64609",
    d: "M-2674.586-1620.868l-1.227-.916c0-.2-.007-.41-.011-.615.1-.668.51-.651.784-.222C-2674.719-1622.118-2673.537-1621.747-2674.586-1620.868Z",
    fill: "#fde23d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64610",
    "data-name": "Path 64610",
    d: "M-2725.851-1650.184l.592.3c-.081.161-.14.439-.248.46-.339.064-.325-.253-.377-.476A1.15,1.15,0,0,1-2725.851-1650.184Z",
    fill: "#fde33b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64611",
    "data-name": "Path 64611",
    d: "M-2736.378-1561.218c0-.1,0-.2,0-.307.031-.175,0-.425.272-.384a.413.413,0,0,1,.243.314C-2735.863-1561.273-2736.136-1561.25-2736.378-1561.218Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64612",
    "data-name": "Path 64612",
    d: "M-2697.157-1633.5l1.556-.005q.309.312.616.625A4.908,4.908,0,0,1-2697.157-1633.5Z",
    fill: "#fce133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64613",
    "data-name": "Path 64613",
    d: "M-2694.673-1632.583a2.174,2.174,0,0,1,1.862.607l-.627.322C-2693.6-1632.3-2694.365-1632.136-2694.673-1632.583Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64614",
    "data-name": "Path 64614",
    d: "M-2725.843-1588.724a6.358,6.358,0,0,0-1.3-2.792l-.114.009a.419.419,0,0,1-.316-.434,2.58,2.58,0,0,0-.245-1.474,1.857,1.857,0,0,1-.17-.35,6.292,6.292,0,0,0-.515-1.279,3.006,3.006,0,0,1-.162-.387c-.1-.478-.414-.966.059-1.42,1.239-.047.848,1.181,1.347,1.714.068.127.125.258.18.391.187.451.319.924.514,1.372a4.723,4.723,0,0,1,1.28,2.671,4.765,4.765,0,0,1,.387.967c.4,1.488,1.37,2.738,1.754,4.23.085.259.169.518.271.771.153.455.391.928-.21,1.256q-.012.327-.024.653l-1.817-3.781A5.772,5.772,0,0,0-2725.843-1588.724Z",
    fill: "#373233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64615",
    "data-name": "Path 64615",
    d: "M-2728.642-1596.764c0,.544.418,1.022.245,1.592-1.194-.961-1.461-2.371-1.806-3.742l-.018-.305.17-.569c.621-.355,1.095-1.153,2-.664.675.453.847,1.241,1.251,1.874a13.451,13.451,0,0,0,.658,1.532l-.013.507c.18.33.614.575.353,1.052a.65.65,0,0,1-.664.091c-.539-.488-.576-1.208-.846-1.821-.111-.334-.2-.675-.338-1-.209-.385-.283-.874-.792-1.019C-2729-1598.445-2727.861-1597.528-2728.642-1596.764Z",
    fill: "#3c3131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64616",
    "data-name": "Path 64616",
    d: "M-2730.2-1598.914l1.806,3.742,0-.009a9.892,9.892,0,0,1,.656,1.542l-.005-.01a.527.527,0,0,1,.1.619.29.29,0,0,1-.393-.013c-1.463-1.494-1.561-3.611-2.431-5.377C-2730.521-1598.517-2730.3-1598.746-2730.2-1598.914Z",
    fill: "#debc43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64617",
    "data-name": "Path 64617",
    d: "M-2728.042-1593.043l.328,0a.747.747,0,0,1,.406.9c.017.211.035.421.052.632C-2727.964-1591.79-2728.02-1592.408-2728.042-1593.043Z",
    fill: "#ebc241"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64618",
    "data-name": "Path 64618",
    d: "M-2699.915-1659.466l-8.351.01-1.542,0c.616-.56,1.369-.279,2.053-.289,2.6-.038,5.207-.013,7.811-.011C-2699.932-1659.661-2699.922-1659.564-2699.915-1659.466Z",
    fill: "#fce133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64619",
    "data-name": "Path 64619",
    d: "M-2715.063-1551.331a3.671,3.671,0,0,0,.123-3.061,9.967,9.967,0,0,1-.429-3.429l.574.305c.728.732.606,1.745.689,2.608a96.014,96.014,0,0,1,.708,10.252,1.992,1.992,0,0,1-.337,1.322c-.934.035-.614-.7-.7-1.168-.355-1.85-.141-3.733-.316-5.594l-.481.34a1.135,1.135,0,0,1-.077-.384C-2715.247-1550.54-2715.149-1550.935-2715.063-1551.331Z",
    fill: "#e6ba2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64620",
    "data-name": "Path 64620",
    d: "M-2714.755-1550.1c.653.343.277.942.285,1.4a19.531,19.531,0,0,0,.631,5.4,1.269,1.269,0,0,1-.016,1.853c-.942.069-.935-.572-.9-1.215C-2714.6-1545.141-2715.277-1547.619-2714.755-1550.1Z",
    fill: "#edac25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64621",
    "data-name": "Path 64621",
    d: "M-2713.855-1541.448q.007-.925.016-1.853.006-.627.012-1.255a.5.5,0,0,1,.561.419c.161,1.714.559,3.445-.26,5.111l-.148.034-.152-.005c0-.1-.007-.19-.012-.285v-.62Q-2713.847-1540.676-2713.855-1541.448Z",
    fill: "#f2c74e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64622",
    "data-name": "Path 64622",
    d: "M-2652.041-1610.647v2.473A2.324,2.324,0,0,1-2652.041-1610.647Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64623",
    "data-name": "Path 64623",
    d: "M-2649.57-1607.249l.618.309c-.044.337.116.71-.186,1.015C-2649.772-1606.21-2649.5-1606.786-2649.57-1607.249Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64624",
    "data-name": "Path 64624",
    d: "M-2714.872-1559.641c-.423-3.919-2.177-7.442-3.322-11.146.141-.141.206-.364.441-.4.489.1.552.577.79.9a4.816,4.816,0,0,1,.564,1.141c.581,1.97,1.695,3.764,1.926,5.849.115.533.193,1.073.34,1.6.019.97.7,1.918.1,2.907C-2714.943-1558.458-2714.319-1559.629-2714.872-1559.641Z",
    fill: "#36362b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64625",
    "data-name": "Path 64625",
    d: "M-2713.526-1539.026c-.158-1.84.329-3.715-.3-5.53.023-4.346-.612-8.642-.968-12.96.03-.128.061-.255.092-.383a.637.637,0,0,1,.524.443c.192.613.1,1.278.338,1.884a13.193,13.193,0,0,0,.344,1.942,27.546,27.546,0,0,1,.107,3.119,4.751,4.751,0,0,0,.21,1.815c.009,1.837.334,3.651.407,5.485-.193,1.4.429,2.894-.452,4.223C-2713.326-1539-2713.426-1539.01-2713.526-1539.026Z",
    fill: "#d8ab3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64626",
    "data-name": "Path 64626",
    d: "M-2717.834-1571.1l-.36.316q-1.046-2.328-2.092-4.657l-1.029-3.052.709.59c.532-.061.714.352.864.712.686,1.645,1.39,3.283,2.036,4.945A1.019,1.019,0,0,1-2717.834-1571.1Z",
    fill: "#38322a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64627",
    "data-name": "Path 64627",
    d: "M-2714.422-1557.5l-.282-.4q-.082-.871-.168-1.742c.519.072.343.718.737.894,1.156.348.428,1.4.763,2.036.637-.581.912-.288.915.413a2.436,2.436,0,0,1-.46,1.122c-.328.494-.363,1.178-.969,1.488a4.013,4.013,0,0,1-.278-1.92C-2714.476-1556.207-2714.087-1556.9-2714.422-1557.5Z",
    fill: "#3b3937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64628",
    "data-name": "Path 64628",
    d: "M-2688.818-1555.348c-.288,3.571-.583,7.141-.856,10.714-.042.558.015,1.124.027,1.686a10.579,10.579,0,0,1,.05,2.02c-.336.7.169,1.546-.4,2.2-1.038-.058-.629-1.02-.958-1.524a3.168,3.168,0,0,1,.013-1.319,29.077,29.077,0,0,0,.157-4.775c.077-1.672-.255-3.4.609-4.969a4.87,4.87,0,0,0,.364-2.38,3.364,3.364,0,0,1,.554-1.607A.32.32,0,0,1-2688.818-1555.348Z",
    fill: "#3f3930"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64629",
    "data-name": "Path 64629",
    d: "M-2688.818-1555.348h-.295c-.715-1.087.144-2.23-.12-3.333a12.146,12.146,0,0,1,.106-2.046,12.355,12.355,0,0,1,.585-2.1c.356-.533.176-1.236.555-1.763a.293.293,0,0,1,.417-.029l.552-.3q-.13.765-.262,1.531a19.147,19.147,0,0,0-.971,4.928Z",
    fill: "#403330"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64630",
    "data-name": "Path 64630",
    d: "M-2689.765-1540.855q.058-1.047.118-2.093c.655,1.036-.276,2.332.546,3.341l.6.026c.218.138.47.253.379.59a.909.909,0,0,1-.43.3C-2690.009-1538.828-2690.009-1538.828-2689.765-1540.855Z",
    fill: "#dfbe5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64631",
    "data-name": "Path 64631",
    d: "M-2657.918-1629.8l-.6-1.239h.606Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64632",
    "data-name": "Path 64632",
    d: "M-2672.126-1552.261c-.023-.525.058-1,.617-1.23,0,.1.006.2.007.3-.106.31-.213.62-.319.931C-2671.923-1552.258-2672.024-1552.26-2672.126-1552.261Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64633",
    "data-name": "Path 64633",
    d: "M-2725.255-1589.643l-.314-.92a4.975,4.975,0,0,0-.163-3.225c.167-.428.552-.2.838-.277.364.184.61-.011.838-.262a1.533,1.533,0,0,1,.6.585,2.293,2.293,0,0,1,.543,1.4.992.992,0,0,1-.188.4c-.625.392-.417,1.117-.666,1.652C-2724.049-1589.675-2724.3-1588.8-2725.255-1589.643Z",
    fill: "#3d453a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64634",
    "data-name": "Path 64634",
    d: "M-2723.716-1593.651c-.271-.146-.295-.417-.34-.676.185-1.57,1.683-2.309,2.287-3.614.585.093.822-.763,1.458-.534a.65.65,0,0,1,.186.607C-2721.348-1596.486-2722.63-1595.152-2723.716-1593.651Z",
    fill: "#382f2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64635",
    "data-name": "Path 64635",
    d: "M-2724.894-1594.065c-.167.408-.429.18-.668.1a1.013,1.013,0,0,1-.377-.514c-.111-.345-.238-.693.046-1.021q-.133-.519-.266-1.039C-2725.178-1596-2725.116-1594.991-2724.894-1594.065Z",
    fill: "#3a3f25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64636",
    "data-name": "Path 64636",
    d: "M-2728.055-1600.452c-.851-.337-1.158.964-2,.664C-2729.648-1600.8-2728.955-1600.936-2728.055-1600.452Z",
    fill: "#3f382d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64637",
    "data-name": "Path 64637",
    d: "M-2726.146-1597.046a1.691,1.691,0,0,1-.658-1.532A2.039,2.039,0,0,1-2726.146-1597.046Z",
    fill: "#3f382d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64638",
    "data-name": "Path 64638",
    d: "M-2688.187-1539.282l-.309-.3,11.12-.012c.016.561-.428.589-.8.7-2.807.1-5.615.029-8.423.042A2.117,2.117,0,0,1-2688.187-1539.282Z",
    fill: "#f8cc30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64639",
    "data-name": "Path 64639",
    d: "M-2677.989-1539.277a.664.664,0,0,0,.613-.316c.606-.118,1.3.3,1.824-.31a8.406,8.406,0,0,1,.662-2.77c.086-.158.175-.152.265,0,.1,1.3-.8,2.44-.565,3.755l-.2.161a3.379,3.379,0,0,1-2.516-.069A.315.315,0,0,1-2677.989-1539.277Z",
    fill: "#e8cc5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64640",
    "data-name": "Path 64640",
    d: "M-2684.2-1574.185c-.162,1.284-1.127,2.208-1.521,3.389-.767.122-1.079-.4-1.355-.964.729-2.525,1.9-4.886,2.774-7.357.143-.4.3-.75.05-1.145-.183-.5.262-1.025-.068-1.518a6.539,6.539,0,0,1-.568-.8,1.679,1.679,0,0,1,.509-1.12,1.731,1.731,0,0,1,.515-.392c2.071-.66,2.788-2.337,3.193-4.251.689-1.181.04-2.64.793-3.806,1.029.167,1.039.98.974,1.713a22.215,22.215,0,0,1-.338,2.827,1.352,1.352,0,0,1-.152.258,2.706,2.706,0,0,0-.268.37,1.343,1.343,0,0,1,.211-.272.5.5,0,0,1,.595.073c.172,1.783-.859,3.156-1.576,4.635a.411.411,0,0,1-.407,0,2.1,2.1,0,0,1-.337-.934c-.838.124-.9.213-.96,1.353a13.243,13.243,0,0,1-.319,1.607c.149-.365.17-.837.722-.867.285.153.491.344.337.706a28.2,28.2,0,0,0-1.888,4.882c-.066.255-.14.658-.59.363C-2684.614-1575.343-2684.672-1575.122-2684.2-1574.185Z",
    fill: "#3d4249"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64641",
    "data-name": "Path 64641",
    d: "M-2686.928-1571.725l1.21.929c.2.923-.5,1.624-.609,2.473a10.538,10.538,0,0,0-1.243,3.706l-.294,0c-.458.553.093,1.283-.322,1.844-.473.535-.071,1.353-.606,1.868-.324.488-.2,1.072-.346,1.6-.067.248-.121.53-.429.561-.36.036-.717-.278-.631-.509.329-.879-.568-.217-.63-.551-.361-1.144.248-2.143.468-3.2.937-2.768,1.529-5.661,2.957-8.254A1.071,1.071,0,0,1-2686.928-1571.725Z",
    fill: "#3b4242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64642",
    "data-name": "Path 64642",
    d: "M-2680.774-1582.535a20.481,20.481,0,0,0,1.857-4.633c.085-.779.123-1.588,1.143-1.759a.683.683,0,0,1,.4.214q-.484,1.384-.971,2.767l-2.711,5.95c-.01-.232-.02-.464-.031-.7A1.792,1.792,0,0,1-2680.774-1582.535Z",
    fill: "#36342e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64643",
    "data-name": "Path 64643",
    d: "M-2684.2-1574.185c-.9.291-.551-.432-.574-.767-.026-.367-.162-.867.364-1.014.385-.107.5.216.536.538C-2684.312-1575.1-2684.114-1574.606-2684.2-1574.185Z",
    fill: "#4a413d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64644",
    "data-name": "Path 64644",
    d: "M-2680.774-1582.535a3.089,3.089,0,0,1-.313,1.843c-.1,0-.2.01-.306.019l-.307-.629c-.306-.875.092-1.22.929-1.235Z",
    fill: "#2b3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64645",
    "data-name": "Path 64645",
    d: "M-2708.267-1658.84l-2.471.308a3.476,3.476,0,0,1,2.47-.617C-2708.267-1659.046-2708.267-1658.943-2708.267-1658.84Z",
    fill: "#fce133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64646",
    "data-name": "Path 64646",
    d: "M-2672.723-1548.857a14.632,14.632,0,0,1-1.244,3.721C-2673.821-1546.466-2673.851-1547.855-2672.723-1548.857Z",
    fill: "#e9af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64647",
    "data-name": "Path 64647",
    d: "M-2676.138-1541.757a2.583,2.583,0,0,0,.311-1.542C-2675.407-1542.679-2675.176-1542.1-2676.138-1541.757Z",
    fill: "#e9af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64648",
    "data-name": "Path 64648",
    d: "M-2674.625-1542.676l-.132-.007-.133.01c.128-.554.151-1.152.661-1.542A3.177,3.177,0,0,1-2674.625-1542.676Z",
    fill: "#e9af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64649",
    "data-name": "Path 64649",
    d: "M-2677.7-1588.718c-.9.125-.556,1.236-1.221,1.55h-.619a11.181,11.181,0,0,1,.248-3.163,1.614,1.614,0,0,0-.558-1.781c-.4.079-.317.75-.839.677-.431-.27-.408-.685-.361-1.111.161-.563.232-1.091-.51-1.3a.668.668,0,0,1-.333-.706,5.635,5.635,0,0,1,.189-.823.81.81,0,0,1,.762-.644c.842-.086,1.114.566,1.451,1.129a.805.805,0,0,1,.093.441c.052-.169-.01-.386.205-.486.413.14.176,1.542,1.151.593.387.164.921-.275,1.21.3.4.974-.126,1.937-.025,2.908A7.731,7.731,0,0,1-2677.7-1588.718Z",
    fill: "#3d4342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64650",
    "data-name": "Path 64650",
    d: "M-2687.546-1598.283a.648.648,0,0,0,.6-.305c1.469-.219,2.953-.695,4.345.277a1.2,1.2,0,0,1-.727.579,1.417,1.417,0,0,1-.592.113,5.619,5.619,0,0,0-5,1.959c-.488.279-.915.383-1.037-.368A3.217,3.217,0,0,1-2687.546-1598.283Z",
    fill: "#3c312b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64651",
    "data-name": "Path 64651",
    d: "M-2683.24-1597.991a.72.72,0,0,1,.643-.32,5.926,5.926,0,0,1,3.408,3.373c-.023.2-.045.4-.069.606-.5-.028-.429-.532-.613-.79a2.425,2.425,0,0,0-.9-.7A29.643,29.643,0,0,1-2683.24-1597.991Z",
    fill: "#372f1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64652",
    "data-name": "Path 64652",
    d: "M-2677.071-1594.283c-.32-.059-.714,1.068-.967-.061l.378-1.475.551-.7a1.283,1.283,0,0,1,.522.99A1.455,1.455,0,0,1-2677.071-1594.283Z",
    fill: "#343722"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64653",
    "data-name": "Path 64653",
    d: "M-2686.961-1563.383a1.831,1.831,0,0,1,.627-1.247c-.1.758.341,1.668-.613,2.187Z",
    fill: "#f0c31c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64654",
    "data-name": "Path 64654",
    d: "M-2687.546-1598.283c-.767.682-1.741,1.149-2.208,2.141-.367.792-.85.9-1.461.246a13.552,13.552,0,0,0-2.458-2.235.547.547,0,0,1-.087-.4c.438-.642.819-.252,1.223.056.509.389,1.035.756,1.554,1.132.908.616,1.1-.855,1.864-.643A2.613,2.613,0,0,1-2687.546-1598.283Z",
    fill: "#dfc14b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64655",
    "data-name": "Path 64655",
    d: "M-2689.119-1597.988c-.281.335-.55.683-.848,1-.6.651-.9.38-1.016-.361.006-.11.011-.221.016-.331h.3a10.845,10.845,0,0,1,.933-.611A.625.625,0,0,1-2689.119-1597.988Z",
    fill: "#ddb815"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64656",
    "data-name": "Path 64656",
    d: "M-2689.729-1598.287a.929.929,0,0,1-.933.611,1.978,1.978,0,0,1,.931-.92Z",
    fill: "#eab121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64657",
    "data-name": "Path 64657",
    d: "M-2715.064-1599.524a.641.641,0,0,0,.309-.618c.707.771,1.315,1.651,2.577.692.435-.331,1.192-.1,1.748.234-.518.671-1.641.569-1.942,1.569-.088.291-.427.1-.575-.138a1.168,1.168,0,0,0-1.19-.5c-.066-.019-.133-.038-.2-.055C-2714.71-1598.654-2715.482-1598.724-2715.064-1599.524Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64658",
    "data-name": "Path 64658",
    d: "M-2665.944-1565.853a2.052,2.052,0,0,1-1.234-.308,1.688,1.688,0,0,1,.618-1.235c.058.483-.214,1.131.611,1.234C-2665.945-1566.059-2665.944-1565.956-2665.944-1565.853Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64659",
    "data-name": "Path 64659",
    d: "M-2677.071-1594.283a2.23,2.23,0,0,1,.311-1.232c-.277-1.155.474-2.051.772-3.062.365-.632.562-1.472,1.523-1.43.861.039,1.1.745,1.354,1.406l-.222.919-.295.3c.2-.022-.3.013-.122-.094-.059-.032-.08-.376-.164-.084-.582,2.035-1.86,3.76-2.533,5.752a.888.888,0,0,1-.622.629C-2677.5-1592.216-2676.834-1593.25-2677.071-1594.283Z",
    fill: "#3d424b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64660",
    "data-name": "Path 64660",
    d: "M-2677.069-1591.183c.782-2.527,2.483-4.662,3.1-7.275.51.241.215.724.337,1.072-.692,2.206-1.986,4.171-2.572,6.42q-.588,1.126-1.174,2.253l-.322-.005A5.573,5.573,0,0,1-2677.069-1591.183Z",
    fill: "#32322b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64661",
    "data-name": "Path 64661",
    d: "M-2693.76-1598.533a.982.982,0,0,1,.035.195l-.126.166c-.387.081-.807-.043-.952.02.149-.1.567.064.962.038a3.8,3.8,0,0,1,1.419,1.139,1.035,1.035,0,0,0,.734.773,1.169,1.169,0,0,0,.7.175c.462.514.857.308,1.232-.116.01.5.266.521.632.321.4.154.649.578.355.806-.835.646-.462,1.463-.486,2.232a2.523,2.523,0,0,1-.33,1.015c-.512.551-.885.335-1.191-.222-.216-.393-.17-.931-.653-1.177-.352-.2-.322-.817-.882-.78-.409-.462-.733-.986-1.12-1.462-.822-1.435-2.325-1.206-3.62-1.481-.332-.254-.171-.576-.129-.877-.135-.377-.565-.175-.777-.393-.042-.057-.083-.114-.125-.17l.978-.513,2.114-.034A1.93,1.93,0,0,1-2693.76-1598.533Z",
    fill: "#3c4143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64662",
    "data-name": "Path 64662",
    d: "M-2717.834-1571.1a38.732,38.732,0,0,0-2.772-6.8,15.509,15.509,0,0,0-2.476-5.573c.283-.41,0-.81-.019-1.216.3-.762,1.009-.746,1.654-.851a1.372,1.372,0,0,1,.408.167c2.305,2.381,4.736,1.682,6.347-1.054,1.807-3.068,1.555-6.009-.817-9.2a.855.855,0,0,1,0-.465.918.918,0,0,1,.98-.529,1.723,1.723,0,0,1,1.128.757c-.1.527.067.881.638.974a1.7,1.7,0,0,1,.234.387c1.056,1.509.259,3.263.638,4.867.125.528-.067,1.123.317,1.605.164.244.318.495.476.743.771,1.529,1.719,2.845,3.545,3.246a2.2,2.2,0,0,0,1.876-.258c.705-.36,1.248-.971,1.983-1.289.524-.154,1.05-.307,1.4.312a2.058,2.058,0,0,1-.7,1.627,9.955,9.955,0,0,1-2.879,1.426,5.544,5.544,0,0,1-5.607-2.084c-.192-.225-.111-.812-.692-.6a1.767,1.767,0,0,1-.853.376,1.22,1.22,0,0,0-1.1.606c-1.15,1.722-3.013,1.673-4.754,1.927-.2.058-.4.1-.592.167-.462.173-.3.58-.344.911.151-.087.282-.221.478-.211a.879.879,0,0,1,.381.171,2.49,2.49,0,0,1,.714,1.781,3.174,3.174,0,0,0,.9,3.185c.273,1.072.891,2.016,1.15,3.093.2.623.592,1.171.737,1.817a1.964,1.964,0,0,1,.02.866c.028.342-.57.909.344.933a7.589,7.589,0,0,1,1.594,4.465,2.2,2.2,0,0,1-1.27,1.457c-.3-2.06-1.787-3.745-1.851-5.879a8.427,8.427,0,0,1-.365-1.682.7.7,0,0,1-.244.762Z",
    fill: "#3c4349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64663",
    "data-name": "Path 64663",
    d: "M-2710.737-1597.976l.008.328a2.867,2.867,0,0,1-2.052,2.308c-.4-.074-.5-.473-.775-.691a10.2,10.2,0,0,0-1.08-1.169c-.383-.39-.9-.619-1.259-1.037-.152-.254-.312-.508-.034-.78.738-.1,1.233.386,1.789.729l0,0c.08.126.149.261.241.378.754.966,1.5,1.979,2.486.192C-2711.321-1597.877-2710.968-1597.892-2710.737-1597.976Z",
    fill: "#d9bd3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64664",
    "data-name": "Path 64664",
    d: "M-2661-1572.641c.194,1.9-.9,3.152-2.176,4.314Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64665",
    "data-name": "Path 64665",
    d: "M-2714.14-1598.288l-1.867-.607a.188.188,0,0,1-.285-.01.68.68,0,0,0-.614-.325c.544-.54,1.228-.2,1.842-.294C-2715.152-1598.816-2714.046-1599-2714.14-1598.288Z",
    fill: "#e7b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64666",
    "data-name": "Path 64666",
    d: "M-2720.311-1597.97v-.505l.336-.329,2.683-.068c.45.219,1.088,0,1.378.594-.03.5-.407.553-.784.606-.58-.363-.528.669-1.034.473a1.39,1.39,0,0,1-.4-.147C-2718.784-1597.8-2719.7-1597.353-2720.311-1597.97Z",
    fill: "#2f2934"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64667",
    "data-name": "Path 64667",
    d: "M-2703.006-1597.365c.516.533.753,1.323,1.508,1.636-.1.589-.516.447-.9.387-1.73-1.622-3.6-2.859-6.153-2.374a.857.857,0,0,1-.71-.227.368.368,0,0,1,.035-.41c1.949-1.042,3.76-.414,5.551.459Z",
    fill: "#3e342d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64668",
    "data-name": "Path 64668",
    d: "M-2709.222-1598.353l.016.366a1.185,1.185,0,0,1-.543.79,3.026,3.026,0,0,0-.866.759c-.557.584-.907,1.325-1.45,1.916-.268-.181-.566.089-.837-.055l-.02-.314a.505.505,0,0,1,.063-.717c1.02-.356,1.364-1.418,2.13-2.04Z",
    fill: "#493d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64669",
    "data-name": "Path 64669",
    d: "M-2673.111-1598.6c-1.442-1.54-1.494-1.539-2.7.019a.517.517,0,0,1-.289-.321c.779-2.015,1.318-2.228,2.973-1.175A1.876,1.876,0,0,1-2673.111-1598.6Z",
    fill: "#32322b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64670",
    "data-name": "Path 64670",
    d: "M-2676.1-1598.9l.289.321c-.007,1.118-.721,2.017-.947,3.067-.379-.244-.28-.653-.349-1.005-.151-.8.706-1.263.681-2.022C-2676.319-1598.662-2676.21-1598.782-2676.1-1598.9Z",
    fill: "#322d24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64671",
    "data-name": "Path 64671",
    d: "M-2696.835-1597.965l-.309.912c-.1.417-.478.6-.749.881a1.088,1.088,0,0,1-.545.248c-1.029-.053-1.25.564-1.179,1.425a10.032,10.032,0,0,0-.367,7.1c.163.528.528.966.679,1.5-.037.655.639,1.409-.261,1.948-.589-.025-.762-.483-.958-.917-.407-1.24-1.305-2.327-1.051-3.786.067-.388-.319.189-.5,0-.88-.692-.132-1.866-.787-2.62a1.348,1.348,0,0,1-.381-.11.836.836,0,0,1-.294-.934,2.421,2.421,0,0,1,.273-.573c.138-1.376,1.656-1.745,2.109-2.893l.082-.565a.558.558,0,0,1,.218.025c1.2-.257,1.755-1.569,2.968-1.8C-2697.532-1598.084-2697.148-1598.258-2696.835-1597.965Z",
    fill: "#3d424a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64672",
    "data-name": "Path 64672",
    d: "M-2698.059-1597.963c-.84.718-1.639,1.492-2.54,2.122-.307.215-.168-.307-.253-.482l2.174-1.915.6-.093.056.1c.072.07.09.134.056.19S-2698.03-1597.963-2698.059-1597.963Z",
    fill: "#372c28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64673",
    "data-name": "Path 64673",
    d: "M-2701.152-1595.783c-.272.708-.043,1.786-1.363,1.742-.111,0,.046.963-.442,1.31-.442-.223-.54-.761-.943-1.021a2.742,2.742,0,0,1-.652-1.082,1.251,1.251,0,0,1-.022-1.04c.788-.265,1.591-.611,2.175.362.316-.009.65.061.9-.217Z",
    fill: "#3a413c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64674",
    "data-name": "Path 64674",
    d: "M-2715.976-1598.278l-1.316-.594,1-.033c.095,0,.19,0,.285.01l.337.557A.2.2,0,0,1-2715.976-1598.278Z",
    fill: "#cba732"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64675",
    "data-name": "Path 64675",
    d: "M-2728.025-1529.051q22.328-.015,44.656-.03c1.385,0,2.771-.017,4.157-.027.292-.213.506-.121.668.165-.281,1.165.6.085.773.393.823.719,2.124,1.06,1.991,2.53a2.646,2.646,0,0,1-2.513.25,2.482,2.482,0,0,1-.493-.252,6.181,6.181,0,0,0-2.141-.154q-19.191-.009-38.381,0a32.161,32.161,0,0,0-3.374.023.564.564,0,0,1-.253.359,8.124,8.124,0,0,1-3,.178,2.13,2.13,0,0,1-.511-.12c-.908-.58-1.826-1.156-1.69-2.459a.532.532,0,0,1,.574-.384c15.331.257,30.662.007,42.8.106-11.358.038-25.907-.049-40.455.012C-2726.154-1528.455-2727.257-1528.084-2728.025-1529.051Z",
    fill: "#221f23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64676",
    "data-name": "Path 64676",
    d: "M-2727.73-1533.1c-.484,0-.931-.41-1.466-.042-.307.211-.6.932-1.1.316-.412-.51.286-.777.408-1.181a3.046,3.046,0,0,1,1.912-.458q21.516,0,43.032,0a4.366,4.366,0,0,1,1.375.134.69.69,0,0,1,.484.647c-.126.63-.645.531-1.084.581-1.162-.339-2.324.014-3.487.012Q-2707.692-1533.122-2727.73-1533.1Z",
    fill: "#434446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64677",
    "data-name": "Path 64677",
    d: "M-2728.025-1529.051a5.37,5.37,0,0,0,2.837.347q22.308,0,44.615-.074c.194,0,.411-.034.5.308a5.066,5.066,0,0,1-1.9.309q-22.081,0-44.162.039c-.608,0-1.446-.8-1.926.28-.627-.19-1.567-.081-1.183-1.237Z",
    fill: "#1c1b1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64678",
    "data-name": "Path 64678",
    d: "M-2683.221-1533.425l-.025-.61c.759-.643,1.631-.4,2.481-.318,1.876,1.171,3.117,3.017,4.71,4.493.639.592.3,1.106-.537,1.21-.453.056-.913.015-1.37.032a.607.607,0,0,1-.634-.168.7.7,0,0,0-.616-.322,1.757,1.757,0,0,0-.634-1.211c-1.44.2-1.671-1.33-2.615-1.867A1.725,1.725,0,0,1-2683.221-1533.425Z",
    fill: "#3f4143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64679",
    "data-name": "Path 64679",
    d: "M-2729.242-1529.079c-.141.925.956.665,1.183,1.237A7.329,7.329,0,0,0-2726.5-1526a.674.674,0,0,1-.614.307c-.828.263-1.655-.094-2.483-.008l0-.316c.189-.245.411-.225.678-.127.4.148.928.222.98-.31s-.55-.268-.847-.368c-1.009-.342-.521-1.3-.831-1.915Z",
    fill: "#3f3f41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64680",
    "data-name": "Path 64680",
    d: "M-2683.221-1533.425a30.411,30.411,0,0,0,3.375,3.106c-.728.966-1.171.212-1.7-.259a19.269,19.269,0,0,0-2.629-2.527C-2683.942-1533.473-2683.565-1533.4-2683.221-1533.425Z",
    fill: "#3f3f41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64681",
    "data-name": "Path 64681",
    d: "M-2729.521-1529.576c-.241-.114-.631-.195-.491-.475a2.594,2.594,0,0,1,.869-.981c.19-.124.475.206.384.476C-2728.893-1530.155-2728.948-1529.639-2729.521-1529.576Z",
    fill: "#3f3f41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64682",
    "data-name": "Path 64682",
    d: "M-2682.109-1530.073c-.884,0-.978-.442-1.008-1.04C-2682.4-1531.153-2682.353-1530.629-2682.109-1530.073Z",
    fill: "#3f3f41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64683",
    "data-name": "Path 64683",
    d: "M-2731.754-1532.805l.01.936c.016.214.32.712-.263.419-.511-.257-.333-.867-.356-1.346Z",
    fill: "#34322c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64684",
    "data-name": "Path 64684",
    d: "M-2731.388-1530.744c.115.145.3.283.344.456.051.2-.174.222-.277.134a2.349,2.349,0,0,1-.339-.467Z",
    fill: "#595c5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64685",
    "data-name": "Path 64685",
    d: "M-2730.2-1512.728l0-.606c4.372.084,8.743-.783,13.117-.011a2.6,2.6,0,0,0,.768.005c.378-.049.941.216,1.075-.3.13-.5-.255-.764-.758-.953-1.208-.454-1.621-1.708-2.4-2.594-.041-.046.176-.32.274-.488a2.788,2.788,0,0,1,2.056-.44q19.735-.015,39.473,0a4.247,4.247,0,0,1,1.82.212,1.046,1.046,0,0,1,.494,1.321c-.179.483-.672.343-1.075.341-12.133-.058-24.266-.009-36.4-.026a14.21,14.21,0,0,1-2-.027c-.551-.081-.663.161-.911.585-.372.638.192.693.417.917a4,4,0,0,0,3.3.97c9.347-.629,18.706-.11,28.057-.295,1.807-.036,3.59.182,5.383.3a1.99,1.99,0,0,0,1.486-.206c1.269-1.018,1.753-.955,2.858.414a1.21,1.21,0,0,1-.436.986c-.616.211-1.161.719-1.891.45a7.038,7.038,0,0,0-1.689-.1q-16.882-.006-33.764-.006a11,11,0,0,0-2.293.2c-3.264-.293-6.521.244-9.785.1-2.188-.1-4.376-.185-6.553-.438Z",
    fill: "#434546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64686",
    "data-name": "Path 64686",
    d: "M-2729.894-1517.674c.22-.4.749-.189,1.2-.616-1.587-.413-.513-1.624-.894-2.43,1.829-.009,3.658-.026,5.487-.025a2.974,2.974,0,0,0,1.621-.307l.212-.011a3.908,3.908,0,0,0,2.1-.057,3.4,3.4,0,0,1,.472-.032,2.392,2.392,0,0,1,1.692.41c.567.643,1.329.454,2.029.454q18.981.013,37.962.008a12.939,12.939,0,0,1,2.156.083c.641.107,1.266.287,1.17,1.123-.089.774-.675.955-1.349.958-.206,0-.412-.007-.618-.007q-18.6-.006-37.19-.009c-1.441,0-2.876.056-4.31.184C-2722.06-1517.421-2725.982-1517.749-2729.894-1517.674Z",
    fill: "#241f23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64687",
    "data-name": "Path 64687",
    d: "M-2718.159-1517.948c-.026-.18-.14-.553,0-.509,1.035.329,2.008-.16,3.021-.156,12.554.042,25.108.026,37.663.033.612,0,1.224.114,1.836.1a.667.667,0,0,0,.709-.667c.027-.493-.227-.569-.675-.558-.662.016-1.327-.114-1.99-.114q-19.218-.012-38.435-.012c-.663,0-1.326-.12-1.989-.13-1.529-.023-.132-.515-.133-.781a2.087,2.087,0,0,1,1.734-.441q20.448-.016,40.9,0a3.119,3.119,0,0,1,1.215.137c.973.612.19,1.6.5,2.2a8.458,8.458,0,0,1,.081-1.885c.328-.106.47.006.416.352a7.1,7.1,0,0,1,0,2.345c-.113,1.19-.693.809-1.287.384l-43.532-.024A2.247,2.247,0,0,1-2718.159-1517.948Z",
    fill: "#1f1e21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64688",
    "data-name": "Path 64688",
    d: "M-2718.99-1516.866h-9.088C-2727.263-1517.429-2721.206-1517.619-2718.99-1516.866Z",
    fill: "#444849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64689",
    "data-name": "Path 64689",
    d: "M-2730.2-1513.334c-.1,0-.2,0-.3-.005.063-1.289,1.6-1.384,1.993-2.42.021-.054.7-.212.362.376-.276.487.556.6.327,1.1A1.686,1.686,0,0,0-2730.2-1513.334Z",
    fill: "#434546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64690",
    "data-name": "Path 64690",
    d: "M-2727.111-1525.691a.653.653,0,0,1,.614-.307q.144.016.288.027c.161.1.341.159.5.255a4.449,4.449,0,0,1,.758.619c.794,1.023,2.19,1.579,2.38,3.07a.711.711,0,0,1-.223.357C-2724.44-1522.784-2725.5-1524.537-2727.111-1525.691Z",
    fill: "#3f4143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64691",
    "data-name": "Path 64691",
    d: "M-2722.789-1521.67l.005-.326c.7-.371,1.022.089,1.33.59a.483.483,0,0,1-.125.439.934.934,0,0,1-.9-.085h0Z",
    fill: "#555859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64692",
    "data-name": "Path 64692",
    d: "M-2713.519-1512.417a9.088,9.088,0,0,1,2.433-.3q17.058.02,34.115.019c.592,0,1.245-.224,1.765.285-.578.5-1.279.3-1.926.3q-16.59.02-33.18.01,16.733,0,33.466.009a5.175,5.175,0,0,1,2.568.3c.87,1.581,0,3.007-.57,4.342-1.732,4.087-5.071,5.519-9.318,5.233a.7.7,0,0,1,.142-.572.764.764,0,0,0,.225-.622c-11.653-1.008-23.351-.316-35.033-.505-1.567-.026-3.124.076-4.264,1.4-.426-.053-.912.142-1.241-.3-.085-.331-.233-.542-.609-.324a6.825,6.825,0,0,1-3.712-3.388c-.848-1.4-.62-3.04-1.035-4.537-.331-1.2.883-.2,1.036-.718.672-.028.393.536.527.819,0-.026.02,0,.02,0s0-.113,0-.137c-.108-1.163.807-1.141,1.442-1.094,3.529.26,7.057-.016,10.584.086A7.882,7.882,0,0,0-2713.519-1512.417Z",
    fill: "#222023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64693",
    "data-name": "Path 64693",
    d: "M-2723.1-1502.519c-.373-.552,1.443-.737.25-1.474-.086-.053.283-.34.548-.341q8.442-.023,16.885-.039c5.038-.007,10.076.02,15.114-.014a28.726,28.726,0,0,1,4.75.542,2.777,2.777,0,0,0,1.214.027c.5-.163,1.081-.712,1.344.093a1.09,1.09,0,0,1-.818,1.235,1.325,1.325,0,0,0-.357.273q-18.664,0-37.328-.01C-2722.034-1502.228-2722.637-1502.018-2723.1-1502.519Z",
    fill: "#22211f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64694",
    "data-name": "Path 64694",
    d: "M-2674.278-1511.793a9.822,9.822,0,0,1-2.745-.01q-16.824.033-33.647.014h-1.649v-.62h37.112l1.543-.3a.281.281,0,0,1,.432.138,10.58,10.58,0,0,1-.1,2.671c.068.3.022.542-.307.653a20.134,20.134,0,0,0-.059-2.558C-2673.8-1512.527-2674.083-1512.1-2674.278-1511.793Z",
    fill: "#1b1c1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64695",
    "data-name": "Path 64695",
    d: "M-2724.946-1503.147a.627.627,0,0,1,.9-.216c.22.181-.247.318-.29.54Z",
    fill: "#22211f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64696",
    "data-name": "Path 64696",
    d: "M-2713.519-1512.417c.286,1.077-.585.6-.919.606-3.478.036-6.956.012-10.434.027-1.292.006-2.775-.469-3.476,1.231-.041-.428.143-.912-.309-1.237l-.924-.627c3.1-.6,6.191.238,9.29.005,1.911-.144,3.829-.2,5.745-.254A3.994,3.994,0,0,1-2713.519-1512.417Z",
    fill: "#1b1c1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64697",
    "data-name": "Path 64697",
    d: "M-2719.729-1482.81a9.486,9.486,0,0,1,.314,3.172A3.735,3.735,0,0,1-2719.729-1482.81Z",
    fill: "#f8d23b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64698",
    "data-name": "Path 64698",
    d: "M-2719.423-1479.647a9,9,0,0,1,.622,3.437A6.19,6.19,0,0,1-2719.423-1479.647Z",
    fill: "#f8d23b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64699",
    "data-name": "Path 64699",
    d: "M-2718.574-1474.989a2.324,2.324,0,0,1,.7,2.18A6.189,6.189,0,0,1-2718.574-1474.989Z",
    fill: "#f8d23b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64700",
    "data-name": "Path 64700",
    d: "M-2717.541-1471.627a2.626,2.626,0,0,1,.6,1.866A2.293,2.293,0,0,1-2717.541-1471.627Z",
    fill: "#f8d23b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64701",
    "data-name": "Path 64701",
    d: "M-2717.224-1461.74c-.1,0-.2,0-.308-.006a17.5,17.5,0,0,0-1.239-4.635c.55-.617.593.275.924.309l.007.01c.449.945.485,2.02.981,2.963A1.207,1.207,0,0,1-2717.224-1461.74Z",
    fill: "#f45a2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64702",
    "data-name": "Path 64702",
    d: "M-2709.511-1490.977l1.247-.115a.172.172,0,0,1,.306,0l.63.284c.442.975-.549,1.647-.531,2.533a5.7,5.7,0,0,1-.153.659c-.991,3.418.158,6.07,2.906,8.155a4,4,0,0,1,1.705,1.893c.076.949-.554,1.428-1.239,1.873a1.554,1.554,0,0,1-.9.2c-.958-.217-1.748-.615-1.894-1.731a.881.881,0,0,0-.238-.392c-1.423-1.736-3.019-3.417-1.7-6.023-.516.4-.71,1.047-1.317.859-.552-.17-.658-.758-.7-1.276-.1-1.21.082-2.442-.889-3.483-.461-.5-.033-.951.614-1.028.361-.043.8.243,1.043.069.2-.15,1.552.455.608-.732a1.269,1.269,0,0,1,.161-1.456A2.7,2.7,0,0,1-2709.511-1490.977Z",
    fill: "#f8fbf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64703",
    "data-name": "Path 64703",
    d: "M-2697.763-1492.021c.711-.125,1.3-1.428,2.16-.228.033.046.3,0,.389-.081.3-.293.069-.533-.1-.8a43.284,43.284,0,0,0-3.526-3.913c-.261-.307-.99-.55-.48-1.022.416-.384.626.293.885.56a18.183,18.183,0,0,0,3.127,3.1,5.2,5.2,0,0,1,2.184,2.381c-.152.342-.617.51-.541.979a.772.772,0,0,1-.465.387,2.077,2.077,0,0,1-1.22-.3C-2695.99-1491.687-2697.14-1491.262-2697.763-1492.021Z",
    fill: "#abafb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64704",
    "data-name": "Path 64704",
    d: "M-2706.427-1490.494a.589.589,0,0,1,.63-.578.634.634,0,0,1,.926-.015l1.239.005c.392-.464.922-.358,1.416-.313,1.747.161,3.531-.367,5.251.279a3.489,3.489,0,0,1,.262,3.289.442.442,0,0,1-.438.156,1.784,1.784,0,0,1-1.066-1.4c-.229-1.065-.905-1.355-1.9-1.307-1.016.05-2.037,0-3.056.018a1.317,1.317,0,0,0-1.277.634c-.769,1.266-.853,1.243-1.542-.061-.1-.182-.225-.339-.336-.509C-2706.357-1490.359-2706.392-1490.427-2706.427-1490.494Z",
    fill: "#f6fdef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64705",
    "data-name": "Path 64705",
    d: "M-2696.924-1490.79c-2.215-.587-4.477-.076-6.708-.292-.359-1.1.283-.887.965-.787a10.808,10.808,0,0,0,4.9-.152c.8.332,1.925-.28,2.471.826a.72.72,0,0,1-.426.608A1.066,1.066,0,0,1-2696.924-1490.79Z",
    fill: "#9da0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64706",
    "data-name": "Path 64706",
    d: "M-2693.745-1491.095c-1.378-1.366.581-.5.616-.924,1.229.47,2.487-.021,3.736.108.775.081.157.479.277.686a.859.859,0,0,1-.781.626C-2691.167-1490.863-2692.547-1490.277-2693.745-1491.095Z",
    fill: "#9da3a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64707",
    "data-name": "Path 64707",
    d: "M-2687.243-1491.181l1.512,1.36a3.872,3.872,0,0,1,.485,1.74.78.78,0,0,1-.406.461c-.427.083-.618-.239-.853-.49-.218-.255-.443-.5-.639-.778a4.509,4.509,0,0,0-1.189-1.3,1,1,0,0,1-.327-.51.663.663,0,0,1,.108-.39C-2688.152-1491.642-2687.691-1491.319-2687.243-1491.181Z",
    fill: "#d05413"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64708",
    "data-name": "Path 64708",
    d: "M-2706.645-1490.489a.758.758,0,0,0,.218-.005l.059.032a2.317,2.317,0,0,1,.409,1.455,10.7,10.7,0,0,0,1.143,3.944.539.539,0,0,1-.6.3,2.67,2.67,0,0,1-1.282-1.113c-1.023-1.36-.513-2.822-.284-4.267A.679.679,0,0,1-2706.645-1490.489Z",
    fill: "#f4fadb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64709",
    "data-name": "Path 64709",
    d: "M-2709.511-1490.977c0,.063-.006.124-.014.186a1.832,1.832,0,0,1-1.021.39,5.738,5.738,0,0,0-3.3,1.845c-.247.235-.493.473-.758.69-.262.1-.558.518-.751-.074l.3-.707a5.407,5.407,0,0,0,1.581-1.521c.443-.02.6-.449.918-.645A6.871,6.871,0,0,1-2709.511-1490.977Z",
    fill: "#f2f3be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64710",
    "data-name": "Path 64710",
    d: "M-2706.645-1490.489l-.139.344a11.708,11.708,0,0,0-.522,3.3c.047.454,0,.944-.611,1.067a.955.955,0,0,1-.341-.883c-.127-.551.337-1.094.021-1.648-.028-.954.732-1.622.909-2.5A.8.8,0,0,1-2706.645-1490.489Z",
    fill: "#ca6821"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64711",
    "data-name": "Path 64711",
    d: "M-2707.958-1491.1l-.307,0c-.531-.64-1.4-.008-2.075-.609a2.57,2.57,0,0,1,2.548-.05C-2707.262-1491.494-2707.958-1491.337-2707.958-1491.1Z",
    fill: "#a0a09c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64712",
    "data-name": "Path 64712",
    d: "M-2704.871-1491.087l-.926.015c-.087-.346-.52-.808.224-.909C-2704.9-1492.071-2704.864-1491.576-2704.871-1491.087Z",
    fill: "#98a69e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64713",
    "data-name": "Path 64713",
    d: "M-2688.552-1491.091l.009.324a.842.842,0,0,1-.74.682c-.368-.125-.687-.284-.5-.769l.662-.37Z",
    fill: "#f5de42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64714",
    "data-name": "Path 64714",
    d: "M-2717.224-1461.74c.462-1.536-.9-2.811-.616-4.322.592,1.486,2.282,2.753.925,4.629Z",
    fill: "#e75d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64715",
    "data-name": "Path 64715",
    d: "M-2715.353-1487.94c.234.295.4-.055.595-.067a2.025,2.025,0,0,1,.844,1,6.392,6.392,0,0,1,.252,1.059,3.211,3.211,0,0,1,.476,1.9c-.062.424-.187.847-.633.966-.523.139-.707-.327-.868-.684a6.817,6.817,0,0,1-.666-2.225c-1,1.913-.344,3.752.15,5.595a14.9,14.9,0,0,1,.9,5.264.429.429,0,0,1-.423.207c-.942-.513-1.012-1.516-1.216-2.377-.283-1.2-.651-2.372-.949-3.566a2.257,2.257,0,0,1-.1-.5c.055-1.074-.138-2.139-.1-3.215a2.066,2.066,0,0,1,.52-1.546C-2716.13-1486.717-2716.259-1487.675-2715.353-1487.94Z",
    fill: "#fcfdef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64716",
    "data-name": "Path 64716",
    d: "M-2716.56-1486.134c-.8,1.64-.182,3.288-.031,4.933-.8.092-.386-.646-.635-.93h0c0-.871,0-1.741,0-2.611C-2717.232-1485.317-2717.251-1485.9-2716.56-1486.134Z",
    fill: "#f6ed35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64717",
    "data-name": "Path 64717",
    d: "M-2718.462-1482.134v2.6c-.475-1.139-.973-1.808-.306-2.6C-2718.666-1482.132-2718.564-1482.133-2718.462-1482.134Z",
    fill: "#faf023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64718",
    "data-name": "Path 64718",
    d: "M-2717.226-1482.131l.635.93a.237.237,0,0,1,.008.244,25.4,25.4,0,0,0,2.058,6.918c.115.293.225.588.323.887a5.381,5.381,0,0,1,.222,2.279l-.157.173c-1.222.01-2.061-.211-1.069-1.652a.581.581,0,0,0-.22-.917c-.678-.232-.384.262-.369.58.018.363-.23.4-.507.269s-.614-.26-.478-.659a8.3,8.3,0,0,1,.545-1.253,1.434,1.434,0,0,0-.144-1.832,2.336,2.336,0,0,1-.641-2.59,3.454,3.454,0,0,0-.306-1.922A1.6,1.6,0,0,1-2717.226-1482.131Z",
    fill: "#f0ea2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64719",
    "data-name": "Path 64719",
    d: "M-2711.979-1462.365a2.3,2.3,0,0,0-.491.363c-.769.971-1.274.8-1.625-.327-.518-1.661-1.059-3.315-1.59-4.972.23-1.2-1.01-2.159-.542-3.375,1.258.682.532,2.175,1.24,3.138l.536-.7c.055.049.109.1.165.145a23.171,23.171,0,0,1,1.085,4.471c.029.388-.023.219.27.144C-2712.024-1463.706-2711.752-1463.206-2711.979-1462.365Z",
    fill: "#eef12b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64720",
    "data-name": "Path 64720",
    d: "M-2714.451-1468.235a6.6,6.6,0,0,1,.314-2.465v0c.36-.161.614.041.865.253a6.3,6.3,0,0,1,1.082,2.89c.038.2.008-.053.019.152.036.707.666,1.739-.336,1.989-.876.22-.794-.972-1.14-1.535-.162-.349-.164-.779-.516-1.034a2.167,2.167,0,0,1-.278-.237Z",
    fill: "#ebec2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64721",
    "data-name": "Path 64721",
    d: "M-2680.472-1534.016l-2.774-.019-46.643.022-.317-.038.609-.3a1.984,1.984,0,0,1,1.5-.663c.822-.025,1.644-.072,2.468-.072q20.917,0,41.832,0a5.06,5.06,0,0,0,4.82-1.672c1.006-1.134,2.376-1.819,4-.9.669.381.569-.289.7-.621a.71.71,0,0,1,.493-.525c.7.036.575.561.577.989,0,1.1.021,2.193-.009,3.289a.32.32,0,0,1-.38.264c-.4-.5-.169-1.044-.183-1.478-.192.5.114,1.155-.133,1.755A12.7,12.7,0,0,1-2680.472-1534.016Z",
    fill: "#222023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64722",
    "data-name": "Path 64722",
    d: "M-2690.658-1540.21c.6.317-.036,1.2.677,1.471.054.028.108.056.165.084a1.7,1.7,0,0,0,.338.176,3.65,3.65,0,0,1,1.389.47c.517.586,1.215.4,1.858.438,1.766.114,3.553-.248,5.3.247.29,1.562-.881,1.874-1.949,2.277a8.1,8.1,0,0,1-1.982.245c-14.663,0-29.327-.031-43.991.016a1.111,1.111,0,0,1-.727-.174q-.161-1.236-.32-2.47c.1-.827.759-.555,1.244-.623a1.641,1.641,0,0,1,1.223-.076c.275.121-.292.654.312.626,2.972-.137,5.947,0,8.921-.07a1.165,1.165,0,0,0,.888-.508,2.477,2.477,0,0,1,1.1-.115c.532.052.5.687.9.88.463-.108.249-.731.668-.865a5.2,5.2,0,0,1,1.058.015c1.693,1.182,1.866,1.165,3.148-.3a6.648,6.648,0,0,1,2.242-.013,1.748,1.748,0,0,1,.538.451.894.894,0,0,0,.9.454c3.958.044,7.916,0,11.875.019.213,0,.407-.054.429-.326.193-.658.824-.28,1.193-.518a.666.666,0,0,1,.057-.327,1.744,1.744,0,0,1,.235-.265,1.3,1.3,0,0,1,.771-.446c.3.011.525.265.829.263C-2690.911-1539.378-2691.054-1539.979-2690.658-1540.21Z",
    fill: "#222023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64723",
    "data-name": "Path 64723",
    d: "M-2729.577-1534.96q19.8,0,39.6-.005a34.85,34.85,0,0,0,7.344-.326c-.026.374-.4.42-.6.637q-21.369,0-42.737.007a14.363,14.363,0,0,0-3.635.294C-2729.591-1534.556-2729.584-1534.758-2729.577-1534.96Z",
    fill: "#1c1a1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64724",
    "data-name": "Path 64724",
    d: "M-2715.988-1538.032l-1.236-.007a1.584,1.584,0,0,1-1.262.442q-3.835.027-7.672,0a1.593,1.593,0,0,1-1.264-.437l-1.231-.019a2.914,2.914,0,0,1,.011-.306c4.608,0,9.217.008,13.825-.007.54,0,1.138.2,1.6-.278l-.018-.048a.3.3,0,0,1,.416.044.609.609,0,0,1-.055.663.525.525,0,0,1-.649-.058l-1.234,0A.884.884,0,0,1-2715.988-1538.032Z",
    fill: "#0c0702"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64725",
    "data-name": "Path 64725",
    d: "M-2712.9-1538.653l-.331-.039a.81.81,0,0,0,.006-.3q.012-2.155.025-4.31c.856.152.656.86.711,1.4a15.933,15.933,0,0,1,.019,1.635C-2712.5-1539.694-2712.415-1539.1-2712.9-1538.653Z",
    fill: "#453f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64726",
    "data-name": "Path 64726",
    d: "M-2716.612-1459.9c0-.206,0-.412.015-.617.026-.38.128-.727.568-.8a.517.517,0,0,1,.569.418.7.7,0,0,1-.527.948,2.908,2.908,0,0,1-.61.063Z",
    fill: "#e75d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64727",
    "data-name": "Path 64727",
    d: "M-2673.412-1534.36c-.008-1.181-.02-2.362-.022-3.543,0-.377.031-.757-.536-.673a1,1,0,0,1-1.067.071.552.552,0,0,1-.221-.372l.068-.045.9-.041c.684-.053,1.307-.02,1.269.922a18.716,18.716,0,0,0,.045,3.944.343.343,0,0,1-.377.124.3.3,0,0,1-.1-.248C-2673.448-1534.314-2673.433-1534.36-2673.412-1534.36Z",
    fill: "#718b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64728",
    "data-name": "Path 64728",
    d: "M-2673.667-1542.377a1.561,1.561,0,0,1,.306-2.161A3.857,3.857,0,0,1-2673.667-1542.377Z",
    fill: "#9be7f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64729",
    "data-name": "Path 64729",
    d: "M-2641.229-1559.364a4.385,4.385,0,0,0,2.479-3.05c.5-1.808,2.379-1.862,3.705-2.425a3.657,3.657,0,0,1,4.142.5c.562.53,1.39-.04,2.022.347l.009.005c1.228.414,1.832-.4,2.529-1.19,1.288-1.468,2.8-2.582,4.921-2.132a16.736,16.736,0,0,0,2.449.064c1.231.013,2.079.88,3.091,1.382h0c.408.7.558,1.519,1.435,1.983.733.387.877,1.343.933,2.15a1.889,1.889,0,0,0,.727,1.426l-.012,0a.575.575,0,0,0,.7.093c3.045-1.127,5.46.059,7.651,2.077l0-.008c-.069,1.431-.069,1.431-1.944,1.2.451.461.444.512,2.167.772.822.124,1.158.336.684,1.141-2.657-.034-5.314-.083-7.97-.1-8.534-.066-17.073-.172-25.6.042-3.848.1-7.692-.327-11.532.063-.239.047-.686.337-.461-.268a7.556,7.556,0,0,1,.772-1.278l.308-.309a20.228,20.228,0,0,0,3.4-2.162c.224-.36.588-.3.927-.309C-2642.877-1559.818-2642.053-1559.22-2641.229-1559.364Z",
    fill: "#fdfefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64730",
    "data-name": "Path 64730",
    d: "M-2648.644-1555.038c.292-.647.868-.644,1.444-.617a43.567,43.567,0,0,1,5.368.235c1.22.208,2.533-.221,3.8-.224,9.1-.025,18.2-.01,27.3-.016,1.618,0,3.225.443,4.859.02a3.154,3.154,0,0,1,2.332.6c-.124.54-.124,1-1,.988-6.737-.07-13.477.041-20.212-.107-2.757-.061-5.506.048-8.254.086-2.985.042-5.937-.431-8.912-.341-1.84.056-3.662.433-5.517.313C-2648.1-1554.143-2648.72-1554.108-2648.644-1555.038Z",
    fill: "#fefcf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64731",
    "data-name": "Path 64731",
    d: "M-2649.259-1556.27l0-.933c.193-.3.394-.326.6-.02l-.249.33Z",
    fill: "#a4ddf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64732",
    "data-name": "Path 64732",
    d: "M-2681.377-1469.142a18.985,18.985,0,0,1,1.207-8.665c.646.775.189,1.609.139,2.464.292-.733-.064-1.59.537-2.2a8.216,8.216,0,0,1-.632,5.043.86.86,0,0,1-.324-.518.346.346,0,0,0-.02.136c-.012.244.242.231.35.358A8.732,8.732,0,0,1-2681.377-1469.142Z",
    fill: "#ef5b29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64733",
    "data-name": "Path 64733",
    d: "M-2685.738-1487.653l.3-.37c.824-1.389,1.1-.016,1.588.314a1.2,1.2,0,0,1,.657.854q-.031.36-.064.72c-.5.412-.671-.853-1.212-.23a.806.806,0,0,1-.4.069A1.258,1.258,0,0,1-2685.738-1487.653Z",
    fill: "#ea4c13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64734",
    "data-name": "Path 64734",
    d: "M-2683.849-1487.709c-.535-.074-.859-1.22-1.588-.314-.16-.589-.683-1.119-.294-1.8A4.216,4.216,0,0,1-2683.849-1487.709Z",
    fill: "#df5d3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64735",
    "data-name": "Path 64735",
    d: "M-2679.494-1477.548l-.384,2.489-.292-.01v-2.738a.66.66,0,0,1,.316-.606c.227.135.1.465.334.6A.244.244,0,0,1-2679.494-1477.548Z",
    fill: "#f34b06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64736",
    "data-name": "Path 64736",
    d: "M-2679.52-1477.813a.614.614,0,0,1-.334-.6q-.009-.468-.018-.935l.03-.6A3.111,3.111,0,0,1-2679.52-1477.813Z",
    fill: "#ef5b29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64737",
    "data-name": "Path 64737",
    d: "M-2673.412-1534.36a1.141,1.141,0,0,1,.111.286,2.765,2.765,0,0,1-1.227,2.457,1.732,1.732,0,0,0-.491,2.491c.336.816-.3,1.914.735,2.513.475-.411.271-1.224.914-1.523.4.284.087.746.268,1.086-.51,1.043.719.713.935,1.184.016.057.031.115.046.173-.369.53.376.374.407.661.242,1.338-.321,2.637-.183,3.969-.277.63-1.131.067-1.414.685l-.4-.3c-.091.092-.17.084-.24-.025q-15.249-.019-30.5-.039-6.855-.006-13.709.008l-1.847-.029c.01-.524.4-.517.758-.526.822-.02,1.641-.077,2.464-.077q19.3.01,38.6.005c.492,0,.983,0,1.118,0-4.735,0-9.823-.014-14.912,0-9,.031-18.009-.074-27.014.041-.85.011-1.721.467-2.564-.04-.429-.175-.7-.656-1.23-.632-.364-1.4-1.854-1.89-2.477-3.078a2.67,2.67,0,0,1,2.71-.258,2.731,2.731,0,0,0,.451.308,4.017,4.017,0,0,0,1.378.128q20.3,0,40.588,0a6.466,6.466,0,0,0,1.071-.058,1.821,1.821,0,0,0,.443-.2,4.858,4.858,0,0,1,2.474-.455c.254-.168.547-.317.33-.707l-2.176-2.16a.18.18,0,0,1-.08-.194c.021-.068.043-.1.067-.1.577-.444,1.244-.264,2.351-.136-1.743-1.947-3.517-3.324-4.818-5.113l6.531-.069a.431.431,0,0,1,.3-.231A1.435,1.435,0,0,0-2673.412-1534.36Z",
    fill: "#404143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64738",
    "data-name": "Path 64738",
    d: "M-2674.595-1517.649c.481.045,1.032.33,1.287-.384.382.565,1.2.064,1.575.642-.04.277-.628.3-.453.446,1.157.96.353,2.093.272,3.109-.066.838-.722,1.014-1.445.5l-.042-.3c-.932.232-1.227-.6-1.774-1.029-.033-.025-.585.038-.209.421.86.872.15.852-.507.92-1.8.188-3.565-.318-5.358-.317q-12.877.01-25.753.007a19.537,19.537,0,0,0-2.9.224c-2.254.337-4.406.1-5.772-2.274.255-.054.555-.119.856-.182-.088-.5-.88-.046-.89-.791h41.225C-2674.346-1516.865-2674.7-1517.263-2674.595-1517.649Z",
    fill: "#404143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64739",
    "data-name": "Path 64739",
    d: "M-2673.359-1513.337c.851.084,1.226-.082,1.161-1.149-.063-1.011.816-2.2-.923-2.764l1.388-.141c1.078,1.232.619,2.673.4,4a1.2,1.2,0,0,1-1.6.729.344.344,0,0,1-.5-.04,1.78,1.78,0,0,1-.231-.012A.656.656,0,0,1-2673.359-1513.337Z",
    fill: "#27383b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64740",
    "data-name": "Path 64740",
    d: "M-2671.8-1529.379c-.364.617-1.247.322-1.621.921a.545.545,0,0,1-.5-.208c-.23-.23-.656-.188-.783-.561a5.209,5.209,0,0,1,2.575-3.013.893.893,0,0,1,.259.342C-2671.5-1531.068-2672.134-1530.211-2671.8-1529.379Z",
    fill: "#404241"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64741",
    "data-name": "Path 64741",
    d: "M-2671.9-1521.063c-.429-.066-.916.174-1.44-.405,1.454-.093,1.218-1.1,1.208-1.984a2.874,2.874,0,0,1,.32-1.625c-.08-.069-.107-.137-.081-.206s.052-.1.079-.1l.3.333a4.42,4.42,0,0,1,.016,3.4Z",
    fill: "#293034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64742",
    "data-name": "Path 64742",
    d: "M-2672.106-1531.839l-.023-.353c.021-.682-1.225-.944-.6-1.824l1.21.345a1.254,1.254,0,0,0,.344.876,4.835,4.835,0,0,1,0,2.468l-.329.306C-2672.047-1530.514-2671.784-1531.273-2672.106-1531.839Z",
    fill: "#2f4146"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64743",
    "data-name": "Path 64743",
    d: "M-2672.106-1531.839a3.105,3.105,0,0,1,.6,1.818c-.038.241.067.548-.293.642-.278-.129-1.076.1-.629-.554S-2672.2-1531.208-2672.106-1531.839Z",
    fill: "#0e1e22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64744",
    "data-name": "Path 64744",
    d: "M-2673.658-1528.791l.238.333.05.322c-.39.657.012,1.537-.6,2.131C-2674.359-1526.989-2675.1-1528.012-2673.658-1528.791Z",
    fill: "#070508"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64745",
    "data-name": "Path 64745",
    d: "M-2671.491-1521.655q-.008-1.7-.016-3.4l.326.291a5.994,5.994,0,0,1,0,2.778Z",
    fill: "#404143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64746",
    "data-name": "Path 64746",
    d: "M-2671.811-1525.387l0,.31-1.42-.068c.185-.788.752-.432,1.108-.548Z",
    fill: "#283b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64747",
    "data-name": "Path 64747",
    d: "M-2671.184-1521.985l0-2.778A2.926,2.926,0,0,1-2671.184-1521.985Z",
    fill: "#add6de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64748",
    "data-name": "Path 64748",
    d: "M-2673.432-1512.7l.5.04c-.532.862.062,1.884-.393,2.757Q-2673.38-1511.3-2673.432-1512.7Z",
    fill: "#434546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64749",
    "data-name": "Path 64749",
    d: "M-2671.177-1530.327q0-1.234,0-2.468A2.443,2.443,0,0,1-2671.177-1530.327Z",
    fill: "#add6de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64750",
    "data-name": "Path 64750",
    d: "M-2672.167-1525.866c-.73-.064-1.375-.2-.935-1.184C-2673.176-1526.352-2672.308-1526.4-2672.167-1525.866Z",
    fill: "#add6de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64751",
    "data-name": "Path 64751",
    d: "M-2604.445-1558.14c-1.51-.244-2.3-1.807-3.91-2.02-.806-.107-1.427-.4-2.28.051a1.925,1.925,0,0,1-2.165-.2,7.147,7.147,0,0,1,7.815,1.3A1.238,1.238,0,0,1-2604.445-1558.14Z",
    fill: "#ebfafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64752",
    "data-name": "Path 64752",
    d: "M-2612.788-1560.307c-.854-.122-1.347-.321-1.078-1.465a1.586,1.586,0,0,0-1.2-2.078c-1.183-.258-.708-1.274-.813-2.016A7.7,7.7,0,0,1-2612.788-1560.307Z",
    fill: "#ebfafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64753",
    "data-name": "Path 64753",
    d: "M-2615.882-1565.865c-1.187-.02-1.893-1.262-3.1-1.222a.215.215,0,0,1-.066-.222c.025-.073.049-.11.072-.11l.923.011C-2617.414-1566.778-2616.312-1566.8-2615.882-1565.865Z",
    fill: "#ebfafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64754",
    "data-name": "Path 64754",
    d: "M-2644.627-1559.055a4.955,4.955,0,0,1-3.4,2.162C-2646.966-1557.73-2646.024-1558.75-2644.627-1559.055Z",
    fill: "#effcfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64755",
    "data-name": "Path 64755",
    d: "M-2641.229-1559.364c-.824.617-1.648-.3-2.471,0A2.367,2.367,0,0,1-2641.229-1559.364Z",
    fill: "#effcfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64756",
    "data-name": "Path 64756",
    d: "M-2618.98-1567.419l-.006.332a3.447,3.447,0,0,1-2.373.2c-1.021-.185-2.192-.81-2.737.759-1.794-.3-1.789,1.6-2.788,2.243a1.672,1.672,0,0,1-1.988-.1c.654.086.954-.316,1.347-.781C-2625.341-1567.357-2622.357-1568.571-2618.98-1567.419Z",
    fill: "#effcfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64757",
    "data-name": "Path 64757",
    d: "M-2672.733-1534.016c-.188.737,1,1.017.6,1.824-.707,1.125-1.9,1.861-2.47,3.1a.4.4,0,0,1-.592-.034c-.969-.819-1.075-1.581.064-2.379a6.286,6.286,0,0,0,1.825-2.565l.324-.024A.417.417,0,0,1-2672.733-1534.016Z",
    fill: "#3f4143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64758",
    "data-name": "Path 64758",
    d: "M-2707.35-1460.5a.647.647,0,0,1,.344-.641c.569,1.007,1.414,1.876,1.551,3.1C-2706.61-1458.458-2706.839-1459.588-2707.35-1460.5Z",
    fill: "#d74e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64759",
    "data-name": "Path 64759",
    d: "M-2707.335-1464.827l-.316-.308-.314-.012a31.732,31.732,0,0,1,3.088-3.871c.259-.265,1.057-.619.095-1.051-.294-.489.1-.617.412-.786,1.513-.209,1.831-1.735,2.79-2.559.482-.414.672-1.133,1.324-1.415a1.723,1.723,0,0,1,1.659.96.791.791,0,0,1-.007.436,56.728,56.728,0,0,1-4.837,6.259c-.244.171-.487.35-.808.183-.473.553-1.567.484-1.541,1.538A1.525,1.525,0,0,0-2707.335-1464.827Z",
    fill: "#f05a29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64760",
    "data-name": "Path 64760",
    d: "M-2714.44-1468.224c.1,0,.2-.007.3-.007.386.188.183.774.624.925.6.4.474,1.166.893,1.8.7-.757-.17-1.454.035-2.109.321-.2.781-.118,1.007-.508a.64.64,0,0,1,.355-.187c.513.151.491.727.874,1.087a2.8,2.8,0,0,1,1.093-2.189c1.28-.269,1.688.054,1.452,1.177a3.471,3.471,0,0,0-.282,1.175c-.085.523-.529.761-.861,1.083-.1.008-.229-.018-.286.07-.111.172-.049-.088.09.065a.428.428,0,0,1,.217.375l-.295.319a10.9,10.9,0,0,0-1.2.937c-.352.754-1.3,1.01-1.555,1.844a1.137,1.137,0,0,0-.632-1.008c-.556.136-.088.9-.864,1.119C-2713.254-1464.363-2714.545-1466.149-2714.44-1468.224Z",
    fill: "#f6ed35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64761",
    "data-name": "Path 64761",
    d: "M-2708.926-1465.465l-.277-.3a.188.188,0,0,1-.056-.2c.027-.063.052-.1.075-.1l.919-.933c-.17-1.1.858-1.472,1.328-2.181.3-.457.718-.829,1.045-1.269.155-.216.316-.428.491-.628a5.837,5.837,0,0,1,.408-.426,1.885,1.885,0,0,1,.81-.557.51.51,0,0,1,.362.158.912.912,0,0,1,.109.6.781.781,0,0,1-.521.615.871.871,0,0,0-.55.608Z",
    fill: "#fbe54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64762",
    "data-name": "Path 64762",
    d: "M-2710.424-1464.209c.219-.546.482-1.035,1.2-.937a2.074,2.074,0,0,1-.825.962Z",
    fill: "#fbe54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64763",
    "data-name": "Path 64763",
    d: "M-2704.583-1457.362l.024-.364c.806-.253,1.039.38,1.4.869a58.535,58.535,0,0,1,3.236,5.55c.391.664.881,1.259,1.244,1.938.309.5.84,1.01,0,1.516l-.077.062A80,80,0,0,1-2704.583-1457.362Z",
    fill: "#fce444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64764",
    "data-name": "Path 64764",
    d: "M-2693.432-1456.485l-.345,1.222q-.732,1.252-1.463,2.5a.393.393,0,0,1-.436.056c-.371-.274-.6-.729-.285-1.034.848-.829,1-2.081,1.871-2.877A.6.6,0,0,1-2693.432-1456.485Z",
    fill: "#fbe045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64765",
    "data-name": "Path 64765",
    d: "M-2698.672-1447.853c.405-.544.025-.88-.324-1.224.168-.476-.008-1.129.687-1.334a.79.79,0,0,1,.405.043,2.437,2.437,0,0,1,.824.6.514.514,0,0,1,.026.387,1.279,1.279,0,0,0-.371,1.249l-.111.287Z",
    fill: "#f9ea35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64766",
    "data-name": "Path 64766",
    d: "M-2697.147-1449.38l.01-.309a3.127,3.127,0,0,1,1.532-3.091l.365.02a15.637,15.637,0,0,1-1.858,3.767A.223.223,0,0,1-2697.147-1449.38Z",
    fill: "#fbd844"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64767",
    "data-name": "Path 64767",
    d: "M-2692.821-1453.711h-.936q.164-.771.329-1.542l.916-.631A3.962,3.962,0,0,1-2692.821-1453.711Z",
    fill: "#f95333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64768",
    "data-name": "Path 64768",
    d: "M-2697.147-1449.38c.016.129.032.257.049.386a.965.965,0,0,1-.327.866C-2698.057-1448.706-2697.674-1449.059-2697.147-1449.38Z",
    fill: "#fce444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64769",
    "data-name": "Path 64769",
    d: "M-2705.181-1463.9l-.407-.04,1.853-2.433c.029-.274.169-.4.452-.342a1.554,1.554,0,0,1,.415,1.445C-2703.743-1464.995-2704.129-1463.887-2705.181-1463.9Z",
    fill: "#fadc50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64770",
    "data-name": "Path 64770",
    d: "M-2703.439-1466.665l-.295.288c-.376-.034-.51-.27-.515-.614l.607-.322c.3-.1.4.082.454.321A.357.357,0,0,1-2703.439-1466.665Z",
    fill: "#cb4825"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64771",
    "data-name": "Path 64771",
    d: "M-2704.558-1458.035c-.029-.883-.933-1.18-1.255-1.877-.555-1.2-1.192-2.386.324-3.378.881-.077,1.48-1.232,2.275-.943.769.278.879,1.4,1.369,2.1.237.336.571.571.827.884.724.624.568,1.966,1.788,2.182.667.382,1.226-.3,1.866-.189a1,1,0,0,1,.154.408,1.433,1.433,0,0,1-.822,1.277c-1.117.386-2.25.94-2.886.059,1.294.769,2.8,1.959,2.651,4.125.683.4,1.046-.882,1.558-.116a1.544,1.544,0,0,1-.041,1.877c-.4.458-.51,1.264-1.321,1.317h0c-.084-.064-.153-.231-.184-.228-1.178.1-1.16.1-1.712-1.169-.775-1.776-1.394-3.624-2.976-4.951-.684-.573-1.235-1.367-.267-2.331a3.608,3.608,0,0,0,.717-1.5C-2703.607-1459.842-2703.065-1458.069-2704.558-1458.035Z",
    fill: "#f9ea35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64772",
    "data-name": "Path 64772",
    d: "M-2704.558-1458.035a2.186,2.186,0,0,0,.962-1.952,1.007,1.007,0,0,1,.794-1.012c.409-.117.669.238.845.536.372.631-.465.7-.494.829-.213.922-1.741,1.754-.142,2.876,2.115,1.484,2.491,4.039,3.543,6.266.571.143.229-.857.81-.8.3.274.114.651.167.982-.643.161-.48.924-.923,1.235-1.551-2.634-3.115-5.259-4.639-7.908a2.1,2.1,0,0,0-.924-.741C-2704.56-1457.829-2704.56-1457.932-2704.558-1458.035Z",
    fill: "#f2ee2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64773",
    "data-name": "Path 64773",
    d: "M-2701.163-1461.124c-1.314-.512-1.386-1.908-2.213-2.942-.582.343-1.085,1.4-2.113.776l.308-.614c.846-.244.947-1.78,2.222-1.28,1.182.351,1.238,1.533,1.758,2.375.063.572.486,1.059.409,1.667A.257.257,0,0,1-2701.163-1461.124Z",
    fill: "#eeed29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64774",
    "data-name": "Path 64774",
    d: "M-2685.738-1487.653l.878,1.231c1.653,1.4,1.959,3.4,2.192,5.354a9.042,9.042,0,0,1-.581,4.5c-1.264,2.917-2.231,5.972-4,8.656a.974.974,0,0,1-.322-.828c.265-1.761,1.7-3.087,1.82-4.9.233-.554.451-1.115.7-1.663a9.052,9.052,0,0,0,.889-6.36,4.661,4.661,0,0,1-.435-.765c.4-1.8-1.073-2.921-1.624-4.376-.194-.513-.591-.97-.1-1.513Z",
    fill: "#fae342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64775",
    "data-name": "Path 64775",
    d: "M-2683.249-1476.571a13.285,13.285,0,0,0-1.611-9.851l.387-.036c1.474.667,1.835,1.943,1.86,3.4l-.017,0c.174,1.229.046,2.483.311,3.7q-.306,1.391-.611,2.782Z",
    fill: "#da511b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64776",
    "data-name": "Path 64776",
    d: "M-2687.261-1468.852q.006.47.011.937l-.316.614h-.316C-2688.318-1468.076-2688.344-1468.686-2687.261-1468.852Z",
    fill: "#feed4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64777",
    "data-name": "Path 64777",
    d: "M-2687.261-1468.852c-.71.315-.615.953-.621,1.55a15.937,15.937,0,0,0-2.77,4.633c-1.007,0-.382.558-.318.925l-.914,1.245c-.445.182-.444.524-.327.909.027.124.053.249.08.374l-.02-.014c-.541.266-.785.045-.832-.512-.27.677.346,1.121.434,1.7.032.4-.195.579-.558.635-1.039.351-1.027-.537-1.226-1.092-.288-.808.147-1.6.16-2.406a3.286,3.286,0,0,0-.285-2.344c-.448-.7-.08-1.347.286-1.981a13.175,13.175,0,0,0,.94-1.554,2.24,2.24,0,0,1,.565-.958c.42-.258.927-.278.884-1.1-.055-1.065.65-2.013,1.083-2.985.218-.489.589-1.121,1.266-.769.723.375.593,1.007.169,1.589a.665.665,0,0,0,.36-.749c-.168-.82-.609-1.59-.031-2.465.183-.276-.368-.542-.591-.809a.98.98,0,0,1-.08-.654c.4-.646.242-1.731,1.39-1.8a.765.765,0,0,1,.191.715,11.656,11.656,0,0,0,1.693-4.036c.169-.539-.3-.55-.465-.811-.253-1.007.153-2,0-3.029a12.621,12.621,0,0,0-2.3-5.255c-.018-.075-.034-.151-.05-.226l.6-.633.361.353a12.1,12.1,0,0,0,1.326,1.454l.527.635a6.52,6.52,0,0,0,1.456,3.07,2.3,2.3,0,0,1,.4,2.807,4.374,4.374,0,0,1-.05,1.751c.475-.408.192-1.089.653-1.42.344,1.887.932,3.8-.4,5.554-.354.467.02,1.147-.506,1.541-.386-.241-.3-.731-.6-1.114a1.624,1.624,0,0,0-.026,2.65C-2685.535-1471.745-2686.712-1470.424-2687.261-1468.852Z",
    fill: "#f5eb33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64778",
    "data-name": "Path 64778",
    d: "M-2690.969-1461.744c-.934-.2-.572-.911-.548-1.466a.352.352,0,0,1,.442-.306c.5.091.371.519.423.847Q-2690.811-1462.207-2690.969-1461.744Z",
    fill: "#e8f22d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64779",
    "data-name": "Path 64779",
    d: "M-2692.211-1459.59a.763.763,0,0,1,.033-1.28c.193-.145.256.188.294.37Z",
    fill: "#ebf222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64780",
    "data-name": "Path 64780",
    d: "M-2682.613-1483.055a9.068,9.068,0,0,0-1.86-3.4c.052-.238.1-.475.157-.712.147.126.3.245.438.381.214.212.416.435.622.654a14.063,14.063,0,0,1,1.552,3.39C-2681.98-1482.926-2682.153-1483.412-2682.613-1483.055Z",
    fill: "#f8542d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64781",
    "data-name": "Path 64781",
    d: "M-2693.747-1461.124a10.828,10.828,0,0,0-.26,2.2c.043.571.033,1.356.9,1.517a1.255,1.255,0,0,1-.325.923l-.623,0c-.844.142-1.382-.025-1.075-1.056.157-.939-.382-1.926.191-2.834C-2694.663-1460.817-2694.545-1461.517-2693.747-1461.124Z",
    fill: "#f8ea3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64782",
    "data-name": "Path 64782",
    d: "M-2692.549-1458.043c-1.663-.562-.263-1.772-.826-2.828.823.528.239,1.6,1.224,1.641A1.168,1.168,0,0,1-2692.549-1458.043Z",
    fill: "#f8ea3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64783",
    "data-name": "Path 64783",
    d: "M-2682.319-1479.353a7.593,7.593,0,0,1-.311-3.7,9.151,9.151,0,0,1,.33,3.079C-2682.307-1479.77-2682.313-1479.562-2682.319-1479.353Z",
    fill: "#da4818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64784",
    "data-name": "Path 64784",
    d: "M-2725.255-1589.643c1.209.33,1.212-.519,1.223-1.294.01-.653.008-1.254.92-1.172a1.177,1.177,0,0,1,.408,1.1,8.732,8.732,0,0,0,1.011,4.707c-.053,1.219-1.155.619-1.706.978Q-2724.328-1587.482-2725.255-1589.643Z",
    fill: "#3c4349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64785",
    "data-name": "Path 64785",
    d: "M-2725.6-1594.562l.036.6c.409,1.135,1.353,2.271-.007,3.4a9.715,9.715,0,0,0-1.227-2.787c-.026-.5.133-1.1-.615-1.246q-.011-.143-.015-.285a2.641,2.641,0,0,1,.317-2.487,3.041,3.041,0,0,1,.628,1.857C-2726.065-1595.308-2726.043-1594.738-2725.6-1594.562Z",
    fill: "#45404c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64786",
    "data-name": "Path 64786",
    d: "M-2727.109-1597.368a6.54,6.54,0,0,1-.317,2.487c-.777-.388-.224-1.635-1.217-1.883a4.158,4.158,0,0,0-.4-1.928c-.276-.738-.044-1.068.705-1.115.332.491.323,1.19.924,1.517C-2727.063-1598.067-2727.123-1597.7-2727.109-1597.368Z",
    fill: "#3e4640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64787",
    "data-name": "Path 64787",
    d: "M-2723.4-1585.32c.262-.836.914-.683,1.536-.605a.29.29,0,0,1,.385-.006.486.486,0,0,1-.059.6c-.586.052-.921.723-1.564.634A.646.646,0,0,1-2723.4-1585.32Z",
    fill: "#32443f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64788",
    "data-name": "Path 64788",
    d: "M-2727.411-1594.6c.23-.03.357-.55.575-.266.341.443.6,1,.04,1.512C-2727.225-1593.655-2727.141-1594.213-2727.411-1594.6Z",
    fill: "#3e4640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64789",
    "data-name": "Path 64789",
    d: "M-2727.308-1592.14l-.406-.9-.035-.61C-2727.31-1593.231-2726.9-1592.805-2727.308-1592.14Z",
    fill: "#424225"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64790",
    "data-name": "Path 64790",
    d: "M-2727.744-1593.639a2.645,2.645,0,0,1-.656-1.542A1.521,1.521,0,0,1-2727.744-1593.639Z",
    fill: "#424225"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64791",
    "data-name": "Path 64791",
    d: "M-2727.418-1598.29c-1.249.068-.856-.865-.924-1.517A1.805,1.805,0,0,1-2727.418-1598.29Z",
    fill: "#3e3f59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64792",
    "data-name": "Path 64792",
    d: "M-2725.6-1594.562c-.97.311-.5-.715-.883-.949l.588.011Q-2725.746-1595.031-2725.6-1594.562Z",
    fill: "#3d453a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64793",
    "data-name": "Path 64793",
    d: "M-2714.763-1563.373l.944-1.254c.319-.056.469.152.606.383a44.851,44.851,0,0,1,1.875,12.71c-.231.609-.215,1.27-.391,1.9s.434-.185.438.2a11.8,11.8,0,0,1,.679,4.34c.025,1.37-.215,2.766.344,4.092a4.919,4.919,0,0,1-.323,2.3.858.858,0,0,1-.429.27c-1.05.053-1.833-.207-1.722-1.493a.577.577,0,0,1,.18-.4c1.416-.577-.7-.373-.171-.756-.151-3.354-.447-6.694-.737-10.035a10.559,10.559,0,0,1,.256-4.235c.134-.455.613-.8.457-1.369-.621-.1-.357.66-.76.748-.271-1.962-.126-3.99-.932-5.867C-2714.947-1562.267-2714.679-1562.856-2714.763-1563.373Z",
    fill: "#3e4244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64794",
    "data-name": "Path 64794",
    d: "M-2714.449-1561.835c1.344,1.791.816,3.88.932,5.867-.855-.782.193-1.987-.618-2.779Q-2714.291-1560.292-2714.449-1561.835Z",
    fill: "#394352"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64795",
    "data-name": "Path 64795",
    d: "M-2717.223-1570.172v-1.843a3.887,3.887,0,0,1,.609,2.763Z",
    fill: "#3d3a29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64796",
    "data-name": "Path 64796",
    d: "M-2712.278-1540.224l-.31.013c-.075.136-.164.153-.27.033-.21-1.029.269-2.133-.342-3.119q-.159-2.789-.318-5.578c-.309-.457-.066-.98-.171-1.461q-.1-1.677-.2-3.353a3.92,3.92,0,0,1,.672-1.658c-.012,4.628.763,9.219.642,13.853-.006.22.189.445.291.668A.416.416,0,0,1-2712.278-1540.224Z",
    fill: "#3b352a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64797",
    "data-name": "Path 64797",
    d: "M-2714.422-1557.5c.517.571.208,1.256.258,1.891A3.516,3.516,0,0,1-2714.422-1557.5Z",
    fill: "#3e4244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64798",
    "data-name": "Path 64798",
    d: "M-2713.689-1550.336c.307.458.125.973.171,1.462A1.873,1.873,0,0,1-2713.689-1550.336Z",
    fill: "#3e4244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64799",
    "data-name": "Path 64799",
    d: "M-2690.646-1559.671c1.256-1.115.039,1.3,1.178.371.079-.311.243-.962.414-1.612.008-.03.085-.062.127-.06s.09.046.134.072q-.009,1.074-.018,2.147a45.22,45.22,0,0,0-.77,5.058,7.822,7.822,0,0,1-.151,2.37c-.881,1.559-.558,3.268-.617,4.929a.294.294,0,0,1-.389.01c-.463-.8-.053-1.987-1.138-2.505a21.125,21.125,0,0,1-.057-4.688c.556-1.56.458-3.235.837-4.829C-2690.991-1558.85-2691.055-1559.341-2690.646-1559.671Z",
    fill: "#3c4248"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64800",
    "data-name": "Path 64800",
    d: "M-2691.577-1548.55c.449-.254,1-.827.926.352-.039.6-.007,1.206-.007,1.809a16.749,16.749,0,0,1,0,4.947v1.232c-.1.635.366,1.607-.92,1.523-.177-3.012-.479-6.017-.479-9.039A.954.954,0,0,1-2691.577-1548.55Z",
    fill: "#3e4340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64801",
    "data-name": "Path 64801",
    d: "M-2689.765-1540.855c.095.985-.207,2.31,1.581,1.847,3.017-.255,6.039-.068,9.059-.1a.325.325,0,0,1,.263.437,1.152,1.152,0,0,1-.5.326,79.561,79.561,0,0,1-9.814-.026,1.262,1.262,0,0,1-.839-.324l.03-.046A3.483,3.483,0,0,1-2689.765-1540.855Z",
    fill: "#957d3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64802",
    "data-name": "Path 64802",
    d: "M-2689.729-1553.806c.424-1.627-.158-3.441.918-4.947.2,1.162-.3,2.262-.3,3.406q-.156.773-.31,1.545C-2689.527-1553.659-2689.629-1553.667-2689.729-1553.806Z",
    fill: "#393738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64803",
    "data-name": "Path 64803",
    d: "M-2690.658-1541.442v-4.947l.309-.007C-2690.5-1544.747-2690.013-1543.06-2690.658-1541.442Z",
    fill: "#363957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64804",
    "data-name": "Path 64804",
    d: "M-2689.729-1553.806c.1,0,.2,0,.306,0-.129.823.273,1.711-.309,2.477Z",
    fill: "#1f1e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64805",
    "data-name": "Path 64805",
    d: "M-2688.186-1562.768c.164-.605-.358-1.329.322-1.844C-2687.98-1564-2687.621-1563.3-2688.186-1562.768Z",
    fill: "#39385f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64806",
    "data-name": "Path 64806",
    d: "M-2678.912-1538.949l-9.272-.059,0-.274,10.2.005c0,.093,0,.185,0,.278A.649.649,0,0,1-2678.912-1538.949Z",
    fill: "#e1c03d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64807",
    "data-name": "Path 64807",
    d: "M-2721.578-1585.911l-.285-.014c-1.366-1.869-1.312-4.026-1.249-6.184.006-.1.011-.206.016-.31a5.943,5.943,0,0,1,1.682-3.934,3.394,3.394,0,0,1,3.564-1.021l.02.015c1.048.153,2.056.37,2.451,1.553.874.22,1.045,1.078,1.348,1.7,1.659,3.371,1.144,7.957-2.493,10.087a3.292,3.292,0,0,1-4.72-1.29.76.76,0,0,1,.62-.235c3.564,1.438,6.036-.093,6.366-4.024a6.273,6.273,0,0,0-2.166-5.647,2.373,2.373,0,0,0-2.251-.657,2.439,2.439,0,0,0-.959.45,6.489,6.489,0,0,0-1.989,7.561,5.073,5.073,0,0,1,.334,1.327A.785.785,0,0,1-2721.578-1585.911Z",
    fill: "#342e2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64808",
    "data-name": "Path 64808",
    d: "M-2717.85-1597.374c-1.229-.04-2.064,1.173-3.321,1.047a4.8,4.8,0,0,1-.909,1.894c-.374.652-.68,1.341-1.016,2.014l-.62-1.232c.478-1.958,2.077-3.032,3.405-4.319C-2719.506-1597.707-2718.418-1598.612-2717.85-1597.374Z",
    fill: "#3c4349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64809",
    "data-name": "Path 64809",
    d: "M-2678.912-1538.949l.921-.05,2.734.122a.549.549,0,0,1,.048.219c-.069.063-.139.127-.207.191-1.184.235-2.376.574-3.481-.256C-2678.905-1538.8-2678.91-1538.873-2678.912-1538.949Z",
    fill: "#a68e5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64810",
    "data-name": "Path 64810",
    d: "M-2684.176-1581.93c1.3.489-.081,1.042.036,1.559.46.9-.312,1.567-.574,2.26-.487,1.29-.655,2.788-1.844,3.746-1-.263-.712-1-.509-1.6a24.1,24.1,0,0,1,1.5-3.7c.439-.82.354-1.15-.634-1.3-.81-.125-1.909-.068-1.919-1.39a1.5,1.5,0,0,1,.946-.233C-2686.2-1582.269-2685.093-1582.519-2684.176-1581.93Z",
    fill: "#e0be3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64811",
    "data-name": "Path 64811",
    d: "M-2686.6-1574.486a59.976,59.976,0,0,0,2.462-5.885c.557.071.683.441.5.88-.641,1.575-1.343,3.126-1.975,4.7-.414,1.032-.488,2.208-1.318,3.061l-.03.62a.89.89,0,0,1-.882.1c-.43-1.006.319-1.735.6-2.576A1.885,1.885,0,0,1-2686.6-1574.486Z",
    fill: "#39342f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64812",
    "data-name": "Path 64812",
    d: "M-2680.463-1588.093c-.161,2.376-1.084,3.55-3.4,4.323a.562.562,0,0,1-.162-.587c.362-.818,1.3-1.048,1.775-1.756a13.121,13.121,0,0,0,.923-1.625,1.168,1.168,0,0,1,.464-.426A.455.455,0,0,1-2680.463-1588.093Z",
    fill: "#393327"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64813",
    "data-name": "Path 64813",
    d: "M-2684.176-1581.93a5.893,5.893,0,0,1-3.081-.3c-.414-.251-1-.24-1.211-.8-.111-.27-.223-.541-.007-.814.636-.258,1.027.334,1.558.443a16.389,16.389,0,0,1,1.808.569,1.626,1.626,0,0,1,.317.286C-2684.4-1582.524-2684.175-1582.342-2684.176-1581.93Z",
    fill: "#37342f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64814",
    "data-name": "Path 64814",
    d: "M-2680.463-1588.093l-.305-.005a3.828,3.828,0,0,1,.246-3.325c.183-.271-.232-1.13.676-.689C-2679.947-1590.756-2679.516-1589.319-2680.463-1588.093Z",
    fill: "#3e342f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64815",
    "data-name": "Path 64815",
    d: "M-2680.771-1582.537a1.493,1.493,0,0,0-.929,1.235l-.856,1.313a3.324,3.324,0,0,1,.237-2.235c.149-.881.509-1.553,1.545-1.552Z",
    fill: "#424235"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64816",
    "data-name": "Path 64816",
    d: "M-2680.774-1583.776c-.7.329-1.022,1.043-1.545,1.552-.733-.85.223-1.224.556-1.722C-2681.67-1584.086-2680.963-1584.644-2680.774-1583.776Z",
    fill: "#4b3a4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64817",
    "data-name": "Path 64817",
    d: "M-2683.859-1584.379v.609l-.31.3a2.518,2.518,0,0,1-1.079.431c-.5-.064-1.086.311-1.49-.279.068-.344.345-.484.613-.633a10.444,10.444,0,0,0,1.013-.457C-2684.691-1584.6-2684.267-1584.786-2683.859-1584.379Z",
    fill: "#37342f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64818",
    "data-name": "Path 64818",
    d: "M-2685.4-1583.458l1.234-.012-.622.924q-.149,0-.3-.006C-2685.433-1582.771-2685.746-1583-2685.4-1583.458Z",
    fill: "#37426f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64819",
    "data-name": "Path 64819",
    d: "M-2679.533-1587.182c-.032.4.077.842-.441,1.054C-2680.335-1586.695-2679.914-1586.923-2679.533-1587.182Z",
    fill: "#3d4342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64820",
    "data-name": "Path 64820",
    d: "M-2690.646-1559.671a19.5,19.5,0,0,1-.939,5.869.3.3,0,0,1-.428-.048,2.541,2.541,0,0,1-.238-1.641,2.679,2.679,0,0,1,.083-.453,10.229,10.229,0,0,0,.269-2.184,3.2,3.2,0,0,1,.1-.431c.144-.423.19-.869.3-1.3.153-1,.384-1.995.469-3.01.333-.587-.046-1.614,1.059-1.724a2.232,2.232,0,0,1-.065,1.52C-2690.067-1561.91-2690.745-1560.86-2690.646-1559.671Z",
    fill: "#41372f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64821",
    "data-name": "Path 64821",
    d: "M-2690.038-1563.075l-.032-1.6a1.13,1.13,0,0,1-.128-1.159c.446-1.576,1.077-3.087,1.663-4.614a.877.877,0,0,1,.766-.657l.811,0c-1.111,1.3-1.242,3-1.85,4.509C-2689.273-1565.445-2689.632-1564.25-2690.038-1563.075Z",
    fill: "#39312d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64822",
    "data-name": "Path 64822",
    d: "M-2689.425-1592.728c-.308-.942-.9-1.94.5-2.561.012,0-.128-.348-.2-.533,1.405-2.229,3.588-2.348,5.881-2.169a3.691,3.691,0,0,1,2.47,2.172.57.57,0,0,0-.622.621c-.665.128-.988-.445-1.439-.73a3.426,3.426,0,0,0-4.014-.042,3.3,3.3,0,0,0-1.716,3.333,2.279,2.279,0,0,1-.025.69c-.244.678.08,1.513-.578,2.075a.433.433,0,0,1-.445-.216C-2690.1-1591.007-2689.517-1591.85-2689.425-1592.728Z",
    fill: "#3a424b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64823",
    "data-name": "Path 64823",
    d: "M-2680.522-1591.423q-.125,1.664-.246,3.325l-.318.319c-.3.256-.374.916-1.012.564a.825.825,0,0,1-.036-.65c.878-1.426.233-2.922.193-4.389a3.306,3.306,0,0,0-.939-2.028c-.3-.341-.671-.65-.467-1.189a.641.641,0,0,1,.378-.215,1.279,1.279,0,0,1,1.222,1.138l.373.549a1.413,1.413,0,0,1,.555,1.3A2.2,2.2,0,0,0-2680.522-1591.423Z",
    fill: "#ddbd3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64824",
    "data-name": "Path 64824",
    d: "M-2681.747-1594.548l-1.139-.986a7.33,7.33,0,0,0-3.246-.451c-.236-.273-.575-.005-.835-.155.954-1.1,2.167-.976,3.36-.611a5.275,5.275,0,0,1,2.215,1.553A.618.618,0,0,1-2681.747-1594.548Z",
    fill: "#3e312a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64825",
    "data-name": "Path 64825",
    d: "M-2680.819-1592.7a2.69,2.69,0,0,1-.555-1.3C-2680.319-1593.8-2680.276-1593.695-2680.819-1592.7Z",
    fill: "#3e342f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64826",
    "data-name": "Path 64826",
    d: "M-2690.985-1596.027l-.6.207c-.35-.268-.754-.481-.925-.926-.372-.452-1.023-.623-1.236-1.234-.092-.037-.13-.085-.113-.144s.039-.1.064-.1l.07-.118A5.221,5.221,0,0,1-2690.985-1596.027Z",
    fill: "#3d2b2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64827",
    "data-name": "Path 64827",
    d: "M-2692.2-1593.968c.77-.446.52.522.885.638.516.58.362,1.392.7,2.033a7.339,7.339,0,0,1,.037,1.2c-.161.645.136,1.476-.733,1.841a.573.573,0,0,1-.425-.2,1.612,1.612,0,0,1-.235-.695c.137-1.5-.5-2.911-.506-4.4A.831.831,0,0,1-2692.2-1593.968Z",
    fill: "#3a332a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64828",
    "data-name": "Path 64828",
    d: "M-2698.056-1596.421l.912-.632c1.538,0,3.2-.323,4.016,1.554a1.865,1.865,0,0,1-1.173.094c-.934-.724-2.021-.509-3.074-.5A1.255,1.255,0,0,1-2698.056-1596.421Z",
    fill: "#343031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64829",
    "data-name": "Path 64829",
    d: "M-2690.953-1591.183a6.622,6.622,0,0,1-.361-2.147c.624-.3.612.077.683.546s-.1,1.283.88.985c.335.556.116,1.159.146,1.74C-2690.988-1589.312-2690.437-1590.888-2690.953-1591.183Z",
    fill: "#3d4050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64830",
    "data-name": "Path 64830",
    d: "M-2694.044-1595.641c.361-.316.618.049.916.142.431.437.928.833.929,1.531l-.039.374c-.831.3-1-.519-1.458-.854C-2693.9-1594.82-2694.49-1595.081-2694.044-1595.641Z",
    fill: "#423620"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64831",
    "data-name": "Path 64831",
    d: "M-2689.758-1589.952q0-.924.007-1.847c.035-.336-.029-.706.326-.929q0,1.389-.01,2.777c.388.624.615,1.218-.31,1.585A1.165,1.165,0,0,1-2689.758-1589.952Z",
    fill: "#1f2327"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64832",
    "data-name": "Path 64832",
    d: "M-2698.059-1597.963a.827.827,0,0,1,.035-.271,5.907,5.907,0,0,1,1.131-.152c.453.024.235.249.058.421Z",
    fill: "#212023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64833",
    "data-name": "Path 64833",
    d: "M-2692.51-1596.746a2,2,0,0,1,.925.926C-2692.1-1595.923-2692.642-1596-2692.51-1596.746Z",
    fill: "#454462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64834",
    "data-name": "Path 64834",
    d: "M-2693.795-1598.22a.939.939,0,0,1,.049.24h-1.3C-2694.6-1598.489-2694.18-1598.219-2693.795-1598.22Z",
    fill: "#22212a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64835",
    "data-name": "Path 64835",
    d: "M-2712.281-1585.025c.029-.341-.075-.761.423-.851.225-.04.323.124.413.337a4.626,4.626,0,0,0,6.918,2.363c.483-.277.9-.683,1.521-.6.031.076.062.152.094.228a1.011,1.011,0,0,1-.159.461c-1.8,1.982-4,1.841-6.3,1.212a11.153,11.153,0,0,1-1.17-.7,4.027,4.027,0,0,1-1.876-2.053A.46.46,0,0,1-2712.281-1585.025Z",
    fill: "#3c3427"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64836",
    "data-name": "Path 64836",
    d: "M-2712.281-1585.025l.006.328a1.061,1.061,0,0,1,.13.824c-1.188.824-2.079,2.041-3.451,2.628a4.827,4.827,0,0,1-1.232.361c-.769.093-.875.52-.637,1.179.258.718.636,1.38.923,2.083a1.487,1.487,0,0,1-.007,1.585c-1.228-.042-.865-1.423-1.591-1.889-.278-.357-.63-.694-.341-1.21l-.649-1.855c.041-.047.083-.094.122-.143.248-.2.379-.518.67-.677.495-.232,1.075-.1,1.559-.377a6.525,6.525,0,0,0,2.42-1.411c.421-.319.673-.842,1.218-1.012C-2712.908-1584.861-2712.674-1585.109-2712.281-1585.025Z",
    fill: "#e3bf37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64837",
    "data-name": "Path 64837",
    d: "M-2713.515-1564.308l-.3-.319a10.139,10.139,0,0,0-1.523-4.641.727.727,0,0,1-.35-.9l-.005-.931c.483-.15.7.233.985.486.846,2.022,1.99,3.947,2.073,6.225C-2712.884-1563.877-2713.172-1563.8-2713.515-1564.308Z",
    fill: "#343325"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64838",
    "data-name": "Path 64838",
    d: "M-2705.471-1584.062c-1.78,1.1-4.5,0-5.552-2.249-.128-.272-.225-.56-.335-.84a.574.574,0,0,1,.367-.182,1.174,1.174,0,0,1,.742.368c.326.346.55.772.879,1.116a4.749,4.749,0,0,0,.711.663,2.337,2.337,0,0,0,1.462.423,3.532,3.532,0,0,1,1.052.148A1.144,1.144,0,0,1-2705.471-1584.062Z",
    fill: "#3e3533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64839",
    "data-name": "Path 64839",
    d: "M-2712.9-1594.577c.206-.035.409-.344.62-.007.4.366,1.02-.067,1.391.4a1.471,1.471,0,0,1,.176.884,2.034,2.034,0,0,1-.455,1.048c-.745,1.156-.343,2.408-.3,3.63a1.614,1.614,0,0,1,.017.455.75.75,0,0,1-.23.386c-.655-.09-.639-.593-.592-1.05.129-1.259-.467-2.507-.02-3.773C-2712.018-1593.39-2713.06-1593.806-2712.9-1594.577Z",
    fill: "#3b414a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64840",
    "data-name": "Path 64840",
    d: "M-2714.134-1583.514a5.38,5.38,0,0,1-2.533,1.592c-.613.331-1.278.065-1.911.169a.592.592,0,0,1-.5-.471.864.864,0,0,1,.822-.312,4.727,4.727,0,0,0,4.112-1.862A.608.608,0,0,1-2714.134-1583.514Z",
    fill: "#3b322d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64841",
    "data-name": "Path 64841",
    d: "M-2705.471-1584.062a.7.7,0,0,1-.632-.316,22.776,22.776,0,0,0,2.65-3.264.781.781,0,0,1,.628-.218c.826,1.2-.035,1.855-.815,2.537Z",
    fill: "#3f3625"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64842",
    "data-name": "Path 64842",
    d: "M-2703.64-1585.323c.147-.836,1.355-1.405.621-2.464a.907.907,0,0,1-.23-.979.771.771,0,0,1,.251-.335.522.522,0,0,1,.4.077,8.309,8.309,0,0,1,.558.9c.371.716.177,1.545.457,2.282a.74.74,0,0,1-.194.62.5.5,0,0,1-.624-.088C-2702.811-1585.617-2703.227-1585.318-2703.64-1585.323Z",
    fill: "#3d424a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64843",
    "data-name": "Path 64843",
    d: "M-2715.976-1598.278l.306-.06c.409.321.972.446,1.23.962-.013.313.226.628,0,.94l-.925.309c-.476-.645-1.623-.728-1.545-1.839C-2716.572-1597.982-2716.205-1597.922-2715.976-1598.278Z",
    fill: "#3b414a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64844",
    "data-name": "Path 64844",
    d: "M-2718.481-1579.136l.479.973c.618.552.6,1.366.855,2.07a.257.257,0,0,1-.4.05C-2718.882-1576.764-2718.909-1577.881-2718.481-1579.136Z",
    fill: "#343526"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64845",
    "data-name": "Path 64845",
    d: "M-2717.545-1576.043l.28,0c.84.335.939,1.151,1.212,1.857a2.4,2.4,0,0,1,.1.7c-.08.377-.032.855-.637.828C-2716.571-1573.88-2717.743-1574.769-2717.545-1576.043Z",
    fill: "#352b22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64846",
    "data-name": "Path 64846",
    d: "M-2716.914-1597.966c.287.8,1.355.953,1.545,1.839l-.01.321a11.2,11.2,0,0,0-2.451-1.553C-2717.285-1597.2-2717.482-1598.161-2716.914-1597.966Z",
    fill: "#3c4349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64847",
    "data-name": "Path 64847",
    d: "M-2716.594-1572.655c.35-.212.279-.56.286-.882.48-.291.528.2.739.4a2.36,2.36,0,0,1,.171.367c.143.526.427,1,.572,1.524a.737.737,0,0,1-.26.76l-.611-.62Z",
    fill: "#3e332c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64848",
    "data-name": "Path 64848",
    d: "M-2714.444-1596.436c-.079-.314-.515-.629,0-.94.432.3.89.571.969,1.162a.275.275,0,0,1-.046.409Z",
    fill: "#312915"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64849",
    "data-name": "Path 64849",
    d: "M-2702.4-1585.315l.627,0c.284-.1.363.069.392.3a2.767,2.767,0,0,1-1.215,1.384.5.5,0,0,1-.383-.122l-.027-.034A4.114,4.114,0,0,1-2702.4-1585.315Z",
    fill: "#3b2b19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64850",
    "data-name": "Path 64850",
    d: "M-2718.764-1581.942l2.1.02c-.51.576-1.219.2-1.811.378a2.64,2.64,0,0,0-.495.576l-.081,0-.077-.026-.108,0-.108,0a.628.628,0,0,1-.248-.422C-2719.545-1581.947-2719.315-1582.2-2718.764-1581.942Z",
    fill: "#aa9a5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64851",
    "data-name": "Path 64851",
    d: "M-2715.692-1570.171q.174.452.35.9c-.063.274.062.692-.307.757-.333.059-.328-.306-.332-.545C-2715.986-1569.45-2716.081-1569.876-2715.692-1570.171Z",
    fill: "#3d3e67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64852",
    "data-name": "Path 64852",
    d: "M-2714.134-1583.514c0-.295-.007-.589-.011-.884.27-.379.515-.868,1-.213A1.927,1.927,0,0,1-2714.134-1583.514Z",
    fill: "#3e3b15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64853",
    "data-name": "Path 64853",
    d: "M-2719.438-1581.288c.03.1.061.2.091.3-.247-.038-.437.666-.63.157-.158-.415-.884-1.176.3-1.384C-2719.4-1581.959-2719.656-1581.563-2719.438-1581.288Z",
    fill: "#37381b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64854",
    "data-name": "Path 64854",
    d: "M-2713.517-1595.805l.046-.409.612.606q-.031.359-.062.717C-2713.8-1594.755-2713.611-1595.31-2713.517-1595.805Z",
    fill: "#3b414a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64855",
    "data-name": "Path 64855",
    d: "M-2721.578-1585.911l.02-.617c.826.009,1.007.5.907,1.208l-.593.006q-.147,0-.293-.015Q-2721.558-1585.62-2721.578-1585.911Z",
    fill: "#3d2f18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64856",
    "data-name": "Path 64856",
    d: "M-2711.682-1587.785l.016-.317a.548.548,0,0,1,.691-.024.77.77,0,0,1,.012.941l-.4.034A.722.722,0,0,1-2711.682-1587.785Z",
    fill: "#282623"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64857",
    "data-name": "Path 64857",
    d: "M-2719.438-1581.288c-.326-.247-.266-.593-.24-.931l.6-.005.315.282A.636.636,0,0,0-2719.438-1581.288Z",
    fill: "#645a36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64858",
    "data-name": "Path 64858",
    d: "M-2711.067-1594.275c-.48.191-1.037.687-1.215-.309a6.242,6.242,0,0,1,1.533-2.166,1.04,1.04,0,0,0,.935-.621l.609-.616c2.746-.487,5.156-.051,6.806,2.475-.668-.57-1.512.275-2.183-.272a.539.539,0,0,1-.6.076,1.423,1.423,0,0,1-.308-.292c-1.008-1.15-2.115-.6-3.212-.183C-2709.759-1595.883-2710.055-1594.633-2711.067-1594.275Z",
    fill: "#3c4349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64859",
    "data-name": "Path 64859",
    d: "M-2709.814-1597.371c.107.837-.086,1.223-.935.621A1.012,1.012,0,0,1-2709.814-1597.371Z",
    fill: "#35455d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64860",
    "data-name": "Path 64860",
    d: "M-2689.758-1589.952l.023,1.551a8.808,8.808,0,0,1,1.374,2.394,2.461,2.461,0,0,1-.616,1.292c-.351.248-.742-.1-1.1.077a5.55,5.55,0,0,1-.976.278,5.494,5.494,0,0,0-1.516,1.011,5.7,5.7,0,0,1-5.922.681c-.586-.253-1.265-.531-1.13-1.408.517-.616-.236-1.236.007-1.853,1.107.154,1.427,1.578,2.609,1.609a4.307,4.307,0,0,0,4.974-2.981c.127-.38.089-.822.457-1.1.1,0,.2.006.3.008.55.479.287,1.258.783,1.92-.457-1.212-.206-2.365-.459-3.466v-1.244C-2690.262-1591.056-2690.557-1589.973-2689.758-1589.952Z",
    fill: "#3a4347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64861",
    "data-name": "Path 64861",
    d: "M-2699.621-1584.076a5.069,5.069,0,0,0,6.918.382c.5-.41.772-1.391,1.757-.973.069,1.148-.923,1.531-1.56,2.173-2.36,1.763-6.115,1.218-8.227-1.1a2.361,2.361,0,0,1-.746-1.475l-.294-.246,0-.618c.973-.449,1.145.406,1.519.932Z",
    fill: "#38302a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64862",
    "data-name": "Path 64862",
    d: "M-2700.248-1587.153a8.223,8.223,0,0,1,.144-6.858,3.9,3.9,0,0,0,.192-.877c.239-.561.512-1.079,1.256-1.017a.644.644,0,0,1,.376.518c-.311.919-.829,1.751-1.146,2.67-.616,1.413-.315,2.906-.391,4.366A1.475,1.475,0,0,1-2700.248-1587.153Z",
    fill: "#3d3230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64863",
    "data-name": "Path 64863",
    d: "M-2700.251-1585c-.546-.244-.808-.954-1.519-.932-.964-.5.113-1.591-.621-2.159.169-.173.053-.483.3-.62l.721-.908A12.848,12.848,0,0,0-2700.251-1585Z",
    fill: "#3c443d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64864",
    "data-name": "Path 64864",
    d: "M-2700.248-1587.153l.066-1.342a.461.461,0,0,1,.389.123,15.733,15.733,0,0,0,2.094,3.354,5.214,5.214,0,0,1,.593.558.391.391,0,0,1-.038.38c-1.33.06-1.712-1.145-2.47-1.849C-2699.8-1586.35-2700.26-1586.629-2700.248-1587.153Z",
    fill: "#413328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64865",
    "data-name": "Path 64865",
    d: "M-2703.207-1592.428a.955.955,0,0,0,.171.986,2.237,2.237,0,0,1,.049,2.446v-.009c-.372.234.011.8-.442,1a.433.433,0,0,1-.4-.226,4.7,4.7,0,0,1-.231-1.926c-.008-.393.011-.786.006-1.18.063-.532-.206-1.061-.025-1.6a.392.392,0,0,1,.381-.209A.722.722,0,0,1-2703.207-1592.428Z",
    fill: "#f4c635"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64866",
    "data-name": "Path 64866",
    d: "M-2702.094-1588.709a.654.654,0,0,1-.3.62l-.339-1a5.069,5.069,0,0,1-.014-2.366c.1-.167.187-.468.3-.475.338-.024.406.306.34.532A9.387,9.387,0,0,0-2702.094-1588.709Z",
    fill: "#3a331e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64867",
    "data-name": "Path 64867",
    d: "M-2698.674-1595.813l-1.238.925c-.134-1.208.316-1.692,1.527-1.23C-2698.315-1595.859-2698.362-1595.71-2698.674-1595.813Z",
    fill: "#3e4430"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64868",
    "data-name": "Path 64868",
    d: "M-2701.49-1593.384a1.431,1.431,0,0,1-.081,1.853A1.949,1.949,0,0,1-2701.49-1593.384Z",
    fill: "#37492f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64869",
    "data-name": "Path 64869",
    d: "M-2702.744-1591.455q.007,1.183.014,2.367a.577.577,0,0,1-.258.092q-.024-1.223-.048-2.446A.408.408,0,0,1-2702.744-1591.455Z",
    fill: "#c1a13a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64870",
    "data-name": "Path 64870",
    d: "M-2703.207-1592.428l-.421-.61a.659.659,0,0,1-.065-.9c.649.157.664.7.736,1.208Z",
    fill: "#5b4f30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64871",
    "data-name": "Path 64871",
    d: "M-2698.674-1595.813l.289-.305.329-.3a.606.606,0,0,1,.616.324c-.023.623-.4.7-.905.594Z",
    fill: "#352813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64872",
    "data-name": "Path 64872",
    d: "M-2703.693-1593.939l.065.9-.313-.009c-.558-.156-.779-.724-1.233-1.009a1.924,1.924,0,0,1-.279-.308c-.422-.924-1.267-.753-2.033-.786a1.171,1.171,0,0,1-.845-.367.793.793,0,0,1,.467-.828,2.293,2.293,0,0,1,2.673.542l-.011.017a1.779,1.779,0,0,1,.925.929Z",
    fill: "#e3bd3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64873",
    "data-name": "Path 64873",
    d: "M-2704.277-1594.857l-.925-.929.62,0Q-2704.429-1595.32-2704.277-1594.857Z",
    fill: "#5b4f30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64874",
    "data-name": "Path 64874",
    d: "M-2675.816-1526.311c.376.313.381.621-.009.926-1.441-.291-2.857.147-4.292.145-13.536-.02-27.072.021-40.608-.054a16.523,16.523,0,0,1-5.153-.389l-.331-.289,3.42-.033a2.657,2.657,0,0,1,1.788-.3q20.457-.011,40.915,0a2.673,2.673,0,0,1,1.788.3C-2677.474-1526.135-2676.58-1525.691-2675.816-1526.311Z",
    fill: "#333436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64875",
    "data-name": "Path 64875",
    d: "M-2722.786-1526.307l-.871-.044-.014-.267h1.08q21.346,0,42.692.01c.54,0,1.143-.2,1.6.3a2.423,2.423,0,0,1-1.356.145q-20.886.009-41.772,0A2.454,2.454,0,0,1-2722.786-1526.307Z",
    fill: "#171719"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64876",
    "data-name": "Path 64876",
    d: "M-2722.786-1526.307l44.485,0,0,.3-44.491,0C-2722.788-1526.106-2722.787-1526.206-2722.786-1526.307Z",
    fill: "#252628"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64877",
    "data-name": "Path 64877",
    d: "M-2678-1528.767c0,.1.008.2.013.3-.142.851-.662.22-1,.232-.171.007-.409-.239-.274-.384s.44-.115.671-.163Z",
    fill: "#1c1b1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64878",
    "data-name": "Path 64878",
    d: "M-2721.554-1521.363a16.046,16.046,0,0,1,4.04-.29q20.541-.053,41.081-.019c.347,0,.693.044,1.349.087a3.554,3.554,0,0,1-2.378.524q-20.385.008-40.772.014c-.591,0-1.245-.228-1.765.28l-.328-.014c-.36-.309-.9.174-1.227-.277C-2721.552-1521.16-2721.552-1521.261-2721.554-1521.363Z",
    fill: "#434748"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64879",
    "data-name": "Path 64879",
    d: "M-2721.554-1521.058c.421.043.891-.136,1.228.277-.765.276-1.529.55-2.155-.271Z",
    fill: "#404143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64880",
    "data-name": "Path 64880",
    d: "M-2673.947-1520.707a.489.489,0,0,1,.24.024v2.366l-.24.005Z",
    fill: "#040204"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64881",
    "data-name": "Path 64881",
    d: "M-2725.878-1525.683q24.3,0,48.6,0c.494,0,1.043-.159,1.45.3-.774.515-1.684-.05-2.476.313a2.612,2.612,0,0,1-1.786.3q-20.457.011-40.915,0a2.6,2.6,0,0,1-1.785-.3c-.825-.4-1.649.234-2.474,0Z",
    fill: "#48494b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64882",
    "data-name": "Path 64882",
    d: "M-2728.235-1510.3c-.167.232-.247.465-.381.5-.272.076-.3-.171-.286-.372.019-.236.206-.318.408-.359C-2728.124-1510.606-2728.535-1510.281-2728.235-1510.3Z",
    fill: "#1b1c1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64883",
    "data-name": "Path 64883",
    d: "M-2721.756-1502.788h34.391v.155h-34.451Z",
    fill: "#2a2927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64884",
    "data-name": "Path 64884",
    d: "M-2715.678-1480.283c-.909-2.692-.718-5.254.619-6.864a5.673,5.673,0,0,0,.305,2.107,5.922,5.922,0,0,0,.837,1.865,2,2,0,0,0-.219-2.664,1.443,1.443,0,0,0,.812-1.8c-.2-.888-.133-2.1,1.352-2.29a2.177,2.177,0,0,0,1.24-.847l1.207-.019a1.794,1.794,0,0,0-.162,1.622c.2.376.688.634.384,1.17-.512-1.107-1.183.983-1.759-.093a.639.639,0,0,0-.966-.065c-.367.4.072.686.336.843.648.386.635.963.657,1.6.032.9-.252,1.86.354,2.69.8-.167.81-.819.835-1.5.535,1.118,1.208,2.15.379,3.3a.476.476,0,0,0,.121.77,12.254,12.254,0,0,1,2.122,2.762c.549.713.773,1.669,1.736,2.046a3.6,3.6,0,0,1-2.268,2.561.934.934,0,0,1-1.084-.392c-.072.5.341.807.384,1.229a.718.718,0,0,1-.4.705c-1.357-.266-1.357-.266-1.367,1.512a.97.97,0,0,1-.483.7c-1.56.047-1.213-1.07-1.232-2.033-.347,0-.625.413-1.015.262a.679.679,0,0,1-.337-.238,2.058,2.058,0,0,1,.118-1.163c.236-.817-.453-.546-.777-.706a1.2,1.2,0,0,1-.182-.383c.593-2.484-1.124-4.7-.693-7.313-.009.011-.459.071-.264.137.04.014.012.056-.035.15C-2715.24-1480.4-2715.342-1480.159-2715.678-1480.283Z",
    fill: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64885",
    "data-name": "Path 64885",
    d: "M-2704.869-1471.32l-.308.312c-.677.43-1.063-.138-1.528-.441a.8.8,0,0,1-.185-.38,29.448,29.448,0,0,1,1.724-2.518c.129-.16.282-.3.417-.449.159-.18.426-.267.472-.544-.229.013-.465.18-.684-.032a.4.4,0,0,1,.149-.557,3.1,3.1,0,0,0,1.285-1.571.4.4,0,0,1,.394.016,1.209,1.209,0,0,1,.392.492,2.376,2.376,0,0,0,.127.275c1.319,1.9,1.319,1.9-.019,3.966a2.969,2.969,0,0,1-.246.344c-.308.26-.538.7-1.062.471h-.311A.629.629,0,0,0-2704.869-1471.32Z",
    fill: "#f8ec31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64886",
    "data-name": "Path 64886",
    d: "M-2703.306-1477.555a.74.74,0,0,0-.222.055c-1.14-1.085-2.309-2.143-3.417-3.26-2.01-2.029-2.229-4.432-1.368-7.033.359.243.071.686.3.97l.059.976a1.794,1.794,0,0,1,.67,1.343,9.3,9.3,0,0,1,.088,1.453,3.656,3.656,0,0,0,1.367,1.877,2.617,2.617,0,0,1,.312.266c.784.964,1.919,1.58,2.6,2.642A.765.765,0,0,1-2703.306-1477.555Z",
    fill: "#d64a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64887",
    "data-name": "Path 64887",
    d: "M-2704.812-1475.929l-.086.586a2.018,2.018,0,0,1-.467.931c-1.5,1.891-3.214,3.593-4.726,5.472-.248.309-.548.646-1.041.408-.22-.453.037-.712.378-.938l.333-.6a2.681,2.681,0,0,1,1.522-1.564l.33-.605c.024-.5.4-.829.617-1.236,1.264-.224,1.624-1.472,2.464-2.177Z",
    fill: "#fcfad3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64888",
    "data-name": "Path 64888",
    d: "M-2708.013-1486.823c-.331-.252-.184-.652-.3-.97l.076-.517C-2707.77-1487.874-2708.017-1487.329-2708.013-1486.823Z",
    fill: "#a83d09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64889",
    "data-name": "Path 64889",
    d: "M-2688.191-1477.5c-.766.384-.576,1.4-1.228,1.858a.267.267,0,0,1-.379-.041,5.777,5.777,0,0,0-.227-1.656,1.048,1.048,0,0,1,.394-1.486c1.608-.706,1.8-2.165,1.925-3.571.075-.854.644-2.066-.828-2.479a2.587,2.587,0,0,0-1.67-3.1c-.168-.076-.018-.48-.006-.734.055-1.213-.419-1.711-1.58-1.675-.224.007-.566-.121-.581.266a.549.549,0,0,0,.382.6,2.86,2.86,0,0,1,1.031.267c.438.3.738.772.349,1.157-1.793,1.775-1.1,3.994-1.139,6.065a4.325,4.325,0,0,1-.351,2.227c-.158.271-.414.251-.662.08-.675-.722-.421-1.626-.492-2.466-.1-2.107.244-4.229-.233-6.32.031-.836-.878-1.413-.643-2.307l.384-.279c1.318.157,2.666-.184,3.968.241.145.3.279.6.629.72l0-.014c1.8,2.341,3.112,4.827,2.368,7.931a1.927,1.927,0,0,0,.111,1.049,1.488,1.488,0,0,1-.028.466,27.409,27.409,0,0,1-1.317,3.07Z",
    fill: "#f9fbec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64890",
    "data-name": "Path 64890",
    d: "M-2694.129-1490.816c.3.64.931,1.112.964,1.888a.391.391,0,0,1-.394.059c-.721-.434-1.013-1.344-1.844-1.657a.643.643,0,0,1-.239-.337q.176-.165.35-.331Z",
    fill: "#ce654b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64891",
    "data-name": "Path 64891",
    d: "M-2704.885-1484.9c-1.525-1.581-1.476-3.582-1.484-5.567,1.229-.257.552,1.084,1.319,1.446-.14-2.306,1.505-1.609,2.769-1.788,2.625-.373,4.65.069,5.146,3.124.012.071.024.142.038.213-.183,1.654-.053,3.359-.8,4.921-.269.562.083,1.1.061,1.654-.015.4.045.884-.448,1.032a.763.763,0,0,1-.969-.548,1.574,1.574,0,0,0-1.488-1.288c-.2-.023-.443-.172-.47-.356-.206-1.412-1.355-1.41-2.368-1.618a12.931,12.931,0,0,0-1.19-1.063C-2704.808-1484.786-2704.847-1484.84-2704.885-1484.9Z",
    fill: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64892",
    "data-name": "Path 64892",
    d: "M-2696.924-1490.79l1.282-.072a.2.2,0,0,0,.131.121,3.194,3.194,0,0,1,1.23,2.676c.077.966.027,1.939.037,2.909-.336,3.405-.9,6.788-1.012,10.215a.852.852,0,0,1-.693.7,1.182,1.182,0,0,1-1.049-.893.945.945,0,0,1,.038-.442c.8-.56-.037-1.287.185-1.909a14.4,14.4,0,0,0,.226-3.524,1.951,1.951,0,0,1,.36-1.459c.624-1.49,1.11-2.986.178-4.537a1.145,1.145,0,0,1-.287-.983c.477-.248.764-.554.315-1.06-.4.4-.1,1.133-.7,1.424l-.2-.064Q-2696.9-1489.24-2696.924-1490.79Z",
    fill: "#fce639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64893",
    "data-name": "Path 64893",
    d: "M-2697.135-1487.68a2.545,2.545,0,0,1,.261-.011.292.292,0,0,1,.15-.072,7.236,7.236,0,0,1,.207,3.891c-.132,1.162-.268,2.322-.349,3.489a6.35,6.35,0,0,1-.165.736c-.1.494-.186,1.075-.846,1.058s-1.175-.3-1.161-1.084c.67-.12,1.121-.253,1.129-1.2.019-2.289.558-4.538.775-6.817Z",
    fill: "#f8f78e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64894",
    "data-name": "Path 64894",
    d: "M-2686.856-1488.96a1.908,1.908,0,0,1-1.326-1.454A2.618,2.618,0,0,1-2686.856-1488.96Z",
    fill: "#f5de42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64895",
    "data-name": "Path 64895",
    d: "M-2707.638-1484.324q-.157-.762-.316-1.522c.543-1.392.119-3.047,1.17-4.3.212,1.423-.618,2.952.437,4.29-.539.2-.658-.114-.759-.468a7.255,7.255,0,0,0,2.43,3.3,1.314,1.314,0,0,1-.027,1.115.585.585,0,0,1-.373.254C-2706.638-1481.864-2706.9-1483.318-2707.638-1484.324Z",
    fill: "#fbea4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64896",
    "data-name": "Path 64896",
    d: "M-2704.873-1483.058c-1.677-.491-2.021-1.942-2.646-3.594l1.171.8.881.918c.351.358.88.423,1.248.754a1.222,1.222,0,0,1,.385.5.548.548,0,0,1-.1.386C-2704.224-1483.139-2704.575-1483.2-2704.873-1483.058Z",
    fill: "#f7e035"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64897",
    "data-name": "Path 64897",
    d: "M-2704.3-1483.943a1.519,1.519,0,0,1-1.164-.994l.582.042,0,0C-2704.583-1484.643-2703.981-1484.573-2704.3-1483.943Z",
    fill: "#f7f481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64898",
    "data-name": "Path 64898",
    d: "M-2710.732-1490.772c.165.926-.585,1.013-1.156,1.2a1.848,1.848,0,0,0-1.048,2.4c.232.357.849.564.5,1.094-.316.485-.839.08-1.269.1a1.727,1.727,0,0,0-.433.134l0-1.234a6.95,6.95,0,0,0-.019-1.559A5.408,5.408,0,0,1-2710.732-1490.772Z",
    fill: "#f8fbf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64899",
    "data-name": "Path 64899",
    d: "M-2714.157-1488.632c.948.508.527,1.033.019,1.559a.952.952,0,0,1-.62-.934Z",
    fill: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64900",
    "data-name": "Path 64900",
    d: "M-2715.678-1480.283c.6-.37,0-1.239.765-1.654a10.749,10.749,0,0,1,.389,2.121c.114,1.028-.145,2.115.8,3.11.792.837-.177,2.13-.107,3.234-.873-.241-1.019-.777-.623-1.534-.18-1.432-.859-2.791-.616-4.288C-2715-1479.773-2715.472-1479.955-2715.678-1480.283Z",
    fill: "#fafcf5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64901",
    "data-name": "Path 64901",
    d: "M-2714.457-1475.006a2,2,0,0,0,.623,1.534c0,.1,0,.2,0,.3.6.485.516,1.2.619,1.85l0,0c1.05.89.94,2.4,1.8,3.387-.138,1.052-.682.6-1.178.317a9.908,9.908,0,0,0-.947-2.783,8.208,8.208,0,0,1-.915-2.749l-.291-.641a1.18,1.18,0,0,1-.022-1.238A2.194,2.194,0,0,1-2714.457-1475.006Z",
    fill: "#fbfabd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64902",
    "data-name": "Path 64902",
    d: "M-2714.76-1475.024q.011.62.021,1.238c-.8-2.343-1.953-4.594-1.844-7.17Q-2715.671-1477.99-2714.76-1475.024Z",
    fill: "#f6ed35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64903",
    "data-name": "Path 64903",
    d: "M-2714.447-1473.145a12.008,12.008,0,0,1,.916,2.749l-.6-.306C-2714.15-1471.528-2714.6-1472.3-2714.447-1473.145Z",
    fill: "#f6ed35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64904",
    "data-name": "Path 64904",
    d: "M-2713.513-1467.306c-1.038.251-.459-.588-.624-.925C-2713.12-1468.469-2713.68-1467.642-2713.513-1467.306Z",
    fill: "#faed48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64905",
    "data-name": "Path 64905",
    d: "M-2683.225-1534.654l.6-.636c.6-.628,1.423-1.034,1.857-1.832a1.6,1.6,0,0,1,.725-1.124,1.47,1.47,0,0,1,.478-.1c.172-.006.342-.009.514-.01,1.682.177,3.41-.384,5.053.337v1.549c-2.5-2.376-4.176-.844-5.692.943C-2680.717-1534.322-2682-1534.731-2683.225-1534.654Z",
    fill: "#222023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64906",
    "data-name": "Path 64906",
    d: "M-2674-1538.018l-5.55-.048c-.045-.367.2-.424.475-.438,1.282-.053,2.569.095,3.848-.081l.021-.073,1.239.082Z",
    fill: "#2e2b2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64907",
    "data-name": "Path 64907",
    d: "M-2673.639-1534.316l-.3.231c0-.593,0-1.185,0-1.975C-2673.524-1535.383-2673.756-1534.825-2673.639-1534.316Z",
    fill: "#060508"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64908",
    "data-name": "Path 64908",
    d: "M-2694.367-1538.033l1.007.6c-.157.481-.524.3-.786.3q-6.222.018-12.446.006c-.646,0-1.43.176-1.366-.906a1.864,1.864,0,0,1,1.569-.447q5.226-.025,10.452,0A1.875,1.875,0,0,1-2694.367-1538.033Z",
    fill: "#20212a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64909",
    "data-name": "Path 64909",
    d: "M-2727.422-1538.034l10.2,0c.352.645.175.925-.573.923-3.407-.014-6.815-.006-10.347-.006Z",
    fill: "#21222b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64910",
    "data-name": "Path 64910",
    d: "M-2680.122-1538.006a1.043,1.043,0,0,1-.651.884c-2.057,0-4.114-.029-6.17.016-.766.016-1.3-.175-1.551-.932,1.566-.65,3.2-.265,4.806-.287C-2682.5-1538.341-2681.255-1538.692-2680.122-1538.006Z",
    fill: "#20212a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64911",
    "data-name": "Path 64911",
    d: "M-2691.888-1547.929a3.772,3.772,0,0,1,.391,2c-.09,1.576-.417,3.194.409,4.777.374.717-.194,1.659-.49,2.465l-.63-.616a.963.963,0,0,1-.35-.662,44.11,44.11,0,0,1,.144-8.091C-2692.16-1548.344-2691.948-1548.449-2691.888-1547.929Z",
    fill: "#3c4248"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64912",
    "data-name": "Path 64912",
    d: "M-2692.873-1538.694a.709.709,0,0,0-.26.087,1.111,1.111,0,0,1-.57.213c-5.421,0-10.843.2-16.26-.143a.339.339,0,0,1-.172-.484,2.915,2.915,0,0,1,2.069-.383c4.114-.015,8.228,0,12.341-.011a5.009,5.009,0,0,0,1.829-.143c.384-.24.4-.755.752-1.019a.418.418,0,0,1,.463.147A1.765,1.765,0,0,1-2692.873-1538.694Z",
    fill: "#967e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64913",
    "data-name": "Path 64913",
    d: "M-2710.072-1538.711l16.938.1c.006.083.011.165.015.248a17.521,17.521,0,0,1-4.273.135c-3.627-.042-7.259.2-10.883-.133a2.764,2.764,0,0,1-2.153.011.289.289,0,0,1-.093-.248c.014-.09.032-.134.053-.134A.355.355,0,0,1-2710.072-1538.711Z",
    fill: "#1d0e00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64914",
    "data-name": "Path 64914",
    d: "M-2692.873-1538.694l.036-1.837c-.751-1.373-.378-2.827-.279-4.254.027-.391.169-.779.164-1.183.013-.542.012-1.085.015-1.628a2.327,2.327,0,0,1,.361-1.564c.8.014.587.458.381.9q-.006,4.479-.013,8.958Z",
    fill: "#413a2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64915",
    "data-name": "Path 64915",
    d: "M-2708.275-1538.357l15.156,0c.121.062.492.148.193.258a4.64,4.64,0,0,1-1.441.068l-13.591,0Z",
    fill: "#0a0701"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64916",
    "data-name": "Path 64916",
    d: "M-2679.227-1538.356l-.325.29-.152,0-.151-.008c-2.787-.306-5.584-.047-8.374-.143a3.983,3.983,0,0,1-1.8-.145c.006-.112.012-.223.018-.334l10.768.074q.168.077.12.168C-2679.158-1538.387-2679.192-1538.356-2679.227-1538.356Z",
    fill: "#201101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64917",
    "data-name": "Path 64917",
    d: "M-2690.03-1538.358c2.859,0,5.718-.009,8.577.01.538,0,1.134-.2,1.6.278a2.723,2.723,0,0,1-.267.064l-8.372-.032C-2689.007-1538.14-2689.606-1537.829-2690.03-1538.358Z",
    fill: "#0b0701"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64918",
    "data-name": "Path 64918",
    d: "M-2710.42-1538.66l-.008.314a1.262,1.262,0,0,1-1.4,1.406c-.537-.1-1.779.2-1.692-1.1l.6-.025c.646-.127,1.372-.007,1.867-.6l.308-.043A.226.226,0,0,1-2710.42-1538.66Z",
    fill: "#1e202c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64919",
    "data-name": "Path 64919",
    d: "M-2715.988-1538.032l1.235-.007a.75.75,0,0,1-.49,1.258C-2715.891-1536.745-2716.008-1537.442-2715.988-1538.032Z",
    fill: "#1e202c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64920",
    "data-name": "Path 64920",
    d: "M-2711.048-1538.672c-.3,1.2-1,1.164-1.867.6q.008-.294.015-.586.021-.762.041-1.525a1.316,1.316,0,0,1,.271-.033C-2712.812-1538.96-2711.9-1538.842-2711.048-1538.672Z",
    fill: "#222023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64921",
    "data-name": "Path 64921",
    d: "M-2680.12-1472.529c-.229-.072-.468.651-.618.075a9.325,9.325,0,0,1-.031-2.046c.89.722.485,1.432.643,1.995Z",
    fill: "#f0592a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64922",
    "data-name": "Path 64922",
    d: "M-2722.787-1525.074l44.486,0c0,.1,0,.205,0,.308a2.432,2.432,0,0,1-1.356.145q-20.886.009-41.773,0a2.455,2.455,0,0,1-1.357-.144Z",
    fill: "#3a3b3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64923",
    "data-name": "Path 64923",
    d: "M-2722.787-1524.763h44.486c-.455.5-1.058.3-1.6.3q-20.645.016-41.289,0C-2721.728-1524.464-2722.331-1524.26-2722.787-1524.763Z",
    fill: "#454648"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64924",
    "data-name": "Path 64924",
    d: "M-2675.191-1529.129l.592.034c.3.131.859-.514.941.3-.843.846-.055,1.875-.314,2.786-.859.111-1.428-.159-1.212-1.129C-2675.031-1527.816-2675.694-1528.467-2675.191-1529.129Z",
    fill: "#1f1e21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64925",
    "data-name": "Path 64925",
    d: "M-2696.185-1474.461l.622-.27a4.7,4.7,0,0,0,.389-2.4c.172-2.5.522-4.989.7-7.492.346-1.223-.218-2.534.364-3.735a.608.608,0,0,1,.771.089c.442,1.755.1,3.541.2,5.309a12.436,12.436,0,0,0,.088,1.977,12.889,12.889,0,0,1-.241,4.871c-.949.151-.635.913-.708,1.488a9.542,9.542,0,0,0-.56,2.929c-.353.328-.683.121-1.014-.043a4.368,4.368,0,0,0-1.3-.983c-.359-.312-.726-.587-1.232-.294a.746.746,0,0,1-.611-.1.282.282,0,0,1,.025-.379l0-.3a.368.368,0,0,1-.11-.371,2.106,2.106,0,0,1,.767-.957C-2697.278-1475.3-2696.882-1474.459-2696.185-1474.461Z",
    fill: "#f25329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64926",
    "data-name": "Path 64926",
    d: "M-2698.689-1474.1c0,.1,0,.206,0,.308l-1.533-.925c-.311-.2-.394-.554-.562-.852-.537-1.027-1.9-1.333-2.221-2.549-.93-.923-2.135-1.568-2.789-2.769a.787.787,0,0,1,1.121.063c1.588,1.6,3.694,2.6,5.125,4.377C-2699.537-1475.566-2698.325-1475.122-2698.689-1474.1Z",
    fill: "#f6562e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64927",
    "data-name": "Path 64927",
    d: "M-2698.691-1473.489l.04.38c.3.457.029.841-.151,1.238a39.129,39.129,0,0,1-4.086,4.917.6.6,0,0,1-.422-.01l-.332-.349c1.374-2.051,3.2-3.764,4.426-5.93C-2699.139-1473.38-2698.87-1473.41-2698.691-1473.489Z",
    fill: "#d44c27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64928",
    "data-name": "Path 64928",
    d: "M-2700.546-1475.649c.362.223.3.591.32.932-.9,1.244-1.775,2.516-2.735,3.716-.26.324-.7.821-1.272.324l.314-.592a7.246,7.246,0,0,1,.935-1.269l-.008.008a18.356,18.356,0,0,0,2.063-3.145A.308.308,0,0,1-2700.546-1475.649Z",
    fill: "#dd5716"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64929",
    "data-name": "Path 64929",
    d: "M-2711.055-1468.57l5.582-6.083c.3.078.424.344.6.552l-1.851,2.473c-.176.349-.533.52-.779.8-.131.143-.264.284-.392.429-.3.558-.985.7-1.3,1.245-.2.648-1.287,1.039-.567,1.971.05.064-.116.363-.246.483-.284.262-.413-.08-.618-.19-.556-.3-.3-.947-.613-1.342-.085-.057-.154-.125-.136-.183C-2711.323-1468.567-2711.187-1468.572-2711.055-1468.57Z",
    fill: "#efeb29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64930",
    "data-name": "Path 64930",
    d: "M-2709.189-1469.153a3.2,3.2,0,0,1,1.227-1.548c.188.06.2.455.342.355.231-.159.005-.442-.03-.672a.941.941,0,0,1,.928-.61,3.714,3.714,0,0,1,1.234,1.234c-.737,1.288-2.128,2.041-2.777,3.4-.511-.408-.235-.782.052-1.153a.744.744,0,0,0,.079-.962C-2708.462-1469.576-2708.83-1469.319-2709.189-1469.153Z",
    fill: "#f8ec2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64931",
    "data-name": "Path 64931",
    d: "M-2711.055-1468.57q-.09.169-.178.339l-.174.3c-.956.234-.782-.736-1.027-1.114a9.331,9.331,0,0,1-.774-2.273c.411-.005.814.007.943-.534.069-.286.21-.639.607-.437.309.157.306.493.216.8-.239.832-.633,1.716.689,2.014Q-2710.9-1469.02-2711.055-1468.57Z",
    fill: "#fafcf5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64932",
    "data-name": "Path 64932",
    d: "M-2709.184-1466.061c-.006.1-.013.2-.019.3-.257.053-.5.4-.768.069-.054-.067.006-.288.081-.384A.39.39,0,0,1-2709.184-1466.061Z",
    fill: "#ecf020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64933",
    "data-name": "Path 64933",
    d: "M-2705.488-1470.394a3.147,3.147,0,0,1-1.234-1.234l1.545.62Z",
    fill: "#efeb29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64934",
    "data-name": "Path 64934",
    d: "M-2704.869-1471.32c-.338-.24-.266-.5,0-.722a.373.373,0,0,1,.617.1Z",
    fill: "#efeb29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64935",
    "data-name": "Path 64935",
    d: "M-2702.984-1472.538a1.883,1.883,0,0,1-.936,1.269c-.007-.222-.014-.445-.021-.667Z",
    fill: "#fbe047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64936",
    "data-name": "Path 64936",
    d: "M-2694.981-1457.416c.008.436-.1.973.663.537.209-.118.233.212.263.39-.518.925-.433,2.176-1.6,2.765-.391.2-.064.628.051.944q-.766,1.545-1.532,3.091a.949.949,0,0,1-.934-.622c.256-1.08,1.853-1.686,1.1-3.129-.747-.08-.249,1.4-1.166.987-.662-.3-.5-1.038-.576-1.643-.259-2.047-1.764-2.9-3.479-3.521.723-1.078.853-1.175,1.508-.289.891,1.2,1.782-.278,2.612.178.34-.019.653-.222,1.007-.151.6-.035,1.159.715,1.783.073C-2695.044-1457.782-2694.886-1457.7-2694.981-1457.416Z",
    fill: "#f3ee31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64937",
    "data-name": "Path 64937",
    d: "M-2703.31-1466.964a1.15,1.15,0,0,0,.272-.054c.062.034.124.068.187.1.769.848.887,2.069,1.669,2.911.495.668,1.026,1.325.712,2.248-.859.266-.685-.589-1-.917q-.747-1.254-1.493-2.509-.24-.741-.48-1.481Z",
    fill: "#faf3df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64938",
    "data-name": "Path 64938",
    d: "M-2697.152-1457.728c-.307.09-.615.492-.921,0,.18-.427.658-.7.633-1.236-.053-1.076.724-1.882.933-2.874a2.506,2.506,0,0,1,.148-.392c.357-.673.815-1.29,1.129-1.988a7.325,7.325,0,0,0,.564-1.294,1.89,1.89,0,0,1,.183-.361,2.613,2.613,0,0,1,.914-.769c.244-.1.487-.234.748-.044-.04.616-.6.906-.88,1.382-.475.82-.985,1.5-.11,2.413.456.474.036,1.172.064,1.767a2.064,2.064,0,0,0-1.008,2.6c.089.4.755.922-.226,1.1l-.312-.308C-2695.913-1457.694-2696.531-1458.656-2697.152-1457.728Z",
    fill: "#f5eb2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64939",
    "data-name": "Path 64939",
    d: "M-2697.483-1459.333c-.466.8-.984,1.331-1.791.341l-.145-.159a.4.4,0,0,1,.219-.521c1.383.116,1.182-1.2,1.688-1.876.054-.13.117-.255.181-.379a20.7,20.7,0,0,1,1.038-2.321c.28-1.295,1.108-2.372,1.43-3.657.19-.758.879-1.063,1.543-1.341a.854.854,0,0,1,.44-.008c.589.688-.056,1.214-.232,1.8a3.174,3.174,0,0,1-.2.38c-.3.48-.776.816-1.067,1.305h0c-.207.434-.319.909-.569,1.325-.388.819-.912,1.563-1.313,2.375l.02-.009A20.1,20.1,0,0,1-2697.483-1459.333Z",
    fill: "#f8fcda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64940",
    "data-name": "Path 64940",
    d: "M-2701.163-1461.124c.1,0,.2.006.3.011a.886.886,0,0,1,.557.144,2.155,2.155,0,0,1,.6.761c.281.363.078.9.437,1.232v-.016c-.14.566-.345.741-.749.16A9.071,9.071,0,0,1-2701.163-1461.124Z",
    fill: "#f2ea1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64941",
    "data-name": "Path 64941",
    d: "M-2697.483-1459.333a6.385,6.385,0,0,1,1.244-2.744c.187,1.265-.834,2.063-1.2,3.114Z",
    fill: "#f3ee31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64942",
    "data-name": "Path 64942",
    d: "M-2705.683-1461.551a1.719,1.719,0,0,1,.733,1.83C-2705.587-1460.122-2705.764-1460.584-2705.683-1461.551Z",
    fill: "#eded25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64943",
    "data-name": "Path 64943",
    d: "M-2700.457-1460.857l-.409-.257c-.254-.5-.743-.909-.6-1.561l.877,1.016A.556.556,0,0,1-2700.457-1460.857Z",
    fill: "#f9ea35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64944",
    "data-name": "Path 64944",
    d: "M-2685.41-1473.486c-.333-.356-1.239-.1-1.173-.569.135-.964-.205-2.333,1.475-2.47.367.362.317.94.327,1.5Z",
    fill: "#f3ec27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64945",
    "data-name": "Path 64945",
    d: "M-2683.872-1482.117c-.1.693.419,1.668-.927,1.867.123-.765-.264-1.535.324-2.2Z",
    fill: "#f0ec23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64946",
    "data-name": "Path 64946",
    d: "M-2692.773-1469.134l-.36-.024c-.749-.521-1.739-.451-2.474-1.006a4.681,4.681,0,0,1-.523-.362c-.8-.863-1.58-1.762-2.949-1.118a.656.656,0,0,1,.035-.417l.393-1.048.59-.086c.589-.236.894.23,1.272.515a3.039,3.039,0,0,1,.533.336,3.444,3.444,0,0,0,1.721,1.1c.345-.608.049-1.241.258-1.8.391-.871.044-1.845.379-2.723l.18-.153a31.225,31.225,0,0,0,.541-4.981c-.044-.462-.436-1.018.341-1.256.1.835-.162,1.718.324,2.5.311,1.857-.277,3.64-.471,5.453-.181,1.688-.213,1.758.62,2.7.735-1.5.892-3.343,2.631-4.137l.313.005-.024.61a20.868,20.868,0,0,1-2.918,5.851A.392.392,0,0,1-2692.773-1469.134Z",
    fill: "#fbf2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64947",
    "data-name": "Path 64947",
    d: "M-2692.525-1469.191a54.725,54.725,0,0,1,3.082-5.839c.274-.045.807-.352.77-.067-.074.571.823,1.174.343,1.328-1.1.353-.567,1.06-.4,1.458.436,1.034-.056,1.527-.85,1.956a.944.944,0,0,1-.11-.259c-.061-.6,1.073-1.353.139-1.691-.729-.263-.918.786-1.146,1.456-.35,1.03-1.264,1.932-.538,3.164-.452.356-.9-.4-1.268.076a.506.506,0,0,1-.427-.41C-2692.767-1468.4-2692.706-1468.816-2692.525-1469.191Z",
    fill: "#f2eb2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64948",
    "data-name": "Path 64948",
    d: "M-2686.987-1480.671a.222.222,0,0,1,.037-.23c.217-.141.077-.484.338-.6.291-.039.937-1.089.789-.062a10.514,10.514,0,0,1-2.444,5.825c-.465-.738.112-1.216.076-1.759l0-.005A18.537,18.537,0,0,0-2686.987-1480.671Z",
    fill: "#efec26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64949",
    "data-name": "Path 64949",
    d: "M-2686.612-1481.5a.677.677,0,0,1-.338.6c.745-3.433-.339-6.432-2.2-9.247a8.492,8.492,0,0,1,2.693,7.6C-2686.484-1482.194-2686.558-1481.849-2686.612-1481.5Z",
    fill: "#f5de42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64950",
    "data-name": "Path 64950",
    d: "M-2692.815-1467.916l.312.307-.318.923-.621.311a.83.83,0,0,1-.018-.949l-.005.005C-2693.24-1467.51-2693.14-1467.835-2692.815-1467.916Z",
    fill: "#f0e519"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64951",
    "data-name": "Path 64951",
    d: "M-2713.515-1564.308c.222.056.462.319.647-.054.739.137.772.818.86,1.314.616,3.473,1.461,6.918,1.4,10.482a13.962,13.962,0,0,0,.217,3.817c.247,2.313-.134,4.653.306,6.96a.976.976,0,0,1-.369.949c-.671-.582-.593-1.37-.6-2.141-.013-2.185.146-4.386-.6-6.5a2.5,2.5,0,0,1-.02-1.839,48.052,48.052,0,0,0-1.171-9.627C-2713.048-1562.074-2713.369-1563.174-2713.515-1564.308Z",
    fill: "#383132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64952",
    "data-name": "Path 64952",
    d: "M-2710.453-1540.84a66.015,66.015,0,0,1-.313-8.015c-.133-.269-.194-.524.136-.7a.513.513,0,0,1,.439.294c.3,2.585.2,5.2.506,7.781-.077.832.2,1.719-.388,2.471a.631.631,0,0,0,0,.3l-.348.051-.32-.055A4.24,4.24,0,0,1-2710.453-1540.84Z",
    fill: "#473c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64953",
    "data-name": "Path 64953",
    d: "M-2712.278-1540.224l0-.6c.109-.215.257-.536.505-.366a.683.683,0,0,1,.266.907C-2711.716-1539.919-2712.01-1540.107-2712.278-1540.224Z",
    fill: "#3b4d28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64954",
    "data-name": "Path 64954",
    d: "M-2711.676-1551.323q.009.92.02,1.839c-.01.05,0,.114-.032.147a1.219,1.219,0,0,1-.19.151A2.6,2.6,0,0,1-2711.676-1551.323Z",
    fill: "#4a425d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64955",
    "data-name": "Path 64955",
    d: "M-2692.2-1548.261c-.01-.321.044-.658-.228-.915a.532.532,0,0,1-.286-.379,1.417,1.417,0,0,1,.011-.495c.338-1.237-.419-2.706.794-3.757l.319.005q0,2.625.008,5.252a.684.684,0,0,1-.311.621Z",
    fill: "#363628"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64956",
    "data-name": "Path 64956",
    d: "M-2679.227-1538.356c0-.087-.008-.175-.017-.263l.347-.1,3.668.138C-2676.538-1538.087-2677.9-1538.485-2679.227-1538.356Z",
    fill: "#423426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64957",
    "data-name": "Path 64957",
    d: "M-2720.651-1585.32l-.907-1.208a8,8,0,0,1-.27-6.8,4.191,4.191,0,0,1,2.135-2.467.688.688,0,0,1,.687.448c-1.111,1.3-2.383,2.518-2.16,4.461a4.1,4.1,0,0,1-.115.856,3.269,3.269,0,0,0,.167,2.085c.086.423.256-.035.342.083.7.339.4,1.231.932,1.663a1.7,1.7,0,0,0,1.511.719,2.845,2.845,0,0,0,2.778-2.256,7.523,7.523,0,0,0,0-5.126,4.436,4.436,0,0,0-1.317-1.984,1.393,1.393,0,0,0-1.062-.289,2.174,2.174,0,0,1-.953-.171c-.584-.329.059-.569.064-.857a2.4,2.4,0,0,1,2.685.593,7.245,7.245,0,0,1,.538,10.006C-2717.183-1583.924-2718.383-1583.866-2720.651-1585.32Z",
    fill: "#e8c340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64958",
    "data-name": "Path 64958",
    d: "M-2719.08-1595.5a.665.665,0,0,1-.613-.294.782.782,0,0,1,.872-.368c.434.416-.308.385-.25.657Z",
    fill: "#e8bf5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64959",
    "data-name": "Path 64959",
    d: "M-2686.6-1574.486c-.04.33-.041.676-.349.9-.871.441-.784,1.428-1.2,2.132a13.392,13.392,0,0,1-.767,1.467,4.108,4.108,0,0,0-.882,2.419c-.393.889-.161,2.025-1.066,2.711-.724-.566-.646-1.4-.714-2.178l-.011,0a2.575,2.575,0,0,1-.078.742,1.272,1.272,0,0,0-.126,1.629,4.656,4.656,0,0,0,.47,1.778,2.287,2.287,0,0,1-.377,1.762c-.709.906-.306,1.924-.288,2.9-.461,3.845-.474,7.735-1.177,11.552-.479.17-.657.564-.706,1.19-.1,1.346.066,2.748-.7,3.98-.08.13-.221.294-.138.409,1.074,1.5-.273,1.479-1.108,1.786-3.915.011-7.825.039-11.735-.014a2.923,2.923,0,0,1-2.071-1.756.858.858,0,0,1,.086-.472c.749-.739.514-1.7.543-2.585.031-.962-.055-1.929-.021-2.888.025-.731-.494-.031-.6-.3a1.819,1.819,0,0,1-.506-1.539,20.772,20.772,0,0,0-.074-6.067,2.852,2.852,0,0,1,.289-1.938c.466-.817-.285-.9-.579-1.274a4.332,4.332,0,0,1,.833-2.49c.494-.5-.1-1.02.141-1.618-.425.192-.3.573-.537.719-1.071-.026-.5-1.242-1.146-1.578-.129-.231-.266-.52-.163-.733.618-1.287-.22-1.744-1.177-2.151a18.211,18.211,0,0,1-2-4.937,3.428,3.428,0,0,0-.424-1.653,2.027,2.027,0,0,1-.109-.427,1.454,1.454,0,0,1,.332-1.142.754.754,0,0,1,.794-.341.545.545,0,0,1,.326.629c-.087.585.269,1.08.353,1.64-1.074-2.7-.3-5.386.041-8.065a2.224,2.224,0,0,1,2.348-2.155,1.086,1.086,0,0,1,.826.639c0,.1.008.281.036.281,1.551.013,3.1.7,4.651-.015.319-.162.631-.364,1.012-.191a1.276,1.276,0,0,0,.652.353c-.2-.151-.487-.1-.613-.323.08-.54.523-.665.937-.825,1.335.088,2.766-.216,3.842.956.172.187.475.175.73.185,1.627.069,3.256.088,4.883.1.883.006,1.617-.3,1.748-1.336a1.4,1.4,0,0,1,.131-.424c.277-.29.629-.486.89-.806a.891.891,0,0,1,1.444-.136c.52.564,1.309.909,1.519,1.743a3,3,0,0,0,2.491.926c1.333-.14,1.276.665.776,1.347-.918,1.253-1.136,2.773-1.815,4.1C-2686.966-1575.384-2687.144-1574.9-2686.6-1574.486Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64960",
    "data-name": "Path 64960",
    d: "M-2688.178-1582.232c-.342-.2-.85-.315-1-.611-.939-1.877-1.818-.83-2.722,0a.425.425,0,0,1-.616,0c.487-.638,1.255-1.035,1.568-1.824l.9-.322a11.7,11.7,0,0,1,1.829,1.969l.965.791Z",
    fill: "#d7bb43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64961",
    "data-name": "Path 64961",
    d: "M-2689.115-1570.177c.49-1.194.978-2.389,1.475-3.58.081-.2.018-.6.384-.461.159.061.207.414.305.635q-.408,1.241-.818,2.48a32.848,32.848,0,0,0-2.3,6.43q-.3.955-.6,1.912a12.131,12.131,0,0,0-.519,2.242c-.255.68-.163,1.421-.367,2.11l.017-.019a5.181,5.181,0,0,0-.317,2.513.221.221,0,0,1-.023.256,50.169,50.169,0,0,0-.624,5.876l-.042.312a5.677,5.677,0,0,0-.121,1.8c-.109.616.059,1.248-.112,1.862-.377,1.552-.02,3.153-.325,4.711a.414.414,0,0,1-.5-.159,9,9,0,0,1,.157-5.131c.6-4,.466-8.07,1.237-12.05a4.013,4.013,0,0,1,.313-2.774,5.561,5.561,0,0,0,.314-1.852,3.274,3.274,0,0,1,.62-1.858c.606-.831.242-1.985.926-2.79A6.87,6.87,0,0,1-2689.115-1570.177Z",
    fill: "#e6c038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64962",
    "data-name": "Path 64962",
    d: "M-2683.859-1584.379l-1.2.228c-.447,0-1.008.2-.985-.589.519-.517,1.315-.173,1.863-.6.818-.405,1.184-1.508,2.281-1.48a.863.863,0,0,1-.117.86A4.669,4.669,0,0,1-2683.859-1584.379Z",
    fill: "#debd3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64963",
    "data-name": "Path 64963",
    d: "M-2682.019-1585.961v-.908a.185.185,0,0,1-.057-.2c.025-.064.048-.095.071-.095l.919-.616A3.136,3.136,0,0,1-2682.019-1585.961Z",
    fill: "#cdb952"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64964",
    "data-name": "Path 64964",
    d: "M-2689.115-1584.7a1.773,1.773,0,0,1,.618-1.244.352.352,0,0,1,.386-.033c.474.941,1.583,1.288,2.076,2.212a.6.6,0,0,1-.594.309c-.085.126-.143.281-.323.308-.676.187-.952-.58-1.525-.641C-2688.948-1583.912-2689.284-1584.129-2689.115-1584.7Z",
    fill: "#404052"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64965",
    "data-name": "Path 64965",
    d: "M-2689.115-1584.7q.318.456.638.912l.255.768a3.639,3.639,0,0,1-1.829-1.969C-2689.511-1585.634-2689.438-1584.761-2689.115-1584.7Z",
    fill: "#38311a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64966",
    "data-name": "Path 64966",
    d: "M-2686.952-1583.148l.323-.308c.409.577.817.123,1.225,0l.315.906A5.131,5.131,0,0,1-2686.952-1583.148Z",
    fill: "#3d4249"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64967",
    "data-name": "Path 64967",
    d: "M-2686.035-1583.765c-.907-.536-1.987-.9-2.189-2.152a.57.57,0,0,1,.343-.188c.593.034.912.5,1.311.836a1.516,1.516,0,0,1,.477.6l1.032.519C-2685.271-1583.734-2685.664-1583.777-2686.035-1583.765Z",
    fill: "#393327"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64968",
    "data-name": "Path 64968",
    d: "M-2692.508-1549.783c.012-1.979-.183-3.981.624-5.876q-.009.926-.02,1.852C-2692.383-1552.507-2691.932-1551.068-2692.508-1549.783Z",
    fill: "#e2b83c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64969",
    "data-name": "Path 64969",
    d: "M-2691.861-1555.915a2,2,0,0,1,.317-2.513A5.627,5.627,0,0,1-2691.861-1555.915Z",
    fill: "#e2b83c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64970",
    "data-name": "Path 64970",
    d: "M-2691.294-1560.6a3.554,3.554,0,0,1,.619-2.162,9.442,9.442,0,0,1-.581,3.111A.793.793,0,0,1-2691.294-1560.6Z",
    fill: "#b69830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64971",
    "data-name": "Path 64971",
    d: "M-2691.294-1560.6c.013.316.025.633.038.949a1.949,1.949,0,0,1-.3,1.241C-2691.5-1559.142-2691.844-1559.925-2691.294-1560.6Z",
    fill: "#e2b83c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64972",
    "data-name": "Path 64972",
    d: "M-2686.655-1584.98l-1.211-.969c-1.422-1-1.513-2.457-1.344-4,.233-.711-.074-1.508.351-2.188a.352.352,0,0,1,.431.049.836.836,0,0,1,.276.539,10.46,10.46,0,0,0,1.761,5.919A.789.789,0,0,1-2686.655-1584.98Z",
    fill: "#e0b73b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64973",
    "data-name": "Path 64973",
    d: "M-2688.5-1592.1l-.354-.029c.007-.2.014-.4.021-.6a3.515,3.515,0,0,1,2.519-3.351,2.927,2.927,0,0,1,3.433.555l-.373.033c-1.939-.452-3.067.856-4.277,1.977-.444.325-.521.881-.81,1.3Z",
    fill: "#d2b549"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64974",
    "data-name": "Path 64974",
    d: "M-2689.21-1589.946a10.176,10.176,0,0,0,1.344,4l-.357.032c-.091-.011-.183-.02-.274-.027-.417-.817-1.451-1.323-1.238-2.457.525-.434.218-1.03.3-1.55Z",
    fill: "#3f3b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64975",
    "data-name": "Path 64975",
    d: "M-2686.319-1596.089a7.318,7.318,0,0,0-2.519,3.351,2.909,2.909,0,0,1,1.871-3.4C-2686.749-1596.154-2686.506-1596.473-2686.319-1596.089Z",
    fill: "#3b331f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64976",
    "data-name": "Path 64976",
    d: "M-2687.882-1593.657a5.6,5.6,0,0,0,1.128-1.007,2.345,2.345,0,0,1,3.495-.837c.2.95,1.212,1.337,1.533,2.231a1.022,1.022,0,0,1,.026.848,2.764,2.764,0,0,1-.914.83c-.1.091-.338.219-.249.308.955.966.49,2.015.11,2.978-.414,1.048.338.336.55.431l.194.086,0,.626c-.005.1-.009.2-.014.294-.431.8-1.312,1.159-1.848,1.856a1.188,1.188,0,0,1-1.255,0c.153-1.356-.628-.616-1.13-.5a.386.386,0,0,1-.37-.122c-1.821-1.809-1.927-4.116-1.883-6.467l.017-.02C-2688.1-1592.563-2688.153-1593.173-2687.882-1593.657Z",
    fill: "#e6b127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64977",
    "data-name": "Path 64977",
    d: "M-2682.626-1591.8a.936.936,0,0,1,.926-.62c.169,1.563,1.2,3.183-.309,4.633h0a.8.8,0,0,1-.324-.663A7.95,7.95,0,0,0-2682.626-1591.8Z",
    fill: "#e6b31b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64978",
    "data-name": "Path 64978",
    d: "M-2697.144-1584.08l0-.331c.618-.608,1.479-.22,2.168-.533a4.484,4.484,0,0,0,2.529-2.966c.252-.408.134-1.082.834-1.169.014.226.029.452.043.677C-2691.615-1585.29-2694.46-1583.083-2697.144-1584.08Z",
    fill: "#453b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64979",
    "data-name": "Path 64979",
    d: "M-2691.617-1589.079l-.571,1.316a.6.6,0,0,1-.454-.431c-.119-1.675.089-3.393-.636-4.992a2.2,2.2,0,0,1-.342-1.2.4.4,0,0,1,.278-.282c.517.207.457,1.005,1.1,1.079A13.622,13.622,0,0,1-2691.617-1589.079Z",
    fill: "#d9bb37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64980",
    "data-name": "Path 64980",
    d: "M-2690.953-1589.939c.638,1.122.435,2.439.832,3.619.087.257.043.534-.26.61-.434.109-.362-.274-.512-.509a3.855,3.855,0,0,1-.384-2.174Z",
    fill: "#3d4050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64981",
    "data-name": "Path 64981",
    d: "M-2698.345-1595.5l.905-.594a3.317,3.317,0,0,1,3.4.457l.7.967-.1.106c-.484.359-.869.044-1.168-.254a1.55,1.55,0,0,0-1.754-.348,2.872,2.872,0,0,0-.759.258c-.636.349-.932,1.011-1.4,1.511-.32.34-.512.9-1.161.674a.535.535,0,0,1,.026-.41A6.064,6.064,0,0,1-2698.345-1595.5Z",
    fill: "#dab847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64982",
    "data-name": "Path 64982",
    d: "M-2691.889-1582.542a1.5,1.5,0,0,1-1.28,1.574c-2.075.015-4.151-.01-6.226-.028-.2,0-.525-.011-.575-.118-.734-1.575-2.242-.751-3.359-1.113-.232-.5.126-.864.311-1.265a2.175,2.175,0,0,1,.039-.255.435.435,0,0,1,.25.016,2.02,2.02,0,0,1,2.761.661c1.654,1.918,5.172,1.847,6.81.914C-2692.768-1582.377-2692.4-1582.7-2691.889-1582.542Z",
    fill: "#e7b322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64983",
    "data-name": "Path 64983",
    d: "M-2703.018-1583.492a2.049,2.049,0,0,1-.311,1.265l-.918.619,0,0-.929.318c-1.306.551-2.589.071-3.88-.086-.347-.183-.565-.433-.438-.857C-2707.117-1581.519-2704.892-1581.6-2703.018-1583.492Z",
    fill: "#dfb642"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64984",
    "data-name": "Path 64984",
    d: "M-2709.5-1582.229l.3.606a.607.607,0,0,1-.913,0l-.646-.606c-.22-.177-.5-.329-.308-.688a.441.441,0,0,1,.576.083Z",
    fill: "#dec052"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64985",
    "data-name": "Path 64985",
    d: "M-2710.485-1582.831l-.539-.015c-.5.263-.845-.05-1.2-.33-.044-.061-.086-.122-.129-.184a.4.4,0,0,1,.069-.408q0-.465.007-.929Z",
    fill: "#d9b953"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64986",
    "data-name": "Path 64986",
    d: "M-2712.282-1583.768c.006.1.007.2,0,.3a4.58,4.58,0,0,1-1.1,1.231,3.975,3.975,0,0,0,1.1-1.233l1.256.62c.091.207.182.413.272.62a2.294,2.294,0,0,0-2.123,2.824c.191,1.476-1.081,2.707-.6,4.178.437,1.332.1,2.747.452,4.1-.374-1.039-1.256-1.9-.867-3.2-.95.316-.859,1.018-.868,1.674-.665.092-.625-.65-1.027-.869a7.594,7.594,0,0,0-.624-1.31c-.057-.407-.4-.767-.2-1.216.156-1.392-.852-2.38-1.272-3.572-.364-1.032-.184-1.573.945-1.673.192.528.184,1.15.713,1.522,1.1,1.385.993,3.081,1.127,4.108-.529-1.092,1.211-2.355.819-4.113-.569.369-1.2,1.527-1.854.16a1.991,1.991,0,0,1,.44-1.987,7.742,7.742,0,0,0,2.5-1.972C-2712.877-1583.9-2712.642-1583.957-2712.282-1583.768Z",
    fill: "#e5b124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64987",
    "data-name": "Path 64987",
    d: "M-2716.3-1579.752c-1.382-.029-.894-.828-.631-1.534l1.245-.31q-.153.921-.3,1.842C-2716.094-1579.626-2716.2-1579.626-2716.3-1579.752Z",
    fill: "#e6ae38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64988",
    "data-name": "Path 64988",
    d: "M-2716.6-1576.041a2.176,2.176,0,0,1,.312,1.224.465.465,0,0,1-.035.674q-.468-.951-.937-1.9-.368-1.059-.737-2.118C-2716.987-1577.817-2717.4-1576.532-2716.6-1576.041Z",
    fill: "#d3b140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64989",
    "data-name": "Path 64989",
    d: "M-2718.972-1580.968c-.134-.45.044-.63.5-.576C-2718.547-1581.27-2718.236-1580.669-2718.972-1580.968Z",
    fill: "#e8cb65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64990",
    "data-name": "Path 64990",
    d: "M-2715.67-1573.592c.661-.029.512.723.913.946h0c.286.484.229,1.1.62,1.547a21.683,21.683,0,0,0,1.849,4.94c1.063,1.648,1.125,3.573,1.49,5.411a60.79,60.79,0,0,1,.986,9.058,7.857,7.857,0,0,1-.2,2.139.324.324,0,0,1-.472.095c-.074-.031-.149-.059-.224-.085-.455-.994.067-2.086-.311-3.087a49.552,49.552,0,0,0-1.849-11.733,24.229,24.229,0,0,0-2.218-6.12l-.025-.827a4.319,4.319,0,0,0-.628-1.626l.013.021A.563.563,0,0,1-2715.67-1573.592Z",
    fill: "#ebbf35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64991",
    "data-name": "Path 64991",
    d: "M-2703.643-1588.1c.1,0,.2-.007.305-.017a.406.406,0,0,1,.007.619,5.185,5.185,0,0,1-2.772,3.121l-1.22-.016c-.067-.757.7-.566,1.01-.9a4.562,4.562,0,0,0,1.627-1.894C-2704.482-1587.648-2704.256-1588.1-2703.643-1588.1Z",
    fill: "#ddb94d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64992",
    "data-name": "Path 64992",
    d: "M-2706.086-1584.993c-.279.477-.967.107-1.238.6a1.582,1.582,0,0,1-1.5-.62,1.137,1.137,0,0,1,.684-.516,1.8,1.8,0,0,1,.877-.008C-2706.855-1585.4-2706.38-1585.389-2706.086-1584.993Z",
    fill: "#e9bd36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64993",
    "data-name": "Path 64993",
    d: "M-2709.519-1585.588c-.569-.214-.667-.788-.94-1.228a2.282,2.282,0,0,1-.432-1.424.361.361,0,0,1,.328-.239,3.261,3.261,0,0,1,1.253,2.5A.684.684,0,0,1-2709.519-1585.588Z",
    fill: "#e4c149"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64994",
    "data-name": "Path 64994",
    d: "M-2709.519-1585.588l.012-.36c.352-.308.655-.118.957.094a1.138,1.138,0,0,1,.251.344c.011.07.02.142.029.213l-.558.283Z",
    fill: "#f6d14a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64995",
    "data-name": "Path 64995",
    d: "M-2710.787-1588.382q.164.783.328,1.565l-.505-.368q-.1-.453-.194-.907a.327.327,0,0,1,.048-.334A.268.268,0,0,1-2710.787-1588.382Z",
    fill: "#a59455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64996",
    "data-name": "Path 64996",
    d: "M-2710.787-1588.382l-.138-.006h-.138c-1.056-.94-.434-2.181-.59-3.283a1.306,1.306,0,0,1,.247-.747c.121-.256.5-.384.378-.759a4.757,4.757,0,0,1,2.473-3.167.632.632,0,0,1,.613.262l-.343.562a3.464,3.464,0,0,1-.511.9c-1.243,1.619-2.089,3.347-1.563,5.474a.6.6,0,0,1-.372.743Z",
    fill: "#d0b14d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64997",
    "data-name": "Path 64997",
    d: "M-2708.591-1596.155a13.41,13.41,0,0,0-2.437,2.978l-.039-1.1c.591-.861,1.073-1.831,2.186-2.165C-2708.564-1596.569-2708.523-1596.418-2708.591-1596.155Z",
    fill: "#362a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64998",
    "data-name": "Path 64998",
    d: "M-2711.375-1591.774a10.206,10.206,0,0,0,.312,3.387c-.031.1-.063.2-.095.3l-.508-.011,0-.287C-2711.733-1589.532-2712.249-1590.712-2711.375-1591.774Z",
    fill: "#3c4349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64999",
    "data-name": "Path 64999",
    d: "M-2711.375-1591.774c-.623,1.084-.147,2.26-.288,3.385-.355-1.371-.812-2.748.257-4.028Z",
    fill: "#2b1f2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65000",
    "data-name": "Path 65000",
    d: "M-2703.331-1587.5c0-.206,0-.412-.007-.619.035-.328-.037-.7.351-.887q-.016.609-.032,1.218Z",
    fill: "#c1a13a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65001",
    "data-name": "Path 65001",
    d: "M-2715.67-1573.592q-.027.339-.056.678l-.582-.623c-.007-.2-.013-.4-.02-.606.012-.225.023-.449.035-.674A1.123,1.123,0,0,1-2715.67-1573.592Z",
    fill: "#d9b83d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65002",
    "data-name": "Path 65002",
    d: "M-2715.739-1572.935a1.5,1.5,0,0,1,.628,1.626A2.712,2.712,0,0,1-2715.739-1572.935Z",
    fill: "#d9b83d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65003",
    "data-name": "Path 65003",
    d: "M-2691.889-1582.542a6.86,6.86,0,0,1-7.051.64,4.294,4.294,0,0,1-1.416-1.123c-.437-.5-.862-1.594-1.7-.276-.145.229-.5-.186-.676-.43l1.25-1.335c1.511,1.816,3.13,3.389,5.775,3.244a7.3,7.3,0,0,0,3.19-1.021l.616,0C-2691.893-1582.745-2691.89-1582.644-2691.889-1582.542Z",
    fill: "#ddba47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65004",
    "data-name": "Path 65004",
    d: "M-2708.591-1596.155l-.29-.285a3.268,3.268,0,0,1,2.536-.593c.687.08,1.276.346,1.154,1.23a4.966,4.966,0,0,0-2.751-.278Z",
    fill: "#392739"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65005",
    "data-name": "Path 65005",
    d: "M-2699.663-1593.136l.059.421c.84,1.132-.136,2.373.212,3.535a1.08,1.08,0,0,1-.548.79,1.438,1.438,0,0,0-.242-.1C-2700.172-1590.06-2700.514-1591.665-2699.663-1593.136Z",
    fill: "#d6b537"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65006",
    "data-name": "Path 65006",
    d: "M-2699.94-1588.39l.292-.636c.467.324.586.883.893,1.315.188.343.3.716.466,1.069.065.107.126.215.193.32s.15.2.223.3a1.548,1.548,0,0,1,.319.682.612.612,0,0,1-.194.516A5.323,5.323,0,0,1-2699.94-1588.39Z",
    fill: "#d8b753"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65007",
    "data-name": "Path 65007",
    d: "M-2697.748-1584.823v-.485c.847-.218,1.6.352,2.437.273a.949.949,0,0,1,.592.339c-.745.648-1.611.258-2.428.285C-2697.388-1584.491-2697.669-1584.51-2697.748-1584.823Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65008",
    "data-name": "Path 65008",
    d: "M-2706.086-1584.993c-.43-.063-.926.131-1.258-.319.127-.833-.291-1.671.02-2.5.829-.886,1.069.145,1.552.442-.044-1.18-.98-2.218-.654-3.51-.889.876-.182,2.179-.9,3.072a.531.531,0,0,1-.61.149,2.242,2.242,0,0,1-.687-.624,9.47,9.47,0,0,1-.719-1.692,1.3,1.3,0,0,1,.788-1.978c1.356-.454,1.928-2.024,3.379-2.32.809.01.935.707,1.236,1.229q.151.775.3,1.552a1.542,1.542,0,0,0-.62.625c-.574,1,.332.491.621.611q0,1.079-.005,2.157C-2704.5-1587.1-2704.8-1585.659-2706.086-1584.993Z",
    fill: "#e7b124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65009",
    "data-name": "Path 65009",
    d: "M-2703.638-1590.258c-.361.223-.5.8-1.233.642.352-.7-.67-2.114,1.232-1.878Q-2703.639-1590.876-2703.638-1590.258Z",
    fill: "#e6ae38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65010",
    "data-name": "Path 65010",
    d: "M-2705.177-1594.275c-1.024.914-1.782,2.169-3.155,2.635-.926.315-1.187.911-.6,1.585.457.521.1,1.253.662,1.652a1.917,1.917,0,0,1-.266,1.884.612.612,0,0,1-.731-.414c-.829-1.993-1.714-3.993-.271-6.089.289-.2.653.161.935-.123,1.653-.885-.087-1.192-.3-1.757a.583.583,0,0,1,.61-.617l.955.021c.718.407,1.623.486,2.153,1.224Z",
    fill: "#e7b030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65011",
    "data-name": "Path 65011",
    d: "M-2705.177-1594.274a2.92,2.92,0,0,1-2.153-1.224C-2706.358-1595.537-2705.3-1595.732-2705.177-1594.274Z",
    fill: "#e4b11c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65012",
    "data-name": "Path 65012",
    d: "M-2708.9-1471.638a4.686,4.686,0,0,1-1.522,1.564,1.644,1.644,0,0,1,.071-2C-2709.726-1472.977-2709.365-1471.9-2708.9-1471.638Z",
    fill: "#fafcf5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65013",
    "data-name": "Path 65013",
    d: "M-2707.952-1473.479a1.11,1.11,0,0,1-.617,1.235c-1.024-.584-.5-1.468-.581-2.239C-2708.132-1474.7-2709.113-1472.991-2707.952-1473.479Z",
    fill: "#fafcf5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65014",
    "data-name": "Path 65014",
    d: "M-2713.21-1471.321a3.006,3.006,0,0,1-.619-1.85l.741-.777A2.69,2.69,0,0,1-2713.21-1471.321Z",
    fill: "#fafcf5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65015",
    "data-name": "Path 65015",
    d: "M-2700.871-1475.636c-.095,1.453-1.15,2.251-2.121,3.106a1.145,1.145,0,0,1,.312-.834c.808-1.008,1.3-1.981-.211-2.851-.157-.09-.088-.574-.124-.875C-2701.867-1477.245-2701.507-1476.238-2700.871-1475.636Z",
    fill: "#fbe047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65016",
    "data-name": "Path 65016",
    d: "M-2700.871-1475.636l-2.144-1.454-.291-.465a.545.545,0,0,1,.3-.563c.811.833,1.987,1.3,2.463,2.469Z",
    fill: "#d74f0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65017",
    "data-name": "Path 65017",
    d: "M-2704.871-1474.1c-.363-.007-.588-.165-.6-.553a1.04,1.04,0,0,1,.575-.689c.407-.286.815-.571,1.294-.906C-2703.456-1475.112-2704.457-1474.782-2704.871-1474.1Z",
    fill: "#e7ea23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65018",
    "data-name": "Path 65018",
    d: "M-2699.62-1476.254c-1.548-1.479-3.5-2.466-4.932-4.1a1.719,1.719,0,0,0-1.246-.536l-.006-.008c-.591-.741-1.249-1.426-1.843-2.165.3-.419-.011-.843.009-1.264.955.7,1.361,1.939,2.453,2.505a15.188,15.188,0,0,1,1.652,1.078c.385.284.711.635,1.075.942a16.821,16.821,0,0,1,3.944,3.744.782.782,0,0,1-.115.416C-2699.222-1475.421-2699.413-1475.85-2699.62-1476.254Z",
    fill: "#de5319"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65019",
    "data-name": "Path 65019",
    d: "M-2707.647-1483.06c.8.564,1.712,1.032,1.843,2.165A3.242,3.242,0,0,1-2707.647-1483.06Z",
    fill: "#f6562e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65020",
    "data-name": "Path 65020",
    d: "M-2689.732-1475.645a14.247,14.247,0,0,0-2.333,4.741c-1.5-.427-1.619-1.386-1.383-2.586.4-2.042.342-4.156.936-6.171.973-1.227.124-2.595.236-3.892a9.046,9.046,0,0,0,.148-3.471c-.179-.6.5-.544.678-.835.2-.315,1.01-.178.677-.789a.907.907,0,0,0-1.306-.4c-.167.09-.315.215-.61.42-.062-.785.236-1.546-.469-2.146h1.941a1.25,1.25,0,0,1,.985.331c.682.7.454,1.408.349,2.292s1.72,0,1.913,1.222c.067.429.121.794-.247,1.12a.565.565,0,0,0-.014.931c.42.354.518-.368.962-.311-.046,1.707.213,3.408-.551,5.085-.336.737-.523,1.362-1.444,1.494a.685.685,0,0,0-.466,1.13C-2688.795-1476.781-2689.518-1476.248-2689.732-1475.645Z",
    fill: "#fafcfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65021",
    "data-name": "Path 65021",
    d: "M-2692.836-1482.165q-.17.627-.341,1.256c-.587-1.78-.12-3.61-.253-5.412-.049-.656-.015-1.319-.019-1.979a.449.449,0,0,1,.022-.635,1.528,1.528,0,0,0,.262.007C-2692.325-1486.709-2692.969-1484.418-2692.836-1482.165Z",
    fill: "#cf532a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65022",
    "data-name": "Path 65022",
    d: "M-2686.987-1480.671a4.974,4.974,0,0,1-1.2,3.168A9.053,9.053,0,0,1-2686.987-1480.671Z",
    fill: "#f5eb33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65023",
    "data-name": "Path 65023",
    d: "M-2693.427-1488.935c-.007.211-.015.423-.022.635l-.6-.011c-.38.963-.049,1.971-.19,2.95a.244.244,0,0,1-.388.14c-.046-1.881.137-3.8-.887-5.521C-2694.183-1490.87-2694.081-1489.584-2693.427-1488.935Z",
    fill: "#f15912"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65024",
    "data-name": "Path 65024",
    d: "M-2697.134-1487.688c.153,2.467-.508,4.866-.606,7.309-.04,1-.608.86-1.242.7-.51.269-.758-.182-1.094-.393-.5-.474-1.115-.8-1.6-1.292-.644-.8-1.868-1.07-2.1-2.257a.4.4,0,0,1,.149-.369,1.378,1.378,0,0,0,1.3.05c.415-.117.977-.013,1.013.431.089,1.126.5,1.74,1.722,1.745a.621.621,0,0,1,.554.965c-.209.437.3.638.77.746A27.134,27.134,0,0,1-2697.134-1487.688Z",
    fill: "#fbfcee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65025",
    "data-name": "Path 65025",
    d: "M-2703.627-1483.989l-.01.316a.2.2,0,0,1-.345.047l-.321-.318q-.29-.476-.578-.953C-2704.136-1485.047-2703.873-1484.529-2703.627-1483.989Z",
    fill: "#f4fadb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65026",
    "data-name": "Path 65026",
    d: "M-2697.158-1480.3c-.231-2.51.549-4.961.433-7.465.4-.607.006-1.331.248-1.926.271-.664.464-.279.567.14.035.544.282,1.129-.307,1.549l.307.925a13.431,13.431,0,0,1,.306,2.527c0,.482.01.963-.014,1.444a1.106,1.106,0,0,1-.29.66c-.66,1.221.123,2.547-.28,3.809a6.4,6.4,0,0,1-.34,1.445c-.214.435-.344.965-1.009.887-.36-.052-.629-.206-.676-.607A8.505,8.505,0,0,0-2697.158-1480.3Z",
    fill: "#efeb2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65027",
    "data-name": "Path 65027",
    d: "M-2694.625-1485.221l.262,0a.431.431,0,0,1,0,.617,87.1,87.1,0,0,1-.613,8.976c-.035.425-.017.845-.589.9C-2695.751-1478.272-2694.983-1481.728-2694.625-1485.221Z",
    fill: "#df551f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65028",
    "data-name": "Path 65028",
    d: "M-2698.076-1476.877a.659.659,0,0,0,.623.308c.283.257,1.061.179.625.923l-.036.391a1.679,1.679,0,0,1-1.795-.785l-4-3.644c.208-.657.682-1.2.834-1.881a.258.258,0,0,1,.367.035c.5.429,1.171.653,1.547,1.242-1.419.664-1.407.648-.131,1.585A5.889,5.889,0,0,1-2698.076-1476.877Z",
    fill: "#f9e745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65029",
    "data-name": "Path 65029",
    d: "M-2695.91-1484.6c.128-.823-.791-1.647,0-2.47.595-.293.938-.037.9.554-.082,1.266-.24,2.529-.407,3.788-.015.116-.32.194-.491.289v-.615A1.684,1.684,0,0,0-2695.91-1484.6Z",
    fill: "#f2ee34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65030",
    "data-name": "Path 65030",
    d: "M-2698.659-1476.04c.706.015,1.143.644,1.795.785q.339.4.679.794c-.9.705-1.187-.611-1.885-.572a.718.718,0,0,1-.62-.613Z",
    fill: "#db4c16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65031",
    "data-name": "Path 65031",
    d: "M-2696.217-1488c.255-.486-.115-1.1.307-1.549.442.427.776.917.493,1.538C-2695.464-1487.906-2695.939-1488-2696.217-1488Z",
    fill: "#f2ee34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65032",
    "data-name": "Path 65032",
    d: "M-2696.828-1475.646c.038-.474-.43-.606-.625-.923.477.046.606-.43.925-.62-.007.374.279.617.405.924C-2695.807-1475.495-2696.187-1475.393-2696.828-1475.646Z",
    fill: "#f6eb2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65033",
    "data-name": "Path 65033",
    d: "M-2698.076-1476.877c-1.021-.317-1.575-1.3-2.514-1.755-.446-.217-1.06-.486-.834-1.218.277-.9.947-.511,1.517-.438l.925.61c1.158,1.235,1.212,1.217,1.824-.619C-2697.261-1479.1-2696.648-1477.716-2698.076-1476.877Z",
    fill: "#f6eb2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65034",
    "data-name": "Path 65034",
    d: "M-2704.873-1483.058c.058-.8.584-.221.886-.3a.86.86,0,0,1,.587.692.983.983,0,0,1-1.06,1.07.774.774,0,0,1-.418-.229Z",
    fill: "#f1e818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65035",
    "data-name": "Path 65035",
    d: "M-2704.878-1481.825c.1.008.2.012.3.014.538.273,1.46.277.919,1.309a3.13,3.13,0,0,1-1.53-1.317C-2705.083-1481.826-2704.981-1481.828-2704.878-1481.825Z",
    fill: "#fdd54f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65036",
    "data-name": "Path 65036",
    d: "M-2703.617-1482.772l-.369-.586a1.347,1.347,0,0,0,0-.268l.345-.047c.45,1,1.664,1.216,2.182,2.143l-.329.042C-2702.746-1481.415-2703.21-1482.053-2703.617-1482.772Z",
    fill: "#f7f481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65037",
    "data-name": "Path 65037",
    d: "M-2709.494-1541.448v.314c.265.378,0,.962.493,1.254a4.542,4.542,0,0,0,2.089.453c4.161-.12,8.331.22,12.487-.2a1.572,1.572,0,0,1,1.3.334c-.221.4-.6.317-.953.316q-8-.016-15.994-.039-.012-1.217-.025-2.433a.422.422,0,0,1,.3-.169l.176.043Z",
    fill: "#e2c13e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65038",
    "data-name": "Path 65038",
    d: "M-2693.127-1539.29c-5.059,0-10.118.013-15.177-.01-.536,0-1.3.348-1.5-.589a2.038,2.038,0,0,1,1.846.285l12.667,0a2.252,2.252,0,0,0,1.854-1.537c.092.005.185.012.277.021a.444.444,0,0,1,.056.643Z",
    fill: "#f4ca34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65039",
    "data-name": "Path 65039",
    d: "M-2693.1-1540.475c-.019-.214-.037-.429-.055-.643.221-1.659-.332-3.368.326-5l.129.033q-.066,2.776-.133,5.552A1.153,1.153,0,0,0-2693.1-1540.475Z",
    fill: "#e0b942"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65040",
    "data-name": "Path 65040",
    d: "M-2692.7-1546.083l-.129-.033a2.815,2.815,0,0,1,.011-1.513c.081-.134.157-.138.229.007A3.093,3.093,0,0,1-2692.7-1546.083Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65041",
    "data-name": "Path 65041",
    d: "M-2692.593-1547.622l-.229-.007c.091-.614-.22-1.288.272-1.842l.127.295Q-2692.508-1548.4-2692.593-1547.622Z",
    fill: "#e2b83c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65042",
    "data-name": "Path 65042",
    d: "M-2694.02-1472.745c0,.723.4,1.738-.224,2.069-.5.265-1.124-.678-1.725-1.035a2.963,2.963,0,0,1-.532-.535c.452-.345.669.027.918.3l.9.271c.521-.382-.405-1.391.665-1.534A.423.423,0,0,1-2694.02-1472.745Z",
    fill: "#d34d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65043",
    "data-name": "Path 65043",
    d: "M-2698.69-1475.646c.207.2.413.409.62.614a.941.941,0,0,1-.619.932c-.034-.838-1.4-1.1-.931-2.154Z",
    fill: "#f05a29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65044",
    "data-name": "Path 65044",
    d: "M-2694.092-1473.174c-.54.365.024,1.166-.592,1.5a3.981,3.981,0,0,1,.327-3.036.264.264,0,0,1,.418.083C-2693.954-1474.139-2693.739-1473.626-2694.092-1473.174Z",
    fill: "#db5820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65045",
    "data-name": "Path 65045",
    d: "M-2694.361-1484.607l0-.617c.149-1.024-.325-2.112.316-3.087C-2694.221-1487.082-2693.723-1485.8-2694.361-1484.607Z",
    fill: "#de411f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65046",
    "data-name": "Path 65046",
    d: "M-2694.058-1474.713c-.1,0-.2,0-.3,0,0-.441-.016-.883,0-1.325.009-.276-.046-.707.355-.654.323.043.232.483.287.761l0-.013C-2694.126-1475.612-2693.707-1475.057-2694.058-1474.713Z",
    fill: "#ea492a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65047",
    "data-name": "Path 65047",
    d: "M-2696.859-1472.513l-1.2-.682c.481-.682.71-.622,1.238.323A.241.241,0,0,1-2696.859-1472.513Z",
    fill: "#ce4529"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65048",
    "data-name": "Path 65048",
    d: "M-2696.859-1472.513l.036-.359c.664-.027,1.171.157,1.24.927l-.918-.3Z",
    fill: "#df4e1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65049",
    "data-name": "Path 65049",
    d: "M-2699.044-1472.061l.062.446c.847.232.837.728.223,1.144a4.869,4.869,0,0,0-2.484,4.214.571.571,0,0,1-.4.591.529.529,0,0,1-.694-.415,1.711,1.711,0,0,0-.612-.846l-.093-.091Z",
    fill: "#faf3df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65050",
    "data-name": "Path 65050",
    d: "M-2707.65-1471.018c1.248.6.332.933-.229,1.527l-.083-1.21Z",
    fill: "#f5ec42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65051",
    "data-name": "Path 65051",
    d: "M-2697.152-1457.728c.068-.439.14-1.008.6-1.076.711-.1.786.768,1.26,1.08C-2695.915-1456.328-2696.533-1457.731-2697.152-1457.728Z",
    fill: "#f8ea3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65052",
    "data-name": "Path 65052",
    d: "M-2702.945-1466.927c.953-.344.691.775,1.659,1.279-.959-1.614-.005-2.457.559-3.434.376-.65.654-1.322,1.565-1.484.659-.117.739-.59.18-1.049.757-1.036,1.507-1.1,2.281-.009a12.137,12.137,0,0,0,.8.918c-.165.232-.442.376-.541.719.386.047.4-.687.849-.41.734.044,1.3.691,2.128.519.4-.082.567.312.334.72-1.7,1.337-2.195,3.319-2.783,5.248-.412.152-.687-.073-.945-.344-.4-.6-.46-1.359-.917-1.926a4.61,4.61,0,0,0,1.1,2.194,4.079,4.079,0,0,1-.468,2.248c0,.1-.006.2-.011.3-.159.071-.31-.1-.4-.078-1.251.251-1.344.288-1.764-1.1a1.606,1.606,0,0,0-2.156-1.284A6.731,6.731,0,0,1-2702.945-1466.927Z",
    fill: "#fbfbfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65053",
    "data-name": "Path 65053",
    d: "M-2701.474-1463.9c1.38-1.015,1.5-.915,2.3.721.3.611.37,1.313.712,1.934.683-.412.119-1.163.691-1.6.567.3.064,1.125.615,1.4a8.573,8.573,0,0,0-.6,1.389c-.262,1.092-.765,1.172-1.54.47-.326-.062-.416-.392-.643-.567-.175-.236-.35-.471-.524-.707l-.132-.8A3.928,3.928,0,0,0-2701.474-1463.9Z",
    fill: "#fbfcf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65054",
    "data-name": "Path 65054",
    d: "M-2695.1-1462.619c.823,1.05.823,1.05-.409,1.892C-2695.743-1461.448-2695.314-1461.967-2695.1-1462.619Z",
    fill: "#f9eb3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65055",
    "data-name": "Path 65055",
    d: "M-2696.259-1462.068a6.128,6.128,0,0,1,1.247-2.511c.167.1.181.225.043.365A3.878,3.878,0,0,1-2696.259-1462.068Z",
    fill: "#f9eb3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65056",
    "data-name": "Path 65056",
    d: "M-2693.46-1467.324q.009.476.018.949l-.937.608A2.97,2.97,0,0,1-2693.46-1467.324Z",
    fill: "#f5eb33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65057",
    "data-name": "Path 65057",
    d: "M-2694.969-1464.214c-.014-.122-.028-.243-.042-.365a1.832,1.832,0,0,1,.634-1.189A1.774,1.774,0,0,1-2694.969-1464.214Z",
    fill: "#f5eb33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65058",
    "data-name": "Path 65058",
    d: "M-2696.836-1464.214l.92.3c-.82.492-.478,1.639-1.226,2.172.008-.837.461-1.618.305-2.475Z",
    fill: "#fbfcf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65059",
    "data-name": "Path 65059",
    d: "M-2692.815-1467.916a.948.948,0,0,1-.649.6q.345-.907.691-1.815a1.323,1.323,0,0,0,.248-.057A2.038,2.038,0,0,1-2692.815-1467.916Z",
    fill: "#f5eb33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65060",
    "data-name": "Path 65060",
    d: "M-2699.933-1460.15l.643.567q.008.3.015.607A1.516,1.516,0,0,1-2699.933-1460.15Z",
    fill: "#f9ea35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65061",
    "data-name": "Path 65061",
    d: "M-2695.595-1470.4c-.039.033-.109.064-.112.1-.054.636-.345,1.061-1.022,1.085a.363.363,0,0,1-.364-.411c.074-.7.408-1.146,1.19-1.083Z",
    fill: "#e9fdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65062",
    "data-name": "Path 65062",
    d: "M-2694.058-1474.713c.057-.425-.155-.923.337-1.228a10.583,10.583,0,0,1-.3,3.2l-.072-.428Q-2694.076-1473.944-2694.058-1474.713Z",
    fill: "#f25329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65063",
    "data-name": "Path 65063",
    d: "M-2711.019-1552.629a9.16,9.16,0,0,1,.31,3.087l-.057.687C-2711.338-1550.08-2710.95-1551.37-2711.019-1552.629Z",
    fill: "#3f3d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65064",
    "data-name": "Path 65064",
    d: "M-2709.8-1541.452l-.3.006-.384-8.011.362-.018c.2.222.139.5.151.755.2,1.848.743,3.659.587,5.548A2.562,2.562,0,0,1-2709.8-1541.452Z",
    fill: "#e9b83e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65065",
    "data-name": "Path 65065",
    d: "M-2715.364-1593.042c1.225,1.943.647,5.86-1,7.35a3.8,3.8,0,0,1-2.1.672,2.277,2.277,0,0,1-.795-2.629c.318-.148.938.08.725-.71a2.5,2.5,0,0,1-.064-1.478c.2-.208.36-.363.15-.73-.553-.967-.107-1.594.823-1.985.349-.059.69.123,1.074.027-.156-.55-.571-1.076-.192-1.677C-2715.723-1594.483-2715.986-1593.237-2715.364-1593.042Z",
    fill: "#e7b02a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65066",
    "data-name": "Path 65066",
    d: "M-2716.6-1594.278c-.253.912.5,1.468,1.067,2.566-.842-.581-1.52-.14-2-.709-1.087-.087-1.177.689-1.168,1.445,0,.332.31.646.242,1.029a5.767,5.767,0,0,1,.309,2.11c-.041.3-.031.711-.388.7-.184-.005-.357-.423-.536-.654-.86-1.119-1.047-2.539-1.667-3.767a.757.757,0,0,1,.057-.879c1.076-.913,1.384-2.534,2.849-3.078.421.048.9-.142,1.219.314C-2716.906-1594.887-2716.361-1594.588-2716.6-1594.278Z",
    fill: "#e5b133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65067",
    "data-name": "Path 65067",
    d: "M-2717.838-1595.512a10.436,10.436,0,0,1-2.045,2.7c-.979.666-.535,1.172-.261,1.771a8.407,8.407,0,0,1,1.067,3.251c-.218,1.016.4,1.847.612,2.768a1.829,1.829,0,0,1-1.535-.915,12.286,12.286,0,0,0-1.547-4.942,4.839,4.839,0,0,1,2.467-4.625l.009-.005Z",
    fill: "#e7b21d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65068",
    "data-name": "Path 65068",
    d: "M-2721.547-1590.877a5.257,5.257,0,0,1,1.547,4.942c-.95-.292-.333-1.376-.93-1.846-.5-.641-.373-1.461-.618-2.174Z",
    fill: "#e8ae2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65069",
    "data-name": "Path 65069",
    d: "M-2721.548-1589.955c1.146.457.388,1.456.618,2.174a1.209,1.209,0,0,1-.02.147,1.253,1.253,0,0,1-.053.138C-2721.559-1588.233-2722.315-1588.926-2721.548-1589.955Z",
    fill: "#e7b21d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65070",
    "data-name": "Path 65070",
    d: "M-2716.6-1594.278c.085-.308-.939-.6-.014-.92.353.756,1.414,1.1,1.254,2.157C-2716.412-1592.817-2716.06-1594-2716.6-1594.278Z",
    fill: "#e4af15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65071",
    "data-name": "Path 65071",
    d: "M-2710.118-1548.865l0-.61c.177-5.678-1-11.18-2.167-16.685.307.13.66.43.915.362,1.3-.35,1.06.345.646.976a3.13,3.13,0,0,0-.317,1.751c.438,1.512,1.422,2.951.619,4.629.376.82.743.378,1.227-.09-1.359,3.222.321,6.514-.613,9.669C-2709.915-1548.723-2710.017-1548.717-2710.118-1548.865Z",
    fill: "#e9b121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65072",
    "data-name": "Path 65072",
    d: "M-2693.437-1541.139c.3,1.621-.714,1.655-1.854,1.537-.086-.655.57-.391.844-.667-.634-.394-1.341-.578-.382-1.559.449-.46.478-1.657.438-2.651-.034-.861-.6-2.082.266-2.989.6.137.2.887.679,1.077Q-2693.442-1543.765-2693.437-1541.139Z",
    fill: "#e5b022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65073",
    "data-name": "Path 65073",
    d: "M-2709.494-1547.312c.244-.055.557-.8.718-.026a15.9,15.9,0,0,1,.036,5.466c-.044.313-.435.4-.754.424l-.008,0A20.846,20.846,0,0,1-2709.494-1547.312Z",
    fill: "#e3b41e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65074",
    "data-name": "Path 65074",
    d: "M-2690.962-1564.925c-.067.666.223,1.451-.62,1.858-.793-.377-.651-.944-.315-1.551a1.194,1.194,0,0,1,0-1.546c.061-.732-.153-1.5.483-2.206Q-2691.187-1566.648-2690.962-1564.925Z",
    fill: "#edae21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65075",
    "data-name": "Path 65075",
    d: "M-2710.426-1558.442c.373-1.62-.829-3.03-.619-4.629.453-.2.642-.067.625.437-.013.39-.1.821.3,1.109a.862.862,0,0,1,.617.928C-2710.094-1560-2709.407-1558.856-2710.426-1558.442Z",
    fill: "#edab37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65076",
    "data-name": "Path 65076",
    d: "M-2710.107-1581.62l.913,0a15.089,15.089,0,0,0,4.015.337,1.434,1.434,0,0,1-1.5.546,9.164,9.164,0,0,0-3.488-.185c-.3.019-.676.206-.661-.272C-2710.817-1581.562-2710.408-1581.574-2710.107-1581.62Z",
    fill: "#edb623"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65077",
    "data-name": "Path 65077",
    d: "M-2709.494-1547.312q0,2.932-.008,5.866c-.1,0-.2,0-.3-.006.162-2.483-.306-4.938-.315-7.413l.306,0Z",
    fill: "#f4ca34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65078",
    "data-name": "Path 65078",
    d: "M-2709.5-1560.6l-.617-.928v-1.858c1.39.766.586,2.156,1.3,2.914C-2709.09-1560.28-2709.276-1560.552-2709.5-1560.6Z",
    fill: "#e1b31e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65079",
    "data-name": "Path 65079",
    d: "M-2707.958-1539.6a3.143,3.143,0,0,1-1.846-.285q.155-.622.31-1.245C-2709.237-1540.368-2708.149-1540.437-2707.958-1539.6Z",
    fill: "#e3b41e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65080",
    "data-name": "Path 65080",
    d: "M-2691.9-1561.215q-.156,1.387-.313,2.774C-2692.5-1559.411-2693.036-1560.407-2691.9-1561.215Z",
    fill: "#dbbc28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65081",
    "data-name": "Path 65081",
    d: "M-2689.115-1570.177a7.133,7.133,0,0,1-.921,2.462C-2690.065-1568.661-2690.075-1569.6-2689.115-1570.177Z",
    fill: "#e2b417"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65082",
    "data-name": "Path 65082",
    d: "M-2691.893-1566.164q0,.772,0,1.546C-2692.883-1565.136-2692.872-1565.651-2691.893-1566.164Z",
    fill: "#efac3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65083",
    "data-name": "Path 65083",
    d: "M-2692.108-1569.445c-.476-.7-.507-1.094-.111-1.571C-2691.719-1570.587-2691.929-1570.164-2692.108-1569.445Z",
    fill: "#e6b414"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65084",
    "data-name": "Path 65084",
    d: "M-2704.247-1581.608c.2,0,.408-.008.61.008.3.023.635.033.691.417.012.084-.185.21-.3.3-.539.41-.486-.219-.688-.4-.112-.1-.211-.213-.316-.32Z",
    fill: "#e2ae13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65085",
    "data-name": "Path 65085",
    d: "M-2714.138-1571.1c-.714-.312-.609-.952-.62-1.547A1.77,1.77,0,0,1-2714.138-1571.1Z",
    fill: "#e5b124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65086",
    "data-name": "Path 65086",
    d: "M-2685.1-1585.31c.329.44.807.262,1.234.3-.665.617-1.492.173-2.226.343l-.562-.31c.011-.219.022-.439.032-.658.1.007.193.012.289.013C-2685.887-1585.662-2685.433-1585.725-2685.1-1585.31Z",
    fill: "#e3bf2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65087",
    "data-name": "Path 65087",
    d: "M-2687.882-1593.657c0,.591.116,1.227-.606,1.532A1.766,1.766,0,0,1-2687.882-1593.657Z",
    fill: "#e0b73b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65088",
    "data-name": "Path 65088",
    d: "M-2682.626-1591.8c1.324,1.165.539,2.655.618,4.012-.371.12-.661.485-1.166.365a5.058,5.058,0,0,1,.419-2.029c.185-.45.344-1-.245-1.354-.26-.156-.856.016-.675-.567C-2683.526-1591.856-2683.032-1591.788-2682.626-1591.8Z",
    fill: "#e7ad31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65089",
    "data-name": "Path 65089",
    d: "M-2684.947-1592.754c-.446-.1-.78-.31-.643-.738.185-.578.423-1.262,1.155-1.267a.832.832,0,0,1,.81.947C-2683.762-1593.169-2684.4-1592.94-2684.947-1592.754Z",
    fill: "#e4b033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65090",
    "data-name": "Path 65090",
    d: "M-2685.1-1585.31c-.426-.046-.91.135-1.233-.315a.961.961,0,0,1,1.254-.554c.237.07.7.064.6.478C-2684.523-1585.532-2684.885-1585.438-2685.1-1585.31Z",
    fill: "#edab34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65091",
    "data-name": "Path 65091",
    d: "M-2694.72-1584.7l-.6-.005c-.135-.327.042-.562.23-.795a6.124,6.124,0,0,0,2.014-2.425c.157-.164.327-.29.571-.184l.317.342A4.22,4.22,0,0,1-2694.72-1584.7Z",
    fill: "#e3bd4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65092",
    "data-name": "Path 65092",
    d: "M-2692.5-1588.1l-.331.314c-1.3-.438-.919-1.424-.774-2.345.036-.223.4-.326.257-.545-.7-1.055-.71-1.048.051-2.526.057-.048.116-.1.174-.143A6.958,6.958,0,0,1-2692.5-1588.1Z",
    fill: "#ecae24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65093",
    "data-name": "Path 65093",
    d: "M-2696.509-1595.492c1.392-.921,2,.751,3.064.924q.157.609.317,1.218l0,.005a2.834,2.834,0,0,1-1.161.389c-.529.1-1.077.692-1.58.212s.057-.917.32-1.332-.1-.514-.341-.682C-2696.164-1594.946-2696.628-1594.977-2696.509-1595.492Z",
    fill: "#e3b31a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65094",
    "data-name": "Path 65094",
    d: "M-2696.509-1595.492a2.383,2.383,0,0,0,.506.3c1.061.314,1.581.75.454,1.664a2.88,2.88,0,0,0-.4.657c1.074-.07,1.857-.949,2.816-.473a1.9,1.9,0,0,1-.357,1.446c-.31.335-1.067.816.232.857.545.017.129.606.044.845a2.046,2.046,0,0,0,.377,2.406,3.7,3.7,0,0,1-2.15,2.477c-1.217.729-2.148.014-3.095-.615l-.294-.306a4.475,4.475,0,0,0-.706-2.464,4.273,4.273,0,0,1,.976-5.145c.406-.419.545-.976.957-1.36A.625.625,0,0,1-2696.509-1595.492Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65095",
    "data-name": "Path 65095",
    d: "M-2697.148-1595.2a1.726,1.726,0,0,1-.627,1.591c-1.558,1.281-1.723,2.67-1.008,4.561.327.866,1.259,1.745.408,2.817l-.017-.02c-.249-.383-.016-1-.588-1.226a2.352,2.352,0,0,1-.668-1.545c-.534-1.236.19-2.458.043-3.689C-2698.592-1593.353-2698.463-1594.864-2697.148-1595.2Z",
    fill: "#e7b71b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65096",
    "data-name": "Path 65096",
    d: "M-2716.3-1579.752l.309,0c.6,1.081.9.223,1.278-.2.253-.281.388-.892.9-.621.532.281-.091.781-.014,1.016.526,1.6-1.447,2.779-.7,4.419.1.228-.317.7-.529,1.12-.848-.774-.376-1.732-.442-2.49C-2715.595-1577.665-2716.23-1578.63-2716.3-1579.752Z",
    fill: "#e9af32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65097",
    "data-name": "Path 65097",
    d: "M-2712.281-1583.466c-.128,1.145-.876,1.582-1.982,1.612l1.985-1.61Z",
    fill: "#eeae3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65098",
    "data-name": "Path 65098",
    d: "M-2707.34-1587.786c.277.825.769,1.65,0,2.474l-.926.014,0-.016a2.133,2.133,0,0,1,.315-2.472Z",
    fill: "#e7b030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65099",
    "data-name": "Path 65099",
    d: "M-2709.2-1593.043c-1.3,2.31-.523,4.42.627,6.494a.783.783,0,0,1-.006.951l-.924-.35a7.585,7.585,0,0,0-1.224-2.456,9.934,9.934,0,0,1,.068-3.627,6.2,6.2,0,0,1,1.768-2.871c.561.215,1.348.077,1.524.9a1.043,1.043,0,0,1-.507,1.009c-.242.2-.464.02-.69-.051A1.813,1.813,0,0,0-2709.2-1593.043Z",
    fill: "#e7b121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65100",
    "data-name": "Path 65100",
    d: "M-2708.583-1585.6l.006-.951a5.6,5.6,0,0,1,.311-1.854.637.637,0,0,1,.308.617,4.955,4.955,0,0,0-.315,2.472Z",
    fill: "#e0b224"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65101",
    "data-name": "Path 65101",
    d: "M-2698.081-1585.929a6.585,6.585,0,0,0,3.095.615l-.334.613a3.7,3.7,0,0,1-2.429-.607Z",
    fill: "#eec423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65102",
    "data-name": "Path 65102",
    d: "M-2698.98-1587.481c.8.12.548.743.588,1.226Z",
    fill: "#e6b02b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65103",
    "data-name": "Path 65103",
    d: "M-2705.513-1586.42c-.735-.428-.557-1.484-1.678-1.54-.357-.017-.122-1.477-.125-2.274a1.738,1.738,0,0,1,.937-1.469c.246-.148.609.1.5.345-.646,1.509.433,2.737.59,4.106A2.758,2.758,0,0,1-2705.513-1586.42Z",
    fill: "#e7b030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65104",
    "data-name": "Path 65104",
    d: "M-2709.2-1593.043c.053-.223.057-.53.386-.455.112.025.168.3.25.456-.034.274.067.717-.248.748C-2709.345-1592.241-2709.121-1592.76-2709.2-1593.043Z",
    fill: "#f0ab45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65105",
    "data-name": "Path 65105",
    d: "M-2703.617-1482.772l1.833,1.283c.633,1.048-.356,1.313-.872,1.806a1.84,1.84,0,0,1-1-.82c.133-.744-.576-.9-.919-1.309A.925.925,0,0,0-2703.617-1482.772Z",
    fill: "#f2ec2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65106",
    "data-name": "Path 65106",
    d: "M-2691.013-1477.345c.287-.01.32.21.326.405.005.138-.039.37-.119.4-.23.082-.356-.114-.408-.307A.382.382,0,0,1-2691.013-1477.345Z",
    fill: "#f9fbec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65107",
    "data-name": "Path 65107",
    d: "M-2695.91-1484.6a1.044,1.044,0,0,1,0,1.546Z",
    fill: "#fce639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65108",
    "data-name": "Path 65108",
    d: "M-2696.837-1464.213c-1.469-.287-1.076-1.733-1.526-2.655,1.27.411,1.593,1.411,1.527,2.654Z",
    fill: "#fbfcf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65109",
    "data-name": "Path 65109",
    d: "M-2699.693-1468.124a.5.5,0,0,1,.553.4c.047.223-.108.372-.339.389s-.538.069-.616-.254C-2700.168-1467.892-2699.936-1468.026-2699.693-1468.124Z",
    fill: "#e6fef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65110",
    "data-name": "Path 65110",
    d: "M-2697.4-1470.919c.057.412.052.8-.335,1.015a.309.309,0,0,1-.433-.266C-2698.174-1470.629-2697.856-1470.834-2697.4-1470.919Z",
    fill: "#fbf2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65111",
    "data-name": "Path 65111",
    d: "M-2697.323-1467.866c.215.018.4.089.421.332.017.207-.029.449-.293.4a.663.663,0,0,1-.423-.345C-2697.705-1467.681-2697.574-1467.85-2697.323-1467.866Z",
    fill: "#fbfcf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65112",
    "data-name": "Path 65112",
    d: "M-2698.947-1465.916a.391.391,0,0,1,.192.507c-.057.193-.186.39-.416.3-.081-.032-.116-.267-.11-.406C-2699.271-1465.714-2699.24-1465.939-2698.947-1465.916Z",
    fill: "#fbfcf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65113",
    "data-name": "Path 65113",
    d: "M-2718.462-1589.947c-1.317-1.1-.261-2.211.2-3.1.282-.546.631.193.727.624-.714.576-1.182,1.127-.419,2.084C-2717.592-1589.883-2718.055-1589.79-2718.462-1589.947Z",
    fill: "#e5b41a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65114",
    "data-name": "Path 65114",
    d: "M-2695.736-1594.2c-.163.257-.411.241-.661.2s-.367-.2-.281-.422a.452.452,0,0,1,.712-.275A.4.4,0,0,1-2695.736-1594.2Z",
    fill: "#ebad40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeation);
export default __webpack_public_path__ + "static/media/ideation.022d28225ab42b3a7e123a2b9e5a8366.svg";
export { ForwardRef as ReactComponent };